import { jsxs as Ie, jsx as A } from "@emotion/react/jsx-runtime";
import { Modal as le } from "@inflearn/ds-modal";
import { Divider as Xr, Group as Cd, Checkbox as bd, Button as al, VisuallyHidden as Xa, TextInput as Td, PasswordInput as wd, Text as eo, OptimizeImage as Nd, COLOR_PALETTE as sl, openAlertModal as Wa, Tooltip as Od, ActionIcon as Md, Icon as Yn, Box as _d, Flex as wr, Anchor as Kn } from "@inflearn/ds-react";
import za, { useMemo as ul, createElement as Sd, useRef as Rd, useEffect as De, createContext as xd, useState as an, useContext as Pd, useCallback as Wr } from "react";
import { I as Ud, u as Cn, C as Bo, a as cl, b as Dd, e as er, A as Ld, h as nt, S as tr, c as $d, d as kd, f as ll, g as to, i as Fd, M as Gd, H as Vd, O as Bd, j as Nr, k as jd, l as Hd, m as Xd, q as Qn, n as Wd } from "./StickyHeaderSkeleton-4367f5a1.mjs";
import { ApiError as zd } from "@inflearn/datasource-rest";
import { useForm as Jd, useWatch as Zd } from "react-hook-form";
import { css as Yd } from "@emotion/react";
import Kd from "dayjs/plugin/duration";
import Qd from "dayjs/plugin/relativeTime";
import bn from "dayjs";
function qd({
  i18n: t,
  defaultNS: e,
  children: r
}) {
  const n = ul(() => ({
    i18n: t,
    defaultNS: e
  }), [t, e]);
  return Sd(Ud.Provider, {
    value: n
  }, r);
}
function ev(t) {
  if (typeof window > "u")
    return t;
  const e = document.createElement("div");
  return e.innerHTML = t, e.querySelectorAll("script").forEach((i) => i.remove()), e.querySelectorAll("*").forEach((i) => {
    Array.from(i.attributes).forEach((o) => {
      (o.name.startsWith("on") || o.value.toLowerCase().includes("javascript:")) && i.removeAttribute(o.name);
    });
  }), e.innerHTML;
}
const tv = new Date((/* @__PURE__ */ new Date()).setHours(23, 59, 59));
function xD({
  id: t,
  isOpened: e,
  title: r,
  body: n,
  onClose: i
}) {
  const {
    t: o
  } = Cn(), a = Rd(null), s = () => {
    var u;
    Bo.set("checked_gr_noti_id", String(t), (u = a == null ? void 0 : a.current) != null && u.checked ? 365 : tv), i();
  };
  return /* @__PURE__ */ Ie(le.Root, { opened: e, onClose: i, closeOnClickOutside: !1, children: [
    /* @__PURE__ */ A(le.Overlay, {}),
    /* @__PURE__ */ Ie(le.Content, { children: [
      /* @__PURE__ */ A(le.Header, { children: /* @__PURE__ */ A(le.Title, { children: r }) }),
      /* @__PURE__ */ Ie(le.Body, { children: [
        /* @__PURE__ */ A("div", { dangerouslySetInnerHTML: {
          __html: ev(n)
        } }),
        /* @__PURE__ */ A(Xr, { mt: 16 })
      ] }),
      /* @__PURE__ */ A(le.Footer, { children: /* @__PURE__ */ Ie(Cd, { position: "apart", w: "100%", children: [
        /* @__PURE__ */ A(bd, { ref: a, label: o("이 공지를 그만 볼래요"), styles: (u) => ({
          label: {
            color: u.colors.gray[6]
          }
        }) }),
        /* @__PURE__ */ A(al, { variant: "default", onClick: s, children: o("닫기") })
      ] }) })
    ] })
  ] });
}
function rv() {
  var S, T;
  const {
    t
  } = Cn(), {
    trackEvent: e
  } = cl(), {
    register: r,
    setFocus: n,
    handleSubmit: i,
    control: o,
    formState: {
      errors: a,
      isValid: s
    }
  } = Jd({
    mode: "onChange",
    defaultValues: {
      email: "",
      password: ""
    }
  }), {
    isLoading: u,
    isError: c,
    error: l,
    mutate: f,
    reset: p
  } = Dd({
    url: Ld.CLIENT_V2_AUTH_SIGNIN,
    options: {
      useErrorBoundary: !1,
      onSuccess: () => {
        nt() && (window.location.href = encodeURI(`${tr.SIGN_IN}?referUrl=${window.location.href}`));
      }
    }
  }), [d, C] = Zd({
    name: ["email", "password"],
    control: o
  });
  return De(() => {
    e(er.VIEW_SIGNIN_MODAL);
  }, []), De(() => {
    n("email");
  }, [n]), De(() => {
    p();
  }, [d, C]), // eslint-disable-next-line @typescript-eslint/no-misused-promises
  /* @__PURE__ */ Ie("form", { onSubmit: i((N, U) => {
    U == null || U.preventDefault(), s && nt() && f({
      email: N.email,
      password: N.password
    });
  }), noValidate: !0, children: [
    /* @__PURE__ */ A(Xa, { children: /* @__PURE__ */ A("label", { htmlFor: "email", children: t("이메일") }) }),
    /* @__PURE__ */ A(Td, { mb: 12, size: "md", id: "email", type: "email", placeholder: t("이메일"), disabled: u, error: (S = a.email) == null ? void 0 : S.message, ...r("email", {
      required: t("이메일을 입력해주세요.")
    }) }),
    /* @__PURE__ */ A(Xa, { children: /* @__PURE__ */ A("label", { htmlFor: "password", children: t("비밀번호") }) }),
    /* @__PURE__ */ A(wd, { mb: 12, size: "md", id: "password", placeholder: t("비밀번호"), disabled: u, error: (T = a.password) == null ? void 0 : T.message, ...r("password", {
      required: t("비밀번호를 입력해주세요.")
    }) }),
    c && /* @__PURE__ */ A(eo, { size: "sm", color: "red.6", children: l instanceof zd ? t(iv(l)) : t("문제가 발생했습니다.") }),
    /* @__PURE__ */ A(al, { mt: 18, fullWidth: !0, variant: "filled", size: "md", type: "submit", loading: u, onClick: () => e(er.CLICK_SIGNIN_AT_SIGNIN, {
      spot: "modal"
    }), children: t("로그인") })
  ] });
}
const nv = {
  EMAIL_NOT_FOUND: "SIGNIN_001",
  BLOCKED_ACCOUNT: "SIGNIN_002",
  INVALID_PASSWORD: "SIGNIN_003",
  EMAIL_VERIFICATION_REQUIRED: "SIGNIN_004"
}, iv = (t) => t.errorCode === nv.EMAIL_VERIFICATION_REQUIRED ? "가입 이메일 인증이 필요합니다." : "이메일 또는 비밀번호를 확인해주세요.";
function ov({
  type: t = "inflearn",
  fill: e,
  size: r = 100,
  className: n
}) {
  return t === "inflearn" ? /* @__PURE__ */ A(Nd, { w: r * 2 + 1, css: /* @__PURE__ */ Yd({
    width: r
  }, process.env.NODE_ENV === "production" ? "" : ";label:BrandLogo;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"), className: n, src: `${$d}/assets/brand/brand_logo.png`, alt: "Inflearn brand logo image" }) : t === "inflearn-circle" ? /* @__PURE__ */ A(sv, { size: r, className: n, fill: e }) : /* @__PURE__ */ A(av, { size: r, className: n, fill: e });
}
function av({
  size: t,
  className: e,
  fill: r
}) {
  return /* @__PURE__ */ Ie("svg", { fill: "none", width: t, height: t, className: e, viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": !0, children: [
    /* @__PURE__ */ A("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 10.7626C3 7.3177 5.76662 4.52502 9.17943 4.52502H12.7955V7.11248H9.17943C7.1823 7.11248 5.56332 8.74672 5.56332 10.7626C5.56332 12.7786 7.1823 14.4128 9.17943 14.4128C11.1765 14.4128 12.7955 12.7786 12.7955 10.7626V7.11248H15.3589V10.7626C15.3589 14.2076 12.5922 17.0003 9.17943 17.0003C5.76662 17.0003 3 14.2076 3 10.7626Z", fill: r || "#21252A" }),
    /* @__PURE__ */ A("path", { d: "M15.4272 5.91089C16.2235 5.91089 16.8691 5.25927 16.8691 4.45545C16.8691 3.65163 16.2235 3 15.4272 3C14.6309 3 13.9854 3.65163 13.9854 4.45545V5.91089H15.4272Z", fill: r || sl.infgreen[6] })
  ] });
}
function sv({
  size: t,
  className: e,
  fill: r
}) {
  return /* @__PURE__ */ A("svg", { fill: "none", width: t, height: t, className: e, viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": !0, children: /* @__PURE__ */ A("path", { d: "M16.4702 7.30208C16.1056 6.46354 15.6135 5.71615 14.9937 5.07813C14.3558 4.4401 13.6267 3.92969 12.7882 3.5651C11.9497 3.20052 11.0383 3 10.0723 3C9.12446 3 8.21308 3.16406 7.35638 3.52865C6.49969 3.89323 5.75236 4.38542 5.09617 5.00521C4.43998 5.64323 3.92961 6.3724 3.56505 7.21094C3.2005 8.04948 3 8.96094 3 9.92708C3 10.875 3.16405 11.7865 3.5286 12.6432C3.89315 13.5 4.38529 14.2474 5.02326 14.9036C5.66122 15.5599 6.40855 16.0703 7.24702 16.4349C8.10371 16.7995 8.99686 17 9.96292 17H16.9988V10.0365C17.017 9.07031 16.8347 8.15885 16.4702 7.30208ZM7.79384 15.1406C7.11943 14.849 6.51792 14.4297 6.00755 13.9193C5.49717 13.3906 5.09617 12.7891 4.80453 12.1146C4.51289 11.4219 4.38529 10.7109 4.38529 9.94531C4.38529 9.16146 4.54934 8.43229 4.84098 7.75781C5.13262 7.08333 5.55186 6.5 6.06223 5.98958C6.59083 5.47917 7.19234 5.09635 7.86676 4.80469C8.5594 4.51302 9.27028 4.38542 10.0358 4.38542C10.8196 4.38542 11.5487 4.54948 12.2231 4.84115C12.8976 5.13281 13.4808 5.53385 13.9912 6.0625C14.5016 6.57292 14.8844 7.17448 15.176 7.84896C15.4676 8.52344 15.5952 9.25261 15.5952 10.0365V14.7396L10.5644 9.65365L11.6763 6.59115C11.8039 6.26302 11.6216 5.89844 11.2935 5.77083C10.9654 5.64323 10.6009 5.82552 10.4733 6.15365L9.58015 8.63281L8.01258 7.04688C7.75739 6.79167 7.35638 6.79167 7.11943 7.04688C6.86424 7.30208 6.86424 7.70313 7.11943 7.9401L10.9472 11.8594H8.17662C7.8303 11.8594 7.53866 12.151 7.53866 12.4974C7.53866 12.8438 7.8303 13.1354 8.17662 13.1354H12.1502C12.1685 13.1354 12.1867 13.1354 12.1867 13.1354L14.6656 15.6146H9.96292C9.17914 15.5964 8.48649 15.4505 7.79384 15.1406Z", fill: r || sl.infgreen[6] }) });
}
const uv = (t) => kd.find((r) => t.startsWith(`/${r}`)) || ll;
bn.extend(Qd);
bn.extend(Kd);
bn.locale(to.language ?? ll);
function cv({
  children: t
}) {
  return De(function() {
    if (!nt())
      return;
    const r = uv(window.location.pathname);
    bn.locale(r), to.changeLanguage(r);
  }, []), /* @__PURE__ */ A(qd, { i18n: to, children: t });
}
var fl = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = "fas", r = "comment", n = 512, i = 512, o = [128489, 61669], a = "f075", s = "M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z";
  t.definition = {
    prefix: e,
    iconName: r,
    icon: [
      n,
      i,
      o,
      a,
      s
    ]
  }, t.faComment = t.definition, t.prefix = e, t.iconName = r, t.width = n, t.height = i, t.ligatures = o, t.unicode = a, t.svgPathData = s, t.aliases = o;
})(fl);
var lv = {
  prefix: "fab",
  iconName: "apple",
  icon: [384, 512, [], "f179", "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"]
}, fv = {
  prefix: "fab",
  iconName: "github",
  icon: [496, 512, [], "f09b", "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"]
}, Or, pv = new Uint8Array(16);
function dv() {
  if (!Or && (Or = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !Or))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Or(pv);
}
const vv = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function hv(t) {
  return typeof t == "string" && vv.test(t);
}
var te = [];
for (var qn = 0; qn < 256; ++qn)
  te.push((qn + 256).toString(16).substr(1));
function gv(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (te[t[e + 0]] + te[t[e + 1]] + te[t[e + 2]] + te[t[e + 3]] + "-" + te[t[e + 4]] + te[t[e + 5]] + "-" + te[t[e + 6]] + te[t[e + 7]] + "-" + te[t[e + 8]] + te[t[e + 9]] + "-" + te[t[e + 10]] + te[t[e + 11]] + te[t[e + 12]] + te[t[e + 13]] + te[t[e + 14]] + te[t[e + 15]]).toLowerCase();
  if (!hv(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
function Pt(t, e, r) {
  t = t || {};
  var n = t.random || (t.rng || dv)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, e) {
    r = r || 0;
    for (var i = 0; i < 16; ++i)
      e[r + i] = n[i];
    return e;
  }
  return gv(n);
}
const pl = "3.7.7", yv = pl, Ut = typeof Buffer == "function", Ja = typeof TextDecoder == "function" ? new TextDecoder() : void 0, Za = typeof TextEncoder == "function" ? new TextEncoder() : void 0, Iv = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", Qt = Array.prototype.slice.call(Iv), Mr = ((t) => {
  let e = {};
  return t.forEach((r, n) => e[r] = n), e;
})(Qt), mv = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/, re = String.fromCharCode.bind(String), Ya = typeof Uint8Array.from == "function" ? Uint8Array.from.bind(Uint8Array) : (t) => new Uint8Array(Array.prototype.slice.call(t, 0)), dl = (t) => t.replace(/=/g, "").replace(/[+\/]/g, (e) => e == "+" ? "-" : "_"), vl = (t) => t.replace(/[^A-Za-z0-9\+\/]/g, ""), hl = (t) => {
  let e, r, n, i, o = "";
  const a = t.length % 3;
  for (let s = 0; s < t.length; ) {
    if ((r = t.charCodeAt(s++)) > 255 || (n = t.charCodeAt(s++)) > 255 || (i = t.charCodeAt(s++)) > 255)
      throw new TypeError("invalid character found");
    e = r << 16 | n << 8 | i, o += Qt[e >> 18 & 63] + Qt[e >> 12 & 63] + Qt[e >> 6 & 63] + Qt[e & 63];
  }
  return a ? o.slice(0, a - 3) + "===".substring(a) : o;
}, jo = typeof btoa == "function" ? (t) => btoa(t) : Ut ? (t) => Buffer.from(t, "binary").toString("base64") : hl, ro = Ut ? (t) => Buffer.from(t).toString("base64") : (t) => {
  let r = [];
  for (let n = 0, i = t.length; n < i; n += 4096)
    r.push(re.apply(null, t.subarray(n, n + 4096)));
  return jo(r.join(""));
}, zr = (t, e = !1) => e ? dl(ro(t)) : ro(t), Av = (t) => {
  if (t.length < 2) {
    var e = t.charCodeAt(0);
    return e < 128 ? t : e < 2048 ? re(192 | e >>> 6) + re(128 | e & 63) : re(224 | e >>> 12 & 15) + re(128 | e >>> 6 & 63) + re(128 | e & 63);
  } else {
    var e = 65536 + (t.charCodeAt(0) - 55296) * 1024 + (t.charCodeAt(1) - 56320);
    return re(240 | e >>> 18 & 7) + re(128 | e >>> 12 & 63) + re(128 | e >>> 6 & 63) + re(128 | e & 63);
  }
}, Ev = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g, gl = (t) => t.replace(Ev, Av), Ka = Ut ? (t) => Buffer.from(t, "utf8").toString("base64") : Za ? (t) => ro(Za.encode(t)) : (t) => jo(gl(t)), Nt = (t, e = !1) => e ? dl(Ka(t)) : Ka(t), Qa = (t) => Nt(t, !0), Cv = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g, bv = (t) => {
  switch (t.length) {
    case 4:
      var e = (7 & t.charCodeAt(0)) << 18 | (63 & t.charCodeAt(1)) << 12 | (63 & t.charCodeAt(2)) << 6 | 63 & t.charCodeAt(3), r = e - 65536;
      return re((r >>> 10) + 55296) + re((r & 1023) + 56320);
    case 3:
      return re((15 & t.charCodeAt(0)) << 12 | (63 & t.charCodeAt(1)) << 6 | 63 & t.charCodeAt(2));
    default:
      return re((31 & t.charCodeAt(0)) << 6 | 63 & t.charCodeAt(1));
  }
}, yl = (t) => t.replace(Cv, bv), Il = (t) => {
  if (t = t.replace(/\s+/g, ""), !mv.test(t))
    throw new TypeError("malformed base64.");
  t += "==".slice(2 - (t.length & 3));
  let e, r = "", n, i;
  for (let o = 0; o < t.length; )
    e = Mr[t.charAt(o++)] << 18 | Mr[t.charAt(o++)] << 12 | (n = Mr[t.charAt(o++)]) << 6 | (i = Mr[t.charAt(o++)]), r += n === 64 ? re(e >> 16 & 255) : i === 64 ? re(e >> 16 & 255, e >> 8 & 255) : re(e >> 16 & 255, e >> 8 & 255, e & 255);
  return r;
}, Ho = typeof atob == "function" ? (t) => atob(vl(t)) : Ut ? (t) => Buffer.from(t, "base64").toString("binary") : Il, ml = Ut ? (t) => Ya(Buffer.from(t, "base64")) : (t) => Ya(Ho(t).split("").map((e) => e.charCodeAt(0))), Al = (t) => ml(El(t)), Tv = Ut ? (t) => Buffer.from(t, "base64").toString("utf8") : Ja ? (t) => Ja.decode(ml(t)) : (t) => yl(Ho(t)), El = (t) => vl(t.replace(/[-_]/g, (e) => e == "-" ? "+" : "/")), no = (t) => Tv(El(t)), wv = (t) => {
  if (typeof t != "string")
    return !1;
  const e = t.replace(/\s+/g, "").replace(/={0,2}$/, "");
  return !/[^\s0-9a-zA-Z\+/]/.test(e) || !/[^\s0-9a-zA-Z\-_]/.test(e);
}, Cl = (t) => ({
  value: t,
  enumerable: !1,
  writable: !0,
  configurable: !0
}), bl = function() {
  const t = (e, r) => Object.defineProperty(String.prototype, e, Cl(r));
  t("fromBase64", function() {
    return no(this);
  }), t("toBase64", function(e) {
    return Nt(this, e);
  }), t("toBase64URI", function() {
    return Nt(this, !0);
  }), t("toBase64URL", function() {
    return Nt(this, !0);
  }), t("toUint8Array", function() {
    return Al(this);
  });
}, Tl = function() {
  const t = (e, r) => Object.defineProperty(Uint8Array.prototype, e, Cl(r));
  t("toBase64", function(e) {
    return zr(this, e);
  }), t("toBase64URI", function() {
    return zr(this, !0);
  }), t("toBase64URL", function() {
    return zr(this, !0);
  });
}, Nv = () => {
  bl(), Tl();
}, Ov = {
  version: pl,
  VERSION: yv,
  atob: Ho,
  atobPolyfill: Il,
  btoa: jo,
  btoaPolyfill: hl,
  fromBase64: no,
  toBase64: Nt,
  encode: Nt,
  encodeURI: Qa,
  encodeURL: Qa,
  utob: gl,
  btou: yl,
  decode: no,
  isValid: wv,
  fromUint8Array: zr,
  toUint8Array: Al,
  extendString: bl,
  extendUint8Array: Tl,
  extendBuiltins: Nv
};
var v = (
  /** @class */
  function() {
    function t() {
    }
    return t.isNotNullOrUndefined = function(e) {
      return e != null;
    }, t.isNullOrUndefined = function(e) {
      return e == null;
    }, t.requiredNotNullOrUndefined = function(e, r) {
      if (r === void 0 && (r = function() {
        return "Required value is null or undefined";
      }), this.isNullOrUndefined(e))
        throw new Error(r());
      return e;
    }, t.fromMap = function(e) {
      var r = {};
      return e.forEach(function(n, i) {
        r[i] = n;
      }), r;
    }, t;
  }()
), x = (
  /** @class */
  function() {
    function t() {
    }
    return t.mapNotNullOrUndefined = function(e, r) {
      for (var n = Array(), i = 0, o = e; i < o.length; i++) {
        var a = o[i], s = r(a);
        v.isNotNullOrUndefined(s) && n.push(s);
      }
      return n;
    }, t.mapOrUndefined = function(e, r) {
      for (var n = Array(), i = 0, o = e; i < o.length; i++) {
        var a = o[i], s = r(a);
        if (v.isNullOrUndefined(s))
          return;
        n.push(s);
      }
      return n;
    }, t.associateTo = function(e, r, n) {
      for (var i = 0, o = e; i < o.length; i++) {
        var a = o[i], s = n(a);
        r.set(s[0], s[1]);
      }
      return r;
    }, t.associate = function(e, r) {
      return this.associateTo(e, /* @__PURE__ */ new Map(), r);
    }, t.associateBy = function(e, r) {
      return this.associate(e, function(n) {
        return [r(n), n];
      });
    }, t.chunked = function(e, r) {
      for (var n = [], i = e.slice(); i.length; )
        n.push(i.splice(0, r));
      return n;
    }, t;
  }()
), Me = {
  DISABLE: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  DEBUG: 4
}, O = (
  /** @class */
  function() {
    function t() {
    }
    return t.setLogLevel = function(e) {
      e === void 0 && (e = Me.INFO), this.logLevel = e;
    }, t.initCounter = function(e) {
      this.counters = x.associate(Object.keys(Me), function(r) {
        return [r, e(r)];
      });
    }, t._log = function(e, r) {
      var n;
      switch (e) {
        case "WARN":
          n = "orange";
          break;
        case "ERROR":
          n = "red";
          break;
        default:
          n = "#AAAAAA";
      }
      if (r instanceof Error) {
        qa.log(e, n, r.message, r);
        return;
      }
      try {
        qa.log(e, n, r);
      } catch {
      }
    }, t.increment = function(e) {
      var r, n;
      (n = (r = t.counters) === null || r === void 0 ? void 0 : r.get(e)) === null || n === void 0 || n.increment();
    }, t.logLevel = Me.INFO, t.log = {
      error: function(e) {
        t.logLevel >= Me.ERROR && (t._log("ERROR", e), t.increment("ERROR"));
      },
      warn: function(e) {
        t.logLevel >= Me.WARN && (t._log("WARN", e), t.increment("WARN"));
      },
      info: function(e) {
        t.logLevel >= Me.INFO && (t._log("INFO", e), t.increment("INFO"));
      },
      debug: function(e) {
        t.logLevel >= Me.DEBUG && (t._log("DEBUG", e), t.increment("DEBUG"));
      }
    }, t;
  }()
), qa = (
  /** @class */
  function() {
    function t() {
    }
    return t.log = function(e, r, n, i) {
      try {
        console.log("%c[".concat(e, "] Hackle: ").concat(n), "color: ".concat(r));
      } catch {
      }
    }, t;
  }()
), io = function(t, e) {
  return io = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, io(t, e);
};
function Y(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  io(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var b = function() {
  return b = Object.assign || function(e) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, b.apply(this, arguments);
};
function Mv(t, e) {
  var r = {};
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(t); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[i]) && (r[n[i]] = t[n[i]]);
  return r;
}
function M(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(s, u);
    }
    c((n = n.apply(t, e || [])).next());
  });
}
function _(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; r; )
      try {
        if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done)
          return o;
        switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
          case 0:
          case 1:
            o = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, i = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < o[1]) {
              r.label = o[1], o = c;
              break;
            }
            if (o && r.label < o[2]) {
              r.label = o[2], r.ops.push(c);
              break;
            }
            o[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = e.call(t, r);
      } catch (l) {
        c = [6, l], i = 0;
      } finally {
        n = o = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function ei(t, e, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = e.length, o; n < i; n++)
      (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}
var es = O.log, fe = (
  /** @class */
  function() {
    function t() {
    }
    return t.isEqual = function(e, r) {
      return e.type === r.type && e.value === r.value;
    }, t.isEquals = function(e, r) {
      if (r == null)
        return !1;
      var n = Object.keys(e);
      return n.length !== Object.keys(r).length ? !1 : n.every(function(i) {
        return e[i] === r[i];
      });
    }, t.sanitize = function(e) {
      var r = {};
      if (v.isNullOrUndefined(e))
        return r;
      for (var n = 0, i = Object.entries(e); n < i.length; n++) {
        var o = i[n], a = o[0], s = o[1];
        if (!this.isValidType(a)) {
          es.debug("Invalid identifier type. The identifier type must be a string of 128 characters or less. [".concat(a, "]"));
          continue;
        }
        var u = this.sanitizeValue(s);
        if (v.isNullOrUndefined(u)) {
          es.debug("Invalid identifier value. The identifier type value be a string of 512 characters or less. [".concat(a, "]"));
          continue;
        }
        r[a] = u;
      }
      return r;
    }, t.isValidType = function(e) {
      return v.isNullOrUndefined(e) ? !1 : typeof e == "string" && e.length > 0 && e.length <= this.MAX_IDENTIFIER_TYPE_LENGTH;
    }, t.sanitizeValue = function(e) {
      return typeof e == "string" && e.length > 0 && e.length <= this.MAX_IDENTIFIER_VALUE_LENGTH ? e : typeof e == "number" ? e.toString() : null;
    }, t.MAX_IDENTIFIER_TYPE_LENGTH = 128, t.MAX_IDENTIFIER_VALUE_LENGTH = 512, t;
  }()
), ti = O.log, de = (
  /** @class */
  function() {
    function t() {
    }
    return t.sanitize = function(e) {
      var r = {};
      if (v.isNullOrUndefined(e))
        return r;
      for (var n = 0, i = Object.entries(e); n < i.length; n++) {
        var o = i[n], a = o[0], s = o[1];
        if (Object.keys(r).length >= this.MAX_PROPERTIES_COUNT) {
          ti.debug("The number of properties cannot exceed 128. Drops excess properties. [".concat(a, ", ").concat(s, "]"));
          break;
        }
        if (!this.isValidKey(a)) {
          ti.debug("Invalid property key. The property key must be a string of 128 characters or less. [".concat(a, "]"));
          continue;
        }
        var u = this.sanitizeValue(a, s);
        if (v.isNullOrUndefined(u)) {
          ti.debug("Invalid property value. The property value mus be 'string(..1024)', 'number', 'boolean', or 'array' type. [".concat(s, "]"));
          continue;
        }
        r[a] = u;
      }
      return r;
    }, t.isValidProperty = function(e, r) {
      return this.isValidKey(e) && this.isValidValue(r);
    }, t.isValidKey = function(e) {
      return v.isNotNullOrUndefined(e) && typeof e == "string" && e.length > 0 && e.length <= this.MAX_PROPERTY_KEY_LENGTH;
    }, t.sanitizeValue = function(e, r) {
      var n = this;
      return typeof e == "string" && e.startsWith(this.SYSTEM_PROPERTY_KEY_PREFIX) ? r : this.isValidValue(r) ? Array.isArray(r) ? r.filter(function(i) {
        return n.isValidElement(i);
      }) : r : null;
    }, t.isValidValue = function(e) {
      return v.isNullOrUndefined(e) ? !1 : typeof e == "string" ? e.length <= this.MAX_PROPERTY_VALUE_LENGTH : typeof e == "number" ? !isNaN(e) && isFinite(e) : typeof e == "boolean" || Array.isArray(e);
    }, t.isValidElement = function(e) {
      return v.isNullOrUndefined(e) ? !1 : typeof e == "string" ? e.length > 0 && e.length <= this.MAX_PROPERTY_VALUE_LENGTH : typeof e == "number";
    }, t.truncateStringValue = function(e) {
      return typeof e == "string" && e.length > this.MAX_PROPERTY_VALUE_LENGTH ? e.slice(0, this.MAX_PROPERTY_VALUE_LENGTH) : e;
    }, t.SYSTEM_PROPERTY_KEY_PREFIX = "$", t.MAX_PROPERTIES_COUNT = 128, t.MAX_PROPERTY_KEY_LENGTH = 128, t.MAX_PROPERTY_VALUE_LENGTH = 1024, t;
  }()
), _v = ["nanoseconds", "microseconds", "milliseconds", "seconds", "minutes", "hours", "days"], Jr = (
  /** @class */
  function() {
    function t() {
    }
    return t.nanosToUnit = function(e, r) {
      switch (r) {
        case "nanoseconds":
          return e;
        case "microseconds":
          return e / (t.C1 / t.C0);
        case "milliseconds":
          return e / (t.C2 / t.C0);
        case "seconds":
          return e / (t.C3 / t.C0);
        case "minutes":
          return e / (t.C4 / t.C0);
        case "hours":
          return e / (t.C5 / t.C0);
        case "days":
          return e / (t.C6 / t.C0);
      }
    }, t.microsToUnit = function(e, r) {
      switch (r) {
        case "nanoseconds":
          return e * (t.C1 / t.C0);
        case "milliseconds":
          return e / (t.C2 / t.C1);
        case "microseconds":
          return e;
        case "seconds":
          return e / (t.C3 / t.C1);
        case "minutes":
          return e / (t.C4 / t.C1);
        case "hours":
          return e / (t.C5 / t.C1);
        case "days":
          return e / (t.C6 / t.C1);
      }
    }, t.millisToUnit = function(e, r) {
      switch (r) {
        case "nanoseconds":
          return e * (t.C2 / t.C0);
        case "microseconds":
          return e * (t.C2 / t.C1);
        case "milliseconds":
          return e;
        case "seconds":
          return e / (t.C3 / t.C2);
        case "minutes":
          return e / (t.C4 / t.C2);
        case "hours":
          return e / (t.C5 / t.C2);
        case "days":
          return e / (t.C6 / t.C2);
      }
    }, t.secondsToUnit = function(e, r) {
      switch (r) {
        case "nanoseconds":
          return e * (t.C3 / t.C0);
        case "microseconds":
          return e * (t.C3 / t.C1);
        case "milliseconds":
          return e * (t.C3 / t.C2);
        case "seconds":
          return e;
        case "minutes":
          return e / (t.C4 / t.C3);
        case "hours":
          return e / (t.C5 / t.C3);
        case "days":
          return e / (t.C6 / t.C3);
      }
    }, t.minutesToUnit = function(e, r) {
      switch (r) {
        case "nanoseconds":
          return e * (t.C4 / t.C0);
        case "microseconds":
          return e * (t.C4 / t.C1);
        case "milliseconds":
          return e * (t.C4 / t.C2);
        case "seconds":
          return e * (t.C4 / t.C3);
        case "minutes":
          return e;
        case "hours":
          return e / (t.C5 / t.C4);
        case "days":
          return e / (t.C6 / t.C4);
      }
    }, t.hoursToUnit = function(e, r) {
      switch (r) {
        case "nanoseconds":
          return e * (t.C5 / t.C0);
        case "microseconds":
          return e * (t.C5 / t.C1);
        case "milliseconds":
          return e * (t.C5 / t.C2);
        case "seconds":
          return e * (t.C5 / t.C3);
        case "minutes":
          return e * (t.C5 / t.C4);
        case "hours":
          return e;
        case "days":
          return e / (t.C6 / t.C5);
      }
    }, t.daysToUnit = function(e, r) {
      switch (r) {
        case "nanoseconds":
          return e * (t.C6 / t.C0);
        case "microseconds":
          return e * (t.C6 / t.C1);
        case "milliseconds":
          return e * (t.C6 / t.C2);
        case "seconds":
          return e * (t.C6 / t.C3);
        case "minutes":
          return e * (t.C6 / t.C4);
        case "hours":
          return e * (t.C6 / t.C5);
        case "days":
          return e;
      }
    }, t.C0 = 1, t.C1 = t.C0 * 1e3, t.C2 = t.C1 * 1e3, t.C3 = t.C2 * 1e3, t.C4 = t.C3 * 60, t.C5 = t.C4 * 60, t.C6 = t.C5 * 24, t.converter = {
      nanoseconds: t.nanosToUnit,
      microseconds: t.microsToUnit,
      milliseconds: t.millisToUnit,
      seconds: t.secondsToUnit,
      minutes: t.minutesToUnit,
      hours: t.hoursToUnit,
      days: t.daysToUnit
    }, t;
  }()
), be = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.tick = function() {
      return Date.now() * 1e3;
    }, t.prototype.currentMillis = function() {
      return Date.now();
    }, t.instance = new t(), t;
  }()
), ur = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.get = function(e, r) {
      return r;
    }, t;
  }()
), oo = (
  /** @class */
  function() {
    function t(e) {
      this.parameters = e;
    }
    return t.prototype.get = function(e, r) {
      var n = this.parameters.get(e);
      return v.isNullOrUndefined(n) ? r : v.isNullOrUndefined(r) || typeof n == typeof r ? n : r;
    }, t;
  }()
), Sv = "https://client-sdk.hackle.io", Rv = "https://event.hackle.io", xv = "https://monitoring.hackle.io", Pv = "https://static.hackle.io", wl = "X-HACKLE-SDK-KEY", Nl = "X-HACKLE-SDK-NAME", Ol = "X-HACKLE-SDK-VERSION", Ml = "X-HACKLE-SDK-TIME", Uv = "11.37.1", Dv = 3e4, ao = 100, Lv = 1e3 * 60, $v = 500, ts = 3e3, _l = 365 * 10, Xo = "_hackle_hid", Sl = "_hackle_id", kv = "hackle-repository-storage", Fv = 1e3 * 60 * 30, rs = "_hackle_session_id", ns = "_hackle_last_event_ts", Ot = -1, Zr = 1e3 * 60, Gv = -1, is = "_hackle_uid", os = "_hackle_did", as = "_hackle_mkt", Vv = "hackle-manual-override_ab", Bv = "hackle-manual-override_ff", jv = "hackle-iam-hide", Hv = "hackle-iam-impression", Xv = "0.0.8", Wv = "hackle-split-url-redirected", zv = 3 * (1 / (60 * 60 * 24)), ri = "hackle-workspace-config", Jv = 1e3 * 60, Zv = 1e3, Rl = 24 * 60 * 60 * 1e3, Wo = O.log;
function Q(t, e) {
  var r = t.find(function(n) {
    return n === e || n.toLowerCase() === e.toLowerCase();
  });
  return r || Wo.debug("Unsupported type [".concat(e, "]. Please use the latest version of sdk.")), r;
}
function ss(t, e) {
  if (!v.isNullOrUndefined(e)) {
    for (var r = new Array(), n = 0, i = e; n < i.length; n++) {
      var o = i[n], a = Q(t, o);
      if (v.isNullOrUndefined(a))
        return;
      r.push(a);
    }
    return r;
  }
}
var rr = (
  /** @class */
  function() {
    function t(e, r) {
      this.value = e, this.reason = r;
    }
    return t.of = function(e, r) {
      return new t(e, r);
    }, t;
  }()
), _r = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.inAppMessage = e, this.message = r, this.reason = n, this.properties = i;
    }
    return t.prototype.isShow = function() {
      return v.isNotNullOrUndefined(this.inAppMessage) && v.isNotNullOrUndefined(this.message);
    }, t.of = function(e, r, n, i) {
      return i === void 0 && (i = {}), new t(r, n, e, i);
    }, t;
  }()
), et = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.variation = e, this.reason = r, this.config = n, this.experiment = i;
    }
    return t.of = function(e, r, n, i) {
      return n === void 0 && (n = new ur()), i === void 0 && (i = void 0), new t(e, r, n, i);
    }, t.prototype.get = function(e, r) {
      switch (typeof r) {
        case "string":
          return this.config.get(e, r);
        case "number":
          return this.config.get(e, r);
        case "boolean":
          return this.config.get(e, r);
        default:
          return this.config.get(e, r);
      }
    }, t;
  }()
), je = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.isOn = e, this.reason = r, this.config = n, this.experiment = i;
    }
    return t.on = function(e, r, n) {
      return r === void 0 && (r = new ur()), n === void 0 && (n = void 0), new t(!0, e, r, n);
    }, t.off = function(e, r, n) {
      return r === void 0 && (r = new ur()), n === void 0 && (n = void 0), new t(!1, e, r, n);
    }, t.prototype.get = function(e, r) {
      switch (typeof r) {
        case "string":
          return this.config.get(e, r);
        case "number":
          return this.config.get(e, r);
        case "boolean":
          return this.config.get(e, r);
        default:
          return this.config.get(e, r);
      }
    }, t;
  }()
), Yv = (
  /** @class */
  function() {
    function t(e, r) {
      this.id = e, this.config = r;
    }
    return t.fromJson = function(e) {
      return new t(e.id, new oo(x.associate(e.parameters, function(r) {
        return [r.key, r.value];
      })));
    }, t.prototype.get = function(e, r) {
      switch (typeof r) {
        case "string":
          return this.config.get(e, r);
        case "number":
          return this.config.get(e, r);
        case "boolean":
          return this.config.get(e, r);
        default:
          return r;
      }
    }, t;
  }()
), w = (
  /** @class */
  function() {
    function t() {
    }
    return t.SDK_NOT_READY = "SDK_NOT_READY", t.EXCEPTION = "EXCEPTION", t.INVALID_INPUT = "INVALID_INPUT", t.UNSUPPORTED_PLATFORM = "UNSUPPORTED_PLATFORM", t.TYPE_MISMATCH = "TYPE_MISMATCH", t.EXPERIMENT_NOT_FOUND = "EXPERIMENT_NOT_FOUND", t.EXPERIMENT_DRAFT = "EXPERIMENT_DRAFT", t.EXPERIMENT_PAUSED = "EXPERIMENT_PAUSED", t.EXPERIMENT_COMPLETED = "EXPERIMENT_COMPLETED", t.OVERRIDDEN = "OVERRIDDEN", t.TRAFFIC_NOT_ALLOCATED = "TRAFFIC_NOT_ALLOCATED", t.NOT_IN_MUTUAL_EXCLUSION_EXPERIMENT = "NOT_IN_MUTUAL_EXCLUSION_EXPERIMENT", t.IDENTIFIER_NOT_FOUND = "IDENTIFIER_NOT_FOUND", t.VARIATION_DROPPED = "VARIATION_DROPPED", t.TRAFFIC_ALLOCATED = "TRAFFIC_ALLOCATED", t.TRAFFIC_ALLOCATED_BY_TARGETING = "TRAFFIC_ALLOCATED_BY_TARGETING", t.NOT_IN_EXPERIMENT_TARGET = "NOT_IN_EXPERIMENT_TARGET", t.FEATURE_FLAG_NOT_FOUND = "FEATURE_FLAG_NOT_FOUND", t.FEATURE_FLAG_INACTIVE = "FEATURE_FLAG_INACTIVE", t.INDIVIDUAL_TARGET_MATCH = "INDIVIDUAL_TARGET_MATCH", t.TARGET_RULE_MATCH = "TARGET_RULE_MATCH", t.DEFAULT_RULE = "DEFAULT_RULE", t.REMOTE_CONFIG_PARAMETER_NOT_FOUND = "REMOTE_CONFIG_PARAMETER_NOT_FOUND", t.IN_APP_MESSAGE_NOT_FOUND = "IN_APP_MESSAGE_NOT_FOUND", t.IN_APP_MESSAGE_DRAFT = "IN_APP_MESSAGE_DRAFT", t.IN_APP_MESSAGE_PAUSED = "IN_APP_MESSAGE_PAUSED", t.IN_APP_MESSAGE_HIDDEN = "IN_APP_MESSAGE_HIDDEN", t.IN_APP_MESSAGE_TARGET = "IN_APP_MESSAGE_TARGET", t.NOT_IN_IN_APP_MESSAGE_PERIOD = "NOT_IN_IN_APP_MESSAGE_PERIOD", t.NOT_IN_IN_APP_MESSAGE_TARGET = "NOT_IN_IN_APP_MESSAGE_TARGET", t;
  }()
), Kv = ["DEFAULT", "SPLIT_URL", "IN_APP_MESSAGE"], ni = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s, u, c, l, f, p, d, C, R, S, T) {
      this.id = e, this.key = r, this.type = n, this.identifierType = i, this.status = o, this.version = a, this.executionVersion = s, this.variations = u, this.userOverrides = c, this.segmentOverrides = l, this.targetAudiences = f, this.splitUrlTargets = p, this.targetRules = d, this.defaultRule = C, this.containerId = R, this.implementationType = S, this.winnerVariationId = T;
    }
    return t.fromJson = function(e, r) {
      var n = t.experimentStatusOrNull(r.execution.status), i = r.variations.map(function(p) {
        return new Qv(p.id, p.key, p.status === "DROPPED", p.parameterConfigurationId);
      }), o = x.associate(r.execution.userOverrides, function(p) {
        return [p.userId, p.variationId];
      }), a = x.mapNotNullOrUndefined(r.execution.segmentOverrides, function(p) {
        return us.fromJson(p, Le.IDENTIFIER);
      }), s = x.mapNotNullOrUndefined(r.execution.targetAudiences, function(p) {
        return We.fromJson(p, Le.PROPERTY);
      }), u = zh.fromJson(r.execution.targetUrls), c = Q(Kv, r.implementationType), l = x.mapNotNullOrUndefined(r.execution.targetRules, function(p) {
        return us.fromJson(p, Le.PROPERTY);
      }), f = Pl.fromJson(r.execution.defaultRule);
      return n && c && f && new t(r.id, r.key, e, r.identifierType, n, r.version, r.execution.version, i, o, a, s, u, l, f, r.containerId, c, r.winnerVariationId);
    }, t.experimentStatusOrNull = function(e) {
      switch (e) {
        case "READY":
          return "DRAFT";
        case "RUNNING":
          return "RUNNING";
        case "PAUSED":
          return "PAUSED";
        case "STOPPED":
          return "COMPLETED";
        default:
          Wo.debug("Unsupported status [".concat(e, "]"));
          return;
      }
    }, t.prototype._winnerVariationOrNull = function() {
      if (this.winnerVariationId)
        return this._getVariationByIdOrNull(this.winnerVariationId);
    }, t.prototype._getVariationByIdOrNull = function(e) {
      return this.variations.find(function(r) {
        return r.id === e;
      });
    }, t.prototype._getVariationByKeyOrNull = function(e) {
      return this.variations.find(function(r) {
        return r.key === e;
      });
    }, t;
  }()
), Qv = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.id = e, this.key = r, this.isDropped = n, this.parameterConfigurationId = i;
    }
    return t;
  }()
), qv = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.id = e, this.seed = r, this.slotSize = n, this.slots = i;
    }
    return t.fromJson = function(e) {
      return new t(e.id, e.seed, e.slotSize, e.slots.map(function(r) {
        var n = r.startInclusive, i = r.endExclusive, o = r.variationId;
        return new eh(n, i, o);
      }));
    }, t;
  }()
), eh = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.startInclusive = e, this.endExclusive = r, this.variationId = n;
    }
    return t.prototype.contains = function(e) {
      return this.startInclusive <= e && e < this.endExclusive;
    }, t;
  }()
), xl = (
  /** @class */
  function() {
    function t(e, r) {
      this.id = e, this.key = r;
    }
    return t.fromJson = function(e) {
      return new t(e.id, e.key);
    }, t;
  }()
), Ee = (
  /** @class */
  function() {
    function t() {
    }
    return t.ID = "$id", t.USER = "$userId", t.DEVICE = "$deviceId", t.SESSION = "$sessionId", t.HACKLE_DEVICE = "$hackleDeviceId", t;
  }()
), sn = function(t) {
  var e = new zo();
  return e.addIdentifiers(t.identifiers || {}), e.add(Ee.ID, t.id), e.add(Ee.DEVICE, t.deviceId), v.isNotNullOrUndefined(t.userId) && e.add(Ee.USER, t.userId), e.build();
}, zo = (
  /** @class */
  function() {
    function t() {
      this.identifiers = {};
    }
    return t.prototype.addIdentifiers = function(e) {
      for (var r in e)
        this.add(r, e[r]);
      return this;
    }, t.prototype.add = function(e, r) {
      var n = fe.sanitizeValue(r);
      return fe.isValidType(e) && n ? this.identifiers[e] = r : Wo.warn("Invalid user identifier [type=".concat(e, ", value=").concat(r, "]")), this;
    }, t.prototype.build = function() {
      return this.identifiers;
    }, t;
  }()
), th = function(t) {
  return !!(t.id || t.userId || t.deviceId || t.identifiers && Object.keys(t.identifiers).length > 0);
}, Yr = function(t) {
  var e, r, n, i = {};
  return i.id = (e = fe.sanitizeValue(t.id)) !== null && e !== void 0 ? e : void 0, i.userId = (r = fe.sanitizeValue(t.userId)) !== null && r !== void 0 ? r : void 0, i.deviceId = (n = fe.sanitizeValue(t.deviceId)) !== null && n !== void 0 ? n : void 0, typeof t.properties == "object" && (i.properties = de.sanitize(t.properties)), typeof t.identifiers == "object" && (i.identifiers = fe.sanitize(t.identifiers)), th(i) ? i : null;
}, We = (
  /** @class */
  function() {
    function t(e) {
      this.conditions = e;
    }
    return t.fromJson = function(e, r) {
      var n = x.mapNotNullOrUndefined(e.conditions, function(i) {
        return rh.fromJson(i, r);
      });
      return new t(n);
    }, t.prototype.toJson = function() {
      return {
        conditions: this.conditions.map(function(e) {
          return e.toJson();
        })
      };
    }, t;
  }()
), rh = (
  /** @class */
  function() {
    function t(e, r) {
      this.key = e, this.match = r;
    }
    return t.fromJson = function(e, r) {
      var n = nh.fromJson(e.key);
      if (n && r.supports(n.type)) {
        var i = ih.fromJson(e.match);
        return i && new t(n, i);
      }
    }, t.prototype.toJson = function() {
      return {
        key: this.key.toJson(),
        match: this.match.toJson()
      };
    }, t;
  }()
), nh = (
  /** @class */
  function() {
    function t(e, r) {
      this.type = e, this.name = r;
    }
    return t.fromJson = function(e) {
      var r = Q(vh, e.type);
      return r && new t(r, e.name);
    }, t.prototype.toJson = function() {
      return {
        type: this.type,
        name: this.name
      };
    }, t;
  }()
), ih = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.type = e, this.operator = r, this.valueType = n, this.values = i;
    }
    return t.fromJson = function(e) {
      var r = Q(fh, e.type), n = Q(ph, e.operator), i = Q(Dl, e.valueType);
      return r && n && i && new t(r, n, i, e.values);
    }, t.prototype.toJson = function() {
      return {
        operator: this.operator,
        type: this.type,
        valueType: this.valueType,
        values: this.values
      };
    }, t;
  }()
), Pl = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.type = e, this.variationId = r, this.bucketId = n;
    }
    return t.fromJson = function(e) {
      var r = Q(dh, e.type);
      return r && new t(r, e.variationId, e.bucketId);
    }, t;
  }()
), us = (
  /** @class */
  function() {
    function t(e, r) {
      this.target = e, this.action = r;
    }
    return t.fromJson = function(e, r) {
      var n = We.fromJson(e.target, r), i = Pl.fromJson(e.action);
      return n && i && new t(n, i);
    }, t;
  }()
), oh = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.id = e, this.key = r, this.type = n, this.targets = i;
    }
    return t.fromJson = function(e) {
      var r = Q(hh, e.type);
      return r && new t(e.id, e.key, r, x.mapNotNullOrUndefined(e.targets, function(n) {
        return We.fromJson(n, Le.SEGMENT);
      }));
    }, t;
  }()
), ah = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.id = e, this.bucketId = r, this.groups = n;
    }
    return t.fromJson = function(e) {
      return new t(e.id, e.bucketId, e.groups.map(function(r) {
        return sh.fromJson(r);
      }));
    }, t.prototype.getGroupOrNull = function(e) {
      return this.groups.find(function(r) {
        return r.id === e;
      });
    }, t;
  }()
), sh = (
  /** @class */
  function() {
    function t(e, r) {
      this.id = e, this.experiments = r;
    }
    return t.fromJson = function(e) {
      return new t(e.id, e.experiments);
    }, t;
  }()
), uh = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a) {
      this.id = e, this.key = r, this.type = n, this.identifierType = i, this.targetRules = o, this.defaultValue = a;
    }
    return t.fromJson = function(e) {
      var r = Q(Dl, e.type), n = x.mapNotNullOrUndefined(e.targetRules, function(o) {
        return ch.fromJson(o, Le.PROPERTY);
      }), i = Ul.fromJson(e.defaultValue);
      return r && new t(e.id, e.key, r, e.identifierType, n, i);
    }, t;
  }()
), ch = (
  /** @class */
  function() {
    function t(e, r, n, i, o) {
      this.key = e, this.name = r, this.target = n, this.bucketId = i, this.value = o;
    }
    return t.fromJson = function(e, r) {
      var n = We.fromJson(e.target, r);
      return n && new t(e.key, e.name, n, e.bucketId, Ul.fromJson(e.value));
    }, t;
  }()
), Ul = (
  /** @class */
  function() {
    function t(e, r) {
      this.id = e, this.rawValue = r;
    }
    return t.fromJson = function(e) {
      return new t(e.id, e.value);
    }, t;
  }()
);
function nr(t, e) {
  return t - e;
}
var cs = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.coreVersion = e, this.prerelease = r, this.build = n;
    }
    return t.tryParse = function(e) {
      var r = t.regExp.exec(e);
      if (r) {
        r[0];
        var n = r[1], i = r[2], o = i === void 0 ? "0" : i, a = r[3], s = a === void 0 ? "0" : a, u = r[4], c = r[5], l = new lh(parseInt(n, 10), parseInt(o, 10), parseInt(s, 10));
        return new t(l, ls.parse(u), ls.parse(c));
      }
    }, t.prototype.compareTo = function(e) {
      return this.coreVersion.compareTo(e.coreVersion) || this.prerelease.compareTo(e.prerelease);
    }, t.prototype.isEqualTo = function(e) {
      return this.compareTo(e) === 0;
    }, t.prototype.isGreaterThan = function(e) {
      return this.compareTo(e) > 0;
    }, t.prototype.isGreaterThanOrEqualTo = function(e) {
      return this.compareTo(e) >= 0;
    }, t.prototype.isLessThan = function(e) {
      return this.compareTo(e) < 0;
    }, t.prototype.isLessThanOrEqualTo = function(e) {
      return this.compareTo(e) <= 0;
    }, t.regExp = /^(0|[1-9]\d*)(?:\.(0|[1-9]\d*))?(?:\.(0|[1-9]\d*))?(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/, t;
  }()
), lh = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.major = e, this.minor = r, this.patch = n;
    }
    return t.prototype.compareTo = function(e) {
      return nr(this.major, e.major) || nr(this.minor, e.minor) || nr(this.patch, e.patch);
    }, t;
  }()
), ls = (
  /** @class */
  function() {
    function t(e) {
      this.identifiers = e;
    }
    return t.parse = function(e) {
      return e ? new t(e.split(".")) : t.EMPTY;
    }, t.prototype.isEmpty = function() {
      return this.identifiers.length === 0;
    }, t.prototype.isNotEmpty = function() {
      return !this.isEmpty();
    }, t.prototype.compareTo = function(e) {
      return this.isEmpty() && e.isEmpty() ? 0 : this.isEmpty() && e.isNotEmpty() ? 1 : this.isNotEmpty() && e.isEmpty() ? -1 : this.compareIdentifiers(e);
    }, t.prototype.compareIdentifiers = function(e) {
      for (var r = Math.min(this.identifiers.length, e.identifiers.length), n = 0; n < r; n++) {
        var i = t.compareIdentifiers(this.identifiers[n], e.identifiers[n]);
        if (i !== 0)
          return i;
      }
      return nr(this.identifiers.length, e.identifiers.length);
    }, t.compareIdentifiers = function(e, r) {
      return t.numericIdentifierRegExp.test(e) && t.numericIdentifierRegExp.test(r) ? nr(+e, +r) : e === r ? 0 : e < r ? -1 : 1;
    }, t.EMPTY = new t([]), t.numericIdentifierRegExp = /^(0|[1-9]\d*)$/, t;
  }()
), fh = ["MATCH", "NOT_MATCH"], Dl = ["STRING", "NUMBER", "BOOLEAN", "VERSION", "JSON", "URL", "NULL", "UNKNOWN"], ph = ["IN", "CONTAINS", "STARTS_WITH", "ENDS_WITH", "GT", "GTE", "LT", "LTE"], dh = ["VARIATION", "BUCKET"], vh = [
  "USER_ID",
  "USER_PROPERTY",
  "HACKLE_PROPERTY",
  "SEGMENT",
  "AB_TEST",
  "FEATURE_FLAG",
  "EVENT_PROPERTY",
  "COHORT"
], hh = ["USER_ID", "USER_PROPERTY"], Le = (
  /** @class */
  function() {
    function t() {
      for (var e = [], r = 0; r < arguments.length; r++)
        e[r] = arguments[r];
      this.supportedKeyTypes = e;
    }
    return t.prototype.supports = function(e) {
      return this.supportedKeyTypes.includes(e);
    }, t.IDENTIFIER = new t("SEGMENT"), t.PROPERTY = new t("SEGMENT", "USER_PROPERTY", "HACKLE_PROPERTY", "AB_TEST", "FEATURE_FLAG", "EVENT_PROPERTY", "COHORT"), t.SEGMENT = new t("USER_ID", "USER_PROPERTY", "HACKLE_PROPERTY", "COHORT"), t;
  }()
), gh = ["ACTIVE", "DRAFT", "PAUSE"], yh = ["WEB", "ANDROID", "IOS"], Ih = ["IMMEDIATE", "CUSTOM"], mh = ["MODAL", "BANNER", "BOTTOM_SHEET", "NONE"], Ah = ["IMAGE_TEXT", "IMAGE_ONLY", "TEXT_ONLY", "IMAGE", "NONE"], Ll = ["VERTICAL", "HORIZONTAL"], Eh = ["CLICK"], Ch = [
  "CLOSE",
  "WEB_LINK",
  "HIDDEN",
  "LINK_AND_CLOSE",
  "LINK_NEW_TAB",
  "LINK_NEW_TAB_AND_CLOSE",
  "LINK_NEW_WINDOW",
  "LINK_NEW_WINDOW_AND_CLOSE"
], bh = ["TOP", "MIDDLE", "BOTTOM"], Th = ["LEFT", "CENTER", "RIGHT"], wh = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s) {
      this.id = e, this.key = r, this.status = n, this.period = i, this.eventTrigger = o, this.targetContext = a, this.messageContext = s;
    }
    return t.fromJson = function(e) {
      var r = Q(gh, e.status);
      if (!v.isNullOrUndefined(r)) {
        var n;
        switch (Q(Ih, e.timeUnit)) {
          case "IMMEDIATE":
            n = new Nh();
            break;
          case "CUSTOM":
            if (v.isNullOrUndefined(e.startEpochTimeMillis) || v.isNullOrUndefined(e.endEpochTimeMillis))
              return;
            n = new Oh(e.startEpochTimeMillis, e.endEpochTimeMillis);
            break;
          default:
            return;
        }
        var i = Dh.fromJson(e.messageContext);
        if (!v.isNullOrUndefined(i)) {
          var o = e.eventTriggerRules.map(_h.fromJson), a = Sh.fromJson(e.eventFrequencyCap);
          return new t(e.id, e.key, r, n, new Mh(o, a), Ph.fromJson(e.targetContext), i);
        }
      }
    }, t.prototype.supports = function(e) {
      return this.messageContext.platformTypes.includes(e);
    }, t;
  }()
), Nh = (
  /** @class */
  function() {
    function t() {
      this.type = "IMMEDIATE";
    }
    return t.prototype.within = function(e) {
      return !0;
    }, t;
  }()
), Oh = (
  /** @class */
  function() {
    function t(e, r) {
      this.startMillisInclusive = e, this.endMillisExclusive = r, this.type = "CUSTOM";
    }
    return t.prototype.within = function(e) {
      return this.startMillisInclusive <= e && e < this.endMillisExclusive;
    }, t;
  }()
), Mh = (
  /** @class */
  function() {
    function t(e, r) {
      this.rules = e, this.frequencyCap = r;
    }
    return t;
  }()
), _h = (
  /** @class */
  function() {
    function t(e, r) {
      this.eventKey = e, this.targets = r;
    }
    return t.fromJson = function(e) {
      return new t(e.eventKey, x.mapNotNullOrUndefined(e.targets, function(r) {
        return We.fromJson(r, Le.PROPERTY);
      }));
    }, t;
  }()
), Sh = (
  /** @class */
  function() {
    function t(e, r) {
      this.identifierCaps = e, this.durationCap = r;
    }
    return t.fromJson = function(e) {
      if (!e)
        return null;
      var r = e.identifiers.map(Rh.fromJson), n = xh.fromJson(e.duration);
      return new t(r, n);
    }, t;
  }()
), Rh = (
  /** @class */
  function() {
    function t(e, r) {
      this.identifierType = e, this.count = r;
    }
    return t.fromJson = function(e) {
      return new t(e.identifierType, e.countPerIdentifier);
    }, t;
  }()
), xh = (
  /** @class */
  function() {
    function t(e, r) {
      this.durationMillis = e, this.count = r;
    }
    return t.fromJson = function(e) {
      if (!e)
        return null;
      var r = Q(_v, e.durationUnit.timeUnit);
      return r ? new t(Jr.converter[r](e.durationUnit.amount, "milliseconds"), e.countPerDuration) : null;
    }, t;
  }()
), Ph = (
  /** @class */
  function() {
    function t(e, r) {
      this.overrides = e, this.targets = r;
    }
    return t.fromJson = function(e) {
      return new t(e.overrides.map(Uh.fromJson), x.mapNotNullOrUndefined(e.targets, function(r) {
        return We.fromJson(r, Le.PROPERTY);
      }));
    }, t;
  }()
), Uh = (
  /** @class */
  function() {
    function t(e, r) {
      this.identifierType = e, this.identifiers = r;
    }
    return t.fromJson = function(e) {
      return new t(e.identifierType, e.identifiers);
    }, t;
  }()
), Dh = (
  /** @class */
  function() {
    function t(e, r, n, i, o) {
      this.defaultLang = e, this.experimentContext = r, this.platformTypes = n, this.orientations = i, this.messages = o;
    }
    return t.fromJson = function(e) {
      var r = null;
      e.exposure.type === "AB_TEST" && e.exposure.key !== null && (r = new Lh(e.exposure.key));
      var n = ss(yh, e.platformTypes);
      if (!v.isNullOrUndefined(n)) {
        var i = ss(Ll, e.orientations);
        if (!v.isNullOrUndefined(i)) {
          var o = x.mapOrUndefined(e.messages, $h.fromJson);
          if (!v.isNullOrUndefined(o))
            return new t(e.defaultLang, r, n, i, o);
        }
      }
    }, t;
  }()
), Lh = (
  /** @class */
  function() {
    function t(e) {
      this.key = e;
    }
    return t;
  }()
), $h = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s, u, c, l, f) {
      this.variationKey = e, this.lang = r, this.layout = n, this.images = i, this.text = o, this.buttons = a, this.closeButton = s, this.background = u, this.action = c, this.outerButtons = l, this.innerButtons = f;
    }
    return t.fromJson = function(e) {
      var r = kh.fromJson(e.layout);
      if (!v.isNullOrUndefined(r)) {
        var n = x.mapOrUndefined(e.images, Fh.fromJson);
        if (!v.isNullOrUndefined(n)) {
          var i = x.mapOrUndefined(e.buttons, so.fromJson);
          if (!v.isNullOrUndefined(i)) {
            var o = void 0;
            if (!(v.isNotNullOrUndefined(e.closeButton) && (o = so.fromJson2(e.closeButton), v.isNullOrUndefined(o)))) {
              var a = x.mapOrUndefined(e.outerButtons, ps.fromJson), s = x.mapOrUndefined(e.innerButtons, ps.fromJson);
              if (!(v.isNullOrUndefined(a) || v.isNullOrUndefined(s)))
                return new t(e.variationKey, e.lang, r, n, e.text ? Gh.fromJson(e.text) : void 0, i, o, new Bh(e.background.color), e.action ? cr.fromJson(e.action) : void 0, a, s);
            }
          }
        }
      }
    }, t.prototype.toJson = function() {
      var e, r, n, i, o, a, s, u;
      return {
        variationKey: this.variationKey,
        lang: this.lang,
        layout: {
          layoutType: this.layout.layoutType,
          alignment: (r = (e = this.layout.alignment) === null || e === void 0 ? void 0 : e.toJson()) !== null && r !== void 0 ? r : null,
          displayType: this.layout.displayType
        },
        images: this.images.map(function(c) {
          return c.toJson();
        }),
        text: (i = (n = this.text) === null || n === void 0 ? void 0 : n.toJson()) !== null && i !== void 0 ? i : null,
        closeButton: (a = (o = this.closeButton) === null || o === void 0 ? void 0 : o.toCloseButtonJson()) !== null && a !== void 0 ? a : null,
        buttons: this.buttons.map(function(c) {
          return c.toJson();
        }),
        background: {
          color: this.background.color
        },
        action: (u = (s = this.action) === null || s === void 0 ? void 0 : s.toJson()) !== null && u !== void 0 ? u : null,
        outerButtons: this.outerButtons.map(function(c) {
          return c.toJson();
        }),
        innerButtons: this.innerButtons.map(function(c) {
          return c.toJson();
        })
      };
    }, t;
  }()
), kh = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.displayType = e, this.layoutType = r, this.alignment = n;
    }
    return t.fromJson = function(e) {
      var r = Q(Ah, e.layoutType), n = Q(mh, e.displayType);
      if (!v.isNullOrUndefined(n) && !v.isNullOrUndefined(r))
        return new t(n, r, e.alignment ? $l.fromJson(e.alignment) : void 0);
    }, t;
  }()
), $l = (
  /** @class */
  function() {
    function t(e, r) {
      this.horizontal = e, this.vertical = r;
    }
    return t.fromJson = function(e) {
      var r = Q(Th, e.horizontal);
      if (!v.isNullOrUndefined(r)) {
        var n = Q(bh, e.vertical);
        if (!v.isNullOrUndefined(n))
          return new t(r, n);
      }
    }, t.prototype.toJson = function() {
      return { horizontal: this.horizontal, vertical: this.vertical };
    }, t;
  }()
), Fh = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.orientation = e, this.imagePath = r, this.action = n;
    }
    return t.fromJson = function(e) {
      var r = Q(Ll, e.orientation);
      if (!v.isNullOrUndefined(r)) {
        var n = void 0;
        if (!(v.isNotNullOrUndefined(e.action) && (n = cr.fromJson(e.action), v.isNullOrUndefined(n))))
          return new t(r, e.imagePath, n);
      }
    }, t.prototype.toJson = function() {
      var e, r;
      return {
        orientation: this.orientation,
        imagePath: this.imagePath,
        action: (r = (e = this.action) === null || e === void 0 ? void 0 : e.toJson()) !== null && r !== void 0 ? r : null
      };
    }, t;
  }()
), Gh = (
  /** @class */
  function() {
    function t(e, r) {
      this.title = e, this.body = r;
    }
    return t.fromJson = function(e) {
      return new t(fs.fromJson(e.title), fs.fromJson(e.body));
    }, t.prototype.toJson = function() {
      return {
        title: {
          text: this.title.text,
          style: {
            textColor: this.title.style.color
          }
        },
        body: {
          text: this.body.text,
          style: {
            textColor: this.body.style.color
          }
        }
      };
    }, t;
  }()
), fs = (
  /** @class */
  function() {
    function t(e, r) {
      this.text = e, this.style = r;
    }
    return t.fromJson = function(e) {
      return new t(e.text, new Vh(e.style.textColor));
    }, t;
  }()
), Vh = (
  /** @class */
  function() {
    function t(e) {
      this.color = e;
    }
    return t;
  }()
), so = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.text = e, this.style = r, this.action = n;
    }
    return t.fromJson = function(e) {
      var r = cr.fromJson(e.action);
      if (!v.isNullOrUndefined(r))
        return new t(e.text, new ds(e.style.textColor, e.style.bgColor, e.style.borderColor), r);
    }, t.fromJson2 = function(e) {
      var r = cr.fromJson(e.action);
      if (!v.isNullOrUndefined(r))
        return new t("✕", new ds(e.style.color, "#FFFFFF", "#FFFFFF"), r);
    }, t.prototype.toJson = function() {
      return {
        text: this.text,
        action: this.action.toJson(),
        style: {
          textColor: this.style.textColor,
          bgColor: this.style.backgroundColor,
          borderColor: this.style.borderColor
        }
      };
    }, t.prototype.toCloseButtonJson = function() {
      return {
        action: this.action.toJson(),
        style: {
          color: this.style.textColor
        }
      };
    }, t;
  }()
), ps = (
  /** @class */
  function() {
    function t(e, r) {
      this.button = e, this.alignment = r;
    }
    return t.fromJson = function(e) {
      var r = so.fromJson(e.button);
      if (!v.isNullOrUndefined(r)) {
        var n = $l.fromJson(e.alignment);
        if (!v.isNullOrUndefined(n))
          return new t(r, n);
      }
    }, t.prototype.toJson = function() {
      return { button: this.button.toJson(), alignment: this.alignment.toJson() };
    }, t;
  }()
), ds = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.textColor = e, this.backgroundColor = r, this.borderColor = n;
    }
    return t;
  }()
), Bh = (
  /** @class */
  function() {
    function t(e) {
      this.color = e;
    }
    return t;
  }()
), cr = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.behavior = e, this.type = r, this.value = n;
    }
    return t.fromJson = function(e) {
      var r, n = Q(Eh, e.behavior);
      if (!v.isNullOrUndefined(n)) {
        var i = Q(Ch, e.type);
        if (!v.isNullOrUndefined(i))
          return new t(n, i, (r = e.value) !== null && r !== void 0 ? r : void 0);
      }
    }, t.prototype.toJson = function() {
      var e;
      return {
        behavior: this.behavior,
        type: this.type,
        value: (e = this.value) !== null && e !== void 0 ? e : null
      };
    }, t;
  }()
), jh = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.type = e, this.close = r, this.link = n;
    }
    return t.fromJson = function(e) {
      var r = e.type, n = e.value, i = this.linkActionTypes.some(function(c) {
        return c === r;
      }), o = this.closeActionTypes.some(function(c) {
        return c === r;
      }), a = this.tabTargetActionsTypes.some(function(c) {
        return c === r;
      }), s = this.windowTargetActionsTypes.some(function(c) {
        return c === r;
      }), u = r === "HIDDEN";
      return new t(i ? "LINK" : "CLOSE", o ? {
        hideDurationMillis: u ? Rl : null
      } : void 0, i ? {
        url: n ?? "",
        target: s ? "NEW_WINDOW" : a ? "NEW_TAB" : "CURRENT",
        shouldCloseAfterLink: o
      } : void 0);
    }, t.fromInteraction = function(e) {
      return e.type === "CLOSE" ? new t(e.type, { hideDurationMillis: null }) : t.fromJson(e.action);
    }, t.fromAction = function(e) {
      return t.fromJson(e.toJson());
    }, t.linkActionTypes = [
      "LINK_AND_CLOSE",
      "LINK_NEW_TAB",
      "LINK_NEW_TAB_AND_CLOSE",
      "LINK_NEW_WINDOW",
      "LINK_NEW_WINDOW_AND_CLOSE",
      "WEB_LINK"
    ], t.closeActionTypes = [
      "CLOSE",
      "HIDDEN",
      "LINK_AND_CLOSE",
      "LINK_NEW_TAB_AND_CLOSE",
      "LINK_NEW_WINDOW_AND_CLOSE"
    ], t.tabTargetActionsTypes = ["LINK_NEW_TAB", "LINK_NEW_TAB_AND_CLOSE"], t.windowTargetActionsTypes = ["LINK_NEW_WINDOW", "LINK_NEW_WINDOW_AND_CLOSE"], t;
  }()
), Hh = (
  /** @class */
  function() {
    function t(e) {
      this.id = e;
    }
    return t;
  }()
), un;
(function(t) {
  t.MANUAL = "MANUAL";
})(un || (un = {}));
var Xh = function(t) {
  return Object.values(un).includes(t);
}, Wh = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.needRedirect = e, this.redirectType = r, this.redirectUrl = n;
    }
    return t.fromDto = function(e) {
      var r = e.needRedirect, n = Xh(e.properties.type) ? e.properties.type : null, i = e.properties.value;
      return new t(r, n, i);
    }, t;
  }()
), zh = (
  /** @class */
  function() {
    function t(e, r) {
      this.includeTargets = e, this.excludeTargets = r;
    }
    return t.fromJson = function(e) {
      if (e !== null) {
        var r = x.mapNotNullOrUndefined(e.match, function(i) {
          return We.fromJson(i, Le.PROPERTY);
        }), n = x.mapNotNullOrUndefined(e.notMatch, function(i) {
          return We.fromJson(i, Le.PROPERTY);
        });
        return new t(r, n);
      }
    }, t;
  }()
), Jh = (
  /** @class */
  function() {
    function t(e) {
      this.name = e, this._tags = {}, this.name = e;
    }
    return t.prototype.tags = function(e) {
      var r = this;
      return Object.entries(e).forEach(function(n) {
        var i = n[0], o = n[1];
        r._tags[i] = o;
      }), this;
    }, t.prototype.tag = function(e, r) {
      return this._tags[e] = r, this;
    }, t.prototype.register = function(e) {
      return e.registerTimer({ name: this.name, tags: this._tags, type: "TIMER" });
    }, t;
  }()
), at = (
  /** @class */
  function() {
    function t(e) {
      this._clock = e, this.startTime = this._clock.tick();
    }
    return t.start = function(e) {
      return e === void 0 && (e = t.defaultClock), new t(e);
    }, t.prototype.stop = function(e) {
      var r = this._clock.tick(), n = r - this.startTime;
      e.record(n, "microseconds");
    }, t.defaultClock = new be(), t;
  }()
);
function Zh(t) {
  return t.id.type === "TIMER";
}
var Yh = (
  /** @class */
  function() {
    function t(e) {
      this.name = e, this._tags = {};
    }
    return t.prototype.tags = function(e) {
      var r = this;
      return Object.entries(e).forEach(function(n) {
        var i = n[0], o = n[1];
        r._tags[i] = o;
      }), this;
    }, t.prototype.tag = function(e, r) {
      return this._tags[e] = r, this;
    }, t.prototype.register = function(e) {
      return e.registerCounter({ name: this.name, tags: this._tags, type: "COUNTER" });
    }, t;
  }()
);
function Kh(t) {
  return t.id.type === "COUNTER";
}
var st = (
  /** @class */
  function() {
    function t(e) {
      this.compareFn = e, this.data = /* @__PURE__ */ new Map(), this.compareFn = e, this.data = /* @__PURE__ */ new Map();
    }
    return t.prototype.values = function() {
      return Array.from(this.data.values());
    }, t.prototype.keys = function() {
      return Array.from(this.data.keys());
    }, t.prototype.get = function(e) {
      var r = this, n = this.keys().find(function(i) {
        return r.compareFn(i, e);
      });
      return n ? this.data.get(n) : void 0;
    }, t.prototype.has = function(e) {
      return this.get(e) !== void 0;
    }, t.prototype.add = function(e, r) {
      var n = r;
      return n || (n = e), this.data.set(e, n), this;
    }, t.prototype.delete = function(e) {
      if (this.has(e)) {
        var r = this.get(e);
        return this.data.delete(e), r;
      }
    }, t.prototype.forEach = function(e) {
      this.data.forEach(e);
    }, t.prototype.filter = function(e) {
      for (var r = new t(this.compareFn), n = 0, i = this.entries(); n < i.length; n++) {
        var o = i[n];
        e(o[0], o[1]) && r.add(o[0], o[1]);
      }
      return r;
    }, t.prototype.entries = function() {
      return Array.from(this.data.entries());
    }, t;
  }()
), K = (
  /** @class */
  function() {
    function t(e, r) {
      this.valueSupplier = r, this.field = e;
    }
    return Object.defineProperty(t.prototype, "value", {
      get: function() {
        return this.valueSupplier();
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }()
);
function Qh(t, e) {
  return t.name === e.name && fe.isEquals(t.tags, e.tags);
}
var kl = (
  /** @class */
  function() {
    function t() {
      this.id = Pt(), this.name = "MetricRegistry", this._metrics = new st(Qh);
    }
    return Object.defineProperty(t.prototype, "metrics", {
      get: function() {
        return Array.from(this._metrics.values());
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.registerCounter = function(e) {
      return this.registerMetricIfNecessary(e, this.createCounter.bind(this));
    }, t.prototype.registerTimer = function(e) {
      return this.registerMetricIfNecessary(e, this.createTimer.bind(this));
    }, t.prototype.counter = function(e, r) {
      return r === void 0 && (r = {}), new Yh(e).tags(r).register(this);
    }, t.prototype.timer = function(e, r) {
      return r === void 0 && (r = {}), new Jh(e).tags(r).register(this);
    }, t.prototype.registerMetricIfNecessary = function(e, r) {
      return this.getOrCreateMetric(e, r);
    }, t.prototype.getOrCreateMetric = function(e, r) {
      var n, i = this._metrics.get(e);
      return i ? n = i : (n = r(e), this._metrics.add(e, n)), n;
    }, t.prototype.close = function() {
    }, t;
  }()
), qh = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n) {
      var i = t.call(this) || this;
      return i.scheduler = r, i.pushIntervalMillis = n, i.publishingJob = null, i;
    }
    return e.prototype.start = function() {
      var r = this;
      this.publishingJob === null && (this.publishingJob = this.scheduler.schedulePeriodically(this.pushIntervalMillis, this.pushIntervalMillis, function() {
        return r.publish(!1);
      }), O.log.debug("PushMetricRegistry started. Publish metrics every ".concat(this.pushIntervalMillis, "ms.")));
    }, e.prototype.stop = function() {
      var r;
      (r = this.publishingJob) === null || r === void 0 || r.cancel(), this.publishingJob = null, this.publish(!0), O.log.debug("PushMetricRegistry stopped.");
    }, e.prototype.close = function() {
      this.stop();
    }, e;
  }(kl)
), vs = (
  /** @class */
  function() {
    function t(e) {
      this.counterValue = 0, this.id = e;
    }
    return t.prototype.count = function() {
      return this.counterValue;
    }, t.prototype.increment = function(e) {
      this.counterValue += e ?? 1;
    }, t.prototype.measure = function() {
      return [new K("count", this.count.bind(this))];
    }, t;
  }()
), eg = (
  /** @class */
  function() {
    function t(e) {
      this.id = e, this.currentCounter = new vs(e);
    }
    return t.prototype.flush = function() {
      var e = this.currentCounter;
      return this.currentCounter = new vs(this.id), e;
    }, t.prototype.count = function() {
      return this.currentCounter.count();
    }, t.prototype.increment = function(e) {
      this.currentCounter.increment(e);
    }, t.prototype.measure = function() {
      return [new K("count", this.count.bind(this))];
    }, t;
  }()
);
function tg(t) {
  return typeof t.flush < "u" && typeof t.flush == "function";
}
var hs = (
  /** @class */
  function() {
    function t(e) {
      this._count = 0, this._total = 0, this._max = 0, this.id = e;
    }
    return t.prototype.count = function() {
      return this._count;
    }, t.prototype.totalTime = function(e) {
      return Jr.nanosToUnit(this._total, e);
    }, t.prototype.max = function(e) {
      return Jr.nanosToUnit(this._max, e);
    }, t.prototype.mean = function(e) {
      return this.count() === 0 ? 0 : this.totalTime(e) / this.count();
    }, t.prototype.record = function(e, r) {
      if (!(e < 0)) {
        var n = Jr.converter[r](e, "nanoseconds");
        this._count = this.count() + 1, this._total += n, this._max = Math.max(n, this._max);
      }
    }, t.prototype.measure = function() {
      var e = this;
      return [
        new K("count", this.count.bind(this)),
        new K("total", function() {
          return e.totalTime("milliseconds");
        }),
        new K("max", function() {
          return e.max("milliseconds");
        }),
        new K("mean", function() {
          return e.mean("milliseconds");
        })
      ];
    }, t;
  }()
), rg = (
  /** @class */
  function() {
    function t(e) {
      this.id = e, this.currentTimer = new hs(e);
    }
    return t.prototype.flush = function() {
      var e = this.currentTimer;
      return this.currentTimer = new hs(this.id), e;
    }, t.prototype.count = function() {
      return this.currentTimer.count();
    }, t.prototype.totalTime = function(e) {
      return this.currentTimer.totalTime(e);
    }, t.prototype.max = function(e) {
      return this.currentTimer.max(e);
    }, t.prototype.record = function(e, r) {
      this.currentTimer.record(e, r);
    }, t.prototype.mean = function(e) {
      return this.count() === 0 ? 0 : this.totalTime(e) / this.count();
    }, t.prototype.measure = function() {
      var e = this;
      return [
        new K("count", this.count.bind(this)),
        new K("total", function() {
          return e.totalTime("milliseconds");
        }),
        new K("max", function() {
          return e.max("milliseconds");
        }),
        new K("mean", function() {
          return e.mean("milliseconds");
        })
      ];
    }, t;
  }()
), ng = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n) {
      return t.call(this, r, n) || this;
    }
    return e.prototype.createCounter = function(r) {
      return new eg(r);
    }, e.prototype.createTimer = function(r) {
      return new rg(r);
    }, e.prototype.publish = function(r) {
      r === void 0 && (r = !1);
      var n = this.metrics.reduce(function(i, o) {
        return tg(o) ? i.concat(o.flush()) : i;
      }, []);
      this.flushMetrics(n, r);
    }, e;
  }(qh)
), ig = (
  /** @class */
  function() {
    function t(e) {
      this.id = e;
    }
    return t.prototype.count = function() {
      return 0;
    }, t.prototype.increment = function(e) {
    }, t.prototype.measure = function() {
      return [new K("count", this.count.bind(this))];
    }, t;
  }()
), og = (
  /** @class */
  function() {
    function t(e) {
      this._counters = new st(function(r, n) {
        return r.id === n.id;
      }), this.id = e, this.noopCounter = new ig(e);
    }
    return Object.defineProperty(t.prototype, "counters", {
      get: function() {
        return Array.from(this._counters.values());
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.add = function(e) {
      this._counters.add(e, e.registerCounter(this.id));
    }, t.prototype.count = function() {
      return (this.counters[0] || this.noopCounter).count();
    }, t.prototype.increment = function(e) {
      this.counters.forEach(function(r) {
        r.increment(e);
      });
    }, t.prototype.measure = function() {
      return [new K("count", this.count.bind(this))];
    }, t;
  }()
);
function ag(t) {
  return typeof t.add < "u" && typeof t.add == "function";
}
var sg = (
  /** @class */
  function() {
    function t(e) {
      this.id = e;
    }
    return t.prototype.measure = function() {
      var e = this;
      return [
        new K("count", this.count.bind(this)),
        new K("total", function() {
          return e.totalTime("milliseconds");
        }),
        new K("max", function() {
          return e.max("milliseconds");
        }),
        new K("mean", function() {
          return e.mean("milliseconds");
        })
      ];
    }, t.prototype.count = function() {
      return 0;
    }, t.prototype.totalTime = function(e) {
      return 0;
    }, t.prototype.max = function(e) {
      return 0;
    }, t.prototype.mean = function(e) {
      return 0;
    }, t.prototype.record = function(e, r) {
    }, t;
  }()
), ug = (
  /** @class */
  function() {
    function t(e) {
      this._timers = new st(function(r, n) {
        return r.id === n.id;
      }), this.id = e, this.noopTimer = new sg(e);
    }
    return Object.defineProperty(t.prototype, "firstTimer", {
      get: function() {
        return this.timers[0] || this.noopTimer;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.totalTime = function(e) {
      return this.firstTimer.totalTime(e);
    }, t.prototype.max = function(e) {
      return this.firstTimer.max(e);
    }, t.prototype.mean = function(e) {
      return this.firstTimer.mean(e);
    }, t.prototype.record = function(e, r) {
      this.timers.forEach(function(n) {
        n.record(e, r);
      });
    }, Object.defineProperty(t.prototype, "timers", {
      get: function() {
        return Array.from(this._timers.values());
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.add = function(e) {
      this._timers.add(e, e.registerTimer(this.id));
    }, t.prototype.count = function() {
      return this.firstTimer.count();
    }, t.prototype.measure = function() {
      var e = this;
      return [
        new K("count", this.count.bind(this)),
        new K("total", function() {
          return e.totalTime("milliseconds");
        }),
        new K("max", function() {
          return e.max("milliseconds");
        }),
        new K("mean", function() {
          return e.mean("milliseconds");
        })
      ];
    }, t;
  }()
), cg = (
  /** @class */
  function(t) {
    Y(e, t);
    function e() {
      var r = t !== null && t.apply(this, arguments) || this;
      return r.registries = new st(function(n, i) {
        return n.id === i.id;
      }), r;
    }
    return e.prototype.createCounter = function(r) {
      var n = new og(r);
      return this.addRegistry(n), n;
    }, e.prototype.createTimer = function(r) {
      var n = new ug(r);
      return this.addRegistry(n), n;
    }, e.prototype.addRegistry = function(r) {
      this.registries.forEach(function(n) {
        return r.add(n);
      });
    }, e.prototype.add = function(r) {
      r instanceof e || this.registries.has(r) || (this.registries.add(r), this.metrics.forEach(function(n) {
        ag(n) && n.add(r);
      }));
    }, e.prototype.close = function() {
      this.registries.forEach(function(r) {
        r.close();
      });
    }, e;
  }(kl)
), Ue = (
  /** @class */
  function() {
    function t() {
    }
    return t.counter = function(e, r) {
      return t.globalRegistry.counter(e, r);
    }, t.timer = function(e, r) {
      return t.globalRegistry.timer(e, r);
    }, t.addRegistry = function(e) {
      t.globalRegistry.add(e), O.log.debug("MetricRegistry added ".concat(e.name));
    }, t.globalRegistry = new cg(), t;
  }()
), Tn = (
  /** @class */
  function() {
    function t() {
    }
    return t.equalsIgnoreCase = function(e, r) {
      return e.toLowerCase() === r.toLowerCase();
    }, t.isNotEmptyString = function(e) {
      return v.isNullOrUndefined(e) || typeof e != "string" ? !1 : e.length > 0;
    }, t;
  }()
), dr = (
  /** @class */
  function() {
    function t(e, r, n, i, o) {
      this.url = e, this.method = r, this.body = n, this.headers = i, this.options = o;
    }
    return t.builder = function() {
      return new gs();
    }, t.get = function(e) {
      return t.builder().url(e).build();
    }, t.prototype.toBuilder = function() {
      return new gs(this);
    }, t;
  }()
), gs = (
  /** @class */
  function() {
    function t(e) {
      var r, n, i, o, a, s, u;
      this._url = (r = e == null ? void 0 : e.url) !== null && r !== void 0 ? r : null, this._method = (n = e == null ? void 0 : e.method) !== null && n !== void 0 ? n : "GET", this._body = (i = e == null ? void 0 : e.body) !== null && i !== void 0 ? i : null, this._headers = (a = (o = e == null ? void 0 : e.headers) === null || o === void 0 ? void 0 : o.toBuilder()) !== null && a !== void 0 ? a : _t.builder(), this._timeoutMillis = (u = (s = e == null ? void 0 : e.options) === null || s === void 0 ? void 0 : s.timeoutMillis) !== null && u !== void 0 ? u : null;
    }
    return t.prototype.url = function(e) {
      return this._url = e, this;
    }, t.prototype.method = function(e) {
      return this._method = e, this;
    }, t.prototype.body = function(e) {
      return this._body = e, this;
    }, t.prototype.addHeader = function(e, r) {
      return this._headers.add(e, r), this;
    }, t.prototype.timeoutMillis = function(e) {
      return this._timeoutMillis = e, this;
    }, t.prototype.build = function() {
      if (this._url === null)
        throw new Error("url is null");
      var e = { timeoutMillis: this._timeoutMillis };
      return new dr(this._url, this._method, this._body, this._headers.build(), e);
    }, t;
  }()
), Fl = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.statusCode = e, this.body = r, this.headers = n;
    }
    return t.ok = function(e, r) {
      return t.of(200, e, r);
    }, t.of = function(e, r, n) {
      return new t(e, r ?? null, n ?? _t.empty());
    }, t.prototype.isSuccessful = function() {
      return this.statusCode >= 200 && this.statusCode < 300;
    }, t.prototype.isClientError = function() {
      return this.statusCode >= 400 && this.statusCode < 500;
    }, t.prototype.isNotModified = function() {
      return this.statusCode === 304;
    }, t;
  }()
), _t = (
  /** @class */
  function() {
    function t(e) {
      this.headers = e;
    }
    return t.empty = function() {
      return new t(/* @__PURE__ */ new Map());
    }, t.builder = function() {
      return new ys(/* @__PURE__ */ new Map());
    }, t.prototype.get = function(e) {
      for (var r = 0, n = Array.from(this.headers.entries()); r < n.length; r++) {
        var i = n[r], o = i[0], a = i[1];
        if (Tn.equalsIgnoreCase(o, e))
          return a;
      }
      return null;
    }, t.prototype.getOrDefault = function(e, r) {
      var n;
      return (n = this.get(e)) !== null && n !== void 0 ? n : r;
    }, t.prototype.raw = function() {
      return Array.from(this.headers.entries()).reduce(function(e, r) {
        var n = r[0], i = r[1];
        return e[n] = i, e;
      }, {});
    }, t.prototype.toBuilder = function() {
      return new ys(this.headers);
    }, t.IF_MODIFIED_SINCE = "If-Modified-Since", t.LAST_MODIFIED = "Last-Modified", t;
  }()
), ys = (
  /** @class */
  function() {
    function t(e) {
      this.headers = e;
    }
    return t.prototype.add = function(e, r) {
      return this.headers.set(e, r), this;
    }, t.prototype.build = function() {
      return new _t(this.headers);
    }, t;
  }()
), lg = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n, i, o, a) {
      var s = t.call(this, o, a) || this;
      return s.url = r, s.transport = n, s.synchronousTransport = i, s.start(), s;
    }
    return e.prototype.flushMetrics = function(r, n) {
      var i = this;
      x.chunked(r.filter(this.isDispatchTarget.bind(this)), ao).forEach(function(o) {
        i.dispatch(o, n);
      });
    }, e.prototype.isDispatchTarget = function(r) {
      return Kh(r) || Zh(r) ? r.count() > 0 : !1;
    }, e.prototype.dispatch = function(r, n) {
      var i = this.createRequest(r);
      this.execute(i, n).catch(function(o) {
        return O.log.debug("Failed to flushing metrics: ".concat(o));
      });
    }, e.prototype.createRequest = function(r) {
      return dr.builder().url(this.url).method("POST").body(JSON.stringify(this.batch(r))).addHeader("Content-Type", "application/json").build();
    }, e.prototype.execute = function(r, n) {
      return n ? this.synchronousTransport.send(r) : this.transport.send(r);
    }, e.prototype.batch = function(r) {
      return {
        metrics: r.map(function(n) {
          return {
            name: n.id.name,
            type: n.id.type,
            tags: n.id.tags,
            measurements: v.fromMap(x.associate(n.measure(), function(i) {
              return [i.field, i.value];
            }))
          };
        })
      };
    }, e.prototype.onLifecycleChanged = function(r, n) {
      switch (r) {
        case "hidden":
        case "pagehide":
          return this.publish(!0);
        case "visible":
        case "pageshow":
        case "blur":
        case "locationChange":
        case "focus":
          return;
      }
    }, e;
  }(ng)
), cn = (
  /** @class */
  function() {
    function t() {
    }
    return t.experiment = function(e, r, n) {
      var i = Ue.timer("experiment.decision", {
        key: String(r),
        variation: n.variation,
        reason: String(n.reason)
      });
      e.stop(i);
    }, t.featureFlag = function(e, r, n) {
      var i = Ue.timer("feature.flag.decision", {
        key: String(r),
        on: String(n.isOn),
        reason: String(n.reason)
      });
      e.stop(i);
    }, t.remoteConfig = function(e, r, n) {
      var i = Ue.timer("remote.config.decision", {
        key: String(r),
        reason: String(n.reason)
      });
      e.stop(i);
    }, t.inAppMessage = function(e, r, n) {
      var i = Ue.timer("iam.decision", {
        key: String(r),
        show: String(n.isShow()),
        reason: String(n.reason)
      });
      e.stop(i);
    }, t;
  }()
), St = (
  /** @class */
  function() {
    function t() {
    }
    return t.record = function(e, r, n) {
      var i = Ue.timer("api.call", {
        operation: e,
        success: t.success(n)
      });
      r.stop(i);
    }, t.success = function(e) {
      return e === null ? "false" : String(e.isSuccessful() || e.isNotModified());
    }, t;
  }()
), fg = (
  /** @class */
  function() {
    function t() {
    }
    return t.decide = function(e, r, n, i) {
      if (v.isNullOrUndefined(n))
        return this.decision(e, r, "NULL", n, i);
      switch (typeof n) {
        case "string":
          return this.decision(e, r, "STRING", n, i);
        case "number":
          return this.decision(e, r, "NUMBER", n, i);
        case "boolean":
          return this.decision(e, r, "BOOLEAN", n, i);
        default:
          return this.decision(e, r, "UNKNOWN", n, i);
      }
    }, t.decision = function(e, r, n, i, o) {
      return v.isNullOrUndefined(r) ? rr.of(i, w.INVALID_INPUT) : e.remoteConfig(r, o, n, i);
    }, t;
  }()
), pg = O.log, dg = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.core = e, this.userManager = r, this.user = n;
    }
    return t.prototype.get = function(e, r) {
      var n = at.start(), i;
      try {
        i = this.decide(e, r);
      } catch (o) {
        pg.error("Unexpected exception while deciding remote config parameter[".concat(e, "]. Returning default value. : ").concat(o)), i = rr.of(r, w.EXCEPTION);
      }
      return cn.remoteConfig(n, e, i), i.value;
    }, t.prototype.decide = function(e, r) {
      var n = this.userManager.resolve(this.user);
      return fg.decide(this.core, e, r, n);
    }, t;
  }()
), Dt = (
  /** @class */
  function() {
    function t() {
      this._properties = /* @__PURE__ */ new Map(), this.MAX_PROPERTIES_COUNT = 128, this.MAX_PROPERTY_KEY_LENGTH = 128;
    }
    return t.prototype.contains = function(e) {
      return this._properties.has(e);
    }, t.prototype.remove = function(e) {
      var r = this;
      return e instanceof Map && e.forEach(function(n, i) {
        r.remove(i);
      }), typeof e == "string" && this._properties.delete(e), this;
    }, t.prototype.compute = function(e, r) {
      var n = this._properties.get(e), i = r(n);
      i !== null ? this.add(e, i) : (n !== null || this.contains(e)) && this.remove(e);
    }, t.prototype.add = function(e, r, n) {
      if (n === void 0 && (n = !1), n && this.contains(e))
        return this;
      if (this._properties.size >= this.MAX_PROPERTIES_COUNT)
        return this;
      if (typeof e == "string" && e.length > this.MAX_PROPERTY_KEY_LENGTH)
        return this;
      var i = de.sanitizeValue(e, r);
      return v.isNullOrUndefined(i) ? this : (this._properties.set(e, i), this);
    }, t.prototype.addProperties = function(e, r) {
      var n = this;
      return r === void 0 && (r = !1), e.forEach(function(i, o) {
        n.add(o, i, r);
      }), this;
    }, t.prototype.build = function() {
      return this._properties;
    }, t;
  }()
), j;
(function(t) {
  t.SET = "$set", t.SET_ONCE = "$setOnce", t.UNSET = "$unset", t.INCREMENT = "$increment", t.APPEND = "$append", t.APPEND_ONCE = "$appendOnce", t.PREPEND = "$prepend", t.PREPEND_ONCE = "$prependOnce", t.REMOVE = "$remove", t.CLEAR_ALL = "$clearAll";
})(j || (j = {}));
var vg = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.operate = function(e, r) {
      return e.size === 0 ? r : r.size === 0 ? e : new Dt().addProperties(e).addProperties(r).build();
    }, t;
  }()
), hg = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.operate = function(e, r) {
      return e.size === 0 ? r : r.size === 0 ? e : new Dt().addProperties(e).addProperties(r, !0).build();
    }, t;
  }()
), gg = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.operate = function(e, r) {
      return e.size === 0 ? /* @__PURE__ */ new Map() : r.size === 0 ? e : new Dt().addProperties(e).remove(r).build();
    }, t;
  }()
), yg = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.operate = function(e, r) {
      var n = this;
      if (r.size === 0)
        return e;
      var i = new Dt();
      return i.addProperties(e), r.forEach(function(o, a) {
        i.compute(a, function(s) {
          return n.increment(s, o);
        });
      }), i.build();
    }, t.prototype.increment = function(e, r) {
      return typeof r != "number" ? e : typeof e != "number" ? e ?? r : e + r;
    }, t;
  }()
), vr = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.operate = function(e, r) {
      var n = this;
      if (r.size === 0)
        return e;
      var i = new Dt();
      return i.addProperties(e), r.forEach(function(o, a) {
        i.compute(a, function(s) {
          return n.compute(s, o);
        });
      }), i.build();
    }, t.prototype.compute = function(e, r) {
      var n = this.toArray(e), i = this.toArray(r);
      return this.operateArray(n, i);
    }, t.prototype.toArray = function(e) {
      return e == null ? [] : Array.isArray(e) ? e : [e];
    }, t.prototype.contains = function(e, r) {
      return e.includes(r);
    }, t.prototype.prepend = function(e, r, n) {
      return n === void 0 && (n = !1), n && this.contains(r, e) ? r : ei([e], r, !0);
    }, t.prototype.append = function(e, r, n) {
      return n === void 0 && (n = !1), n && this.contains(e, r) ? e : ei(ei([], e, !0), [r], !1);
    }, t;
  }()
), Ig = (
  /** @class */
  function(t) {
    Y(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.operateArray = function(r, n) {
      var i = this;
      return n.reduce(function(o, a) {
        return i.append.bind(i)(o, a);
      }, r);
    }, e;
  }(vr)
), mg = (
  /** @class */
  function(t) {
    Y(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.operateArray = function(r, n) {
      return n.reduce(this.appendOnce.bind(this), r);
    }, e.prototype.appendOnce = function(r, n) {
      return this.append(r, n, !0);
    }, e;
  }(vr)
), Ag = (
  /** @class */
  function(t) {
    Y(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.operateArray = function(r, n) {
      var i = this;
      return n.reduceRight(function(o, a) {
        return i.prepend.bind(i)(a, o);
      }, r);
    }, e;
  }(vr)
), Eg = (
  /** @class */
  function(t) {
    Y(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.operateArray = function(r, n) {
      var i = this;
      return n.reduce(this.appendOnce.bind(this), []).reduceRight(function(o, a) {
        return i.prependOnce.bind(i)(a, o);
      }, r);
    }, e.prototype.appendOnce = function(r, n) {
      return this.append(r, n, !0);
    }, e.prototype.prependOnce = function(r, n) {
      return this.prepend(r, n, !0);
    }, e;
  }(vr)
), Cg = (
  /** @class */
  function(t) {
    Y(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.operateArray = function(r, n) {
      return n.reduce(this.remove.bind(this), r);
    }, e.prototype.remove = function(r, n) {
      return r.filter(function(i) {
        return i !== n;
      });
    }, e;
  }(vr)
), bg = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.operate = function(e, r) {
      return /* @__PURE__ */ new Map();
    }, t;
  }()
), Tg = (
  /** @class */
  function() {
    function t() {
    }
    return t.get = function(e) {
      switch (e) {
        case j.SET:
          return new vg();
        case j.SET_ONCE:
          return new hg();
        case j.UNSET:
          return new gg();
        case j.INCREMENT:
          return new yg();
        case j.APPEND:
          return new Ig();
        case j.APPEND_ONCE:
          return new mg();
        case j.PREPEND:
          return new Ag();
        case j.PREPEND_ONCE:
          return new Eg();
        case j.CLEAR_ALL:
          return new bg();
        case j.REMOVE:
          return new Cg();
      }
    }, t;
  }()
), ir = (
  /** @class */
  function() {
    function t() {
      this.operations = /* @__PURE__ */ new Map();
    }
    return t.prototype.set = function(e, r) {
      return this.add(j.SET, e, r);
    }, t.prototype.setOnce = function(e, r) {
      return this.add(j.SET_ONCE, e, r);
    }, t.prototype.unset = function(e) {
      return this.add(j.UNSET, e, "-");
    }, t.prototype.increment = function(e, r) {
      return this.add(j.INCREMENT, e, r);
    }, t.prototype.append = function(e, r) {
      return this.add(j.APPEND, e, r);
    }, t.prototype.appendOnce = function(e, r) {
      return this.add(j.APPEND_ONCE, e, r);
    }, t.prototype.prepend = function(e, r) {
      return this.add(j.PREPEND, e, r);
    }, t.prototype.prependOnce = function(e, r) {
      return this.add(j.PREPEND_ONCE, e, r);
    }, t.prototype.remove = function(e, r) {
      return this.add(j.REMOVE, e, r);
    }, t.prototype.clearAll = function() {
      return this.add(j.CLEAR_ALL, "clearAll", "-");
    }, t.prototype.build = function() {
      var e = Array.from(this.operations.entries()).map(function(r) {
        var n = r[0], i = r[1];
        return [n, i.build()];
      });
      return new wg(new Map(e));
    }, t.prototype.containsKey = function(e) {
      return Array.from(this.operations.entries()).some(function(r) {
        r[0];
        var n = r[1];
        return n.contains(e);
      });
    }, t.prototype.add = function(e, r, n) {
      if (this.containsKey(r))
        return this;
      this.operations.has(e) || this.operations.set(e, new Dt());
      var i = this.operations.get(e);
      return i == null || i.add(r, n), this;
    }, t;
  }()
), wg = (
  /** @class */
  function() {
    function t(e) {
      this.operations = e ?? /* @__PURE__ */ new Map();
    }
    return t.prototype.operate = function(e) {
      var r = e;
      return this.operations.forEach(function(n, i) {
        r = Tg.get(i).operate(r, n);
      }), r;
    }, t.prototype.toEvent = function() {
      var e = {
        key: "$properties"
      };
      return this.operations.forEach(function(r, n) {
        var i, o;
        e.properties = b(b({}, e.properties), (i = {}, i[n] = b(b({}, (o = e.properties) === null || o === void 0 ? void 0 : o[n]), de.sanitize(v.fromMap(r))), i));
      }), e;
    }, t.prototype.toRecord = function() {
      var e = {};
      return this.operations.forEach(function(r, n) {
        var i = {};
        r.forEach(function(o, a) {
          i[a] = o;
        }), e[n] = i;
      }), e;
    }, t;
  }()
), Ng = (
  /** @class */
  function() {
    function t() {
    }
    return t.timeout = function(e, r) {
      return new Promise(function(n, i) {
        setTimeout(function() {
          return i(new Error("timeout (".concat(r, "ms)")));
        }, r), e.then(n, i);
      });
    }, t;
  }()
), uo = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s) {
      e === void 0 && (e = ""), r === void 0 && (r = ""), n === void 0 && (n = ""), i === void 0 && (i = ""), o === void 0 && (o = ""), a === void 0 && (a = ""), s === void 0 && (s = ""), this.pagePath = e, this.host = r, this.hostname = n, this.url = i, this.referrer = o, this.queryParameter = a, this.protocol = s;
    }
    return t.prototype.isEquals = function(e) {
      return this.url === e.url;
    }, Object.defineProperty(t.prototype, "pageTitle", {
      get: function() {
        return typeof window > "u" || typeof document > "u" ? "" : window.document.title;
      },
      enumerable: !1,
      configurable: !0
    }), t.createWithCurrentPage = function() {
      return typeof window > "u" || typeof document > "u" ? new t() : new t(window.location.pathname, window.location.host, window.location.hostname, window.location.href, window.document.referrer, window.location.search, window.location.protocol);
    }, t.prototype.toProperties = function() {
      return {
        pagePath: this.pagePath,
        pageTitle: this.pageTitle,
        host: this.host,
        url: this.url,
        referrer: this.referrer,
        queryParameter: this.queryParameter,
        protocol: this.protocol.replace(":", "")
      };
    }, t;
  }()
), J = O.log, Og = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s, u) {
      this.core = e, this.synchronizer = r, this.sessionManager = n, this.userManager = i, this.fetchThrottler = o, this.pageEventTracker = a, this.inAppMessageUi = s, this.devTools = u, this.initialized = !1, this.initialize = this.initialize.bind(this), this.getSessionId = this.getSessionId.bind(this), this.getUser = this.getUser.bind(this), this.setUser = this.setUser.bind(this), this.setUserId = this.setUserId.bind(this), this.setDeviceId = this.setDeviceId.bind(this), this.setUserProperty = this.setUserProperty.bind(this), this.setUserProperties = this.setUserProperties.bind(this), this.updateUserProperties = this.updateUserProperties.bind(this), this.resetUser = this.resetUser.bind(this), this.variation = this.variation.bind(this), this.variationDetail = this.variationDetail.bind(this), this.isFeatureOn = this.isFeatureOn.bind(this), this.featureFlagDetail = this.featureFlagDetail.bind(this), this.track = this.track.bind(this), this.trackPageView = this.trackPageView.bind(this), this.remoteConfig = this.remoteConfig.bind(this), this.onReady = this.onReady.bind(this), this.onInitialized = this.onInitialized.bind(this), this.showUserExplorer = this.showUserExplorer.bind(this), this.hideUserExplorer = this.hideUserExplorer.bind(this), this.fetch = this.fetch.bind(this), this.close = this.close.bind(this), this.setInAppMessageListener = this.setInAppMessageListener.bind(this), this.initialization = this.initialize();
    }
    return t.prototype.initialize = function() {
      return M(this, void 0, void 0, function() {
        var e;
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return r.trys.push([0, 2, 3, 4]), J.debug("HackleClient initializing"), [4, this.synchronizer.sync()];
            case 1:
              return r.sent(), J.debug("HackleClient initialized"), [3, 4];
            case 2:
              throw e = r.sent(), J.error("HackleClient initialize failed: ".concat(e)), e;
            case 3:
              return this.initialized = !0, [
                7
                /*endfinally*/
              ];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.getSessionId = function() {
      return this.sessionManager.sessionId;
    }, t.prototype.getUser = function() {
      return this.userManager.currentUser;
    }, t.prototype.setUser = function(e) {
      try {
        var r = Yr(e);
        if (!r)
          return J.warn("invalid user"), Promise.resolve();
        var n = this.userManager.setUser(r);
        return this.userManager.syncIfNeeded(n).catch(function() {
        });
      } catch (i) {
        return J.error("Unexpected exception while set user: ".concat(i)), Promise.resolve();
      }
    }, t.prototype.setUserId = function(e) {
      try {
        var r = void 0;
        if (e === void 0)
          r = this.userManager.setUserId(void 0);
        else {
          var n = fe.sanitizeValue(e);
          if (!n)
            return J.warn("Invalid userId. [userId=".concat(e, "]")), Promise.resolve();
          r = this.userManager.setUserId(n);
        }
        return this.userManager.syncIfNeeded(r).catch(function() {
        });
      } catch (i) {
        return J.error("Unexpected exception while set userId: ".concat(i)), Promise.resolve();
      }
    }, t.prototype.setDeviceId = function(e) {
      try {
        var r = fe.sanitizeValue(e);
        if (!r)
          return J.warn("Invalid deviceId. [deviceId=".concat(e, "]")), Promise.resolve();
        var n = this.userManager.setDeviceId(r);
        return this.userManager.syncIfNeeded(n).catch(function() {
        });
      } catch (i) {
        return J.error("Unexpected exception while set deviceId: ".concat(i)), Promise.resolve();
      }
    }, t.prototype.setUserProperty = function(e, r) {
      var n = new ir().set(e, r).build();
      return this.updateUserProperties(n);
    }, t.prototype.setUserProperties = function(e) {
      try {
        var r = de.sanitize(e), n = new ir();
        return Object.entries(r).forEach(function(i) {
          var o = i[0], a = i[1];
          n.set(o, a);
        }), this.updateUserProperties(n.build());
      } catch (i) {
        return J.error("Unexpected exception while set userProperties: ".concat(i)), Promise.resolve();
      }
    }, t.prototype.updateUserProperties = function(e) {
      try {
        var r = e.toEvent();
        return this.track(r), this.userManager.updateUserProperties(e), this.core.flush(!1), Promise.resolve();
      } catch (n) {
        return J.error("Unexpected exception while update userProperties: ".concat(n)), Promise.resolve();
      }
    }, t.prototype.resetUser = function() {
      try {
        var e = this.userManager.resetUser(), r = new ir().clearAll().build();
        return this.track(r.toEvent()), this.userManager.syncIfNeeded(e).catch(function() {
        });
      } catch (n) {
        return J.error("Unexpected exception while reset user: ".concat(n)), Promise.resolve();
      }
    }, t.prototype.variation = function(e, r, n) {
      return this.variationDetail(e, r, n).variation;
    }, t.prototype.variationDetail = function(e, r, n) {
      var i = n || "A", o = at.start(), a = function(s) {
        try {
          var u = s.userManager.resolve(r);
          return s.core.experiment(e, u, i);
        } catch (c) {
          return J.error("Unexpected exception while deciding variation for experiment[".concat(e, "]. Returning default variation[").concat(i, "] : ").concat(c)), et.of(i, w.EXCEPTION);
        }
      }(this);
      return cn.experiment(o, e, a), a;
    }, t.prototype.isFeatureOn = function(e, r) {
      return this.featureFlagDetail(e, r).isOn;
    }, t.prototype.featureFlagDetail = function(e, r) {
      var n = at.start(), i = function(o) {
        try {
          var a = o.userManager.resolve(r);
          return o.core.featureFlag(e, a);
        } catch (s) {
          return J.error("Unexpected exception while deciding feature flag[".concat(e, "]. Returning default value[false] : ").concat(s)), je.off(w.EXCEPTION);
        }
      }(this);
      return cn.featureFlag(n, e, i), i;
    }, t.prototype.track = function(e, r) {
      try {
        J.debug("track event : ".concat(JSON.stringify(e)));
        var n = this._convertEvent(e), i = this.userManager.resolve(r);
        this.core.track(n, i);
      } catch (o) {
        J.error("Unexpected exception while tracking event: ".concat(o));
      }
    }, t.prototype.trackPageView = function(e) {
      var r = uo.createWithCurrentPage();
      this.pageEventTracker.track(r);
    }, t.prototype.remoteConfig = function(e) {
      return new dg(this.core, this.userManager, e);
    }, t.prototype.onReady = function(e, r) {
      r === void 0 && (r = ts), this.onInitialized({ timeout: r }).finally(function() {
        return e();
      });
    }, t.prototype.onInitialized = function(e) {
      var r;
      return M(this, void 0, void 0, function() {
        var n;
        return _(this, function(i) {
          switch (i.label) {
            case 0:
              if (this.initialized)
                return [2, { success: !0 }];
              i.label = 1;
            case 1:
              return i.trys.push([1, 3, , 4]), [4, Ng.timeout(this.initialization, (r = e == null ? void 0 : e.timeout) !== null && r !== void 0 ? r : ts)];
            case 2:
              return i.sent(), [2, { success: !0 }];
            case 3:
              return n = i.sent(), J.error("Failed to onInitialized: ".concat(n)), [2, { success: !1 }];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype._convertEvent = function(e) {
      return typeof e == "string" ? { key: e } : e;
    }, t.prototype.showUserExplorer = function() {
      var e;
      if (!(!((e = this.devTools) === null || e === void 0) && e.userExplorer)) {
        J.error("UserExplorer is not provided");
        return;
      }
      J.debug("UserExplorer opened."), Ue.counter("user.explorer.show", {}).increment(), this.devTools.manager.userExplorer(this.devTools.userExplorer);
    }, t.prototype.hideUserExplorer = function() {
      if (!this.devTools) {
        J.warn("There is no active HackleDevtools.");
        return;
      }
      this.devTools.manager.close();
    }, t.prototype.fetch = function() {
      var e = this;
      return this.fetchThrottler.execute(function() {
        return e.synchronizer.sync();
      }, function() {
        return Promise.resolve();
      });
    }, t.prototype.setInAppMessageListener = function(e) {
      this.inAppMessageUi.setListener(e);
    }, t.prototype.close = function() {
      J.debug("HackleClient closing"), this.core.close(), this.synchronizer.close();
    }, t;
  }()
), Mg = O.log, _g = (
  /** @class */
  function() {
    function t(e, r) {
      this.invocationProcessor = e, this.user = r;
    }
    return t.prototype.get = function(e, r) {
      var n = typeof r;
      try {
        var i = {
          command: "remoteConfig",
          parameters: {
            defaultValue: r,
            key: e,
            valueType: n,
            user: this.user
          }
        }, o = this.invocationProcessor.process(i);
        if (!o)
          throw new Error("invoke result data not exists");
        switch (n) {
          case "number":
            return Number(o);
          case "boolean":
            return !!o;
          default:
            return o;
        }
      } catch (a) {
        return Mg.error("Unexpected exception while deciding remote config parameter[".concat(e, "]. Returning default value. : ").concat(a)), r;
      }
    }, t;
  }()
), Ce = (
  /** @class */
  function() {
    function t() {
    }
    return t.tryParse = function(e) {
      try {
        return new URL(e);
      } catch {
        return;
      }
    }, t.removePathnameTrailingSlash = function(e) {
      var r = e instanceof URL ? e : t.tryParse(e);
      if (!r)
        return String(e);
      if (r.pathname.endsWith("/")) {
        var n = /\/+$/;
        r.pathname = r.pathname.replace(n, "");
      }
      return r.href;
    }, t.tryDecodeURI = function(e) {
      try {
        return decodeURI(e);
      } catch {
        return;
      }
    }, t.tryDecodeURIComponent = function(e) {
      try {
        return decodeURIComponent(e);
      } catch {
        return;
      }
    }, t.decodeURIOrOriginal = function(e) {
      try {
        return decodeURI(e);
      } catch {
        return e;
      }
    }, t.decodeURIComponentOrOriginal = function(e) {
      try {
        return decodeURIComponent(e);
      } catch {
        return e;
      }
    }, t;
  }()
), hr = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = {
        days: 0,
        isCrossSubdomain: !1,
        isSecure: !1
      }), this.options = e;
    }
    return t.extractDomain = function(e) {
      var r = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i, n = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i, i = r, o = e.split("."), a = o[o.length - 1];
      (a.length > 4 || a === "com" || a === "org") && (i = n);
      var s = e.match(i);
      return s ? s[0] : "";
    }, t.prototype.getItem = function(e) {
      for (var r, n = e + "=", i = document.cookie.split(";"), o = 0; o < i.length; o++) {
        for (var a = i[o]; a.charAt(0) == " "; )
          a = a.substring(1, a.length);
        if (a.indexOf(n) === 0)
          return (r = Ce.tryDecodeURIComponent(a.substring(n.length, a.length))) !== null && r !== void 0 ? r : null;
      }
      return null;
    }, t.prototype.getAllItem = function(e) {
      var r = document.cookie.split("; ").map(function(i) {
        return i.split("=");
      }), n = e == null ? void 0 : e.keyPrefix;
      return n ? r.filter(function(i) {
        var o = i[0];
        return i[1], o.startsWith(n);
      }) : r;
    }, t.prototype.setItem = function(e, r, n) {
      var i = b(b({}, this.options), n), o = "", a = "", s = "", u = "";
      if (i.isCrossSubdomain) {
        var c = t.extractDomain(document.location.hostname);
        o = c ? "; domain=." + c : "";
      }
      if (i.days) {
        var l = /* @__PURE__ */ new Date();
        l.setTime(l.getTime() + i.days * 24 * 60 * 60 * 1e3), a = "; expires=" + l.toUTCString();
      }
      i.sameSite && (u = "; SameSite=".concat(i.sameSite)), i.isSecure && (s += "; secure");
      var f = e + "=" + encodeURIComponent(r) + a + "; path=/" + o + u + s;
      return document.cookie = f, f;
    }, t.prototype.removeItem = function(e, r) {
      this.setItem(e, "", b(b({}, r), { days: -1 }));
    }, t.prototype.getOptions = function() {
      return this.options;
    }, t.getInstance = function(e) {
      return e === void 0 && (e = { days: _l, isCrossSubdomain: !0 }), t.storage || (t.storage = new t(e)), t.storage;
    }, t;
  }()
), Sg = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.initialize = function() {
      var e = hr.getInstance().getItem(Xo);
      e || Gl();
    }, t.prototype.onLifecycleChanged = function(e, r) {
      switch (e) {
        case "hidden":
        case "pagehide":
          return Rg();
        case "blur":
        case "focus":
        case "locationChange":
        case "visible":
        case "pageshow":
          return;
      }
    }, t;
  }()
);
function Kr() {
  var t = hr.getInstance(), e = t.getItem(Sl);
  if (e)
    return e;
  var r = t.getItem(Xo);
  return r || Gl();
}
function Rg() {
  hr.getInstance().removeItem(Sl);
}
function Gl() {
  var t = Pt();
  return hr.getInstance().setItem(Xo, t), t;
}
var B = O.log, ln;
(function(t) {
  t.native = "native", t.web_view_wrapper = "web_view_wrapper";
})(ln || (ln = {}));
function xg(t) {
  return !(!t || !("_hackleApp" in t) || t._hackleApp === null || typeof t._hackleApp != "object" || !("getAppSdkKey" in t._hackleApp) || typeof t._hackleApp.getAppSdkKey != "function" || !("getInvocationType" in t._hackleApp) || typeof t._hackleApp.getInvocationType != "function");
}
var Pg = (
  /** @class */
  function() {
    function t(e) {
      this.invocationProcessor = e, this.getSessionId = this.getSessionId.bind(this), this.getUser = this.getUser.bind(this), this.setUser = this.setUser.bind(this), this.setUserId = this.setUserId.bind(this), this.setDeviceId = this.setDeviceId.bind(this), this.setUserProperty = this.setUserProperty.bind(this), this.setUserProperties = this.setUserProperties.bind(this), this.updateUserProperties = this.updateUserProperties.bind(this), this.resetUser = this.resetUser.bind(this), this.variation = this.variation.bind(this), this.variationDetail = this.variationDetail.bind(this), this.isFeatureOn = this.isFeatureOn.bind(this), this.featureFlagDetail = this.featureFlagDetail.bind(this), this.track = this.track.bind(this), this.trackPageView = this.trackPageView.bind(this), this.remoteConfig = this.remoteConfig.bind(this), this.onReady = this.onReady.bind(this), this.onInitialized = this.onInitialized.bind(this), this.showUserExplorer = this.showUserExplorer.bind(this), this.hideUserExplorer = this.hideUserExplorer.bind(this), this.fetch = this.fetch.bind(this), this.close = this.close.bind(this), this.setInAppMessageListener = this.setInAppMessageListener.bind(this);
    }
    return t.prototype.getSessionId = function() {
      try {
        var e = { command: "getSessionId" }, r = this.invocationProcessor.process(e);
        return r ?? Kr();
      } catch (n) {
        return B.error("Unexpected exception while get sessionId: ".concat(n)), Kr();
      }
    }, t.prototype.getUser = function() {
      var e;
      try {
        var r = { command: "getUser" }, n = this.invocationProcessor.process(r);
        return (e = Yr(n)) !== null && e !== void 0 ? e : this.defaultUser();
      } catch (i) {
        return B.error("Unexpected exception while get user: ".concat(i)), this.defaultUser();
      }
    }, t.prototype.setUser = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n;
        return _(this, function(i) {
          try {
            if (r = Yr(e), !r)
              return B.warn("invalid user"), [
                2
                /*return*/
              ];
            n = { command: "setUser", parameters: { user: r } }, this.invocationProcessor.process(n);
          } catch (o) {
            B.error("Unexpected exception while set user: ".concat(o));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.setUserId = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n;
        return _(this, function(i) {
          try {
            if (r = fe.sanitizeValue(e), !r)
              return B.warn("Invalid userId. [userId=".concat(e, "]")), [
                2
                /*return*/
              ];
            n = { command: "setUserId", parameters: { userId: r } }, this.invocationProcessor.process(n);
          } catch (o) {
            B.error("Unexpected exception while set userId: ".concat(o));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.setDeviceId = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n;
        return _(this, function(i) {
          try {
            if (r = fe.sanitizeValue(e), !r)
              return B.warn("Invalid deviceId. [deviceId=".concat(e, "]")), [
                2
                /*return*/
              ];
            n = {
              command: "setDeviceId",
              parameters: { deviceId: r }
            }, this.invocationProcessor.process(n);
          } catch (o) {
            B.error("Unexpected exception while set deviceId: ".concat(o));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.setUserProperty = function(e, r) {
      return M(this, void 0, void 0, function() {
        var n;
        return _(this, function(i) {
          try {
            n = {
              command: "setUserProperty",
              parameters: { key: e, value: r }
            }, this.invocationProcessor.process(n);
          } catch (o) {
            B.error("Unexpected exception while set userProperty: ".concat(o));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.setUserProperties = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n;
        return _(this, function(i) {
          try {
            r = de.sanitize(e), n = new ir(), Object.entries(r).forEach(function(o) {
              var a = o[0], s = o[1];
              n.set(a, s);
            }), this.updateUserProperties(n.build());
          } catch (o) {
            B.error("Unexpected exception while set userProperties: ".concat(o));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.updateUserProperties = function(e) {
      return M(this, void 0, void 0, function() {
        var r;
        return _(this, function(n) {
          try {
            r = {
              command: "updateUserProperties",
              parameters: { operations: e.toRecord() }
            }, this.invocationProcessor.process(r);
          } catch (i) {
            B.error("Unexpected exception while update userProperties: ".concat(i));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.resetUser = function() {
      return M(this, void 0, void 0, function() {
        var e;
        return _(this, function(r) {
          try {
            e = { command: "resetUser" }, this.invocationProcessor.process(e);
          } catch (n) {
            B.error("Unexpected exception while reset user: ".concat(n));
          }
          return [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.variation = function(e, r, n) {
      n === void 0 && (n = "A");
      try {
        var i = {
          command: "variation",
          parameters: { experimentKey: e, defaultVariation: n, user: this.convertUser(r) }
        }, o = this.invocationProcessor.process(i);
        if (!o)
          throw new Error("invoke result data not exists");
        return o;
      } catch (a) {
        return B.error("Unexpected exception while deciding variation for experiment[".concat(e, "]. Returning default variation[").concat(n, "] : ").concat(a)), n;
      }
    }, t.prototype.variationDetail = function(e, r, n) {
      var i;
      n === void 0 && (n = "A");
      try {
        var o = {
          command: "variationDetail",
          parameters: { experimentKey: e, defaultVariation: n, user: this.convertUser(r) }
        }, a = this.invocationProcessor.process(o);
        if (a === null)
          throw new Error("invoke result data not exists");
        return et.of(a.variation, a.reason, new oo(new Map(Object.entries((i = a.config.parameters) !== null && i !== void 0 ? i : {}))));
      } catch (s) {
        return B.error("Unexpected exception while deciding variation for experiment[".concat(e, "]. Returning default variation[").concat(n, "] : ").concat(s)), et.of(n, w.EXCEPTION);
      }
    }, t.prototype.isFeatureOn = function(e, r) {
      try {
        var n = {
          command: "isFeatureOn",
          parameters: { featureKey: e, user: this.convertUser(r) }
        }, i = this.invocationProcessor.process(n);
        if (i === null)
          throw new Error("invoke result data not exists");
        return !!i;
      } catch (o) {
        return B.error("Unexpected exception while deciding feature flag[".concat(e, "]. Returning default value[false] : ").concat(o)), !1;
      }
    }, t.prototype.featureFlagDetail = function(e, r) {
      var n;
      try {
        var i = {
          command: "featureFlagDetail",
          parameters: { featureKey: e, user: this.convertUser(r) }
        }, o = this.invocationProcessor.process(i);
        if (o === null)
          throw new Error("invoke result data not exists");
        return new je(o.isOn, o.reason, new oo(new Map(Object.entries((n = o.config.parameters) !== null && n !== void 0 ? n : {}))), void 0);
      } catch (a) {
        return B.error("Unexpected exception while deciding feature flag[".concat(e, "]. Returning default value[false] : ").concat(a)), je.off(w.EXCEPTION);
      }
    }, t.prototype.track = function(e, r) {
      try {
        var n = {
          command: "track",
          parameters: { event: this.convertEvent(e), user: this.convertUser(r) }
        };
        this.invocationProcessor.process(n);
      } catch (i) {
        B.error("Unexpected exception while tracking event: ".concat(i));
      }
    }, t.prototype.trackPageView = function(e) {
      B.info("Web to app integration feature is not support 'trackPageView' method");
    }, t.prototype.remoteConfig = function(e) {
      return new _g(this.invocationProcessor, this.convertUser(e));
    }, t.prototype.onReady = function(e, r) {
      e();
    }, t.prototype.showUserExplorer = function() {
      try {
        var e = { command: "showUserExplorer" };
        this.invocationProcessor.process(e);
      } catch (r) {
        B.error("Unexpected exception while show userExplorer: ".concat(r));
      }
    }, t.prototype.hideUserExplorer = function() {
      B.info("Web to app integration feature is not support 'hideUserExplorer' method");
    }, t.prototype.setInAppMessageListener = function(e) {
      B.info("Web to app integration feature is not support 'setInAppMessageListener' method");
    }, t.prototype.fetch = function() {
      return Promise.resolve();
    }, t.prototype.onInitialized = function(e) {
      return Promise.resolve({ success: !0 });
    }, t.prototype.close = function() {
      B.info("Web to app integration feature is not support 'close' method");
    }, t.prototype.convertEvent = function(e) {
      return typeof e == "string" ? { key: e } : e;
    }, t.prototype.convertUser = function(e) {
      var r;
      if (typeof e == "string")
        return e;
      if (e)
        return (r = Yr(e)) !== null && r !== void 0 ? r : void 0;
    }, t.prototype.defaultUser = function() {
      return {
        deviceId: Kr()
      };
    }, t;
  }()
), Ug = (
  /** @class */
  function() {
    function t(e, r) {
      this.browser = e, this.app = r, this.getSessionId = this.getSessionId.bind(this), this.getUser = this.getUser.bind(this), this.setUser = this.setUser.bind(this), this.setUserId = this.setUserId.bind(this), this.setDeviceId = this.setDeviceId.bind(this), this.setUserProperty = this.setUserProperty.bind(this), this.setUserProperties = this.setUserProperties.bind(this), this.updateUserProperties = this.updateUserProperties.bind(this), this.resetUser = this.resetUser.bind(this), this.variation = this.variation.bind(this), this.variationDetail = this.variationDetail.bind(this), this.isFeatureOn = this.isFeatureOn.bind(this), this.featureFlagDetail = this.featureFlagDetail.bind(this), this.track = this.track.bind(this), this.trackPageView = this.trackPageView.bind(this), this.remoteConfig = this.remoteConfig.bind(this), this.onReady = this.onReady.bind(this), this.onInitialized = this.onInitialized.bind(this), this.showUserExplorer = this.showUserExplorer.bind(this), this.hideUserExplorer = this.hideUserExplorer.bind(this), this.fetch = this.fetch.bind(this), this.close = this.close.bind(this), this.setInAppMessageListener = this.setInAppMessageListener.bind(this);
    }
    return t.prototype.getSessionId = function() {
      return this.browser.getSessionId();
    }, t.prototype.getUser = function() {
      return this.browser.getUser();
    }, t.prototype.syncUser = function() {
      return M(this, void 0, void 0, function() {
        var e;
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return e = this.browser.getUser(), [4, this.app.setUser(e)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.setUser = function(e) {
      return M(this, void 0, void 0, function() {
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.browser.setUser(e)];
            case 1:
              return r.sent(), [4, this.syncUser()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.setUserId = function(e) {
      return M(this, void 0, void 0, function() {
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.browser.setUserId(e)];
            case 1:
              return r.sent(), [4, this.syncUser()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.setDeviceId = function(e) {
      return M(this, void 0, void 0, function() {
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.browser.setDeviceId(e)];
            case 1:
              return r.sent(), [4, this.syncUser()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.setUserProperty = function(e, r) {
      return M(this, void 0, void 0, function() {
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.browser.setUserProperty(e, r)];
            case 1:
              return n.sent(), [4, this.syncUser()];
            case 2:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.setUserProperties = function(e) {
      return M(this, void 0, void 0, function() {
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.browser.setUserProperties(e)];
            case 1:
              return r.sent(), [4, this.syncUser()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.updateUserProperties = function(e) {
      return M(this, void 0, void 0, function() {
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.browser.updateUserProperties(e)];
            case 1:
              return r.sent(), [4, this.syncUser()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.resetUser = function() {
      return M(this, void 0, void 0, function() {
        return _(this, function(e) {
          switch (e.label) {
            case 0:
              return [4, this.browser.resetUser()];
            case 1:
              return e.sent(), [4, this.syncUser()];
            case 2:
              return e.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.variation = function(e, r, n) {
      return n === void 0 && (n = "A"), this.browser.variation(e, r, n);
    }, t.prototype.variationDetail = function(e, r, n) {
      return n === void 0 && (n = "A"), this.browser.variationDetail(e, r, n);
    }, t.prototype.isFeatureOn = function(e, r) {
      return this.browser.isFeatureOn(e, r);
    }, t.prototype.featureFlagDetail = function(e, r) {
      return this.browser.featureFlagDetail(e, r);
    }, t.prototype.track = function(e, r) {
      return this.browser.track(e, r);
    }, t.prototype.trackPageView = function(e) {
      return this.browser.trackPageView(e);
    }, t.prototype.remoteConfig = function(e) {
      return this.browser.remoteConfig(e);
    }, t.prototype.onReady = function(e, r) {
      this.browser.onReady(e, r);
    }, t.prototype.showUserExplorer = function() {
      this.browser.showUserExplorer();
    }, t.prototype.hideUserExplorer = function() {
      this.browser.hideUserExplorer();
    }, t.prototype.fetch = function() {
      return this.browser.fetch();
    }, t.prototype.onInitialized = function(e) {
      return this.browser.onInitialized(e);
    }, t.prototype.close = function() {
      this.browser.close();
    }, t.prototype.setInAppMessageListener = function(e) {
      this.browser.setInAppMessageListener(e);
    }, t;
  }()
), Is = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Dg = { exports: {} }, Sr = function(t) {
  return t && t.Math == Math && t;
}, X = (
  // eslint-disable-next-line es-x/no-global-this -- safe
  Sr(typeof globalThis == "object" && globalThis) || Sr(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  Sr(typeof self == "object" && self) || Sr(typeof Is == "object" && Is) || // eslint-disable-next-line no-new-func -- fallback
  function() {
    return this;
  }() || Function("return this")()
), wn = {}, F = function(t) {
  try {
    return !!t();
  } catch {
    return !0;
  }
}, Lg = F, ve = !Lg(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] != 7;
}), $g = F, Nn = !$g(function() {
  var t = function() {
  }.bind();
  return typeof t != "function" || t.hasOwnProperty("prototype");
}), kg = Nn, Rr = Function.prototype.call, ee = kg ? Rr.bind(Rr) : function() {
  return Rr.apply(Rr, arguments);
}, Vl = {}, Bl = {}.propertyIsEnumerable, jl = Object.getOwnPropertyDescriptor, Fg = jl && !Bl.call({ 1: 2 }, 1);
Vl.f = Fg ? function(e) {
  var r = jl(this, e);
  return !!r && r.enumerable;
} : Bl;
var Lt = function(t, e) {
  return {
    enumerable: !(t & 1),
    configurable: !(t & 2),
    writable: !(t & 4),
    value: e
  };
}, Hl = Nn, Xl = Function.prototype, Gg = Xl.bind, co = Xl.call, Vg = Hl && Gg.bind(co, co), k = Hl ? function(t) {
  return t && Vg(t);
} : function(t) {
  return t && function() {
    return co.apply(t, arguments);
  };
}, Wl = k, Bg = Wl({}.toString), jg = Wl("".slice), $t = function(t) {
  return jg(Bg(t), 8, -1);
}, Hg = k, Xg = F, Wg = $t, ii = Object, zg = Hg("".split), lt = Xg(function() {
  return !ii("z").propertyIsEnumerable(0);
}) ? function(t) {
  return Wg(t) == "String" ? zg(t, "") : ii(t);
} : ii, Jg = TypeError, Jo = function(t) {
  if (t == null)
    throw Jg("Can't call method on " + t);
  return t;
}, Zg = lt, Yg = Jo, he = function(t) {
  return Zg(Yg(t));
}, G = function(t) {
  return typeof t == "function";
}, Kg = G, oe = function(t) {
  return typeof t == "object" ? t !== null : Kg(t);
}, oi = X, Qg = G, qg = function(t) {
  return Qg(t) ? t : void 0;
}, ne = function(t, e) {
  return arguments.length < 2 ? qg(oi[t]) : oi[t] && oi[t][e];
}, ey = k, On = ey({}.isPrototypeOf), ty = ne, ft = ty("navigator", "userAgent") || "", zl = X, ai = ft, ms = zl.process, As = zl.Deno, Es = ms && ms.versions || As && As.version, Cs = Es && Es.v8, Ae, fn;
Cs && (Ae = Cs.split("."), fn = Ae[0] > 0 && Ae[0] < 4 ? 1 : +(Ae[0] + Ae[1]));
!fn && ai && (Ae = ai.match(/Edge\/(\d+)/), (!Ae || Ae[1] >= 74) && (Ae = ai.match(/Chrome\/(\d+)/), Ae && (fn = +Ae[1])));
var pt = fn, bs = pt, ry = F, Jl = !!Object.getOwnPropertySymbols && !ry(function() {
  var t = Symbol();
  return !String(t) || !(Object(t) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && bs && bs < 41;
}), ny = Jl, Zl = ny && !Symbol.sham && typeof Symbol.iterator == "symbol", iy = ne, oy = G, ay = On, sy = Zl, uy = Object, Yl = sy ? function(t) {
  return typeof t == "symbol";
} : function(t) {
  var e = iy("Symbol");
  return oy(e) && ay(e.prototype, uy(t));
}, cy = String, gr = function(t) {
  try {
    return cy(t);
  } catch {
    return "Object";
  }
}, ly = G, fy = gr, py = TypeError, ie = function(t) {
  if (ly(t))
    return t;
  throw py(fy(t) + " is not a function");
}, dy = ie, dt = function(t, e) {
  var r = t[e];
  return r == null ? void 0 : dy(r);
}, si = ee, ui = G, ci = oe, vy = TypeError, hy = function(t, e) {
  var r, n;
  if (e === "string" && ui(r = t.toString) && !ci(n = si(r, t)) || ui(r = t.valueOf) && !ci(n = si(r, t)) || e !== "string" && ui(r = t.toString) && !ci(n = si(r, t)))
    return n;
  throw vy("Can't convert object to primitive value");
}, Zo = { exports: {} }, Ts = X, gy = Object.defineProperty, Yo = function(t, e) {
  try {
    gy(Ts, t, { value: e, configurable: !0, writable: !0 });
  } catch {
    Ts[t] = e;
  }
  return e;
}, yy = X, Iy = Yo, ws = "__core-js_shared__", my = yy[ws] || Iy(ws, {}), Mn = my, Ns = Mn;
(Zo.exports = function(t, e) {
  return Ns[t] || (Ns[t] = e !== void 0 ? e : {});
})("versions", []).push({
  version: "3.24.1",
  mode: "global",
  copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.24.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var Ay = Jo, Ey = Object, W = function(t) {
  return Ey(Ay(t));
}, Cy = k, by = W, Ty = Cy({}.hasOwnProperty), Te = Object.hasOwn || function(e, r) {
  return Ty(by(e), r);
}, wy = k, Ny = 0, Oy = Math.random(), My = wy(1 .toString), Ko = function(t) {
  return "Symbol(" + (t === void 0 ? "" : t) + ")_" + My(++Ny + Oy, 36);
}, _y = X, Sy = Zo.exports, Os = Te, Ry = Ko, Ms = Jl, Kl = Zl, It = Sy("wks"), it = _y.Symbol, _s = it && it.for, xy = Kl ? it : it && it.withoutSetter || Ry, z = function(t) {
  if (!Os(It, t) || !(Ms || typeof It[t] == "string")) {
    var e = "Symbol." + t;
    Ms && Os(it, t) ? It[t] = it[t] : Kl && _s ? It[t] = _s(e) : It[t] = xy(e);
  }
  return It[t];
}, Py = ee, Ss = oe, Rs = Yl, Uy = dt, Dy = hy, Ly = z, $y = TypeError, ky = Ly("toPrimitive"), Fy = function(t, e) {
  if (!Ss(t) || Rs(t))
    return t;
  var r = Uy(t, ky), n;
  if (r) {
    if (e === void 0 && (e = "default"), n = Py(r, t, e), !Ss(n) || Rs(n))
      return n;
    throw $y("Can't convert object to primitive value");
  }
  return e === void 0 && (e = "number"), Dy(t, e);
}, Gy = Fy, Vy = Yl, _n = function(t) {
  var e = Gy(t, "string");
  return Vy(e) ? e : e + "";
}, By = X, xs = oe, lo = By.document, jy = xs(lo) && xs(lo.createElement), Sn = function(t) {
  return jy ? lo.createElement(t) : {};
}, Hy = ve, Xy = F, Wy = Sn, Ql = !Hy && !Xy(function() {
  return Object.defineProperty(Wy("div"), "a", {
    get: function() {
      return 7;
    }
  }).a != 7;
}), zy = ve, Jy = ee, Zy = Vl, Yy = Lt, Ky = he, Qy = _n, qy = Te, eI = Ql, Ps = Object.getOwnPropertyDescriptor;
wn.f = zy ? Ps : function(e, r) {
  if (e = Ky(e), r = Qy(r), eI)
    try {
      return Ps(e, r);
    } catch {
    }
  if (qy(e, r))
    return Yy(!Jy(Zy.f, e, r), e[r]);
};
var ge = {}, tI = ve, rI = F, ql = tI && rI(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype != 42;
}), nI = oe, iI = String, oI = TypeError, ae = function(t) {
  if (nI(t))
    return t;
  throw oI(iI(t) + " is not an object");
}, aI = ve, sI = Ql, uI = ql, xr = ae, Us = _n, cI = TypeError, li = Object.defineProperty, lI = Object.getOwnPropertyDescriptor, fi = "enumerable", pi = "configurable", di = "writable";
ge.f = aI ? uI ? function(e, r, n) {
  if (xr(e), r = Us(r), xr(n), typeof e == "function" && r === "prototype" && "value" in n && di in n && !n[di]) {
    var i = lI(e, r);
    i && i[di] && (e[r] = n.value, n = {
      configurable: pi in n ? n[pi] : i[pi],
      enumerable: fi in n ? n[fi] : i[fi],
      writable: !1
    });
  }
  return li(e, r, n);
} : li : function(e, r, n) {
  if (xr(e), r = Us(r), xr(n), sI)
    try {
      return li(e, r, n);
    } catch {
    }
  if ("get" in n || "set" in n)
    throw cI("Accessors not supported");
  return "value" in n && (e[r] = n.value), e;
};
var fI = ve, pI = ge, dI = Lt, kt = fI ? function(t, e, r) {
  return pI.f(t, e, dI(1, r));
} : function(t, e, r) {
  return t[e] = r, t;
}, Qo = { exports: {} }, fo = ve, vI = Te, ef = Function.prototype, hI = fo && Object.getOwnPropertyDescriptor, qo = vI(ef, "name"), gI = qo && function() {
}.name === "something", yI = qo && (!fo || fo && hI(ef, "name").configurable), tf = {
  EXISTS: qo,
  PROPER: gI,
  CONFIGURABLE: yI
}, II = k, mI = G, po = Mn, AI = II(Function.toString);
mI(po.inspectSource) || (po.inspectSource = function(t) {
  return AI(t);
});
var Rn = po.inspectSource, EI = X, CI = G, bI = Rn, Ds = EI.WeakMap, TI = CI(Ds) && /native code/.test(bI(Ds)), wI = Zo.exports, NI = Ko, Ls = wI("keys"), ea = function(t) {
  return Ls[t] || (Ls[t] = NI(t));
}, xn = {}, OI = TI, rf = X, vi = k, MI = oe, _I = kt, hi = Te, gi = Mn, SI = ea, RI = xn, $s = "Object already initialized", vo = rf.TypeError, xI = rf.WeakMap, pn, lr, dn, PI = function(t) {
  return dn(t) ? lr(t) : pn(t, {});
}, UI = function(t) {
  return function(e) {
    var r;
    if (!MI(e) || (r = lr(e)).type !== t)
      throw vo("Incompatible receiver, " + t + " required");
    return r;
  };
};
if (OI || gi.state) {
  var Je = gi.state || (gi.state = new xI()), DI = vi(Je.get), ks = vi(Je.has), LI = vi(Je.set);
  pn = function(t, e) {
    if (ks(Je, t))
      throw new vo($s);
    return e.facade = t, LI(Je, t, e), e;
  }, lr = function(t) {
    return DI(Je, t) || {};
  }, dn = function(t) {
    return ks(Je, t);
  };
} else {
  var mt = SI("state");
  RI[mt] = !0, pn = function(t, e) {
    if (hi(t, mt))
      throw new vo($s);
    return e.facade = t, _I(t, mt, e), e;
  }, lr = function(t) {
    return hi(t, mt) ? t[mt] : {};
  }, dn = function(t) {
    return hi(t, mt);
  };
}
var Ft = {
  set: pn,
  get: lr,
  has: dn,
  enforce: PI,
  getterFor: UI
}, $I = F, kI = G, Pr = Te, ho = ve, FI = tf.CONFIGURABLE, GI = Rn, nf = Ft, VI = nf.enforce, BI = nf.get, Qr = Object.defineProperty, jI = ho && !$I(function() {
  return Qr(function() {
  }, "length", { value: 8 }).length !== 8;
}), HI = String(String).split("String"), XI = Qo.exports = function(t, e, r) {
  String(e).slice(0, 7) === "Symbol(" && (e = "[" + String(e).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), r && r.getter && (e = "get " + e), r && r.setter && (e = "set " + e), (!Pr(t, "name") || FI && t.name !== e) && (ho ? Qr(t, "name", { value: e, configurable: !0 }) : t.name = e), jI && r && Pr(r, "arity") && t.length !== r.arity && Qr(t, "length", { value: r.arity });
  try {
    r && Pr(r, "constructor") && r.constructor ? ho && Qr(t, "prototype", { writable: !1 }) : t.prototype && (t.prototype = void 0);
  } catch {
  }
  var n = VI(t);
  return Pr(n, "source") || (n.source = HI.join(typeof e == "string" ? e : "")), t;
};
Function.prototype.toString = XI(function() {
  return kI(this) && BI(this).source || GI(this);
}, "toString");
var WI = G, zI = ge, JI = Qo.exports, ZI = Yo, Se = function(t, e, r, n) {
  n || (n = {});
  var i = n.enumerable, o = n.name !== void 0 ? n.name : e;
  if (WI(r) && JI(r, o, n), n.global)
    i ? t[e] = r : ZI(e, r);
  else {
    try {
      n.unsafe ? t[e] && (i = !0) : delete t[e];
    } catch {
    }
    i ? t[e] = r : zI.f(t, e, {
      value: r,
      enumerable: !1,
      configurable: !n.nonConfigurable,
      writable: !n.nonWritable
    });
  }
  return t;
}, Pn = {}, YI = Math.ceil, KI = Math.floor, QI = Math.trunc || function(e) {
  var r = +e;
  return (r > 0 ? KI : YI)(r);
}, qI = QI, Fe = function(t) {
  var e = +t;
  return e !== e || e === 0 ? 0 : qI(e);
}, em = Fe, tm = Math.max, rm = Math.min, vt = function(t, e) {
  var r = em(t);
  return r < 0 ? tm(r + e, 0) : rm(r, e);
}, nm = Fe, im = Math.min, om = function(t) {
  return t > 0 ? im(nm(t), 9007199254740991) : 0;
}, am = om, L = function(t) {
  return am(t.length);
}, sm = he, um = vt, cm = L, Fs = function(t) {
  return function(e, r, n) {
    var i = sm(e), o = cm(i), a = um(n, o), s;
    if (t && r != r) {
      for (; o > a; )
        if (s = i[a++], s != s)
          return !0;
    } else
      for (; o > a; a++)
        if ((t || a in i) && i[a] === r)
          return t || a || 0;
    return !t && -1;
  };
}, ta = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: Fs(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: Fs(!1)
}, lm = k, yi = Te, fm = he, pm = ta.indexOf, dm = xn, Gs = lm([].push), of = function(t, e) {
  var r = fm(t), n = 0, i = [], o;
  for (o in r)
    !yi(dm, o) && yi(r, o) && Gs(i, o);
  for (; e.length > n; )
    yi(r, o = e[n++]) && (~pm(i, o) || Gs(i, o));
  return i;
}, ra = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], vm = of, hm = ra, gm = hm.concat("length", "prototype");
Pn.f = Object.getOwnPropertyNames || function(e) {
  return vm(e, gm);
};
var af = {};
af.f = Object.getOwnPropertySymbols;
var ym = ne, Im = k, mm = Pn, Am = af, Em = ae, Cm = Im([].concat), bm = ym("Reflect", "ownKeys") || function(e) {
  var r = mm.f(Em(e)), n = Am.f;
  return n ? Cm(r, n(e)) : r;
}, Vs = Te, Tm = bm, wm = wn, Nm = ge, sf = function(t, e, r) {
  for (var n = Tm(e), i = Nm.f, o = wm.f, a = 0; a < n.length; a++) {
    var s = n[a];
    !Vs(t, s) && !(r && Vs(r, s)) && i(t, s, o(e, s));
  }
}, Om = F, Mm = G, _m = /#|\.prototype\./, yr = function(t, e) {
  var r = Rm[Sm(t)];
  return r == Pm ? !0 : r == xm ? !1 : Mm(e) ? Om(e) : !!e;
}, Sm = yr.normalize = function(t) {
  return String(t).replace(_m, ".").toLowerCase();
}, Rm = yr.data = {}, xm = yr.NATIVE = "N", Pm = yr.POLYFILL = "P", na = yr, Ii = X, Um = wn.f, Dm = kt, Lm = Se, $m = Yo, km = sf, Fm = na, E = function(t, e) {
  var r = t.target, n = t.global, i = t.stat, o, a, s, u, c, l;
  if (n ? a = Ii : i ? a = Ii[r] || $m(r, {}) : a = (Ii[r] || {}).prototype, a)
    for (s in e) {
      if (c = e[s], t.dontCallGetSet ? (l = Um(a, s), u = l && l.value) : u = a[s], o = Fm(n ? s : r + (i ? "." : "#") + s, t.forced), !o && u !== void 0) {
        if (typeof c == typeof u)
          continue;
        km(c, u);
      }
      (t.sham || u && u.sham) && Dm(c, "sham", !0), Lm(a, s, c, t);
    }
}, Gm = F, Vm = !Gm(function() {
  function t() {
  }
  return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
}), Bm = Te, jm = G, Hm = W, Xm = ea, Wm = Vm, Bs = Xm("IE_PROTO"), go = Object, zm = go.prototype, Un = Wm ? go.getPrototypeOf : function(t) {
  var e = Hm(t);
  if (Bm(e, Bs))
    return e[Bs];
  var r = e.constructor;
  return jm(r) && e instanceof r ? r.prototype : e instanceof go ? zm : null;
}, Jm = G, Zm = String, Ym = TypeError, Km = function(t) {
  if (typeof t == "object" || Jm(t))
    return t;
  throw Ym("Can't set " + Zm(t) + " as a prototype");
}, Qm = k, qm = ae, eA = Km, Dn = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var t = !1, e = {}, r;
  try {
    r = Qm(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set), r(e, []), t = e instanceof Array;
  } catch {
  }
  return function(i, o) {
    return qm(i), eA(o), t ? r(i, o) : i.__proto__ = o, i;
  };
}() : void 0), uf = {}, tA = of, rA = ra, nA = Object.keys || function(e) {
  return tA(e, rA);
}, iA = ve, oA = ql, aA = ge, sA = ae, uA = he, cA = nA;
uf.f = iA && !oA ? Object.defineProperties : function(e, r) {
  sA(e);
  for (var n = uA(r), i = cA(r), o = i.length, a = 0, s; o > a; )
    aA.f(e, s = i[a++], n[s]);
  return e;
};
var lA = ne, cf = lA("document", "documentElement"), fA = ae, pA = uf, js = ra, dA = xn, vA = cf, hA = Sn, gA = ea, Hs = ">", Xs = "<", yo = "prototype", Io = "script", lf = gA("IE_PROTO"), mi = function() {
}, ff = function(t) {
  return Xs + Io + Hs + t + Xs + "/" + Io + Hs;
}, Ws = function(t) {
  t.write(ff("")), t.close();
  var e = t.parentWindow.Object;
  return t = null, e;
}, yA = function() {
  var t = hA("iframe"), e = "java" + Io + ":", r;
  return t.style.display = "none", vA.appendChild(t), t.src = String(e), r = t.contentWindow.document, r.open(), r.write(ff("document.F=Object")), r.close(), r.F;
}, Ur, qr = function() {
  try {
    Ur = new ActiveXObject("htmlfile");
  } catch {
  }
  qr = typeof document < "u" ? document.domain && Ur ? Ws(Ur) : yA() : Ws(Ur);
  for (var t = js.length; t--; )
    delete qr[yo][js[t]];
  return qr();
};
dA[lf] = !0;
var Gt = Object.create || function(e, r) {
  var n;
  return e !== null ? (mi[yo] = fA(e), n = new mi(), mi[yo] = null, n[lf] = e) : n = qr(), r === void 0 ? n : pA.f(n, r);
}, IA = k, pf = Error, mA = IA("".replace), AA = function(t) {
  return String(pf(t).stack);
}("zxcasd"), df = /\n\s*at [^:]*:[^\n]*/, EA = df.test(AA), CA = function(t, e) {
  if (EA && typeof t == "string" && !pf.prepareStackTrace)
    for (; e--; )
      t = mA(t, df, "");
  return t;
}, bA = oe, TA = kt, wA = function(t, e) {
  bA(e) && "cause" in e && TA(t, "cause", e.cause);
}, zs = k, NA = ie, OA = Nn, MA = zs(zs.bind), we = function(t, e) {
  return NA(t), e === void 0 ? t : OA ? MA(t, e) : function() {
    return t.apply(e, arguments);
  };
}, Ir = {}, _A = z, SA = Ir, RA = _A("iterator"), xA = Array.prototype, vf = function(t) {
  return t !== void 0 && (SA.Array === t || xA[RA] === t);
}, PA = z, UA = PA("toStringTag"), hf = {};
hf[UA] = "z";
var ia = String(hf) === "[object z]", DA = ia, LA = G, en = $t, $A = z, kA = $A("toStringTag"), FA = Object, GA = en(function() {
  return arguments;
}()) == "Arguments", VA = function(t, e) {
  try {
    return t[e];
  } catch {
  }
}, Ln = DA ? en : function(t) {
  var e, r, n;
  return t === void 0 ? "Undefined" : t === null ? "Null" : typeof (r = VA(e = FA(t), kA)) == "string" ? r : GA ? en(e) : (n = en(e)) == "Object" && LA(e.callee) ? "Arguments" : n;
}, BA = Ln, Js = dt, jA = Ir, HA = z, XA = HA("iterator"), $n = function(t) {
  if (t != null)
    return Js(t, XA) || Js(t, "@@iterator") || jA[BA(t)];
}, WA = ee, zA = ie, JA = ae, ZA = gr, YA = $n, KA = TypeError, kn = function(t, e) {
  var r = arguments.length < 2 ? YA(t) : e;
  if (zA(r))
    return JA(WA(r, t));
  throw KA(ZA(t) + " is not iterable");
}, QA = ee, Zs = ae, qA = dt, gf = function(t, e, r) {
  var n, i;
  Zs(t);
  try {
    if (n = qA(t, "return"), !n) {
      if (e === "throw")
        throw r;
      return r;
    }
    n = QA(n, t);
  } catch (o) {
    i = !0, n = o;
  }
  if (e === "throw")
    throw r;
  if (i)
    throw n;
  return Zs(n), r;
}, eE = we, tE = ee, rE = ae, nE = gr, iE = vf, oE = L, Ys = On, aE = kn, sE = $n, Ks = gf, uE = TypeError, tn = function(t, e) {
  this.stopped = t, this.result = e;
}, Qs = tn.prototype, ht = function(t, e, r) {
  var n = r && r.that, i = !!(r && r.AS_ENTRIES), o = !!(r && r.IS_RECORD), a = !!(r && r.IS_ITERATOR), s = !!(r && r.INTERRUPTED), u = eE(e, n), c, l, f, p, d, C, R, S = function(N) {
    return c && Ks(c, "normal", N), new tn(!0, N);
  }, T = function(N) {
    return i ? (rE(N), s ? u(N[0], N[1], S) : u(N[0], N[1])) : s ? u(N, S) : u(N);
  };
  if (o)
    c = t.iterator;
  else if (a)
    c = t;
  else {
    if (l = sE(t), !l)
      throw uE(nE(t) + " is not iterable");
    if (iE(l)) {
      for (f = 0, p = oE(t); p > f; f++)
        if (d = T(t[f]), d && Ys(Qs, d))
          return d;
      return new tn(!1);
    }
    c = aE(t, l);
  }
  for (C = o ? t.next : c.next; !(R = tE(C, c)).done; ) {
    try {
      d = T(R.value);
    } catch (N) {
      Ks(c, "throw", N);
    }
    if (typeof d == "object" && d && Ys(Qs, d))
      return d;
  }
  return new tn(!1);
}, cE = Ln, lE = String, Fn = function(t) {
  if (cE(t) === "Symbol")
    throw TypeError("Cannot convert a Symbol value to a string");
  return lE(t);
}, fE = Fn, pE = function(t, e) {
  return t === void 0 ? arguments.length < 2 ? "" : e : fE(t);
}, dE = F, vE = Lt, hE = !dE(function() {
  var t = Error("a");
  return "stack" in t ? (Object.defineProperty(t, "stack", vE(1, 7)), t.stack !== 7) : !0;
}), gE = E, yE = On, IE = Un, vn = Dn, mE = sf, yf = Gt, Dr = kt, Ai = Lt, AE = CA, EE = wA, CE = ht, bE = pE, TE = z, wE = hE, NE = TE("toStringTag"), hn = Error, OE = [].push, fr = function(e, r) {
  var n = arguments.length > 2 ? arguments[2] : void 0, i = yE(Ei, this), o;
  vn ? o = vn(new hn(), i ? IE(this) : Ei) : (o = i ? this : yf(Ei), Dr(o, NE, "Error")), r !== void 0 && Dr(o, "message", bE(r)), wE && Dr(o, "stack", AE(o.stack, 1)), EE(o, n);
  var a = [];
  return CE(e, OE, { that: a }), Dr(o, "errors", a), o;
};
vn ? vn(fr, hn) : mE(fr, hn, { name: !0 });
var Ei = fr.prototype = yf(hn.prototype, {
  constructor: Ai(1, fr),
  message: Ai(1, ""),
  name: Ai(1, "AggregateError")
});
gE({ global: !0, constructor: !0, arity: 2 }, {
  AggregateError: fr
});
var ME = z, _E = Gt, SE = ge.f, mo = ME("unscopables"), Ao = Array.prototype;
Ao[mo] == null && SE(Ao, mo, {
  configurable: !0,
  value: _E(null)
});
var V = function(t) {
  Ao[mo][t] = !0;
}, RE = F, xE = G, qs = Un, PE = Se, UE = z, Eo = UE("iterator"), If = !1, ut, Ci, bi;
[].keys && (bi = [].keys(), "next" in bi ? (Ci = qs(qs(bi)), Ci !== Object.prototype && (ut = Ci)) : If = !0);
var DE = ut == null || RE(function() {
  var t = {};
  return ut[Eo].call(t) !== t;
});
DE && (ut = {});
xE(ut[Eo]) || PE(ut, Eo, function() {
  return this;
});
var mf = {
  IteratorPrototype: ut,
  BUGGY_SAFARI_ITERATORS: If
}, LE = ge.f, $E = Te, kE = z, eu = kE("toStringTag"), Gn = function(t, e, r) {
  t && !r && (t = t.prototype), t && !$E(t, eu) && LE(t, eu, { configurable: !0, value: e });
}, FE = mf.IteratorPrototype, GE = Gt, VE = Lt, BE = Gn, jE = Ir, HE = function() {
  return this;
}, XE = function(t, e, r, n) {
  var i = e + " Iterator";
  return t.prototype = GE(FE, { next: VE(+!n, r) }), BE(t, i, !1), jE[i] = HE, t;
}, WE = E, zE = ee, Af = tf, JE = G, ZE = XE, tu = Un, ru = Dn, YE = Gn, KE = kt, Ti = Se, QE = z, qE = Ir, Ef = mf, eC = Af.PROPER, tC = Af.CONFIGURABLE, nu = Ef.IteratorPrototype, Lr = Ef.BUGGY_SAFARI_ITERATORS, Wt = QE("iterator"), iu = "keys", zt = "values", ou = "entries", rC = function() {
  return this;
}, oa = function(t, e, r, n, i, o, a) {
  ZE(r, e, n);
  var s = function(T) {
    if (T === i && p)
      return p;
    if (!Lr && T in l)
      return l[T];
    switch (T) {
      case iu:
        return function() {
          return new r(this, T);
        };
      case zt:
        return function() {
          return new r(this, T);
        };
      case ou:
        return function() {
          return new r(this, T);
        };
    }
    return function() {
      return new r(this);
    };
  }, u = e + " Iterator", c = !1, l = t.prototype, f = l[Wt] || l["@@iterator"] || i && l[i], p = !Lr && f || s(i), d = e == "Array" && l.entries || f, C, R, S;
  if (d && (C = tu(d.call(new t())), C !== Object.prototype && C.next && (tu(C) !== nu && (ru ? ru(C, nu) : JE(C[Wt]) || Ti(C, Wt, rC)), YE(C, u, !0))), eC && i == zt && f && f.name !== zt && (tC ? KE(l, "name", zt) : (c = !0, p = function() {
    return zE(f, this);
  })), i)
    if (R = {
      values: s(zt),
      keys: o ? p : s(iu),
      entries: s(ou)
    }, a)
      for (S in R)
        (Lr || c || !(S in l)) && Ti(l, S, R[S]);
    else
      WE({ target: e, proto: !0, forced: Lr || c }, R);
  return l[Wt] !== p && Ti(l, Wt, p, { name: i }), qE[e] = p, R;
}, nC = he, aa = V, au = Ir, Cf = Ft, iC = ge.f, oC = oa, aC = ve, bf = "Array Iterator", sC = Cf.set, uC = Cf.getterFor(bf), cC = oC(Array, "Array", function(t, e) {
  sC(this, {
    type: bf,
    target: nC(t),
    // target
    index: 0,
    // next index
    kind: e
    // kind
  });
}, function() {
  var t = uC(this), e = t.target, r = t.kind, n = t.index++;
  return !e || n >= e.length ? (t.target = void 0, { value: void 0, done: !0 }) : r == "keys" ? { value: n, done: !1 } : r == "values" ? { value: e[n], done: !1 } : { value: [n, e[n]], done: !1 };
}, "values"), su = au.Arguments = au.Array;
aa("keys");
aa("values");
aa("entries");
if (aC && su.name !== "values")
  try {
    iC(su, "name", { value: "values" });
  } catch {
  }
var lC = ia, fC = Ln, pC = lC ? {}.toString : function() {
  return "[object " + fC(this) + "]";
}, dC = ia, vC = Se, hC = pC;
dC || vC(Object.prototype, "toString", hC, { unsafe: !0 });
var gC = $t, yC = X, Vt = gC(yC.process) == "process", IC = ne, mC = ge, AC = z, EC = ve, uu = AC("species"), sa = function(t) {
  var e = IC(t), r = mC.f;
  EC && e && !e[uu] && r(e, uu, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, CC = On, bC = TypeError, ua = function(t, e) {
  if (CC(e, t))
    return t;
  throw bC("Incorrect invocation");
}, TC = k, wC = F, Tf = G, NC = Ln, OC = ne, MC = Rn, wf = function() {
}, _C = [], Nf = OC("Reflect", "construct"), ca = /^\s*(?:class|function)\b/, SC = TC(ca.exec), RC = !ca.exec(wf), Jt = function(e) {
  if (!Tf(e))
    return !1;
  try {
    return Nf(wf, _C, e), !0;
  } catch {
    return !1;
  }
}, Of = function(e) {
  if (!Tf(e))
    return !1;
  switch (NC(e)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return RC || !!SC(ca, MC(e));
  } catch {
    return !0;
  }
};
Of.sham = !0;
var Bt = !Nf || wC(function() {
  var t;
  return Jt(Jt.call) || !Jt(Object) || !Jt(function() {
    t = !0;
  }) || t;
}) ? Of : Jt, xC = Bt, PC = gr, UC = TypeError, DC = function(t) {
  if (xC(t))
    return t;
  throw UC(PC(t) + " is not a constructor");
}, cu = ae, LC = DC, $C = z, kC = $C("species"), Mf = function(t, e) {
  var r = cu(t).constructor, n;
  return r === void 0 || (n = cu(r)[kC]) == null ? e : LC(n);
}, FC = Nn, _f = Function.prototype, lu = _f.apply, fu = _f.call, Sf = typeof Reflect == "object" && Reflect.apply || (FC ? fu.bind(lu) : function() {
  return fu.apply(lu, arguments);
}), GC = k, Rf = GC([].slice), VC = TypeError, BC = function(t, e) {
  if (t < e)
    throw VC("Not enough arguments");
  return t;
}, jC = ft, xf = /(?:ipad|iphone|ipod).*applewebkit/i.test(jC), pe = X, HC = Sf, XC = we, pu = G, WC = Te, zC = F, du = cf, JC = Rf, vu = Sn, ZC = BC, YC = xf, KC = Vt, Co = pe.setImmediate, bo = pe.clearImmediate, QC = pe.process, wi = pe.Dispatch, qC = pe.Function, hu = pe.MessageChannel, eb = pe.String, Ni = 0, or = {}, gu = "onreadystatechange", pr, Ze, Oi, Mi;
try {
  pr = pe.location;
} catch {
}
var la = function(t) {
  if (WC(or, t)) {
    var e = or[t];
    delete or[t], e();
  }
}, _i = function(t) {
  return function() {
    la(t);
  };
}, yu = function(t) {
  la(t.data);
}, Iu = function(t) {
  pe.postMessage(eb(t), pr.protocol + "//" + pr.host);
};
(!Co || !bo) && (Co = function(e) {
  ZC(arguments.length, 1);
  var r = pu(e) ? e : qC(e), n = JC(arguments, 1);
  return or[++Ni] = function() {
    HC(r, void 0, n);
  }, Ze(Ni), Ni;
}, bo = function(e) {
  delete or[e];
}, KC ? Ze = function(t) {
  QC.nextTick(_i(t));
} : wi && wi.now ? Ze = function(t) {
  wi.now(_i(t));
} : hu && !YC ? (Oi = new hu(), Mi = Oi.port2, Oi.port1.onmessage = yu, Ze = XC(Mi.postMessage, Mi)) : pe.addEventListener && pu(pe.postMessage) && !pe.importScripts && pr && pr.protocol !== "file:" && !zC(Iu) ? (Ze = Iu, pe.addEventListener("message", yu, !1)) : gu in vu("script") ? Ze = function(t) {
  du.appendChild(vu("script"))[gu] = function() {
    du.removeChild(this), la(t);
  };
} : Ze = function(t) {
  setTimeout(_i(t), 0);
});
var Pf = {
  set: Co,
  clear: bo
}, tb = ft, rb = X, nb = /ipad|iphone|ipod/i.test(tb) && rb.Pebble !== void 0, ib = ft, ob = /web0s(?!.*chrome)/i.test(ib), ct = X, mu = we, ab = wn.f, Si = Pf.set, sb = xf, ub = nb, cb = ob, Ri = Vt, Au = ct.MutationObserver || ct.WebKitMutationObserver, Eu = ct.document, Cu = ct.process, $r = ct.Promise, bu = ab(ct, "queueMicrotask"), Uf = bu && bu.value, Zt, Ke, ar, bt, xi, Pi, kr, Tu;
Uf || (Zt = function() {
  var t, e;
  for (Ri && (t = Cu.domain) && t.exit(); Ke; ) {
    e = Ke.fn, Ke = Ke.next;
    try {
      e();
    } catch (r) {
      throw Ke ? bt() : ar = void 0, r;
    }
  }
  ar = void 0, t && t.enter();
}, !sb && !Ri && !cb && Au && Eu ? (xi = !0, Pi = Eu.createTextNode(""), new Au(Zt).observe(Pi, { characterData: !0 }), bt = function() {
  Pi.data = xi = !xi;
}) : !ub && $r && $r.resolve ? (kr = $r.resolve(void 0), kr.constructor = $r, Tu = mu(kr.then, kr), bt = function() {
  Tu(Zt);
}) : Ri ? bt = function() {
  Cu.nextTick(Zt);
} : (Si = mu(Si, ct), bt = function() {
  Si(Zt);
}));
var lb = Uf || function(t) {
  var e = { fn: t, next: void 0 };
  ar && (ar.next = e), Ke || (Ke = e, bt()), ar = e;
}, fb = X, pb = function(t, e) {
  var r = fb.console;
  r && r.error && (arguments.length == 1 ? r.error(t) : r.error(t, e));
}, jt = function(t) {
  try {
    return { error: !1, value: t() };
  } catch (e) {
    return { error: !0, value: e };
  }
}, Df = function() {
  this.head = null, this.tail = null;
};
Df.prototype = {
  add: function(t) {
    var e = { item: t, next: null };
    this.head ? this.tail.next = e : this.head = e, this.tail = e;
  },
  get: function() {
    var t = this.head;
    if (t)
      return this.head = t.next, this.tail === t && (this.tail = null), t.item;
  }
};
var db = Df, vb = X, mr = vb.Promise, Lf = typeof Deno == "object" && Deno && typeof Deno.version == "object", hb = Lf, gb = Vt, yb = !hb && !gb && typeof window == "object" && typeof document == "object", Ib = X, sr = mr, mb = G, Ab = na, Eb = Rn, Cb = z, bb = yb, Tb = Lf, Ui = pt;
sr && sr.prototype;
var wb = Cb("species"), To = !1, $f = mb(Ib.PromiseRejectionEvent), Nb = Ab("Promise", function() {
  var t = Eb(sr), e = t !== String(sr);
  if (!e && Ui === 66)
    return !0;
  if (!Ui || Ui < 51 || !/native code/.test(t)) {
    var r = new sr(function(o) {
      o(1);
    }), n = function(o) {
      o(function() {
      }, function() {
      });
    }, i = r.constructor = {};
    if (i[wb] = n, To = r.then(function() {
    }) instanceof n, !To)
      return !0;
  }
  return !e && (bb || Tb) && !$f;
}), Ar = {
  CONSTRUCTOR: Nb,
  REJECTION_EVENT: $f,
  SUBCLASSING: To
}, Ge = {}, wu = ie, Ob = function(t) {
  var e, r;
  this.promise = new t(function(n, i) {
    if (e !== void 0 || r !== void 0)
      throw TypeError("Bad Promise constructor");
    e = n, r = i;
  }), this.resolve = wu(e), this.reject = wu(r);
};
Ge.f = function(t) {
  return new Ob(t);
};
var Mb = E, gn = Vt, ze = X, Rt = ee, Nu = Se, Ou = Dn, _b = Gn, Sb = sa, Rb = ie, rn = G, xb = oe, Pb = ua, Ub = Mf, kf = Pf.set, fa = lb, Db = pb, Lb = jt, $b = db, Ff = Ft, yn = mr, pa = Ar, Gf = Ge, Vn = "Promise", Vf = pa.CONSTRUCTOR, kb = pa.REJECTION_EVENT, Fb = pa.SUBCLASSING, Di = Ff.getterFor(Vn), Gb = Ff.set, Tt = yn && yn.prototype, Qe = yn, Fr = Tt, Bf = ze.TypeError, wo = ze.document, da = ze.process, No = Gf.f, Vb = No, Bb = !!(wo && wo.createEvent && ze.dispatchEvent), jf = "unhandledrejection", jb = "rejectionhandled", Mu = 0, Hf = 1, Hb = 2, va = 1, Xf = 2, Gr, _u, Xb, Su, Wf = function(t) {
  var e;
  return xb(t) && rn(e = t.then) ? e : !1;
}, zf = function(t, e) {
  var r = e.value, n = e.state == Hf, i = n ? t.ok : t.fail, o = t.resolve, a = t.reject, s = t.domain, u, c, l;
  try {
    i ? (n || (e.rejection === Xf && zb(e), e.rejection = va), i === !0 ? u = r : (s && s.enter(), u = i(r), s && (s.exit(), l = !0)), u === t.promise ? a(Bf("Promise-chain cycle")) : (c = Wf(u)) ? Rt(c, u, o, a) : o(u)) : a(r);
  } catch (f) {
    s && !l && s.exit(), a(f);
  }
}, Jf = function(t, e) {
  t.notified || (t.notified = !0, fa(function() {
    for (var r = t.reactions, n; n = r.get(); )
      zf(n, t);
    t.notified = !1, e && !t.rejection && Wb(t);
  }));
}, Zf = function(t, e, r) {
  var n, i;
  Bb ? (n = wo.createEvent("Event"), n.promise = e, n.reason = r, n.initEvent(t, !1, !0), ze.dispatchEvent(n)) : n = { promise: e, reason: r }, !kb && (i = ze["on" + t]) ? i(n) : t === jf && Db("Unhandled promise rejection", r);
}, Wb = function(t) {
  Rt(kf, ze, function() {
    var e = t.facade, r = t.value, n = Ru(t), i;
    if (n && (i = Lb(function() {
      gn ? da.emit("unhandledRejection", r, e) : Zf(jf, e, r);
    }), t.rejection = gn || Ru(t) ? Xf : va, i.error))
      throw i.value;
  });
}, Ru = function(t) {
  return t.rejection !== va && !t.parent;
}, zb = function(t) {
  Rt(kf, ze, function() {
    var e = t.facade;
    gn ? da.emit("rejectionHandled", e) : Zf(jb, e, t.value);
  });
}, wt = function(t, e, r) {
  return function(n) {
    t(e, n, r);
  };
}, Mt = function(t, e, r) {
  t.done || (t.done = !0, r && (t = r), t.value = e, t.state = Hb, Jf(t, !0));
}, Oo = function(t, e, r) {
  if (!t.done) {
    t.done = !0, r && (t = r);
    try {
      if (t.facade === e)
        throw Bf("Promise can't be resolved itself");
      var n = Wf(e);
      n ? fa(function() {
        var i = { done: !1 };
        try {
          Rt(
            n,
            e,
            wt(Oo, i, t),
            wt(Mt, i, t)
          );
        } catch (o) {
          Mt(i, o, t);
        }
      }) : (t.value = e, t.state = Hf, Jf(t, !1));
    } catch (i) {
      Mt({ done: !1 }, i, t);
    }
  }
};
if (Vf && (Qe = function(e) {
  Pb(this, Fr), Rb(e), Rt(Gr, this);
  var r = Di(this);
  try {
    e(wt(Oo, r), wt(Mt, r));
  } catch (n) {
    Mt(r, n);
  }
}, Fr = Qe.prototype, Gr = function(e) {
  Gb(this, {
    type: Vn,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new $b(),
    rejection: !1,
    state: Mu,
    value: void 0
  });
}, Gr.prototype = Nu(Fr, "then", function(e, r) {
  var n = Di(this), i = No(Ub(this, Qe));
  return n.parent = !0, i.ok = rn(e) ? e : !0, i.fail = rn(r) && r, i.domain = gn ? da.domain : void 0, n.state == Mu ? n.reactions.add(i) : fa(function() {
    zf(i, n);
  }), i.promise;
}), _u = function() {
  var t = new Gr(), e = Di(t);
  this.promise = t, this.resolve = wt(Oo, e), this.reject = wt(Mt, e);
}, Gf.f = No = function(t) {
  return t === Qe || t === Xb ? new _u(t) : Vb(t);
}, rn(yn) && Tt !== Object.prototype)) {
  Su = Tt.then, Fb || Nu(Tt, "then", function(e, r) {
    var n = this;
    return new Qe(function(i, o) {
      Rt(Su, n, i, o);
    }).then(e, r);
  }, { unsafe: !0 });
  try {
    delete Tt.constructor;
  } catch {
  }
  Ou && Ou(Tt, Fr);
}
Mb({ global: !0, constructor: !0, wrap: !0, forced: Vf }, {
  Promise: Qe
});
_b(Qe, Vn, !1);
Sb(Vn);
var Jb = z, Yf = Jb("iterator"), Kf = !1;
try {
  var Zb = 0, xu = {
    next: function() {
      return { done: !!Zb++ };
    },
    return: function() {
      Kf = !0;
    }
  };
  xu[Yf] = function() {
    return this;
  }, Array.from(xu, function() {
    throw 2;
  });
} catch {
}
var ha = function(t, e) {
  if (!e && !Kf)
    return !1;
  var r = !1;
  try {
    var n = {};
    n[Yf] = function() {
      return {
        next: function() {
          return { done: r = !0 };
        }
      };
    }, t(n);
  } catch {
  }
  return r;
}, Yb = mr, Kb = ha, Qb = Ar.CONSTRUCTOR, Qf = Qb || !Kb(function(t) {
  Yb.all(t).then(void 0, function() {
  });
}), qb = E, eT = ee, tT = ie, rT = Ge, nT = jt, iT = ht, oT = Qf;
qb({ target: "Promise", stat: !0, forced: oT }, {
  all: function(e) {
    var r = this, n = rT.f(r), i = n.resolve, o = n.reject, a = nT(function() {
      var s = tT(r.resolve), u = [], c = 0, l = 1;
      iT(e, function(f) {
        var p = c++, d = !1;
        l++, eT(s, r, f).then(function(C) {
          d || (d = !0, u[p] = C, --l || i(u));
        }, o);
      }), --l || i(u);
    });
    return a.error && o(a.value), n.promise;
  }
});
var aT = E, sT = Ar.CONSTRUCTOR, Mo = mr, uT = ne, cT = G, lT = Se, Pu = Mo && Mo.prototype;
aT({ target: "Promise", proto: !0, forced: sT, real: !0 }, {
  catch: function(t) {
    return this.then(void 0, t);
  }
});
if (cT(Mo)) {
  var Uu = uT("Promise").prototype.catch;
  Pu.catch !== Uu && lT(Pu, "catch", Uu, { unsafe: !0 });
}
var fT = E, pT = ee, dT = ie, vT = Ge, hT = jt, gT = ht, yT = Qf;
fT({ target: "Promise", stat: !0, forced: yT }, {
  race: function(e) {
    var r = this, n = vT.f(r), i = n.reject, o = hT(function() {
      var a = dT(r.resolve);
      gT(e, function(s) {
        pT(a, r, s).then(n.resolve, i);
      });
    });
    return o.error && i(o.value), n.promise;
  }
});
var IT = E, mT = ee, AT = Ge, ET = Ar.CONSTRUCTOR;
IT({ target: "Promise", stat: !0, forced: ET }, {
  reject: function(e) {
    var r = AT.f(this);
    return mT(r.reject, void 0, e), r.promise;
  }
});
var CT = ae, bT = oe, TT = Ge, qf = function(t, e) {
  if (CT(t), bT(e) && e.constructor === t)
    return e;
  var r = TT.f(t), n = r.resolve;
  return n(e), r.promise;
}, wT = E, NT = ne, OT = Ar.CONSTRUCTOR, MT = qf;
NT("Promise");
wT({ target: "Promise", stat: !0, forced: OT }, {
  resolve: function(e) {
    return MT(this, e);
  }
});
var _T = E, ST = ee, RT = ie, xT = Ge, PT = jt, UT = ht;
_T({ target: "Promise", stat: !0 }, {
  allSettled: function(e) {
    var r = this, n = xT.f(r), i = n.resolve, o = n.reject, a = PT(function() {
      var s = RT(r.resolve), u = [], c = 0, l = 1;
      UT(e, function(f) {
        var p = c++, d = !1;
        l++, ST(s, r, f).then(function(C) {
          d || (d = !0, u[p] = { status: "fulfilled", value: C }, --l || i(u));
        }, function(C) {
          d || (d = !0, u[p] = { status: "rejected", reason: C }, --l || i(u));
        });
      }), --l || i(u);
    });
    return a.error && o(a.value), n.promise;
  }
});
var DT = E, LT = ee, $T = ie, kT = ne, FT = Ge, GT = jt, VT = ht, Du = "No one promise resolved";
DT({ target: "Promise", stat: !0 }, {
  any: function(e) {
    var r = this, n = kT("AggregateError"), i = FT.f(r), o = i.resolve, a = i.reject, s = GT(function() {
      var u = $T(r.resolve), c = [], l = 0, f = 1, p = !1;
      VT(e, function(d) {
        var C = l++, R = !1;
        f++, LT(u, r, d).then(function(S) {
          R || p || (p = !0, o(S));
        }, function(S) {
          R || p || (R = !0, c[C] = S, --f || a(new n(c, Du)));
        });
      }), --f || a(new n(c, Du));
    });
    return s.error && a(s.value), i.promise;
  }
});
var BT = E, In = mr, jT = F, ep = ne, tp = G, HT = Mf, Lu = qf, XT = Se, _o = In && In.prototype, WT = !!In && jT(function() {
  _o.finally.call({ then: function() {
  } }, function() {
  });
});
BT({ target: "Promise", proto: !0, real: !0, forced: WT }, {
  finally: function(t) {
    var e = HT(this, ep("Promise")), r = tp(t);
    return this.then(
      r ? function(n) {
        return Lu(e, t()).then(function() {
          return n;
        });
      } : t,
      r ? function(n) {
        return Lu(e, t()).then(function() {
          throw n;
        });
      } : t
    );
  }
});
if (tp(In)) {
  var $u = ep("Promise").prototype.finally;
  _o.finally !== $u && XT(_o, "finally", $u, { unsafe: !0 });
}
var ga = k, zT = Fe, JT = Fn, ZT = Jo, YT = ga("".charAt), ku = ga("".charCodeAt), KT = ga("".slice), Fu = function(t) {
  return function(e, r) {
    var n = JT(ZT(e)), i = zT(r), o = n.length, a, s;
    return i < 0 || i >= o ? t ? "" : void 0 : (a = ku(n, i), a < 55296 || a > 56319 || i + 1 === o || (s = ku(n, i + 1)) < 56320 || s > 57343 ? t ? YT(n, i) : a : t ? KT(n, i, i + 2) : (a - 55296 << 10) + (s - 56320) + 65536);
  };
}, QT = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: Fu(!1),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: Fu(!0)
}, qT = QT.charAt, ew = Fn, rp = Ft, tw = oa, np = "String Iterator", rw = rp.set, nw = rp.getterFor(np);
tw(String, "String", function(t) {
  rw(this, {
    type: np,
    string: ew(t),
    index: 0
  });
}, function() {
  var e = nw(this), r = e.string, n = e.index, i;
  return n >= r.length ? { value: void 0, done: !0 } : (i = qT(r, n), e.index += i.length, { value: i, done: !1 });
});
var iw = X, ip = iw, ow = ip, aw = ow.Promise, sw = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, uw = Sn, Li = uw("span").classList, Gu = Li && Li.constructor && Li.constructor.prototype, cw = Gu === Object.prototype ? void 0 : Gu, Vu = X, op = sw, lw = cw, qt = cC, $i = kt, ap = z, ki = ap("iterator"), Bu = ap("toStringTag"), Fi = qt.values, sp = function(t, e) {
  if (t) {
    if (t[ki] !== Fi)
      try {
        $i(t, ki, Fi);
      } catch {
        t[ki] = Fi;
      }
    if (t[Bu] || $i(t, Bu, e), op[e]) {
      for (var r in qt)
        if (t[r] !== qt[r])
          try {
            $i(t, r, qt[r]);
          } catch {
            t[r] = qt[r];
          }
    }
  }
};
for (var Gi in op)
  sp(Vu[Gi] && Vu[Gi].prototype, Gi);
sp(lw, "DOMTokenList");
var fw = aw, pw = fw, dw = pw, vw = dw, hw = E, gw = Ge, yw = jt;
hw({ target: "Promise", stat: !0, forced: !0 }, {
  try: function(t) {
    var e = gw.f(this), r = yw(t);
    return (r.error ? e.reject : e.resolve)(r.value), e.promise;
  }
});
var Iw = vw, mw = Iw;
(function(t) {
  t.exports = mw;
})(Dg);
var Aw = { exports: {} }, Ew = ae, Cw = gf, bw = function(t, e, r, n) {
  try {
    return n ? e(Ew(r)[0], r[1]) : e(r);
  } catch (i) {
    Cw(t, "throw", i);
  }
}, Tw = _n, ww = ge, Nw = Lt, Ht = function(t, e, r) {
  var n = Tw(e);
  n in t ? ww.f(t, n, Nw(0, r)) : t[n] = r;
}, Ow = we, Mw = ee, _w = W, Sw = bw, Rw = vf, xw = Bt, Pw = L, ju = Ht, Uw = kn, Dw = $n, Hu = Array, Lw = function(e) {
  var r = _w(e), n = xw(this), i = arguments.length, o = i > 1 ? arguments[1] : void 0, a = o !== void 0;
  a && (o = Ow(o, i > 2 ? arguments[2] : void 0));
  var s = Dw(r), u = 0, c, l, f, p, d, C;
  if (s && !(this === Hu && Rw(s)))
    for (p = Uw(r, s), d = p.next, l = n ? new this() : []; !(f = Mw(d, p)).done; u++)
      C = a ? Sw(p, o, [f.value, u], !0) : f.value, ju(l, u, C);
  else
    for (c = Pw(r), l = n ? new this(c) : Hu(c); c > u; u++)
      C = a ? o(r[u], u) : r[u], ju(l, u, C);
  return l.length = u, l;
}, $w = E, kw = Lw, Fw = ha, Gw = !Fw(function(t) {
  Array.from(t);
});
$w({ target: "Array", stat: !0, forced: Gw }, {
  from: kw
});
var Vw = $t, gt = Array.isArray || function(e) {
  return Vw(e) == "Array";
}, Bw = E, jw = gt;
Bw({ target: "Array", stat: !0 }, {
  isArray: jw
});
var Hw = E, Xw = F, Ww = Bt, zw = Ht, up = Array, Jw = Xw(function() {
  function t() {
  }
  return !(up.of.call(t) instanceof t);
});
Hw({ target: "Array", stat: !0, forced: Jw }, {
  of: function() {
    for (var e = 0, r = arguments.length, n = new (Ww(this) ? this : up)(r); r > e; )
      zw(n, e, arguments[e++]);
    return n.length = r, n;
  }
});
var Zw = E, Yw = W, Kw = L, Qw = Fe, qw = V;
Zw({ target: "Array", proto: !0 }, {
  at: function(e) {
    var r = Yw(this), n = Kw(r), i = Qw(e), o = i >= 0 ? i : n + i;
    return o < 0 || o >= n ? void 0 : r[o];
  }
});
qw("at");
var e0 = TypeError, t0 = 9007199254740991, yt = function(t) {
  if (t > t0)
    throw e0("Maximum allowed index exceeded");
  return t;
}, Xu = gt, r0 = Bt, n0 = oe, i0 = z, o0 = i0("species"), Wu = Array, a0 = function(t) {
  var e;
  return Xu(t) && (e = t.constructor, r0(e) && (e === Wu || Xu(e.prototype)) ? e = void 0 : n0(e) && (e = e[o0], e === null && (e = void 0))), e === void 0 ? Wu : e;
}, s0 = a0, Xt = function(t, e) {
  return new (s0(t))(e === 0 ? 0 : e);
}, u0 = F, c0 = z, l0 = pt, f0 = c0("species"), Er = function(t) {
  return l0 >= 51 || !u0(function() {
    var e = [], r = e.constructor = {};
    return r[f0] = function() {
      return { foo: 1 };
    }, e[t](Boolean).foo !== 1;
  });
}, p0 = E, d0 = F, v0 = gt, h0 = oe, g0 = W, y0 = L, zu = yt, Ju = Ht, I0 = Xt, m0 = Er, A0 = z, E0 = pt, cp = A0("isConcatSpreadable"), C0 = E0 >= 51 || !d0(function() {
  var t = [];
  return t[cp] = !1, t.concat()[0] !== t;
}), b0 = m0("concat"), T0 = function(t) {
  if (!h0(t))
    return !1;
  var e = t[cp];
  return e !== void 0 ? !!e : v0(t);
}, w0 = !C0 || !b0;
p0({ target: "Array", proto: !0, arity: 1, forced: w0 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function(e) {
    var r = g0(this), n = I0(r, 0), i = 0, o, a, s, u, c;
    for (o = -1, s = arguments.length; o < s; o++)
      if (c = o === -1 ? r : arguments[o], T0(c))
        for (u = y0(c), zu(i + u), a = 0; a < u; a++, i++)
          a in c && Ju(n, i, c[a]);
      else
        zu(i + 1), Ju(n, i++, c);
    return n.length = i, n;
  }
});
var Zu = gr, N0 = TypeError, Bn = function(t, e) {
  if (!delete t[e])
    throw N0("Cannot delete property " + Zu(e) + " of " + Zu(t));
}, O0 = W, Vi = vt, M0 = L, _0 = Bn, S0 = Math.min, R0 = [].copyWithin || function(e, r) {
  var n = O0(this), i = M0(n), o = Vi(e, i), a = Vi(r, i), s = arguments.length > 2 ? arguments[2] : void 0, u = S0((s === void 0 ? i : Vi(s, i)) - a, i - o), c = 1;
  for (a < o && o < a + u && (c = -1, a += u - 1, o += u - 1); u-- > 0; )
    a in n ? n[o] = n[a] : _0(n, o), o += c, a += c;
  return n;
}, x0 = E, P0 = R0, U0 = V;
x0({ target: "Array", proto: !0 }, {
  copyWithin: P0
});
U0("copyWithin");
var D0 = we, L0 = k, $0 = lt, k0 = W, F0 = L, G0 = Xt, Yu = L0([].push), Be = function(t) {
  var e = t == 1, r = t == 2, n = t == 3, i = t == 4, o = t == 6, a = t == 7, s = t == 5 || o;
  return function(u, c, l, f) {
    for (var p = k0(u), d = $0(p), C = D0(c, l), R = F0(d), S = 0, T = f || G0, N = e ? T(u, R) : r || a ? T(u, 0) : void 0, U, D; R > S; S++)
      if ((s || S in d) && (U = d[S], D = C(U, S, p), t))
        if (e)
          N[S] = D;
        else if (D)
          switch (t) {
            case 3:
              return !0;
            case 5:
              return U;
            case 6:
              return S;
            case 2:
              Yu(N, U);
          }
        else
          switch (t) {
            case 4:
              return !1;
            case 7:
              Yu(N, U);
          }
    return o ? -1 : n || i ? i : N;
  };
}, Ve = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: Be(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: Be(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: Be(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: Be(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: Be(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: Be(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: Be(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: Be(7)
}, V0 = F, Ne = function(t, e) {
  var r = [][t];
  return !!r && V0(function() {
    r.call(null, e || function() {
      return 1;
    }, 1);
  });
}, B0 = E, j0 = Ve.every, H0 = Ne, X0 = H0("every");
B0({ target: "Array", proto: !0, forced: !X0 }, {
  every: function(e) {
    return j0(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var W0 = W, Ku = vt, z0 = L, J0 = function(e) {
  for (var r = W0(this), n = z0(r), i = arguments.length, o = Ku(i > 1 ? arguments[1] : void 0, n), a = i > 2 ? arguments[2] : void 0, s = a === void 0 ? n : Ku(a, n); s > o; )
    r[o++] = e;
  return r;
}, Z0 = E, Y0 = J0, K0 = V;
Z0({ target: "Array", proto: !0 }, {
  fill: Y0
});
K0("fill");
var Q0 = E, q0 = Ve.filter, eN = Er, tN = eN("filter");
Q0({ target: "Array", proto: !0, forced: !tN }, {
  filter: function(e) {
    return q0(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var rN = E, nN = Ve.find, iN = V, So = "find", lp = !0;
So in [] && Array(1)[So](function() {
  lp = !1;
});
rN({ target: "Array", proto: !0, forced: lp }, {
  find: function(e) {
    return nN(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
iN(So);
var oN = E, aN = Ve.findIndex, sN = V, Ro = "findIndex", fp = !0;
Ro in [] && Array(1)[Ro](function() {
  fp = !1;
});
oN({ target: "Array", proto: !0, forced: fp }, {
  findIndex: function(e) {
    return aN(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
sN(Ro);
var uN = we, cN = lt, lN = W, fN = L, Qu = function(t) {
  var e = t == 1;
  return function(r, n, i) {
    for (var o = lN(r), a = cN(o), s = uN(n, i), u = fN(a), c, l; u-- > 0; )
      if (c = a[u], l = s(c, u, o), l)
        switch (t) {
          case 0:
            return c;
          case 1:
            return u;
        }
    return e ? -1 : void 0;
  };
}, pp = {
  // `Array.prototype.findLast` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLast: Qu(0),
  // `Array.prototype.findLastIndex` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLastIndex: Qu(1)
}, pN = E, dN = pp.findLast, vN = V;
pN({ target: "Array", proto: !0 }, {
  findLast: function(e) {
    return dN(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
vN("findLast");
var hN = E, gN = pp.findLastIndex, yN = V;
hN({ target: "Array", proto: !0 }, {
  findLastIndex: function(e) {
    return gN(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
yN("findLastIndex");
var IN = gt, mN = L, AN = yt, EN = we, dp = function(t, e, r, n, i, o, a, s) {
  for (var u = i, c = 0, l = a ? EN(a, s) : !1, f, p; c < n; )
    c in r && (f = l ? l(r[c], c, e) : r[c], o > 0 && IN(f) ? (p = mN(f), u = dp(t, e, f, p, u, o - 1) - 1) : (AN(u + 1), t[u] = f), u++), c++;
  return u;
}, vp = dp, CN = E, bN = vp, TN = W, wN = L, NN = Fe, ON = Xt;
CN({ target: "Array", proto: !0 }, {
  flat: function() {
    var e = arguments.length ? arguments[0] : void 0, r = TN(this), n = wN(r), i = ON(r, 0);
    return i.length = bN(i, r, r, n, 0, e === void 0 ? 1 : NN(e)), i;
  }
});
var MN = E, _N = vp, SN = ie, RN = W, xN = L, PN = Xt;
MN({ target: "Array", proto: !0 }, {
  flatMap: function(e) {
    var r = RN(this), n = xN(r), i;
    return SN(e), i = PN(r, 0), i.length = _N(i, r, r, n, 0, 1, e, arguments.length > 1 ? arguments[1] : void 0), i;
  }
});
var UN = Ve.forEach, DN = Ne, LN = DN("forEach"), $N = LN ? [].forEach : function(e) {
  return UN(this, e, arguments.length > 1 ? arguments[1] : void 0);
}, kN = E, qu = $N;
kN({ target: "Array", proto: !0, forced: [].forEach != qu }, {
  forEach: qu
});
var FN = E, GN = ta.includes, VN = F, BN = V, jN = VN(function() {
  return !Array(1).includes();
});
FN({ target: "Array", proto: !0, forced: jN }, {
  includes: function(e) {
    return GN(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
BN("includes");
var HN = E, XN = k, WN = ta.indexOf, zN = Ne, xo = XN([].indexOf), ec = !!xo && 1 / xo([1], 1, -0) < 0, JN = zN("indexOf");
HN({ target: "Array", proto: !0, forced: ec || !JN }, {
  indexOf: function(e) {
    var r = arguments.length > 1 ? arguments[1] : void 0;
    return ec ? xo(this, e, r) || 0 : WN(this, e, r);
  }
});
var ZN = E, YN = k, KN = lt, QN = he, qN = Ne, eO = YN([].join), tO = KN != Object, rO = qN("join", ",");
ZN({ target: "Array", proto: !0, forced: tO || !rO }, {
  join: function(e) {
    return eO(QN(this), e === void 0 ? "," : e);
  }
});
var nO = Sf, iO = he, oO = Fe, aO = L, sO = Ne, uO = Math.min, Po = [].lastIndexOf, hp = !!Po && 1 / [1].lastIndexOf(1, -0) < 0, cO = sO("lastIndexOf"), lO = hp || !cO, fO = lO ? function(e) {
  if (hp)
    return nO(Po, this, arguments) || 0;
  var r = iO(this), n = aO(r), i = n - 1;
  for (arguments.length > 1 && (i = uO(i, oO(arguments[1]))), i < 0 && (i = n + i); i >= 0; i--)
    if (i in r && r[i] === e)
      return i || 0;
  return -1;
} : Po, pO = E, tc = fO;
pO({ target: "Array", proto: !0, forced: tc !== [].lastIndexOf }, {
  lastIndexOf: tc
});
var dO = E, vO = Ve.map, hO = Er, gO = hO("map");
dO({ target: "Array", proto: !0, forced: !gO }, {
  map: function(e) {
    return vO(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var yO = E, IO = W, mO = L, AO = yt, EO = F, CO = EO(function() {
  return [].push.call({ length: 4294967296 }, 1) !== 4294967297;
}), bO = !function() {
  try {
    Object.defineProperty([], "length", { writable: !1 }).push();
  } catch (t) {
    return t instanceof TypeError;
  }
}();
yO({ target: "Array", proto: !0, arity: 1, forced: CO || bO }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function(e) {
    var r = IO(this), n = mO(r), i = arguments.length;
    AO(n + i);
    for (var o = 0; o < i; o++)
      r[n] = arguments[o], n++;
    return r.length = n, n;
  }
});
var TO = ie, wO = W, NO = lt, OO = L, MO = TypeError, rc = function(t) {
  return function(e, r, n, i) {
    TO(r);
    var o = wO(e), a = NO(o), s = OO(o), u = t ? s - 1 : 0, c = t ? -1 : 1;
    if (n < 2)
      for (; ; ) {
        if (u in a) {
          i = a[u], u += c;
          break;
        }
        if (u += c, t ? u < 0 : s <= u)
          throw MO("Reduce of empty array with no initial value");
      }
    for (; t ? u >= 0 : s > u; u += c)
      u in a && (i = r(i, a[u], u, o));
    return i;
  };
}, gp = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: rc(!1),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: rc(!0)
}, _O = E, SO = gp.left, RO = Ne, nc = pt, xO = Vt, PO = RO("reduce"), UO = !xO && nc > 79 && nc < 83;
_O({ target: "Array", proto: !0, forced: !PO || UO }, {
  reduce: function(e) {
    var r = arguments.length;
    return SO(this, e, r, r > 1 ? arguments[1] : void 0);
  }
});
var DO = E, LO = gp.right, $O = Ne, ic = pt, kO = Vt, FO = $O("reduceRight"), GO = !kO && ic > 79 && ic < 83;
DO({ target: "Array", proto: !0, forced: !FO || GO }, {
  reduceRight: function(e) {
    return LO(this, e, arguments.length, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var VO = E, BO = k, jO = gt, HO = BO([].reverse), oc = [1, 2];
VO({ target: "Array", proto: !0, forced: String(oc) === String(oc.reverse()) }, {
  reverse: function() {
    return jO(this) && (this.length = this.length), HO(this);
  }
});
var XO = E, ac = gt, WO = Bt, zO = oe, sc = vt, JO = L, ZO = he, YO = Ht, KO = z, QO = Er, qO = Rf, eM = QO("slice"), tM = KO("species"), Bi = Array, rM = Math.max;
XO({ target: "Array", proto: !0, forced: !eM }, {
  slice: function(e, r) {
    var n = ZO(this), i = JO(n), o = sc(e, i), a = sc(r === void 0 ? i : r, i), s, u, c;
    if (ac(n) && (s = n.constructor, WO(s) && (s === Bi || ac(s.prototype)) ? s = void 0 : zO(s) && (s = s[tM], s === null && (s = void 0)), s === Bi || s === void 0))
      return qO(n, o, a);
    for (u = new (s === void 0 ? Bi : s)(rM(a - o, 0)), c = 0; o < a; o++, c++)
      o in n && YO(u, c, n[o]);
    return u.length = c, u;
  }
});
var nM = E, iM = Ve.some, oM = Ne, aM = oM("some");
nM({ target: "Array", proto: !0, forced: !aM }, {
  some: function(e) {
    return iM(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var uc = vt, sM = L, uM = Ht, cM = Array, lM = Math.max, yp = function(t, e, r) {
  for (var n = sM(t), i = uc(e, n), o = uc(r === void 0 ? n : r, n), a = cM(lM(o - i, 0)), s = 0; i < o; i++, s++)
    uM(a, s, t[i]);
  return a.length = s, a;
}, cc = yp, fM = Math.floor, Uo = function(t, e) {
  var r = t.length, n = fM(r / 2);
  return r < 8 ? pM(t, e) : dM(
    t,
    Uo(cc(t, 0, n), e),
    Uo(cc(t, n), e),
    e
  );
}, pM = function(t, e) {
  for (var r = t.length, n = 1, i, o; n < r; ) {
    for (o = n, i = t[n]; o && e(t[o - 1], i) > 0; )
      t[o] = t[--o];
    o !== n++ && (t[o] = i);
  }
  return t;
}, dM = function(t, e, r, n) {
  for (var i = e.length, o = r.length, a = 0, s = 0; a < i || s < o; )
    t[a + s] = a < i && s < o ? n(e[a], r[s]) <= 0 ? e[a++] : r[s++] : a < i ? e[a++] : r[s++];
  return t;
}, vM = Uo, hM = ft, lc = hM.match(/firefox\/(\d+)/i), gM = !!lc && +lc[1], yM = ft, IM = /MSIE|Trident/.test(yM), mM = ft, fc = mM.match(/AppleWebKit\/(\d+)\./), AM = !!fc && +fc[1], EM = E, Ip = k, CM = ie, bM = W, TM = L, wM = Bn, pc = Fn, ya = F, NM = vM, OM = Ne, dc = gM, MM = IM, vc = pt, hc = AM, He = [], gc = Ip(He.sort), _M = Ip(He.push), SM = ya(function() {
  He.sort(void 0);
}), RM = ya(function() {
  He.sort(null);
}), xM = OM("sort"), mp = !ya(function() {
  if (vc)
    return vc < 70;
  if (!(dc && dc > 3)) {
    if (MM)
      return !0;
    if (hc)
      return hc < 603;
    var t = "", e, r, n, i;
    for (e = 65; e < 76; e++) {
      switch (r = String.fromCharCode(e), e) {
        case 66:
        case 69:
        case 70:
        case 72:
          n = 3;
          break;
        case 68:
        case 71:
          n = 4;
          break;
        default:
          n = 2;
      }
      for (i = 0; i < 47; i++)
        He.push({ k: r + i, v: n });
    }
    for (He.sort(function(o, a) {
      return a.v - o.v;
    }), i = 0; i < He.length; i++)
      r = He[i].k.charAt(0), t.charAt(t.length - 1) !== r && (t += r);
    return t !== "DGBEFHACIJK";
  }
}), PM = SM || !RM || !xM || !mp, UM = function(t) {
  return function(e, r) {
    return r === void 0 ? -1 : e === void 0 ? 1 : t !== void 0 ? +t(e, r) || 0 : pc(e) > pc(r) ? 1 : -1;
  };
};
EM({ target: "Array", proto: !0, forced: PM }, {
  sort: function(e) {
    e !== void 0 && CM(e);
    var r = bM(this);
    if (mp)
      return e === void 0 ? gc(r) : gc(r, e);
    var n = [], i = TM(r), o, a;
    for (a = 0; a < i; a++)
      a in r && _M(n, r[a]);
    for (NM(n, UM(e)), o = n.length, a = 0; a < o; )
      r[a] = n[a++];
    for (; a < i; )
      wM(r, a++);
    return r;
  }
});
var DM = sa;
DM("Array");
var LM = E, $M = W, kM = vt, FM = Fe, GM = L, VM = yt, BM = Xt, jM = Ht, ji = Bn, HM = Er, XM = HM("splice"), WM = Math.max, zM = Math.min;
LM({ target: "Array", proto: !0, forced: !XM }, {
  splice: function(e, r) {
    var n = $M(this), i = GM(n), o = kM(e, i), a = arguments.length, s, u, c, l, f, p;
    for (a === 0 ? s = u = 0 : a === 1 ? (s = 0, u = i - o) : (s = a - 2, u = zM(WM(FM(r), 0), i - o)), VM(i + s - u), c = BM(n, u), l = 0; l < u; l++)
      f = o + l, f in n && jM(c, l, n[f]);
    if (c.length = u, s < u) {
      for (l = o; l < i - u; l++)
        f = l + u, p = l + s, f in n ? n[p] = n[f] : ji(n, p);
      for (l = i; l > i - u + s; l--)
        ji(n, l - 1);
    } else if (s > u)
      for (l = i - u; l > o; l--)
        f = l + u - 1, p = l + s - 1, f in n ? n[p] = n[f] : ji(n, p);
    for (l = 0; l < s; l++)
      n[l + o] = arguments[l + 2];
    return n.length = i - u + s, c;
  }
});
var JM = V;
JM("flat");
var ZM = V;
ZM("flatMap");
var YM = E, KM = W, QM = L, qM = Bn, e1 = yt, t1 = [].unshift(0) !== 1, r1 = !function() {
  try {
    Object.defineProperty([], "length", { writable: !1 }).unshift();
  } catch (t) {
    return t instanceof TypeError;
  }
}();
YM({ target: "Array", proto: !0, arity: 1, forced: t1 || r1 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  unshift: function(e) {
    var r = KM(this), n = QM(r), i = arguments.length;
    if (i) {
      e1(n + i);
      for (var o = n; o--; ) {
        var a = o + i;
        o in r ? r[a] = r[o] : qM(r, a);
      }
      for (var s = 0; s < i; s++)
        r[s] = arguments[s];
    }
    return r.length = n + i;
  }
});
var n1 = ip, i1 = n1.Array, o1 = i1, a1 = o1, Ia = { exports: {} }, Ap = {}, s1 = $t, u1 = he, Ep = Pn.f, c1 = yp, Cp = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], l1 = function(t) {
  try {
    return Ep(t);
  } catch {
    return c1(Cp);
  }
};
Ap.f = function(e) {
  return Cp && s1(e) == "Window" ? l1(e) : Ep(u1(e));
};
var f1 = F, p1 = f1(function() {
  if (typeof ArrayBuffer == "function") {
    var t = new ArrayBuffer(8);
    Object.isExtensible(t) && Object.defineProperty(t, "a", { value: 8 });
  }
}), d1 = F, v1 = oe, h1 = $t, yc = p1, nn = Object.isExtensible, g1 = d1(function() {
  nn(1);
}), y1 = g1 || yc ? function(e) {
  return !v1(e) || yc && h1(e) == "ArrayBuffer" ? !1 : nn ? nn(e) : !0;
} : nn, I1 = F, m1 = !I1(function() {
  return Object.isExtensible(Object.preventExtensions({}));
}), A1 = E, E1 = k, C1 = xn, b1 = oe, ma = Te, T1 = ge.f, Ic = Pn, w1 = Ap, Aa = y1, N1 = Ko, O1 = m1, bp = !1, ke = N1("meta"), M1 = 0, Ea = function(t) {
  T1(t, ke, { value: {
    objectID: "O" + M1++,
    // object ID
    weakData: {}
    // weak collections IDs
  } });
}, _1 = function(t, e) {
  if (!b1(t))
    return typeof t == "symbol" ? t : (typeof t == "string" ? "S" : "P") + t;
  if (!ma(t, ke)) {
    if (!Aa(t))
      return "F";
    if (!e)
      return "E";
    Ea(t);
  }
  return t[ke].objectID;
}, S1 = function(t, e) {
  if (!ma(t, ke)) {
    if (!Aa(t))
      return !0;
    if (!e)
      return !1;
    Ea(t);
  }
  return t[ke].weakData;
}, R1 = function(t) {
  return O1 && bp && Aa(t) && !ma(t, ke) && Ea(t), t;
}, x1 = function() {
  P1.enable = function() {
  }, bp = !0;
  var t = Ic.f, e = E1([].splice), r = {};
  r[ke] = 1, t(r).length && (Ic.f = function(n) {
    for (var i = t(n), o = 0, a = i.length; o < a; o++)
      if (i[o] === ke) {
        e(i, o, 1);
        break;
      }
    return i;
  }, A1({ target: "Object", stat: !0, forced: !0 }, {
    getOwnPropertyNames: w1.f
  }));
}, P1 = Ia.exports = {
  enable: x1,
  fastKey: _1,
  getWeakData: S1,
  onFreeze: R1
};
C1[ke] = !0;
var U1 = G, D1 = oe, mc = Dn, L1 = function(t, e, r) {
  var n, i;
  return (
    // it can work only with native `setPrototypeOf`
    mc && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    U1(n = e.constructor) && n !== r && D1(i = n.prototype) && i !== r.prototype && mc(t, i), t
  );
}, $1 = E, k1 = X, F1 = k, Ac = na, G1 = Se, V1 = Ia.exports, B1 = ht, j1 = ua, H1 = G, Hi = oe, Xi = F, X1 = ha, W1 = Gn, z1 = L1, J1 = function(t, e, r) {
  var n = t.indexOf("Map") !== -1, i = t.indexOf("Weak") !== -1, o = n ? "set" : "add", a = k1[t], s = a && a.prototype, u = a, c = {}, l = function(T) {
    var N = F1(s[T]);
    G1(
      s,
      T,
      T == "add" ? function(D) {
        return N(this, D === 0 ? 0 : D), this;
      } : T == "delete" ? function(U) {
        return i && !Hi(U) ? !1 : N(this, U === 0 ? 0 : U);
      } : T == "get" ? function(D) {
        return i && !Hi(D) ? void 0 : N(this, D === 0 ? 0 : D);
      } : T == "has" ? function(D) {
        return i && !Hi(D) ? !1 : N(this, D === 0 ? 0 : D);
      } : function(D, Oe) {
        return N(this, D === 0 ? 0 : D, Oe), this;
      }
    );
  }, f = Ac(
    t,
    !H1(a) || !(i || s.forEach && !Xi(function() {
      new a().entries().next();
    }))
  );
  if (f)
    u = r.getConstructor(e, t, n, o), V1.enable();
  else if (Ac(t, !0)) {
    var p = new u(), d = p[o](i ? {} : -0, 1) != p, C = Xi(function() {
      p.has(1);
    }), R = X1(function(T) {
      new a(T);
    }), S = !i && Xi(function() {
      for (var T = new a(), N = 5; N--; )
        T[o](N, N);
      return !T.has(-0);
    });
    R || (u = e(function(T, N) {
      j1(T, s);
      var U = z1(new a(), T, u);
      return N != null && B1(N, U[o], { that: U, AS_ENTRIES: n }), U;
    }), u.prototype = s, s.constructor = u), (C || S) && (l("delete"), l("has"), n && l("get")), (S || d) && l(o), i && s.clear && delete s.clear;
  }
  return c[t] = u, $1({ global: !0, constructor: !0, forced: u != a }, c), W1(u, t), i || r.setStrong(u, t, n), u;
}, Z1 = Se, Tp = function(t, e, r) {
  for (var n in e)
    Z1(t, n, e[n], r);
  return t;
}, Y1 = ge.f, K1 = Gt, Ec = Tp, Q1 = we, q1 = ua, e_ = ht, t_ = oa, r_ = sa, Yt = ve, Cc = Ia.exports.fastKey, wp = Ft, bc = wp.set, Wi = wp.getterFor, n_ = {
  getConstructor: function(t, e, r, n) {
    var i = t(function(c, l) {
      q1(c, o), bc(c, {
        type: e,
        index: K1(null),
        first: void 0,
        last: void 0,
        size: 0
      }), Yt || (c.size = 0), l != null && e_(l, c[n], { that: c, AS_ENTRIES: r });
    }), o = i.prototype, a = Wi(e), s = function(c, l, f) {
      var p = a(c), d = u(c, l), C, R;
      return d ? d.value = f : (p.last = d = {
        index: R = Cc(l, !0),
        key: l,
        value: f,
        previous: C = p.last,
        next: void 0,
        removed: !1
      }, p.first || (p.first = d), C && (C.next = d), Yt ? p.size++ : c.size++, R !== "F" && (p.index[R] = d)), c;
    }, u = function(c, l) {
      var f = a(c), p = Cc(l), d;
      if (p !== "F")
        return f.index[p];
      for (d = f.first; d; d = d.next)
        if (d.key == l)
          return d;
    };
    return Ec(o, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function() {
        for (var l = this, f = a(l), p = f.index, d = f.first; d; )
          d.removed = !0, d.previous && (d.previous = d.previous.next = void 0), delete p[d.index], d = d.next;
        f.first = f.last = void 0, Yt ? f.size = 0 : l.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      delete: function(c) {
        var l = this, f = a(l), p = u(l, c);
        if (p) {
          var d = p.next, C = p.previous;
          delete f.index[p.index], p.removed = !0, C && (C.next = d), d && (d.previous = C), f.first == p && (f.first = d), f.last == p && (f.last = C), Yt ? f.size-- : l.size--;
        }
        return !!p;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function(l) {
        for (var f = a(this), p = Q1(l, arguments.length > 1 ? arguments[1] : void 0), d; d = d ? d.next : f.first; )
          for (p(d.value, d.key, this); d && d.removed; )
            d = d.previous;
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function(l) {
        return !!u(this, l);
      }
    }), Ec(o, r ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function(l) {
        var f = u(this, l);
        return f && f.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function(l, f) {
        return s(this, l === 0 ? 0 : l, f);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function(l) {
        return s(this, l = l === 0 ? 0 : l, l);
      }
    }), Yt && Y1(o, "size", {
      get: function() {
        return a(this).size;
      }
    }), i;
  },
  setStrong: function(t, e, r) {
    var n = e + " Iterator", i = Wi(e), o = Wi(n);
    t_(t, e, function(a, s) {
      bc(this, {
        type: n,
        target: a,
        state: i(a),
        kind: s,
        last: void 0
      });
    }, function() {
      for (var a = o(this), s = a.kind, u = a.last; u && u.removed; )
        u = u.previous;
      return !a.target || !(a.last = u = u ? u.next : a.state.first) ? (a.target = void 0, { value: void 0, done: !0 }) : s == "keys" ? { value: u.key, done: !1 } : s == "values" ? { value: u.value, done: !1 } : { value: [u.key, u.value], done: !1 };
    }, r ? "entries" : "values", !r, !0), r_(e);
  }
}, i_ = J1, o_ = n_;
i_("Map", function(t) {
  return function() {
    return t(this, arguments.length ? arguments[0] : void 0);
  };
}, o_);
var a_ = L, Np = function(t, e) {
  for (var r = 0, n = a_(e), i = new t(n); n > r; )
    i[r] = e[r++];
  return i;
}, s_ = we, u_ = k, c_ = lt, l_ = W, f_ = _n, p_ = L, d_ = Gt, v_ = Np, h_ = Array, g_ = u_([].push), Op = function(t, e, r, n) {
  for (var i = l_(t), o = c_(i), a = s_(e, r), s = d_(null), u = p_(o), c = 0, l, f, p; u > c; c++)
    p = o[c], f = f_(a(p, c, i)), f in s ? g_(s[f], p) : s[f] = [p];
  if (n && (l = n(i), l !== h_))
    for (f in s)
      s[f] = v_(l, s[f]);
  return s;
}, y_ = E, I_ = Op, m_ = V;
y_({ target: "Array", proto: !0 }, {
  group: function(e) {
    var r = arguments.length > 1 ? arguments[1] : void 0;
    return I_(this, e, r);
  }
});
m_("group");
var A_ = E, E_ = Op, C_ = Ne, b_ = V;
A_({ target: "Array", proto: !0, forced: !C_("groupBy") }, {
  groupBy: function(e) {
    var r = arguments.length > 1 ? arguments[1] : void 0;
    return E_(this, e, r);
  }
});
b_("groupBy");
var T_ = ne, w_ = we, jn = k, N_ = lt, O_ = W, M_ = L, Mp = T_("Map"), Ca = Mp.prototype, __ = jn(Ca.get), S_ = jn(Ca.has), R_ = jn(Ca.set), x_ = jn([].push), _p = function(e) {
  for (var r = O_(this), n = N_(r), i = w_(e, arguments.length > 1 ? arguments[1] : void 0), o = new Mp(), a = M_(n), s = 0, u, c; a > s; s++)
    c = n[s], u = i(c, s, r), S_(o, u) ? x_(__(o, u), c) : R_(o, u, [c]);
  return o;
}, P_ = E, U_ = Ne, D_ = V, L_ = _p;
P_({ target: "Array", proto: !0, name: "groupToMap", forced: !U_("groupByToMap") }, {
  groupByToMap: L_
});
D_("groupByToMap");
var $_ = E, k_ = V, F_ = _p;
$_({ target: "Array", proto: !0 }, {
  groupToMap: F_
});
k_("groupToMap");
var G_ = L, V_ = function(t, e) {
  for (var r = G_(t), n = new e(r), i = 0; i < r; i++)
    n[i] = t[r - i - 1];
  return n;
}, B_ = E, j_ = V_, H_ = he, X_ = V, W_ = Array;
B_({ target: "Array", proto: !0 }, {
  toReversed: function() {
    return j_(H_(this), W_);
  }
});
X_("toReversed");
var z_ = X, Sp = function(t) {
  return z_[t].prototype;
}, J_ = E, Z_ = k, Y_ = ie, K_ = he, Q_ = Np, q_ = Sp, eS = V, tS = Array, rS = Z_(q_("Array").sort);
J_({ target: "Array", proto: !0 }, {
  toSorted: function(e) {
    e !== void 0 && Y_(e);
    var r = K_(this), n = Q_(tS, r);
    return rS(n, e);
  }
});
eS("toSorted");
var nS = E, iS = V, oS = yt, aS = L, sS = vt, uS = he, cS = Fe, lS = Array, fS = Math.max, pS = Math.min;
nS({ target: "Array", proto: !0 }, {
  toSpliced: function(e, r) {
    var n = uS(this), i = aS(n), o = sS(e, i), a = arguments.length, s = 0, u, c, l, f;
    for (a === 0 ? u = c = 0 : a === 1 ? (u = 0, c = i - o) : (u = a - 2, c = pS(fS(cS(r), 0), i - o)), l = oS(i + u - c), f = lS(l); s < o; s++)
      f[s] = n[s];
    for (; s < o + u; s++)
      f[s] = arguments[s - o + 2];
    for (; s < l; s++)
      f[s] = n[s + c - u];
    return f;
  }
});
iS("toSpliced");
var dS = L, vS = Fe, hS = RangeError, gS = function(t, e, r, n) {
  var i = dS(t), o = vS(r), a = o < 0 ? i + o : o;
  if (a >= i || a < 0)
    throw hS("Incorrect index");
  for (var s = new e(i), u = 0; u < i; u++)
    s[u] = u === a ? n : t[u];
  return s;
}, yS = E, IS = gS, mS = he, AS = Array;
yS({ target: "Array", proto: !0 }, {
  with: function(t, e) {
    return IS(mS(this), AS, t, e);
  }
});
var ES = a1, CS = ES, Rp = X, xp = Mn, Pp = G, Vr = Un, bS = Se, TS = z, Tc = "USE_FUNCTION_CONSTRUCTOR", wc = TS("asyncIterator"), Nc = Rp.AsyncIterator, Oc = xp.AsyncIteratorPrototype, Xe, zi;
if (Oc)
  Xe = Oc;
else if (Pp(Nc))
  Xe = Nc.prototype;
else if (xp[Tc] || Rp[Tc])
  try {
    zi = Vr(Vr(Vr(Function("return async function*(){}()")()))), Vr(zi) === Object.prototype && (Xe = zi);
  } catch {
  }
Xe || (Xe = {});
Pp(Xe[wc]) || bS(Xe, wc, function() {
  return this;
});
var wS = Xe, Mc = ee, Do = ae, NS = Gt, OS = dt, MS = Tp, Up = Ft, _S = ne, SS = wS, Lo = _S("Promise"), Dp = "AsyncFromSyncIterator", RS = Up.set, _c = Up.getterFor(Dp), Sc = function(t, e, r) {
  var n = t.done;
  Lo.resolve(t.value).then(function(i) {
    e({ done: n, value: i });
  }, r);
}, Lp = function(e) {
  RS(this, {
    type: Dp,
    iterator: Do(e),
    next: e.next
  });
};
Lp.prototype = MS(NS(SS), {
  next: function() {
    var e = _c(this);
    return new Lo(function(r, n) {
      var i = Do(Mc(e.next, e.iterator));
      Sc(i, r, n);
    });
  },
  return: function() {
    var t = _c(this).iterator;
    return new Lo(function(e, r) {
      var n = OS(t, "return");
      if (n === void 0)
        return e({ done: !0, value: void 0 });
      var i = Do(Mc(n, t));
      Sc(i, e, r);
    });
  }
});
var $p = Lp, xS = ee, PS = $p, US = ae, DS = kn, LS = dt, $S = z, kS = $S("asyncIterator"), FS = function(t, e) {
  var r = arguments.length < 2 ? LS(t, kS) : e;
  return r ? US(xS(r, t)) : new PS(DS(t));
}, GS = ie, VS = ae, BS = function(t) {
  return {
    iterator: t,
    next: GS(VS(t).next)
  };
}, jS = ee, HS = ne, XS = dt, WS = function(t, e, r, n) {
  try {
    var i = XS(t, "return");
    if (i)
      return HS("Promise").resolve(jS(i, t)).then(function() {
        e(r);
      }, function(o) {
        n(o);
      });
  } catch (o) {
    return n(o);
  }
  e(r);
}, zS = ee, JS = ie, Rc = ae, ZS = yt, YS = ne, KS = BS, Ji = WS, Kt = function(t) {
  var e = t == 0, r = t == 1, n = t == 2, i = t == 3;
  return function(o, a, s) {
    var u = KS(o), c = YS("Promise"), l = u.iterator, f = u.next, p = 0, d = a !== void 0;
    return (d || !e) && JS(a), new c(function(C, R) {
      var S = function(N) {
        Ji(l, R, N, R);
      }, T = function() {
        try {
          if (e && d)
            try {
              ZS(p);
            } catch (N) {
              S(N);
            }
          c.resolve(Rc(zS(f, l))).then(function(N) {
            try {
              if (Rc(N).done)
                e ? (s.length = p, C(s)) : C(i ? !1 : n || void 0);
              else {
                var U = N.value;
                try {
                  d ? c.resolve(e ? a(U, p) : a(U)).then(function(D) {
                    if (r)
                      T();
                    else if (n)
                      D ? T() : Ji(l, C, !1, R);
                    else if (e)
                      try {
                        s[p++] = D, T();
                      } catch (Oe) {
                        S(Oe);
                      }
                    else
                      D ? Ji(l, C, i || U, R) : T();
                  }, S) : (s[p++] = U, T());
                } catch (D) {
                  S(D);
                }
              }
            } catch (D) {
              R(D);
            }
          }, R);
        } catch (N) {
          R(N);
        }
      };
      T();
    });
  };
}, QS = {
  toArray: Kt(0),
  forEach: Kt(1),
  every: Kt(2),
  some: Kt(3),
  find: Kt(4)
}, qS = we, eR = W, tR = Bt, rR = FS, nR = kn, iR = $n, oR = dt, aR = Sp, sR = ne, uR = z, cR = $p, lR = QS.toArray, fR = uR("asyncIterator"), pR = aR("Array").values, dR = function(e) {
  var r = this, n = arguments.length, i = n > 1 ? arguments[1] : void 0, o = n > 2 ? arguments[2] : void 0;
  return new (sR("Promise"))(function(a) {
    var s = eR(e);
    i !== void 0 && (i = qS(i, o));
    var u = oR(s, fR), c = u ? void 0 : iR(s) || pR, l = tR(r) ? new r() : [], f = u ? rR(s, u) : new cR(nR(s, c));
    a(lR(f, i, l));
  });
}, vR = E, hR = dR;
vR({ target: "Array", stat: !0, forced: !0 }, {
  fromAsync: hR
});
var gR = E, yR = Ve.filterReject, IR = V;
gR({ target: "Array", proto: !0, forced: !0 }, {
  filterOut: function(e) {
    return yR(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
IR("filterOut");
var mR = E, AR = Ve.filterReject, ER = V;
mR({ target: "Array", proto: !0, forced: !0 }, {
  filterReject: function(e) {
    return AR(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
ER("filterReject");
var CR = E, bR = gt, xc = Object.isFrozen, Pc = function(t, e) {
  if (!xc || !bR(t) || !xc(t))
    return !1;
  for (var r = 0, n = t.length, i; r < n; )
    if (i = t[r++], !(typeof i == "string" || e && typeof i > "u"))
      return !1;
  return n !== 0;
};
CR({ target: "Array", stat: !0, sham: !0, forced: !0 }, {
  isTemplateObject: function(e) {
    if (!Pc(e, !0))
      return !1;
    var r = e.raw;
    return r.length === e.length && Pc(r, !1);
  }
});
var Uc = Qo.exports, TR = ge, kp = function(t, e, r) {
  return r.get && Uc(r.get, e, { getter: !0 }), r.set && Uc(r.set, e, { setter: !0 }), TR.f(t, e, r);
}, wR = ve, NR = V, Dc = W, Lc = L, OR = kp;
wR && (OR(Array.prototype, "lastItem", {
  configurable: !0,
  get: function() {
    var e = Dc(this), r = Lc(e);
    return r == 0 ? void 0 : e[r - 1];
  },
  set: function(e) {
    var r = Dc(this), n = Lc(r);
    return r[n == 0 ? 0 : n - 1] = e;
  }
}), NR("lastItem"));
var MR = ve, _R = V, SR = W, RR = L, xR = kp;
MR && (xR(Array.prototype, "lastIndex", {
  configurable: !0,
  get: function() {
    var e = SR(this), r = RR(e);
    return r == 0 ? 0 : r - 1;
  }
}), _R("lastIndex"));
var PR = ne, Hn = k, UR = ie, DR = L, LR = W, $R = Xt, Fp = PR("Map"), ba = Fp.prototype, kR = Hn(ba.forEach), FR = Hn(ba.has), GR = Hn(ba.set), VR = Hn([].push), BR = function(e) {
  var r = LR(this), n = DR(r), i = $R(r, 0), o = new Fp(), a = e != null ? UR(e) : function(l) {
    return l;
  }, s, u, c;
  for (s = 0; s < n; s++)
    u = r[s], c = a(u), FR(o, c) || GR(o, c, u);
  return kR(o, function(l) {
    VR(i, l);
  }), i;
}, jR = E, HR = V, XR = BR;
jR({ target: "Array", proto: !0, forced: !0 }, {
  uniqueBy: XR
});
HR("uniqueBy");
var WR = CS, zR = WR;
(function(t) {
  t.exports = zR;
})(Aw);
var JR = function(t, e) {
  var r;
  if (e.currentSessionId === null)
    return t;
  if (!t.user.identifiers[Ee.SESSION]) {
    var n = t.copyWithUser(b(b({}, t.user), { identifiers: b(b({}, t.user.identifiers), (r = {}, r[Ee.SESSION] = e.sessionId, r)) }));
    return n;
  }
  return t;
}, Z = (
  /** @class */
  function() {
    function t(e, r, n) {
      n === void 0 && (n = Pt()), this.timestamp = e, this.user = r, this.insertId = n;
    }
    return t.exposure = function(e, r, n, i) {
      return new ZR(i, e, r.experiment, r.variationId, r.variationKey, r.reason, n);
    }, t.track = function(e, r, n, i) {
      return new YR(i, n, e, r);
    }, t.remoteConfig = function(e, r, n, i) {
      return new KR(i, e, r.parameter, r.valueId, r.reason, n);
    }, t.isExposureEvent = function(e) {
      return e.experiment !== void 0;
    }, t.isTrackEvent = function(e) {
      return e.eventType !== void 0;
    }, t.isRemoteConfigEvent = function(e) {
      return e.parameter !== void 0;
    }, t.isExposureEventDto = function(e) {
      return "experimentId" in e && typeof e.experimentId < "u";
    }, t.isTrackEventDto = function(e) {
      return "eventTypeId" in e && typeof e.eventTypeId < "u";
    }, t.isRemoteConfigEventDto = function(e) {
      return "parameterId" in e && typeof e.parameterId < "u";
    }, t.prototype.toDto = function() {
      return {
        insertId: this.insertId,
        timestamp: this.timestamp,
        userId: this.user.identifiers[Ee.ID],
        identifiers: this.user.identifiers,
        userProperties: de.sanitize(this.user.properties),
        hackleProperties: de.sanitize(this.user.hackleProperties)
      };
    }, t;
  }()
), ZR = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n, i, o, a, s, u, c) {
      var l = t.call(this, r, n, c) || this;
      return l.experiment = i, l.variationId = o, l.variationKey = a, l.decisionReason = s, l.properties = u, l;
    }
    return e.prototype.copyWithUser = function(r) {
      return new e(this.timestamp, r, this.experiment, this.variationId, this.variationKey, this.decisionReason, this.properties, this.insertId);
    }, e.prototype.toDto = function() {
      return b(b({}, t.prototype.toDto.call(this)), { experimentId: this.experiment.id, experimentKey: this.experiment.key, experimentType: this.experiment.type, experimentVersion: this.experiment.version, variationId: this.variationId, variationKey: this.variationKey, decisionReason: this.decisionReason.toString(), properties: this.properties });
    }, e;
  }(Z)
), YR = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n, i, o, a) {
      var s = t.call(this, r, n, a) || this;
      return s.eventType = i, s.event = o, s;
    }
    return e.prototype.copyWithUser = function(r) {
      return new e(this.timestamp, r, this.eventType, this.event, this.insertId);
    }, e.prototype.toDto = function() {
      return b(b({}, t.prototype.toDto.call(this)), { eventTypeId: this.eventType.id, eventTypeKey: this.eventType.key, value: this.event.value || 0, properties: de.sanitize(this.event.properties) });
    }, e;
  }(Z)
), KR = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n, i, o, a, s, u) {
      var c = t.call(this, r, n, u) || this;
      return c.parameter = i, c.valueId = o, c.decisionReason = a, c.properties = s, c;
    }
    return e.prototype.copyWithUser = function(r) {
      return new e(this.timestamp, r, this.parameter, this.valueId, this.decisionReason, this.properties, this.insertId);
    }, e.prototype.toDto = function() {
      return b(b({}, t.prototype.toDto.call(this)), { parameterId: this.parameter.id, parameterKey: this.parameter.key, parameterType: this.parameter.type, valueId: this.valueId, decisionReason: this.decisionReason.toString(), properties: de.sanitize(this.properties) });
    }, e;
  }(Z)
), Gp = (
  /** @class */
  function() {
    function t(e, r) {
      this.userManager = e, this.core = r;
    }
    return t.isSessionEvent = function(e) {
      return Z.isTrackEvent(e) ? e.event.key === t.SESSION_START_EVENT_NAME || e.event.key === t.SESSION_END_EVENT_NAME : !1;
    }, t.prototype.onSessionStarted = function(e, r, n) {
      this.track(t.SESSION_START_EVENT_NAME, e, r, n);
    }, t.prototype.onSessionEnded = function(e, r, n) {
      this.track(t.SESSION_END_EVENT_NAME, e, r, n);
    }, t.prototype.track = function(e, r, n, i) {
      var o = { key: e }, a = this.userManager.toHackleUser(n), s = this.decorateSession(a, r);
      this.core.track(o, s, i);
    }, t.prototype.decorateSession = function(e, r) {
      var n = new zo().add(Ee.SESSION, r).addIdentifiers(e.identifiers).build();
      return b(b({}, e), { identifiers: n });
    }, t.SESSION_START_EVENT_NAME = "$session_start", t.SESSION_END_EVENT_NAME = "$session_end", t;
  }()
), QR = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.delegate = e, this.eventDedupDeterminer = r, this.sessionManager = n, this.userManager = i;
    }
    return t.prototype.process = function(e) {
      if (Gp.isSessionEvent(e) || this.sessionManager.startNewSessionIfNeeded(this.userManager.currentUser, e.timestamp), !this.eventDedupDeterminer.isDedupTarget(e)) {
        var r = JR(e.copyWithUser(e.user), this.sessionManager);
        this.delegate.process(r);
      }
    }, t.prototype.flush = function(e) {
      this.delegate.flush(e);
    }, t.prototype.close = function() {
      this.delegate.close();
    }, t.prototype.onLifecycleChanged = function(e, r) {
      switch (e) {
        case "hidden":
        case "pagehide":
          return this.flush(!0);
        case "blur":
        case "focus":
        case "locationChange":
        case "visible":
        case "pageshow":
          return;
      }
    }, t;
  }()
), qR = (
  /** @class */
  function() {
    function t() {
    }
    return t.toEvent = function(e) {
      var r;
      return {
        key: t.EVENT_KEY,
        properties: {
          level: t.LEVEL_ERROR,
          type: e.name,
          message: (r = e.message) !== null && r !== void 0 ? r : "",
          $stacktrace: t._stacktrace(e)
        }
      };
    }, t._stacktrace = function(e) {
      return v.isNullOrUndefined(e.stack) ? "" : e.stack.split(`
`).slice(0, t.STACK_TRACK_LIMIT).join(`
`);
    }, t.EVENT_KEY = "$trace", t.LEVEL_ERROR = "error", t.STACK_TRACK_LIMIT = 30, t;
  }()
), Ta = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r) {
      if (!this.supports(e))
        throw new Error("Unsupported EvaluatorRequest ".concat(e.toString()));
      if (r.contains(e)) {
        var n = r.stack.map(function(i) {
          return i.toString();
        }).join(" - ");
        throw new Error("Circular evaluation has occurred [".concat(n, " - ").concat(e.toString(), "]"));
      }
      r.addRequest(e);
      try {
        return this.evaluateInternal(e, r);
      } finally {
        r.removeRequest(e);
      }
    }, t;
  }()
), q = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a) {
      this.reason = e, this.targetEvaluations = r, this.experiment = n, this.variationId = i, this.variationKey = o, this.config = a;
    }
    return t.prototype.with = function(e) {
      return new t(e, this.targetEvaluations, this.experiment, this.variationId, this.variationKey, this.config);
    }, t.of = function(e, r, n, i) {
      var o = this.config(e.workspace, n);
      return new t(i, r.targetEvaluations, e.experiment, n.id, n.key, o);
    }, t.ofDefault = function(e, r, n) {
      var i = e.experiment._getVariationByKeyOrNull(e.defaultVariationKey);
      return v.isNotNullOrUndefined(i) ? this.of(e, r, i, n) : new t(n, r.targetEvaluations, e.experiment, void 0, e.defaultVariationKey, void 0);
    }, t.config = function(e, r) {
      if (!v.isNullOrUndefined(r.parameterConfigurationId))
        return v.requiredNotNullOrUndefined(e.getParameterConfigurationOrNull(r.parameterConfigurationId), function() {
          return "ParameterConfiguration[".concat(r.parameterConfigurationId, "]");
        });
    }, t;
  }()
), e2 = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r) {
      var n = t.call(this) || this;
      return n.evaluationFlowFactory = r, n;
    }
    return e.prototype.supports = function(r) {
      return r.experiment !== void 0;
    }, e.prototype.evaluateInternal = function(r, n) {
      var i, o = this.evaluationFlowFactory.getExperimentFlow(r.experiment.type);
      return (i = o.evaluate(r, n)) !== null && i !== void 0 ? i : q.ofDefault(r, n, w.TRAFFIC_NOT_ALLOCATED);
    }, e;
  }(Ta)
), on = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a) {
      this.reason = e, this.targetEvaluations = r, this.parameter = n, this.valueId = i, this.value = o, this.properties = a;
    }
    return t.of = function(e, r, n, i, o, a) {
      return a.returnValue = de.truncateStringValue(i), new t(o, r.targetEvaluations, e.parameter, n, i, a);
    }, t.ofDefault = function(e, r, n, i) {
      return this.of(e, r, void 0, e.defaultValue, n, i);
    }, t;
  }()
), t2 = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r) {
      var n = t.call(this) || this;
      return n.targetRuleDeterminer = r, n;
    }
    return e.prototype.supports = function(r) {
      return r.parameter !== void 0;
    }, e.prototype.evaluateInternal = function(r, n) {
      var i = {};
      if (i.requestValueType = r.requiredType, i.requestDefaultValue = de.truncateStringValue(r.defaultValue), v.isNullOrUndefined(r.user.identifiers[r.parameter.identifierType]))
        return on.ofDefault(r, n, w.IDENTIFIER_NOT_FOUND, i);
      var o = this.targetRuleDeterminer.determineTargetRuleOrNull(r, n);
      return v.isNotNullOrUndefined(o) ? (i.targetRuleKey = o.key, i.targetRuleName = o.name, this.evaluation(r, n, o.value, w.TARGET_RULE_MATCH, i)) : this.evaluation(r, n, r.parameter.defaultValue, w.DEFAULT_RULE, i);
    }, e.prototype.evaluation = function(r, n, i, o, a) {
      return r.requiredType === "UNKNOWN" || r.requiredType !== "NULL" && typeof r.defaultValue != typeof i.rawValue ? on.ofDefault(r, n, w.TYPE_MISMATCH, a) : on.of(r, n, i.id, i.rawValue, o, a);
    }, e;
  }(Ta)
), Cr = (
  /** @class */
  function() {
    function t(e, r) {
      this.type = e, this.id = r;
    }
    return t.prototype.isEquals = function(e) {
      return this.type === e.type && this.id === e.id;
    }, t;
  }()
), tt = (
  /** @class */
  function() {
    function t() {
      this._stack = [], this._targetEvaluations = [], this._properties = {};
    }
    return t.create = function() {
      return new t();
    }, Object.defineProperty(t.prototype, "stack", {
      get: function() {
        return Array.from(this._stack);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "targetEvaluations", {
      get: function() {
        return Array.from(this._targetEvaluations);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "properties", {
      get: function() {
        return de.sanitize(this._properties);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.contains = function(e) {
      return this._stack.some(function(r) {
        return r.key.isEquals(e.key);
      });
    }, t.prototype.addRequest = function(e) {
      this._stack.push(e);
    }, t.prototype.removeRequest = function(e) {
      var r = this._stack.indexOf(e, 0);
      r > -1 && this._stack.splice(r, 1);
    }, t.prototype.getEvaluation = function(e) {
      return this._targetEvaluations.find(function(r) {
        return r instanceof q && r.experiment.id === e.id;
      });
    }, t.prototype.addEvaluation = function(e) {
      this._targetEvaluations.push(e);
    }, t.prototype.setProperty = function(e, r) {
      this._properties[e] = r;
    }, t;
  }()
), rt = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.key = new Cr("EXPERIMENT", n.id), this.workspace = e, this.user = r, this.experiment = n, this.defaultVariationKey = i;
    }
    return t.of = function(e, r, n, i) {
      return new t(e, r, n, i);
    }, t.by = function(e, r) {
      return new t(e.workspace, e.user, r, "A");
    }, t.prototype.toString = function() {
      return "EvaluatorRequest(type=".concat(this.experiment.type, ", key=").concat(this.experiment.key, ")");
    }, t;
  }()
), r2 = (
  /** @class */
  function() {
    function t(e, r, n, i, o) {
      this.key = new Cr("REMOTE_CONFIG", n.id), this.workspace = e, this.user = r, this.parameter = n, this.requiredType = i, this.defaultValue = o;
    }
    return t.of = function(e, r, n, i, o) {
      return new t(e, r, n, i, o);
    }, t.prototype.toString = function() {
      return "EvaluatorRequest(type=".concat(this.key.type, ", key=").concat(this.parameter.key, ")");
    }, t;
  }()
), $e = (
  /** @class */
  function() {
    function t() {
    }
    return t.asString = function(e) {
      switch (typeof e) {
        case "string":
          return e;
        case "number":
          return e.toString();
        default:
          return;
      }
    }, t.asNumber = function(e) {
      switch (typeof e) {
        case "number":
          return this.asActualNumber(e);
        case "string":
          return this.asActualNumber(Number(e));
        default:
          return;
      }
    }, t.asActualNumber = function(e) {
      if (!isNaN(e) && isFinite(e))
        return e;
    }, t;
  }()
), n2 = (
  /** @class */
  function() {
    function t(e) {
      this.storages = e;
    }
    return t.prototype.getVariation = function(e, r) {
      if (this.storages.length !== 0)
        for (var n = 0, i = this.storages; n < i.length; n++) {
          var o = i[n], a = o.getVariation(e, r);
          if (a !== void 0)
            return a;
        }
    }, t;
  }()
), $c = (
  /** @class */
  function() {
    function t(e) {
      this.listStorage = e;
    }
    return t.prototype.getVariation = function(e, r) {
      var n = this.get(e);
      if (n)
        return e._getVariationByIdOrNull(n);
    }, t.prototype.get = function(e) {
      var r = this.listStorage.getItem(e.id.toString());
      return $e.asNumber(r);
    }, t.prototype.getAll = function() {
      var e = /* @__PURE__ */ new Map();
      return this.listStorage.entries().forEach(function(r) {
        var n = r[0], i = r[1], o = $e.asNumber(n), a = $e.asNumber(i);
        v.isNullOrUndefined(o) || o < 0 || v.isNullOrUndefined(a) || o < 0 || e.set(o, a);
      }), e;
    }, t.prototype.set = function(e, r) {
      this.listStorage.setItem(e.id.toString(), r.toString());
    }, t.prototype.remove = function(e) {
      this.listStorage.removeItem(e.id.toString());
    }, t.prototype.clear = function() {
      this.listStorage.clear();
    }, t;
  }()
), i2 = (
  /** @class */
  function() {
    function t() {
      this.evaluators = new Array();
    }
    return t.prototype.add = function(e) {
      this.evaluators.push(e);
    }, t.prototype.evaluate = function(e, r) {
      var n = this.evaluators.find(function(i) {
        return i.supports(e);
      });
      if (v.isNullOrUndefined(n))
        throw new Error("Unsupported EvaluatorRequest [".concat(e.toString(), "]"));
      return n.evaluate(e, r);
    }, t;
  }()
), o2 = (
  /** @class */
  function() {
    function t(e) {
      this.conditionMatcherFactory = e;
    }
    return t.prototype.matches = function(e, r, n) {
      var i = this;
      return n.conditions.every(function(o) {
        return i._matches(e, r, o);
      });
    }, t.prototype.anyMatches = function(e, r, n) {
      var i = this;
      return n.length ? n.some(function(o) {
        return i.matches(e, r, o);
      }) : !0;
    }, t.prototype._matches = function(e, r, n) {
      var i = this.conditionMatcherFactory.getMatcher(n.key.type);
      return i.matches(e, r, n);
    }, t;
  }()
), Vp = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.decorate = function(e) {
      return e;
    }, t;
  }()
), a2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.decorate = function(e) {
      return typeof e == "string" ? Ce.decodeURIOrOriginal(e) : e;
    }, t;
  }()
), s2 = (
  /** @class */
  function() {
    function t(e, r) {
      this.valueMatcherFactory = e, this.operatorMatcherFactory = r;
    }
    return t.prototype.matches = function(e, r, n) {
      n === void 0 && (n = new Vp());
      var i = this.valueMatcherFactory.getMatcher(r.valueType), o = this.operatorMatcherFactory.getMatcher(r.operator), a = this.userValueMatches(e, r, i, o, n);
      return this.typeMatches(r.type, a);
    }, t.prototype.userValueMatches = function(e, r, n, i, o) {
      return Array.isArray(e) ? this.arrayMatches(e, r, n, i, o) : this.singleMatches(e, r, n, i, o);
    }, t.prototype.singleMatches = function(e, r, n, i, o) {
      return r.values.some(function(a) {
        return n.matches(i, o.decorate(e), o.decorate(a));
      });
    }, t.prototype.arrayMatches = function(e, r, n, i, o) {
      var a = this;
      return e.some(function(s) {
        return a.singleMatches(s, r, n, i, o);
      });
    }, t.prototype.typeMatches = function(e, r) {
      switch (e) {
        case "MATCH":
          return r;
        case "NOT_MATCH":
          return !r;
      }
    }, t;
  }()
), u2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.booleanMatches = function(e, r) {
      return e === r;
    }, t.prototype.numberMatches = function(e, r) {
      return e === r;
    }, t.prototype.stringMatches = function(e, r) {
      return e === r;
    }, t.prototype.versionMatches = function(e, r) {
      return e.isEqualTo(r);
    }, t.prototype.urlMatches = function(e, r) {
      var n = Ce.decodeURIOrOriginal(Ce.removePathnameTrailingSlash(e)), i = Ce.decodeURIOrOriginal(Ce.removePathnameTrailingSlash(r));
      return n === i;
    }, t;
  }()
), c2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.booleanMatches = function(e, r) {
      return !1;
    }, t.prototype.numberMatches = function(e, r) {
      return !1;
    }, t.prototype.stringMatches = function(e, r) {
      return e.includes(r);
    }, t.prototype.versionMatches = function(e, r) {
      return !1;
    }, t.prototype.urlMatches = function(e, r) {
      var n = Ce.decodeURIOrOriginal(e.href);
      return n.includes(r) || n.includes(encodeURI(r));
    }, t;
  }()
), l2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.booleanMatches = function(e, r) {
      return !1;
    }, t.prototype.numberMatches = function(e, r) {
      return !1;
    }, t.prototype.stringMatches = function(e, r) {
      return e.startsWith(r);
    }, t.prototype.versionMatches = function(e, r) {
      return !1;
    }, t.prototype.urlMatches = function(e, r) {
      var n = Ce.decodeURIOrOriginal(e.href);
      return n.startsWith(r) || n.startsWith(encodeURI(r));
    }, t;
  }()
), f2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.booleanMatches = function(e, r) {
      return !1;
    }, t.prototype.numberMatches = function(e, r) {
      return !1;
    }, t.prototype.stringMatches = function(e, r) {
      return e.endsWith(r);
    }, t.prototype.versionMatches = function(e, r) {
      return !1;
    }, t.prototype.urlMatches = function(e, r) {
      return !1;
    }, t;
  }()
), p2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.booleanMatches = function(e, r) {
      return !1;
    }, t.prototype.numberMatches = function(e, r) {
      return e > r;
    }, t.prototype.stringMatches = function(e, r) {
      return e > r;
    }, t.prototype.versionMatches = function(e, r) {
      return e.isGreaterThan(r);
    }, t.prototype.urlMatches = function(e, r) {
      return !1;
    }, t;
  }()
), d2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.booleanMatches = function(e, r) {
      return !1;
    }, t.prototype.numberMatches = function(e, r) {
      return e >= r;
    }, t.prototype.stringMatches = function(e, r) {
      return e >= r;
    }, t.prototype.versionMatches = function(e, r) {
      return e.isGreaterThanOrEqualTo(r);
    }, t.prototype.urlMatches = function(e, r) {
      return !1;
    }, t;
  }()
), v2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.booleanMatches = function(e, r) {
      return !1;
    }, t.prototype.numberMatches = function(e, r) {
      return e < r;
    }, t.prototype.stringMatches = function(e, r) {
      return e < r;
    }, t.prototype.versionMatches = function(e, r) {
      return e.isLessThan(r);
    }, t.prototype.urlMatches = function(e, r) {
      return !1;
    }, t;
  }()
), h2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.booleanMatches = function(e, r) {
      return !1;
    }, t.prototype.numberMatches = function(e, r) {
      return e <= r;
    }, t.prototype.stringMatches = function(e, r) {
      return e <= r;
    }, t.prototype.versionMatches = function(e, r) {
      return e.isLessThanOrEqualTo(r);
    }, t.prototype.urlMatches = function(e, r) {
      return !1;
    }, t;
  }()
), g2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getMatcher = function(e) {
      switch (e) {
        case "IN":
          return t.IN_MATCHER;
        case "CONTAINS":
          return t.CONTAINS_MATCHER;
        case "STARTS_WITH":
          return t.STARTS_WITH_MATCHER;
        case "ENDS_WITH":
          return t.ENDS_WITH_MATCHER;
        case "GT":
          return t.GT_MATCHER;
        case "GTE":
          return t.GTE_MATCHER;
        case "LT":
          return t.LT_MATCHER;
        case "LTE":
          return t.LTE_MATCHER;
      }
    }, t.IN_MATCHER = new u2(), t.CONTAINS_MATCHER = new c2(), t.STARTS_WITH_MATCHER = new l2(), t.ENDS_WITH_MATCHER = new f2(), t.GT_MATCHER = new p2(), t.GTE_MATCHER = new d2(), t.LT_MATCHER = new v2(), t.LTE_MATCHER = new h2(), t;
  }()
), y2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.matches = function(e, r, n) {
      var i = $e.asString(r), o = $e.asString(n);
      return v.isNullOrUndefined(i) || v.isNullOrUndefined(o) ? !1 : e.stringMatches(i, o);
    }, t;
  }()
), I2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.matches = function(e, r, n) {
      var i = $e.asNumber(r), o = $e.asNumber(n);
      return v.isNullOrUndefined(i) || v.isNullOrUndefined(o) ? !1 : e.numberMatches(i, o);
    }, t;
  }()
), m2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.matches = function(e, r, n) {
      return typeof r == "boolean" && typeof n == "boolean" ? e.booleanMatches(r, n) : !1;
    }, t;
  }()
), A2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.matches = function(e, r, n) {
      var i = cs.tryParse(r), o = cs.tryParse(n);
      return i && o ? e.versionMatches(i, o) : !1;
    }, t;
  }()
), E2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.matches = function(e, r, n) {
      var i = Ce.tryParse(r), o = $e.asString(n);
      return v.isNullOrUndefined(i) || v.isNullOrUndefined(o) ? !1 : e.urlMatches(i, o);
    }, t;
  }()
), C2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.matches = function(e, r, n) {
      return !1;
    }, t;
  }()
), b2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getMatcher = function(e) {
      switch (e) {
        case "STRING":
          return t.STRING_MATCHER;
        case "JSON":
          return t.STRING_MATCHER;
        case "NUMBER":
          return t.NUMBER_MATCHER;
        case "BOOLEAN":
          return t.BOOLEAN_MATCHER;
        case "VERSION":
          return t.VERSION_MATCHER;
        case "URL":
          return t.URL_MATCHER;
        case "NULL":
          return t.NULL_MATCHER;
        case "UNKNOWN":
          return t.NULL_MATCHER;
      }
    }, t.STRING_MATCHER = new y2(), t.NUMBER_MATCHER = new I2(), t.BOOLEAN_MATCHER = new m2(), t.VERSION_MATCHER = new A2(), t.URL_MATCHER = new E2(), t.NULL_MATCHER = new C2(), t;
  }()
), T2 = (
  /** @class */
  function() {
    function t(e, r) {
      this.URL_HACKLE_PROPERTY_KEY_NAMES = ["pagePath", "host", "url", "queryParameter"], this.userValueResolver = e, this.valueOperatorMatcher = r;
    }
    return t.prototype.matches = function(e, r, n) {
      var i = this.userValueResolver.resolveOrNull(e.user, n.key);
      if (v.isNullOrUndefined(i))
        return !1;
      var o = this.valueDecorator(n.key);
      return this.valueOperatorMatcher.matches(i, n.match, o);
    }, t.prototype.valueDecorator = function(e) {
      return e.type === "HACKLE_PROPERTY" && this.URL_HACKLE_PROPERTY_KEY_NAMES.includes(e.name) ? new a2() : new Vp();
    }, t;
  }()
), w2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.resolveOrNull = function(e, r) {
      switch (r.type) {
        case "USER_ID":
          return e.identifiers[r.name];
        case "USER_PROPERTY":
          return e.properties[r.name];
        case "HACKLE_PROPERTY":
          return e.hackleProperties[r.name];
        case "SEGMENT":
        case "AB_TEST":
        case "FEATURE_FLAG":
        case "EVENT_PROPERTY":
        case "COHORT":
          throw new Error("Unsupported TargetKeyType [".concat(r.type, "]"));
      }
    }, t;
  }()
), N2 = (
  /** @class */
  function() {
    function t(e) {
      this.segmentMatcher = e;
    }
    return t.prototype.matches = function(e, r, n) {
      var i = this;
      if (n.key.type != "SEGMENT")
        throw new Error("Unsupported TargetKeyType [".concat(n.key.type, "]"));
      var o = n.match.values.some(function(a) {
        return i._matches(e, r, a);
      });
      switch (n.match.type) {
        case "MATCH":
          return o;
        case "NOT_MATCH":
          return !o;
      }
    }, t.prototype._matches = function(e, r, n) {
      if (typeof n != "string")
        throw new Error("SegmentKey[".concat(n, "]"));
      var i = e.workspace.getSegmentOrNull(n);
      if (!i)
        throw new Error("Segment[".concat(n, "]"));
      return this.segmentMatcher.matches(e, r, i);
    }, t;
  }()
), O2 = (
  /** @class */
  function() {
    function t(e) {
      this.userConditionMatcher = e;
    }
    return t.prototype.matches = function(e, r, n) {
      var i = this;
      return n.targets.some(function(o) {
        return i._matches(e, r, o);
      });
    }, t.prototype._matches = function(e, r, n) {
      var i = this;
      return n.conditions.every(function(o) {
        return i.userConditionMatcher.matches(e, r, o);
      });
    }, t;
  }()
), M2 = (
  /** @class */
  function() {
    function t(e, r) {
      this.abTestMatcher = e, this.featureFlagMatcher = r;
    }
    return t.prototype.matches = function(e, r, n) {
      switch (n.key.type) {
        case "AB_TEST":
          return this.abTestMatcher.matches(e, r, n);
        case "FEATURE_FLAG":
          return this.featureFlagMatcher.matches(e, r, n);
        case "USER_ID":
        case "USER_PROPERTY":
        case "HACKLE_PROPERTY":
        case "EVENT_PROPERTY":
        case "SEGMENT":
        case "COHORT":
          throw new Error("Unsupported TargetKeyType [".concat(n.key.type, "]"));
      }
    }, t;
  }()
), Bp = (
  /** @class */
  function() {
    function t(e, r) {
      this.evaluator = e, this.valueOperatorMatcher = r;
    }
    return t.prototype.matches = function(e, r, n) {
      var i, o = v.requiredNotNullOrUndefined($e.asNumber(n.key.name), function() {
        return "Invalid key [".concat(n.key.type, ", ").concat(n.key.name, "]");
      }), a = this.experiment(e, o);
      if (v.isNullOrUndefined(a))
        return !1;
      var s = (i = r.getEvaluation(a)) !== null && i !== void 0 ? i : this.evaluate(e, r, a);
      return this.evaluationMatches(s, n);
    }, t.prototype.evaluate = function(e, r, n) {
      var i = rt.by(e, n), o = this.evaluator.evaluate(i, r), a = this.resolve(e, o);
      return r.addEvaluation(a), a;
    }, t;
  }()
), _2 = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n) {
      return t.call(this, r, n) || this;
    }
    return e.prototype.experiment = function(r, n) {
      return r.workspace.getExperimentOrNull(n);
    }, e.prototype.resolve = function(r, n) {
      return r instanceof rt && n.reason === w.TRAFFIC_ALLOCATED ? n.with(w.TRAFFIC_ALLOCATED_BY_TARGETING) : n;
    }, e.prototype.evaluationMatches = function(r, n) {
      return e.AB_TEST_MATCHED_REASONS.includes(r.reason) ? this.valueOperatorMatcher.matches(r.variationKey, n.match) : !1;
    }, e.AB_TEST_MATCHED_REASONS = [
      w.OVERRIDDEN,
      w.TRAFFIC_ALLOCATED,
      w.EXPERIMENT_COMPLETED,
      w.TRAFFIC_ALLOCATED_BY_TARGETING
    ], e;
  }(Bp)
), S2 = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n) {
      return t.call(this, r, n) || this;
    }
    return e.prototype.experiment = function(r, n) {
      return r.workspace.getFeatureFlagOrNull(n);
    }, e.prototype.resolve = function(r, n) {
      return n;
    }, e.prototype.evaluationMatches = function(r, n) {
      var i = r.variationKey !== "A";
      return this.valueOperatorMatcher.matches(i, n.match);
    }, e;
  }(Bp)
), R2 = (
  /** @class */
  function() {
    function t(e, r) {
      this.eventValueResolver = e, this.valueOperatorMatcher = r;
    }
    return t.prototype.matches = function(e, r, n) {
      if (!this.isEventEvaluatorRequest(e))
        return !1;
      var i = this.eventValueResolver.resolveOrNull(e.event, n.key);
      return v.isNullOrUndefined(i) ? !1 : this.valueOperatorMatcher.matches(i, n.match);
    }, t.prototype.isEventEvaluatorRequest = function(e) {
      return e.event !== void 0;
    }, t;
  }()
), x2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.resolveOrNull = function(e, r) {
      var n;
      switch (r.type) {
        case "EVENT_PROPERTY":
          return (n = this.properties(e)) === null || n === void 0 ? void 0 : n[r.name];
        case "USER_ID":
        case "USER_PROPERTY":
        case "HACKLE_PROPERTY":
        case "SEGMENT":
        case "AB_TEST":
        case "FEATURE_FLAG":
        case "COHORT":
          throw new Error("Unsupported TargetKeyType [".concat(r.type, "]"));
      }
    }, t.prototype.properties = function(e) {
      if (Z.isTrackEvent(e))
        return e.event.properties;
      if (Z.isExposureEvent(e) || Z.isRemoteConfigEvent(e))
        return e.properties;
    }, t;
  }()
), P2 = (
  /** @class */
  function() {
    function t(e) {
      this.valueOperatorMatcher = e;
    }
    return t.prototype.matches = function(e, r, n) {
      var i, o;
      if (n.key.type !== "COHORT")
        throw new Error("Unsupported TargetKeyType [".concat(n.key.type, "]"));
      var a = (o = (i = e.user.cohorts) === null || i === void 0 ? void 0 : i.map(function(s) {
        return s.id;
      })) !== null && o !== void 0 ? o : [];
      return this.valueOperatorMatcher.matches(a, n.match);
    }, t;
  }()
), U2 = (
  /** @class */
  function() {
    function t(e) {
      var r = new s2(new b2(), new g2());
      this.userConditionMatcher = new T2(new w2(), r), this.eventConditionMatcher = new R2(new x2(), r), this.segmentConditionMatcher = new N2(new O2(this.userConditionMatcher)), this.experimentConditionMatcher = new M2(new _2(e, r), new S2(e, r)), this.cohortConditionMatcher = new P2(r);
    }
    return t.prototype.getMatcher = function(e) {
      switch (e) {
        case "USER_ID":
        case "USER_PROPERTY":
        case "HACKLE_PROPERTY":
          return this.userConditionMatcher;
        case "EVENT_PROPERTY":
          return this.eventConditionMatcher;
        case "SEGMENT":
          return this.segmentConditionMatcher;
        case "AB_TEST":
        case "FEATURE_FLAG":
          return this.experimentConditionMatcher;
        case "COHORT":
          return this.cohortConditionMatcher;
      }
    }, t;
  }()
), D2 = (
  /** @class */
  function() {
    function t(e) {
      this.bucketer = e;
    }
    return t.prototype.resolveOrNull = function(e, r, n) {
      switch (n.type) {
        case "VARIATION":
          return this.resolveVariation(e, n);
        case "BUCKET":
          return this.resolveBucket(e, n);
      }
    }, t.prototype.resolveVariation = function(e, r) {
      return e.experiment._getVariationByIdOrNull(r.variationId);
    }, t.prototype.resolveBucket = function(e, r) {
      var n = e.workspace.getBucketOrNull(r.bucketId), i = e.user.identifiers[e.experiment.identifierType];
      if (i) {
        var o = this.bucketer.bucketing(n, i);
        if (o)
          return e.experiment._getVariationByIdOrNull(o.variationId);
      }
    }, t;
  }()
), L2 = {
  murmurhash3_x86_32: function(t, e, r, n) {
    n === void 0 && (n = t.length);
    for (var i = 3432918353, o = 461845907, a = n & -4, s = e, u, c = 0; c < a; c += 4)
      u = t.charCodeAt(c) & 255 | (t.charCodeAt(c + 1) & 255) << 8 | (t.charCodeAt(c + 2) & 255) << 16 | (t.charCodeAt(c + 3) & 255) << 24, u = this.mul32(u, i), u = (u & 131071) << 15 | u >>> 17, u = this.mul32(u, o), s ^= u, s = (s & 524287) << 13 | s >>> 19, s = s * 5 + 3864292196 | 0;
    switch (u = 0, n % 4) {
      case 3:
        u = (t.charCodeAt(a + 2) & 255) << 16;
      case 2:
        u |= (t.charCodeAt(a + 1) & 255) << 8;
      case 1:
        u |= t.charCodeAt(a) & 255, u = this.mul32(u, i), u = (u & 131071) << 15 | u >>> 17, u = this.mul32(u, o), s ^= u;
    }
    return s ^= n, s ^= s >>> 16, s = this.mul32(s, 2246822507), s ^= s >>> 13, s = this.mul32(s, 3266489909), s ^= s >>> 16, s;
  },
  mul32: function(t, e) {
    var r = e & 65535, n = e - r;
    return (n * t | 0) + (r * t | 0) | 0;
  }
}, $2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.bucketing = function(e, r) {
      var n = this.calculateSlotNumber(e.seed, e.slotSize, r);
      return e.slots.find(function(i) {
        return i.contains(n);
      });
    }, t.prototype.calculateSlotNumber = function(e, r, n) {
      var i = L2.murmurhash3_x86_32(n, e);
      return Math.abs(i) % Math.abs(r);
    }, t;
  }()
), Zi = (
  /** @class */
  function() {
    function t(e, r) {
      this.flowEvaluator = e, this.nextFlow = r;
    }
    return t.prototype.evaluate = function(e, r) {
      if (this.flowEvaluator && this.nextFlow)
        return this.flowEvaluator.evaluate(e, r, this.nextFlow);
    }, t.end = function() {
      return new t(void 0, void 0);
    }, t.decision = function(e, r) {
      return new t(e, r);
    }, t.of = function() {
      for (var e = [], r = 0; r < arguments.length; r++)
        e[r] = arguments[r];
      for (var n = this.end(), i = 0, o = e.reverse(); i < o.length; i++) {
        var a = o[i];
        n = this.decision(a, n);
      }
      return n;
    }, t;
  }()
), kc = (
  /** @class */
  function() {
    function t(e) {
      this.overrideResolver = e;
    }
    return t.prototype.evaluate = function(e, r, n) {
      var i = this.overrideResolver.resolveOrNull(e, r);
      if (i)
        switch (e.experiment.type) {
          case "AB_TEST":
            return q.of(e, r, i, w.OVERRIDDEN);
          case "FEATURE_FLAG":
            return q.of(e, r, i, w.INDIVIDUAL_TARGET_MATCH);
        }
      else
        return n.evaluate(e, r);
    }, t;
  }()
), Fc = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r, n) {
      return e.experiment.status === "DRAFT" ? q.ofDefault(e, r, w.EXPERIMENT_DRAFT) : n.evaluate(e, r);
    }, t;
  }()
), Gc = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r, n) {
      if (e.experiment.status === "PAUSED")
        switch (e.experiment.type) {
          case "AB_TEST":
            return q.ofDefault(e, r, w.EXPERIMENT_PAUSED);
          case "FEATURE_FLAG":
            return q.ofDefault(e, r, w.FEATURE_FLAG_INACTIVE);
        }
      else
        return n.evaluate(e, r);
    }, t;
  }()
), Vc = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r, n) {
      if (e.experiment.status === "COMPLETED") {
        var i = e.experiment._winnerVariationOrNull();
        if (!i)
          throw new Error("winner variation [".concat(e.experiment.id, "]"));
        return q.of(e, r, i, w.EXPERIMENT_COMPLETED);
      } else
        return n.evaluate(e, r);
    }, t;
  }()
), k2 = (
  /** @class */
  function() {
    function t(e) {
      this.experimentTargetDeterminer = e;
    }
    return t.prototype.evaluate = function(e, r, n) {
      if (e.experiment.type !== "AB_TEST")
        throw new Error("experiment type must be AB_TEST [".concat(e.experiment.id, "]"));
      var i = this.experimentTargetDeterminer.isUserInExperimentTarget(e, r);
      return i ? n.evaluate(e, r) : q.ofDefault(e, r, w.NOT_IN_EXPERIMENT_TARGET);
    }, t;
  }()
), F2 = (
  /** @class */
  function() {
    function t(e) {
      this.actionResolver = e;
    }
    return t.prototype.evaluate = function(e, r, n) {
      if (e.experiment.status !== "RUNNING")
        throw new Error("experiment status must be RUNNING [".concat(e.experiment.id, "]"));
      if (e.experiment.type !== "AB_TEST")
        throw new Error("experiment type must be AB_TEST [".concat(e.experiment.id, "]"));
      var i = this.actionResolver.resolveOrNull(e, r, e.experiment.defaultRule);
      return i ? i.isDropped ? q.ofDefault(e, r, w.VARIATION_DROPPED) : q.of(e, r, i, w.TRAFFIC_ALLOCATED) : q.ofDefault(e, r, w.TRAFFIC_NOT_ALLOCATED);
    }, t;
  }()
), G2 = (
  /** @class */
  function() {
    function t(e, r) {
      this.targetRuleDeterminer = e, this.actionResolver = r;
    }
    return t.prototype.evaluate = function(e, r, n) {
      if (e.experiment.status !== "RUNNING")
        throw new Error("experiment status must be RUNNING [".concat(e.experiment.id, "]"));
      if (e.experiment.type !== "FEATURE_FLAG")
        throw new Error("experiment type must be FEATURE_FLAG [".concat(e.experiment.id, "]"));
      if (!e.user.identifiers[e.experiment.identifierType])
        return n.evaluate(e, r);
      var i = this.targetRuleDeterminer.determineTargetRuleOrNull(e, r);
      if (!i)
        return n.evaluate(e, r);
      var o = this.actionResolver.resolveOrNull(e, r, i.action);
      if (!o)
        throw new Error("FeatureFlag must decide the Variation [".concat(e.experiment.id, "]"));
      return q.of(e, r, o, w.TARGET_RULE_MATCH);
    }, t;
  }()
), V2 = (
  /** @class */
  function() {
    function t(e) {
      this.actionResolver = e;
    }
    return t.prototype.evaluate = function(e, r, n) {
      if (e.experiment.status !== "RUNNING")
        throw new Error("experiment status must be RUNNING [".concat(e.experiment.id, "]"));
      if (e.experiment.type !== "FEATURE_FLAG")
        throw new Error("experiment type must be FEATURE_FLAG [".concat(e.experiment.id, "]"));
      if (!e.user.identifiers[e.experiment.identifierType])
        return q.ofDefault(e, r, w.DEFAULT_RULE);
      var i = this.actionResolver.resolveOrNull(e, r, e.experiment.defaultRule);
      if (!i)
        throw new Error("FeatureFlag must decide the Variation [".concat(e.experiment.id, "]"));
      return q.of(e, r, i, w.DEFAULT_RULE);
    }, t;
  }()
), B2 = (
  /** @class */
  function() {
    function t(e) {
      this.containerResolver = e;
    }
    return t.prototype.evaluate = function(e, r, n) {
      var i = e.experiment.containerId;
      if (!i)
        return n.evaluate(e, r);
      var o = e.workspace.getContainerOrNull(i);
      if (!o)
        throw new Error("container[".concat(i, "]"));
      var a = this.containerResolver.isUserInContainerGroup(e, r, o);
      return a ? n.evaluate(e, r) : q.ofDefault(e, r, w.NOT_IN_MUTUAL_EXCLUSION_EXPERIMENT);
    }, t;
  }()
), Bc = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r, n) {
      return e.user.identifiers[e.experiment.identifierType] ? n.evaluate(e, r) : q.ofDefault(e, r, w.IDENTIFIER_NOT_FOUND);
    }, t;
  }()
), j2 = (
  /** @class */
  function() {
    function t(e) {
      this.targetMatcher = e;
    }
    return t.prototype.isUserInExperimentTarget = function(e, r) {
      var n = this;
      return e.experiment.targetAudiences.length === 0 ? !0 : e.experiment.targetAudiences.some(function(i) {
        return n.targetMatcher.matches(e, r, i);
      });
    }, t;
  }()
), H2 = (
  /** @class */
  function() {
    function t(e) {
      this.targetMatcher = e;
    }
    return t.prototype.determineTargetRuleOrNull = function(e, r) {
      var n = this;
      return e.experiment.targetRules.find(function(i) {
        return n.targetMatcher.matches(e, r, i.target);
      });
    }, t;
  }()
), X2 = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.manualOverrideStorage = e, this.targetMatcher = r, this.actionResolver = n;
    }
    return t.prototype.resolveOrNull = function(e, r) {
      var n, i;
      return (i = (n = this.resolveManualOverride(e)) !== null && n !== void 0 ? n : this._resolveUserOverride(e)) !== null && i !== void 0 ? i : this._resolveSegmentOverride(e, r);
    }, t.prototype.resolveManualOverride = function(e) {
      return this.manualOverrideStorage.getVariation(e.experiment, e.user);
    }, t.prototype._resolveUserOverride = function(e) {
      var r = e.experiment, n = e.user.identifiers[r.identifierType];
      if (n) {
        var i = r.userOverrides.get(n);
        if (i)
          return r._getVariationByIdOrNull(i);
      }
    }, t.prototype._resolveSegmentOverride = function(e, r) {
      var n = this, i = e.experiment.segmentOverrides.find(function(o) {
        return n.targetMatcher.matches(e, r, o.target);
      });
      if (i)
        return this.actionResolver.resolveOrNull(e, r, i.action);
    }, t;
  }()
), W2 = (
  /** @class */
  function() {
    function t(e) {
      this.bucketer = e;
    }
    return t.prototype.isUserInContainerGroup = function(e, r, n) {
      var i = e.user.identifiers[e.experiment.identifierType];
      if (v.isNullOrUndefined(i))
        return !1;
      var o = e.workspace.getBucketOrNull(n.bucketId);
      if (v.isNullOrUndefined(o))
        throw new Error("Bucket[".concat(n.bucketId, "]"));
      var a = this.bucketer.bucketing(o, i);
      if (v.isNullOrUndefined(a))
        return !1;
      var s = n.getGroupOrNull(a.variationId);
      if (v.isNullOrUndefined(s))
        throw new Error("ContainerGroup[".concat(a.variationId, "]"));
      return s.experiments.includes(e.experiment.id);
    }, t;
  }()
), _e = (
  /** @class */
  function() {
    function t(e, r, n, i, o) {
      this.reason = e, this.targetEvaluations = r, this.inAppMessage = n, this.message = i, this.properties = o;
    }
    return t.of = function(e, r, n, i) {
      return new t(n, r.targetEvaluations, e.inAppMessage, i, r.properties);
    }, t;
  }()
), z2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r, n) {
      return e.inAppMessage.supports("WEB") ? n.evaluate(e, r) : _e.of(e, r, w.UNSUPPORTED_PLATFORM);
    }, t;
  }()
), J2 = (
  /** @class */
  function() {
    function t(e, r) {
      this.userOverrideMatcher = e, this.inAppMessageResolver = r;
    }
    return t.prototype.evaluate = function(e, r, n) {
      if (this.userOverrideMatcher.matches(e, r)) {
        var i = this.inAppMessageResolver.resolve(e, r);
        return _e.of(e, r, w.OVERRIDDEN, i);
      }
      return n.evaluate(e, r);
    }, t;
  }()
), Z2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r, n) {
      return e.inAppMessage.status === "DRAFT" ? _e.of(e, r, w.IN_APP_MESSAGE_DRAFT) : n.evaluate(e, r);
    }, t;
  }()
), Y2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r, n) {
      return e.inAppMessage.status === "PAUSE" ? _e.of(e, r, w.IN_APP_MESSAGE_PAUSED) : n.evaluate(e, r);
    }, t;
  }()
), K2 = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.evaluate = function(e, r, n) {
      return e.inAppMessage.period.within(e.timestamp) ? n.evaluate(e, r) : _e.of(e, r, w.NOT_IN_IN_APP_MESSAGE_PERIOD);
    }, t;
  }()
), Q2 = (
  /** @class */
  function() {
    function t(e) {
      this.hiddenMatcher = e;
    }
    return t.prototype.evaluate = function(e, r, n) {
      return this.hiddenMatcher.matches(e, r) ? _e.of(e, r, w.IN_APP_MESSAGE_HIDDEN) : n.evaluate(e, r);
    }, t;
  }()
), q2 = (
  /** @class */
  function() {
    function t(e, r) {
      this.targetMatcher = e, this.inAppMessageResolver = r;
    }
    return t.prototype.evaluate = function(e, r, n) {
      if (this.targetMatcher.matches(e, r)) {
        var i = this.inAppMessageResolver.resolve(e, r);
        return _e.of(e, r, w.IN_APP_MESSAGE_TARGET, i);
      }
      return _e.of(e, r, w.NOT_IN_IN_APP_MESSAGE_TARGET);
    }, t;
  }()
), ex = (
  /** @class */
  function() {
    function t(e) {
      this.evaluator = e;
    }
    return t.prototype.resolve = function(e, r) {
      var n;
      return (n = this.resolveExperiment(e, r)) !== null && n !== void 0 ? n : this.resolveDefault(e);
    }, t.prototype.resolveExperiment = function(e, r) {
      var n = e.inAppMessage.messageContext.experimentContext;
      if (!n)
        return null;
      var i = v.requiredNotNullOrUndefined(e.workspace.getExperimentOrNull(n.key), function() {
        return "Experiment[".concat(n.key, "]");
      }), o = rt.by(e, i), a = this.evaluator.evaluate(o, r);
      this.addExperimentContext(a, r);
      var s = e.inAppMessage.messageContext.defaultLang;
      return this.resolveMessage(e, function(u) {
        return u.lang === s && a.variationKey === u.variationKey;
      });
    }, t.prototype.addExperimentContext = function(e, r) {
      r.addEvaluation(e), r.setProperty("experiment_id", e.experiment.id), r.setProperty("experiment_key", e.experiment.key), r.setProperty("variation_id", e.variationId), r.setProperty("variation_key", e.variationKey), r.setProperty("experiment_decision_reason", e.reason);
    }, t.prototype.resolveDefault = function(e) {
      var r = e.inAppMessage.messageContext.defaultLang;
      return this.resolveMessage(e, function(n) {
        return n.lang === r;
      });
    }, t.prototype.resolveMessage = function(e, r) {
      var n = e.inAppMessage.messageContext.messages.find(r);
      return v.requiredNotNullOrUndefined(n, function() {
        return "InAppMessage must be decided [".concat(e.inAppMessage.id, "]");
      });
    }, t;
  }()
), tx = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.matches = function(e, r) {
      var n = this;
      return e.inAppMessage.targetContext.overrides.some(function(i) {
        return n.isUserOverridden(e, i);
      });
    }, t.prototype.isUserOverridden = function(e, r) {
      var n = e.user.identifiers[r.identifierType];
      return v.isNullOrUndefined(n) ? !1 : r.identifiers.includes(n);
    }, t;
  }()
), rx = (
  /** @class */
  function() {
    function t(e) {
      this.targetMatcher = e;
    }
    return t.prototype.matches = function(e, r) {
      var n = this, i = e.inAppMessage.targetContext.targets;
      return i.length === 0 ? !0 : i.some(function(o) {
        return n.targetMatcher.matches(e, r, o);
      });
    }, t;
  }()
), nx = (
  /** @class */
  function() {
    function t(e) {
      this.storage = e;
    }
    return t.prototype.matches = function(e, r) {
      return this.storage.exist(e.inAppMessage, e.timestamp);
    }, t;
  }()
), ix = (
  /** @class */
  function() {
    function t(e, r) {
      this.targetMatcher = e, this.bucketer = r;
    }
    return t.prototype.determineTargetRuleOrNull = function(e, r) {
      var n = this;
      return e.parameter.targetRules.find(function(i) {
        return n.matches(e, r, i);
      });
    }, t.prototype.matches = function(e, r, n) {
      if (!this.targetMatcher.matches(e, r, n.target))
        return !1;
      var i = e.user.identifiers[e.parameter.identifierType];
      if (v.isNullOrUndefined(i))
        return !1;
      var o = e.workspace.getBucketOrNull(n.bucketId);
      if (v.isNullOrUndefined(o))
        throw new Error("bucket[".concat(n.bucketId, "]"));
      return v.isNotNullOrUndefined(this.bucketer.bucketing(o, i));
    }, t;
  }()
), $o = (
  /** @class */
  function() {
    function t() {
    }
    return t.get = function(e) {
      return v.requiredNotNullOrUndefined(this.getOrNull(e), function() {
        return "Instance not registered [".concat(e, "]");
      });
    }, t.getOrNull = function(e) {
      return t.instances.get(e);
    }, t.register = function(e, r) {
      return t.instances.set(e, r), r;
    }, t.instances = /* @__PURE__ */ new Map(), t;
  }()
), ox = (
  /** @class */
  function() {
    function t(e, r, n) {
      var i = new $2(), o = $o.register("targetMatcher", new o2(new U2(e))), a = new D2(i), s = new X2(r, o, a), u = new W2(i);
      this.abTestFlow = Zi.of(new kc(s), new Bc(), new B2(u), new k2(new j2(o)), new Fc(), new Gc(), new Vc(), new F2(a)), this.featureFlagFlow = Zi.of(new Fc(), new Gc(), new Vc(), new kc(s), new Bc(), new G2(new H2(o), a), new V2(a));
      var c = new ex(e);
      this.inAppMessageFlow = Zi.of(new z2(), new J2(new tx(), c), new Z2(), new Y2(), new K2(), new Q2(new nx(n)), new q2(new rx(o), c)), this.remoteConfigParameterTargetRuleDeterminer = new ix(o, i);
    }
    return t.prototype.getExperimentFlow = function(e) {
      switch (e) {
        case "AB_TEST":
          return this.abTestFlow;
        case "FEATURE_FLAG":
          return this.featureFlagFlow;
      }
    }, t.prototype.getInAppMessageFlow = function() {
      return this.inAppMessageFlow;
    }, t;
  }()
), ax = (
  /** @class */
  function() {
    function t(e) {
      this.clock = e;
    }
    return t.prototype.create = function(e, r) {
      var n = this, i = this.clock.currentMillis(), o = new Array(), a = this.createEvent(e, r, i, {});
      return a && o.push(a), r.targetEvaluations.forEach(function(s) {
        var u, c = (u = {}, u[t.ROOT_TYPE] = e.key.type, u[t.ROOT_ID] = e.key.id, u), l = n.createEvent(e, s, i, c);
        l && o.push(l);
      }), o;
    }, t.prototype.createEvent = function(e, r, n, i) {
      var o;
      if (r instanceof q)
        return i[t.CONFIG_ID_PROPERTY_KEY] = (o = r.config) === null || o === void 0 ? void 0 : o.id, i[t.EXPERIMENT_VERSION_KEY] = r.experiment.version, i[t.EXECUTION_VERSION_KEY] = r.experiment.executionVersion, Z.exposure(e.user, r, i, n);
      if (r instanceof on)
        return Z.remoteConfig(e.user, r, b(b({}, i), r.properties), n);
      if (r instanceof _e)
        return null;
      throw new Error("Unsupported Evaluation [".concat(typeof r, "]"));
    }, t.ROOT_TYPE = "$targetingRootType", t.ROOT_ID = "$targetingRootId", t.CONFIG_ID_PROPERTY_KEY = "$parameterConfigurationId", t.EXPERIMENT_VERSION_KEY = "$experiment_version", t.EXECUTION_VERSION_KEY = "$execution_version", t;
  }()
), sx = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r) {
      var n = t.call(this) || this;
      return n.evaluationFlowFactory = r, n;
    }
    return e.prototype.supports = function(r) {
      return r.inAppMessage !== void 0;
    }, e.prototype.evaluateInternal = function(r, n) {
      var i, o = this.evaluationFlowFactory.getInAppMessageFlow();
      return (i = o.evaluate(r, n)) !== null && i !== void 0 ? i : _e.of(r, n, w.NOT_IN_IN_APP_MESSAGE_TARGET);
    }, e;
  }(Ta)
), ux = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.key = new Cr("IN_APP_MESSAGE", n.id), this.workspace = e, this.user = r, this.inAppMessage = n, this.timestamp = i;
    }
    return t.of = function(e, r, n, i) {
      return new t(e, r, n, i);
    }, t.prototype.toString = function() {
      return "EvaluatorRequest(type=".concat(this.key.type, ", key=").concat(this.inAppMessage.key, ")");
    }, t;
  }()
), se = O.log, cx = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s, u) {
      this.experimentEvaluator = e, this.remoteConfigEvaluator = r, this.inAppMessageEvaluator = n, this.workspaceFetcher = i, this.eventFactory = o, this.eventProcessor = a, this.errorDedupDeterminer = s, this.clock = u;
    }
    return t.create = function(e, r, n, i) {
      var o = new i2(), a = new n2(n), s = new ox(o, a, i), u = new e2(s), c = new t2(s.remoteConfigParameterTargetRuleDeterminer), l = new sx(s);
      return o.add(u), o.add(c), new t(u, c, l, e, new ax(be.instance), r, new lx(), be.instance);
    }, t.prototype.experiment = function(e, r, n) {
      var i = this;
      if (!e)
        return se.error("experimentKey must not be empty"), et.of(n, w.INVALID_INPUT);
      var o = this.workspaceFetcher.get();
      if (!o)
        return se.warn("SDK not ready."), et.of(n, w.SDK_NOT_READY);
      var a = o.getExperimentOrNull(e);
      if (!a)
        return se.warn("Experiment does not exist."), et.of(n, w.EXPERIMENT_NOT_FOUND);
      var s = rt.of(o, r, a, n), u = this.experimentInternal(s), c = u[0], l = u[1], f = this.eventFactory.create(s, c);
      return f.forEach(function(p) {
        return i.eventProcessor.process(p);
      }), l;
    }, t.prototype.experiments = function(e) {
      var r = this, n = new st(function(o, a) {
        return o.id === a.id;
      }), i = this.workspaceFetcher.get();
      return i && i.getExperiments().forEach(function(o) {
        var a = rt.of(i, e, o, "A"), s = r.experimentInternal(a);
        s[0];
        var u = s[1];
        n.add(o, u);
      }), n;
    }, t.prototype.experimentInternal = function(e) {
      var r, n = this.experimentEvaluator.evaluate(e, tt.create()), i = (r = n.config) !== null && r !== void 0 ? r : new ur(), o = et.of(n.variationKey, n.reason, i, n.experiment);
      return [n, o];
    }, t.prototype.featureFlag = function(e, r) {
      var n = this;
      if (!e)
        return se.error("featureKey must not be empty"), je.off(w.INVALID_INPUT);
      var i = this.workspaceFetcher.get();
      if (!i)
        return se.warn("SDK not ready."), je.off(w.SDK_NOT_READY);
      var o = i.getFeatureFlagOrNull(e);
      if (!o)
        return se.warn("FeatureFlag does not exist."), je.off(w.FEATURE_FLAG_NOT_FOUND);
      var a = rt.of(i, r, o, "A"), s = this.featureFlagInternal(a), u = s[0], c = s[1], l = this.eventFactory.create(a, u);
      return l.forEach(function(f) {
        return n.eventProcessor.process(f);
      }), c;
    }, t.prototype.featureFlags = function(e) {
      var r = this, n = new st(function(o, a) {
        return o.id === a.id;
      }), i = this.workspaceFetcher.get();
      return i && i.getFeatureFlags().forEach(function(o) {
        var a = rt.of(i, e, o, "A"), s = r.featureFlagInternal(a);
        s[0];
        var u = s[1];
        n.add(o, u);
      }), n;
    }, t.prototype.featureFlagInternal = function(e) {
      var r, n = this.experimentEvaluator.evaluate(e, tt.create()), i = (r = n.config) !== null && r !== void 0 ? r : new ur(), o = n.variationKey === "A" ? je.off(n.reason, i, n.experiment) : je.on(n.reason, i, n.experiment);
      return [n, o];
    }, t.prototype.inAppMessage = function(e, r) {
      var n = this, i = this.workspaceFetcher.get();
      if (!i)
        return se.warn("SDK not ready."), _r.of(w.SDK_NOT_READY);
      var o = i.getInAppMessageOrNull(e);
      if (!o)
        return se.warn("In app message does not exist."), _r.of(w.IN_APP_MESSAGE_NOT_FOUND);
      var a = ux.of(i, r, o, this.clock.currentMillis()), s = this.inAppMessageEvaluator.evaluate(a, tt.create()), u = this.eventFactory.create(a, s);
      return u.forEach(function(c) {
        return n.eventProcessor.process(c);
      }), _r.of(s.reason, s.inAppMessage, s.message, s.properties);
    }, t.prototype.tryInAppMessage = function(e, r) {
      var n = at.start(), i;
      try {
        i = this.inAppMessage(e, r);
      } catch (o) {
        se.error("Unexpected error while deciding in app message [".concat(e, "]: ").concat(o)), i = _r.of(w.EXCEPTION);
      }
      return cn.inAppMessage(n, e, i), i;
    }, t.prototype.track = function(e, r, n) {
      var i;
      if (n === void 0 && (n = (/* @__PURE__ */ new Date()).getTime()), !e) {
        se.warn("event must not be null.");
        return;
      }
      if (typeof e != "object") {
        se.warn("Event must be event type.");
        return;
      }
      if (typeof e == "object" && (!e.key || typeof e.key != "string")) {
        se.warn("Event key must be not null. or event key must be string type.");
        return;
      }
      var o = ((i = this.workspaceFetcher.get()) === null || i === void 0 ? void 0 : i.getEventTypeOrNull(e.key)) || new xl(0, e.key);
      this.eventProcessor.process(Z.track(o, e, r, n));
    }, t.prototype.trackException = function(e, r) {
      if (!this.errorDedupDeterminer.isDedupTarget(e)) {
        var n = qR.toEvent(e);
        this.flush(), this.track(n, r), this.flush();
      }
    }, t.prototype.flush = function(e) {
      e === void 0 && (e = !1), this.eventProcessor.flush(e);
    }, t.prototype.remoteConfig = function(e, r, n, i) {
      var o = this, a = this.workspaceFetcher.get();
      if (v.isNullOrUndefined(a))
        return se.warn("SDK not ready."), rr.of(i, w.SDK_NOT_READY);
      var s = a.getRemoteConfigParameterOrNull(e);
      if (v.isNullOrUndefined(s))
        return se.warn("Remote config parameter does not exist."), rr.of(i, w.REMOTE_CONFIG_PARAMETER_NOT_FOUND);
      var u = r2.of(a, r, s, n, i), c = this.remoteConfigEvaluator.evaluate(u, tt.create()), l = this.eventFactory.create(u, c);
      return l.forEach(function(f) {
        return o.eventProcessor.process(f);
      }), rr.of(c.value, c.reason);
    }, t.prototype.close = function() {
      this.eventProcessor.close();
    }, t;
  }()
), lx = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.isDedupTarget = function(e) {
      return this._isSameError(e, this.previous) ? !0 : (this.previous = e, !1);
    }, t.prototype._isSameError = function(e, r) {
      return v.isNullOrUndefined(r) ? !1 : e.name === r.name && e.message === r.message && e.stack === r.stack;
    }, t;
  }()
), fx = (
  /** @class */
  function() {
    function t() {
      this._installed = [], this._installations = {
        onerror: px,
        onunhandledrejection: dx
      };
    }
    return t.prototype.install = function(e, r) {
      this._install("onerror", e, r), this._install("onunhandledrejection", e, r);
    }, t.prototype._install = function(e, r, n) {
      if (!(e in this._installed)) {
        var i = this._installations[e];
        i(r, n), this._installed.push(e);
      }
    }, t;
  }()
), Yi = null;
function px(t, e) {
  Yi = window.onerror, window.onerror = function(r, n, i, o, a) {
    v.isNotNullOrUndefined(a) && t.trackException(a, e.resolve()), Yi && Yi.apply(this, arguments);
  };
}
var Ki;
function dx(t, e) {
  Ki = window.onunhandledrejection, window.onunhandledrejection = function(r) {
    var n;
    try {
      "reason" in r ? n = r.reason : "detail" in r && "reason" in r.detail && (n = r.detail.reason);
    } catch {
    }
    n instanceof Error && t.trackException(n, e.resolve()), Ki && Ki.apply(this, arguments);
  };
}
var vx = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.storage = e, this.storageKey = r, this.maxSize = n;
    }
    return t.prototype.read = function() {
      return M(this, void 0, void 0, function() {
        var e;
        return _(this, function(r) {
          return e = this.storage.getItem(this.storageKey), e ? [2, JSON.parse(e)] : [2, []];
        });
      });
    }, t.prototype.save = function(e) {
      return M(this, void 0, void 0, function() {
        var r;
        return _(this, function(n) {
          return e.length === 0 ? [2, this.clear()] : (r = JSON.stringify(e.slice(-this.maxSize)), this.storage.setItem(this.storageKey, r), [
            2
            /*return*/
          ]);
        });
      });
    }, t.prototype.add = function(e) {
      return M(this, void 0, void 0, function() {
        var r;
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.read()];
            case 1:
              return r = n.sent(), [4, this.save(r.concat(e).slice(-this.maxSize))];
            case 2:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.delete = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n, i = this;
        return _(this, function(o) {
          switch (o.label) {
            case 0:
              return [4, this.read()];
            case 1:
              return r = o.sent(), n = r.filter(function(a) {
                return !i.isDeleteTarget(a, e);
              }), [4, this.save(n)];
            case 2:
              return o.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.isDeleteTarget = function(e, r) {
      return r.some(function(n) {
        return n.insertId === e.insertId;
      });
    }, t.prototype.clear = function() {
      return M(this, void 0, void 0, function() {
        return _(this, function(e) {
          return this.storage.removeItem(this.storageKey), [
            2
            /*return*/
          ];
        });
      });
    }, t;
  }()
), wa = function(t, e) {
  return t === null ? !1 : t.userId === e.userId && t.deviceId === e.deviceId;
}, hx = function(t, e) {
  return wa(t, e) ? b(b({}, e), { properties: b(b({}, t.properties), e.properties) }) : e;
}, Na = (
  /** @class */
  function() {
    function t(e) {
      this.cohorts = e;
    }
    return t.builder = function() {
      return new jc();
    }, t.empty = function() {
      return t.builder().build();
    }, t.from = function(e) {
      return new t(e);
    }, t.fromDto = function(e) {
      for (var r = t.builder(), n = 0, i = e.cohorts; n < i.length; n++) {
        var o = i[n];
        r.put({
          identifier: o.identifier,
          cohorts: o.cohorts.map(function(a) {
            return new Hh(a);
          })
        });
      }
      return r.build();
    }, Object.defineProperty(t.prototype, "rawCohorts", {
      get: function() {
        return this.cohorts.values().flatMap(function(e) {
          return e.cohorts;
        });
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.get = function(e) {
      return this.cohorts.get(e);
    }, t.prototype.filterBy = function(e) {
      var r = sn(e), n = this.asComparable().filter(function(i, o) {
        return r[i.type] === i.value;
      });
      return t.from(n);
    }, t.prototype.asArray = function() {
      return this.cohorts.values();
    }, t.prototype.asComparable = function() {
      return this.cohorts;
    }, t.prototype.toBuilder = function() {
      return new jc(this);
    }, t;
  }()
), jc = (
  /** @class */
  function() {
    function t(e) {
      this.cohorts = new st(fe.isEqual), e && this.putAll(e);
    }
    return t.prototype.put = function(e) {
      return this.cohorts.add(e.identifier, e), this;
    }, t.prototype.putAll = function(e) {
      var r = this;
      return e.asArray().forEach(function(n) {
        return r.put(n);
      }), this;
    }, t.prototype.build = function() {
      return new Na(this.cohorts);
    }, t;
  }()
), h = "model", I = "name", g = "type", y = "vendor", m = "version", Ye = "architecture", Br = "console", $ = "mobile", P = "tablet", Pe = "smarttv", Hc = "wearable", gx = (
  /** @class */
  function() {
    function t() {
    }
    return t.parse = function(e) {
      return {
        browser: t.getBrowser(e),
        cpu: t.getCPU(e),
        device: t.getDevice(e),
        engine: t.getEngine(e),
        os: t.getOS(e)
      };
    }, t.getBrowser = function(e) {
      var r = { name: void 0, version: void 0, major: void 0 };
      return t.mapper.rgx.call(r, e, t.regexes.browser), r.major = t.util.major(r.version), r;
    }, t.getCPU = function(e) {
      var r = { architecture: void 0 };
      return t.mapper.rgx.call(r, e, t.regexes.cpu), r;
    }, t.getDevice = function(e) {
      var r = { model: void 0, type: void 0, vendor: void 0 };
      return t.mapper.rgx.call(r, e, t.regexes.device), r;
    }, t.getEngine = function(e) {
      var r = { name: void 0, version: void 0 };
      return t.mapper.rgx.call(r, e, t.regexes.os), r;
    }, t.getOS = function(e) {
      var r = { name: void 0, version: void 0 };
      return t.mapper.rgx.call(r, e, t.regexes.os), r;
    }, t.util = {
      extend: function(e, r) {
        var n = {};
        for (var i in e)
          r[i] && r[i].length % 2 === 0 ? n[i] = r[i].concat(e[i]) : n[i] = e[i];
        return n;
      },
      has: function(e, r) {
        return typeof e == "string" ? r.toLowerCase().indexOf(e.toLowerCase()) !== -1 : !1;
      },
      lowerize: function(e) {
        return e.toLowerCase();
      },
      major: function(e) {
        return typeof e == "string" ? e.replace(/[^\d\.]/g, "").split(".")[0] : void 0;
      },
      trim: function(e) {
        return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
      }
    }, t.mapper = {
      rgx: function(e, r) {
        for (var n = 0, i, o, a, s, u, c; n < r.length && !u; ) {
          var l = r[n], f = r[n + 1];
          for (i = o = 0; i < l.length && !u; )
            if (u = l[i++].exec(e), u)
              for (a = 0; a < f.length; a++)
                c = u[++o], s = f[a], typeof s == "object" && s.length > 0 ? s.length == 2 ? typeof s[1] == "function" ? this[s[0]] = s[1].call(this, c) : this[s[0]] = s[1] : s.length == 3 ? typeof s[1] == "function" && !(s[1].exec && s[1].test) ? this[s[0]] = c ? s[1].call(this, c, s[2]) : void 0 : this[s[0]] = c ? c.replace(s[1], s[2]) : void 0 : s.length == 4 && (this[s[0]] = c ? s[3].call(this, c.replace(s[1], s[2])) : void 0) : this[s] = c || void 0;
          n += 2;
        }
      },
      str: function(e, r) {
        for (var n in r)
          if (typeof r[n] == "object" && r[n].length > 0) {
            for (var i = 0; i < r[n].length; i++)
              if (t.util.has(r[n][i], e))
                return n === "?" ? void 0 : n;
          } else if (t.util.has(r[n], e))
            return n === "?" ? void 0 : n;
        return e;
      }
    }, t.maps = {
      browser: {
        oldsafari: {
          version: {
            "1.0": "/8",
            "1.2": "/1",
            "1.3": "/3",
            "2.0": "/412",
            "2.0.2": "/416",
            "2.0.3": "/417",
            "2.0.4": "/419",
            "?": "/"
          }
        }
      },
      device: {
        amazon: {
          model: {
            "Fire Phone": ["SD", "KF"]
          }
        },
        sprint: {
          model: {
            "Evo Shift 4G": "7373KT"
          },
          vendor: {
            HTC: "APA",
            Sprint: "Sprint"
          }
        }
      },
      os: {
        windows: {
          version: {
            ME: "4.90",
            "NT 3.11": "NT3.51",
            "NT 4.0": "NT4.0",
            2e3: "NT 5.0",
            XP: ["NT 5.1", "NT 5.2"],
            Vista: "NT 6.0",
            7: "NT 6.1",
            8: "NT 6.2",
            "8.1": "NT 6.3",
            10: ["NT 6.4", "NT 10.0"],
            RT: "ARM"
          }
        }
      }
    }, t.regexes = {
      browser: [
        [
          // Presto based
          /(opera\smini)\/([\w\.-]+)/i,
          /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,
          /(opera).+version\/([\w\.]+)/i,
          /(opera)[\/\s]+([\w\.]+)/i
          // Opera < 9.80
        ],
        [I, m],
        [
          /(opios)[\/\s]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [[I, "Opera Mini"], m],
        [
          /\s(opr)\/([\w\.]+)/i
          // Opera Webkit
        ],
        [[I, "Opera"], m],
        [
          // Mixed
          /(kindle)\/([\w\.]+)/i,
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(bidubrowser|baidubrowser)[\/\s]?([\w\.]+)/i,
          /(?:ms|\()(ie)\s([\w\.]+)/i,
          // Webkit/KHTML based
          /(rekonq)\/([\w\.]*)/i,
          /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i
          // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
        ],
        [I, m],
        [
          /(konqueror)\/([\w\.]+)/i
          // Konqueror
        ],
        [[I, "Konqueror"], m],
        [
          /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i
          // IE11
        ],
        [[I, "IE"], m],
        [
          /(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i
          // Microsoft Edge
        ],
        [[I, "Edge"], m],
        [
          /(yabrowser)\/([\w\.]+)/i
          // Yandex
        ],
        [[I, "Yandex"], m],
        [
          /(Avast)\/([\w\.]+)/i
          // Avast Secure Browser
        ],
        [[I, "Avast Secure Browser"], m],
        [
          /(AVG)\/([\w\.]+)/i
          // AVG Secure Browser
        ],
        [[I, "AVG Secure Browser"], m],
        [
          /(puffin)\/([\w\.]+)/i
          // Puffin
        ],
        [[I, "Puffin"], m],
        [
          /(focus)\/([\w\.]+)/i
          // Firefox Focus
        ],
        [[I, "Firefox Focus"], m],
        [
          /(opt)\/([\w\.]+)/i
          // Opera Touch
        ],
        [[I, "Opera Touch"], m],
        [
          /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i
          // UCBrowser
        ],
        [[I, "UCBrowser"], m],
        [
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[I, /_/g, " "], m],
        [
          /(windowswechat qbcore)\/([\w\.]+)/i
          // WeChat Desktop for Windows Built-in Browser
        ],
        [[I, "WeChat(Win) Desktop"], m],
        [
          /(micromessenger)\/([\w\.]+)/i
          // WeChat
        ],
        [[I, "WeChat"], m],
        [
          /(brave)\/([\w\.]+)/i
          // Brave browser
        ],
        [[I, "Brave"], m],
        [
          /(whale)\/([\w\.]+)/i
          // Whale browser
        ],
        [[I, "Whale"], m],
        [
          /(qqbrowserlite)\/([\w\.]+)/i
          // QQBrowserLite
        ],
        [I, m],
        [
          /(QQ)\/([\d\.]+)/i
          // QQ, aka ShouQ
        ],
        [I, m],
        [
          /m?(qqbrowser)[\/\s]?([\w\.]+)/i
          // QQBrowser
        ],
        [I, m],
        [
          /(baiduboxapp)[\/\s]?([\w\.]+)/i
          // Baidu App
        ],
        [I, m],
        [
          /(2345Explorer)[\/\s]?([\w\.]+)/i
          // 2345 Browser
        ],
        [I, m],
        [
          /(MetaSr)[\/\s]?([\w\.]+)/i
          // SouGouBrowser
        ],
        [I],
        [
          /(LBBROWSER)/i
          // LieBao Browser
        ],
        [I],
        [
          /xiaomi\/miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [m, [I, "MIUI Browser"]],
        [
          /;fbav\/([\w\.]+);/i
          // Facebook App for iOS & Android
        ],
        [m, [I, "Facebook"]],
        [
          /safari\s(line)\/([\w\.]+)/i,
          /android.+(line)\/([\w\.]+)\/iab/i
          // Line App for Android
        ],
        [I, m],
        [
          /headlesschrome(?:\/([\w\.]+)|\s)/i
          // Chrome Headless
        ],
        [m, [I, "Chrome Headless"]],
        [
          /\swv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[I, /(.+)/, "$1 WebView"], m],
        [/((?:oculus|samsung)browser)\/([\w\.]+)/i],
        [[I, /(.+(?:g|us))(.+)/, "$1 $2"], m],
        [
          // Oculus / Samsung Browser
          /((?:android.+)crmo|crios)\/([\w\.]+)/i,
          /android.+(chrome)\/([\w\.]+)\s+(?:mobile\s?safari)/i
        ],
        [[I, "Chrome Mobile"], m],
        [
          /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i
          // Android Browser
        ],
        [m, [I, "Android Browser"]],
        [
          /(sailfishbrowser)\/([\w\.]+)/i
          // Sailfish Browser
        ],
        [[I, "Sailfish Browser"], m],
        [
          /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [I, m],
        [
          /(dolfin)\/([\w\.]+)/i
          // Dolphin
        ],
        [[I, "Dolphin"], m],
        [
          /(qihu|qhbrowser|qihoobrowser|360browser)/i
          // 360
        ],
        [[I, "360 Browser"]],
        [
          /(coast)\/([\w\.]+)/i
          // Opera Coast
        ],
        [[I, "Opera Coast"], m],
        [
          /fxios\/([\w\.-]+)/i
          // Firefox for iOS
        ],
        [m, [I, "Firefox"]],
        [
          /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i
          // Mobile Safari
        ],
        [m, [I, "Mobile Safari"]],
        [
          /version\/([\w\.]+).+?(mobile\s?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [m, I],
        [
          /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i
          // Google Search Appliance on iOS
        ],
        [[I, "GSA"], m],
        [
          /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [I, [m, t.mapper.str, t.maps.browser.oldsafari.version]],
        [/(webkit|khtml)\/([\w\.]+)/i],
        [I, m],
        [
          // Gecko based
          /(navigator|netscape)\/([\w\.-]+)/i
          // Netscape
        ],
        [[I, "Netscape"], m],
        [
          /(swiftfox)/i,
          /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
          /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
          /(links)\s\(([\w\.]+)/i,
          /(gobrowser)\/?([\w\.]*)/i,
          /(ice\s?browser)\/v?([\w\._]+)/i,
          /(mosaic)[\/\s]([\w\.]+)/i
          // Mosaic
        ],
        [I, m]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i
          // AMD64
        ],
        [[Ye, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[Ye, t.util.lowerize]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32
        ],
        [[Ye, "ia32"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows\s(ce|mobile);\sppc;/i
        ],
        [[Ye, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i
          // PowerPC
        ],
        [[Ye, /ower/, "", t.util.lowerize]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[Ye, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[Ye, t.util.lowerize]]
      ],
      device: [
        [
          /\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i
          // iPad/PlayBook
        ],
        [h, y, [g, P]],
        [
          /applecoremedia\/[\w\.]+ \((ipad)/
          // iPad
        ],
        [h, [y, "Apple"], [g, P]],
        [
          /(apple\s{0,1}tv)/i
          // Apple TV
        ],
        [
          [h, "Apple TV"],
          [y, "Apple"],
          [g, Pe]
        ],
        [
          /(archos)\s(gamepad2?)/i,
          /(hp).+(touchpad)/i,
          /(hp).+(tablet)/i,
          /(kindle)\/([\w\.]+)/i,
          /\s(nook)[\w\s]+build\/(\w+)/i,
          /(dell)\s(strea[kpr\s\d]*[\dko])/i
          // Dell Streak
        ],
        [y, h, [g, P]],
        [
          /(kf[A-z]+)\sbuild\/.+silk\//i
          // Kindle Fire HD
        ],
        [h, [y, "Amazon"], [g, P]],
        [
          /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i
          // Fire Phone
        ],
        [
          [h, t.mapper.str, t.maps.device.amazon.model],
          [y, "Amazon"],
          [g, $]
        ],
        [
          /android.+aft([bms])\sbuild/i
          // Fire TV
        ],
        [h, [y, "Amazon"], [g, Pe]],
        [
          /\((ip[honed|\s\w*]+);.+(apple)/i
          // iPod/iPhone
        ],
        [h, y, [g, $]],
        [
          /\((ip[honed|\s\w*]+);/i
          // iPod/iPhone
        ],
        [h, [y, "Apple"], [g, $]],
        [
          /(blackberry)[\s-]?(\w+)/i,
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
          // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp)\s([\w\s]+\w)/i,
          /(asus)-?(\w+)/i
          // Asus
        ],
        [y, h, [g, $]],
        [
          /\(bb10;\s(\w+)/i
          // BlackBerry 10
        ],
        [h, [y, "BlackBerry"], [g, $]],
        [
          // Asus Tablets
          /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i
        ],
        [h, [y, "Asus"], [g, P]],
        [
          /(sony)\s(tablet\s[ps])\sbuild\//i,
          /(sony)?(?:sgp.+)\sbuild\//i
        ],
        [
          [y, "Sony"],
          [h, "Xperia Tablet"],
          [g, P]
        ],
        [/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i],
        [h, [y, "Sony"], [g, $]],
        [
          /\s(ouya)\s/i,
          /(nintendo)\s([wids3u]+)/i
          // Nintendo
        ],
        [y, h, [g, Br]],
        [
          /android.+;\s(shield)\sbuild/i
          // Nvidia
        ],
        [h, [y, "Nvidia"], [g, Br]],
        [
          /(playstation\s[34portablevi]+)/i
          // Playstation
        ],
        [h, [y, "Sony"], [g, Br]],
        [
          /(sprint\s(\w+))/i
          // Sprint Phones
        ],
        [
          [y, t.mapper.str, t.maps.device.sprint.vendor],
          [h, t.mapper.str, t.maps.device.sprint.model],
          [g, $]
        ],
        [
          /(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,
          /(zte)-(\w*)/i,
          /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [y, [h, /_/g, " "], [g, $]],
        [
          /(nexus\s9)/i
          // HTC Nexus 9
        ],
        [h, [y, "HTC"], [g, P]],
        [
          /d\/huawei([\w\s-]+)[;\)]/i,
          /(nexus\s6p|vog-l29|ane-lx1|eml-l29)/i
          // Huawei
        ],
        [h, [y, "Huawei"], [g, $]],
        [
          /android.+(bah2?-a?[lw]\d{2})/i
          // Huawei MediaPad
        ],
        [h, [y, "Huawei"], [g, P]],
        [
          /(microsoft);\s(lumia[\s\w]+)/i
          // Microsoft Lumia
        ],
        [y, h, [g, $]],
        [
          /[\s\(;](xbox(?:\sone)?)[\s\);]/i
          // Microsoft Xbox
        ],
        [h, [y, "Microsoft"], [g, Br]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [
          [h, /\./g, " "],
          [y, "Microsoft"],
          [g, $]
        ],
        [
          // Motorola
          /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
          /mot[\s-]?(\w*)/i,
          /(XT\d{3,4}) build\//i,
          /(nexus\s6)/i
        ],
        [h, [y, "Motorola"], [g, $]],
        [/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],
        [h, [y, "Motorola"], [g, P]],
        [
          /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [
          [y, t.util.trim],
          [h, t.util.trim],
          [g, Pe]
        ],
        [/hbbtv.+maple;(\d+)/i],
        [
          [h, /^/, "SmartTV"],
          [y, "Samsung"],
          [g, Pe]
        ],
        [
          /\(dtv[\);].+(aquos)/i
          // Sharp
        ],
        [h, [y, "Sharp"], [g, Pe]],
        [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i],
        [[y, "Samsung"], h, [g, P]],
        [
          // Samsung
          /smart-tv.+(samsung)/i
        ],
        [y, [g, Pe], h],
        [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i, /sec-((sgh\w+))/i],
        [[y, "Samsung"], h, [g, $]],
        [
          /sie-(\w*)/i
          // Siemens
        ],
        [h, [y, "Siemens"], [g, $]],
        [
          /(maemo|nokia).*(n900|lumia\s\d+)/i,
          /(nokia)[\s_-]?([\w-]*)/i
        ],
        [[y, "Nokia"], h, [g, $]],
        [
          /android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i
          // Acer
        ],
        [h, [y, "Acer"], [g, P]],
        [
          /android.+([vl]k\-?\d{3})\s+build/i
          // LG Tablet
        ],
        [h, [y, "LG"], [g, P]],
        [
          /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i
          // LG Tablet
        ],
        [[y, "LG"], h, [g, P]],
        [
          /(lg) netcast\.tv/i
          // LG SmartTV
        ],
        [y, h, [g, Pe]],
        [
          /(nexus\s[45])/i,
          /lg[e;\s\/-]+(\w*)/i,
          /android.+lg(\-?[\d\w]+)\s+build/i
        ],
        [h, [y, "LG"], [g, $]],
        [
          /(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i
          // Lenovo tablets
        ],
        [y, h, [g, P]],
        [
          /android.+(ideatab[a-z0-9\-\s]+)/i
          // Lenovo
        ],
        [h, [y, "Lenovo"], [g, P]],
        [/(lenovo)[_\s-]?([\w-]+)/i],
        [y, h, [g, $]],
        [
          /linux;.+((jolla));/i
          // Jolla
        ],
        [y, h, [g, $]],
        [
          /((pebble))app\/[\d\.]+\s/i
          // Pebble
        ],
        [y, h, [g, Hc]],
        [
          /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i
          // OPPO
        ],
        [y, h, [g, $]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [
          [h, "Chromecast"],
          [y, "Google"],
          [g, Pe]
        ],
        [
          /android.+;\s(glass)\s\d/i
          // Google Glass
        ],
        [h, [y, "Google"], [g, Hc]],
        [
          /android.+;\s(pixel c)[\s)]/i
          // Google Pixel C
        ],
        [h, [y, "Google"], [g, P]],
        [
          /android.+;\s(pixel( [23])?( xl)?)[\s)]/i
          // Google Pixel
        ],
        [h, [y, "Google"], [g, $]],
        [
          /android.+;\s(\w+)\s+build\/hm\1/i,
          /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,
          /android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,
          // Xiaomi Mi
          /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i
          // Redmi Phones
        ],
        [
          [h, /_/g, " "],
          [y, "Xiaomi"],
          [g, $]
        ],
        [
          /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i
          // Mi Pad tablets
        ],
        [
          [h, /_/g, " "],
          [y, "Xiaomi"],
          [g, P]
        ],
        [
          /android.+;\s(m[1-5]\snote)\sbuild/i
          // Meizu
        ],
        [h, [y, "Meizu"], [g, $]],
        [/(mz)-([\w-]{2,})/i],
        [[y, "Meizu"], h, [g, $]],
        [
          /android.+a000(1)\s+build/i,
          /android.+oneplus\s(a\d{4})[\s)]/i
        ],
        [h, [y, "OnePlus"], [g, $]],
        [
          /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i
          // RCA Tablets
        ],
        [h, [y, "RCA"], [g, P]],
        [
          /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i
          // Dell Venue Tablets
        ],
        [h, [y, "Dell"], [g, P]],
        [
          /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i
          // Verizon Tablet
        ],
        [h, [y, "Verizon"], [g, P]],
        [
          /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i
          // Barnes & Noble Tablet
        ],
        [[y, "Barnes & Noble"], h, [g, P]],
        [
          /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i
          // Barnes & Noble Tablet
        ],
        [h, [y, "NuVision"], [g, P]],
        [
          /android.+;\s(k88)\sbuild/i
          // ZTE K Series Tablet
        ],
        [h, [y, "ZTE"], [g, P]],
        [
          /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i
          // Swiss GEN Mobile
        ],
        [h, [y, "Swiss"], [g, $]],
        [
          /android.+[;\/]\s*(zur\d{3})\s+build/i
          // Swiss ZUR Tablet
        ],
        [h, [y, "Swiss"], [g, P]],
        [
          /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i
          // Zeki Tablets
        ],
        [h, [y, "Zeki"], [g, P]],
        [
          /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
          /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i
          // Dragon Touch Tablet
        ],
        [[y, "Dragon Touch"], h, [g, P]],
        [
          /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i
          // Insignia Tablets
        ],
        [h, [y, "Insignia"], [g, P]],
        [
          /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i
          // NextBook Tablets
        ],
        [h, [y, "NextBook"], [g, P]],
        [/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],
        [[y, "Voice"], h, [g, $]],
        [
          // Voice Xtreme Phones
          /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i
          // LvTel Phones
        ],
        [[y, "LvTel"], h, [g, $]],
        [/android.+;\s(PH-1)\s/i],
        [h, [y, "Essential"], [g, $]],
        [
          // Essential PH-1
          /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i
          // Envizen Tablets
        ],
        [h, [y, "Envizen"], [g, P]],
        [
          /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i
          // Le Pan Tablets
        ],
        [y, h, [g, P]],
        [
          /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i
          // MachSpeed Tablets
        ],
        [h, [y, "MachSpeed"], [g, P]],
        [
          /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i
          // Trinity Tablets
        ],
        [y, h, [g, P]],
        [
          /android.+[;\/]\s*TU_(1491)\s+build/i
          // Rotor Tablets
        ],
        [h, [y, "Rotor"], [g, P]],
        [
          /android.+(KS(.+))\s+build/i
          // Amazon Kindle Tablets
        ],
        [h, [y, "Amazon"], [g, P]],
        [
          /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i
          // Gigaset Tablets
        ],
        [y, h, [g, P]],
        [
          /\s(tablet|tab)[;\/]/i,
          /\s(mobile)(?:[;\/]|\ssafari)/i
          // Unidentifiable Mobile
        ],
        [[g, t.util.lowerize], y, h],
        [
          /[\s\/\(](smart-?tv)[;\)]/i
          // SmartTV
        ],
        [[g, Pe]],
        [
          /(android[\w\.\s\-]{0,9});.+build/i
          // Generic Android Device
        ],
        [h, [y, "Generic"]]
      ],
      engine: [
        [
          /windows.+\sedge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [m, [I, "EdgeHTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [m, [I, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,
          /(icab)[\/\s]([23]\.[\d\.]+)/i
          // iCab
        ],
        [I, m],
        [
          /rv\:([\w\.]{1,9}).+(gecko)/i
          // Gecko
        ],
        [m, I]
      ],
      os: [
        [
          // Windows based
          /microsoft\s(windows)\s(vista|xp)/i
          // Windows (iTunes)
        ],
        [I, m],
        [
          /(windows)\snt\s6\.2;\s(arm)/i,
          /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,
          /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
        ],
        [
          [I, t.mapper.str, t.maps.os.windows],
          [m, t.mapper.str, t.maps.os.windows.version]
        ],
        [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],
        [
          [I, "Windows"],
          [m, t.mapper.str, t.maps.os.windows.version]
        ],
        [
          // Mobile/Embedded OS
          /\((bb)(10);/i
          // BlackBerry 10
        ],
        [[I, "BlackBerry"], m],
        [
          /(blackberry)\w*\/?([\w\.]*)/i,
          /(tizen|kaios)[\/\s]([\w\.]+)/i,
          /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i
          // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
        ],
        [I, m],
        [
          /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i
          // Symbian
        ],
        [[I, "Symbian"], m],
        [
          /\((series40);/i
          // Series 40
        ],
        [I],
        [
          /mozilla.+\(mobile;.+gecko.+firefox/i
          // Firefox OS
        ],
        [[I, "Firefox OS"], m],
        [
          // Console
          /(nintendo|playstation)\s([wids34portablevu]+)/i,
          // GNU/Linux based
          /(mint)[\/\s\(]?(\w*)/i,
          /(mageia|vectorlinux)[;\s]/i,
          /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
          // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
          // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
          /(hurd|linux)\s?([\w\.]*)/i,
          /(gnu)\s?([\w\.]*)/i
          // GNU
        ],
        [[I, "Linux"], m],
        [
          /(cros)\s[\w]+\s([\w\.]+\w)/i
          // Chromium OS
        ],
        [[I, "Chromium OS"], m],
        [
          // Solaris
          /(sunos)\s?([\w\.\d]*)/i
          // Solaris
        ],
        [[I, "Solaris"], m],
        [
          // BSD based
          /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
        ],
        [[I, "Linux"], m],
        [
          /(iphone)(?:.*os\s*([\w]*)\slike\smac|;\sopera)/i
          // iOS
        ],
        [
          [I, "iOS"],
          [m, /_/g, "."]
        ],
        [
          /(ipad)(?:.*os\s*([\w]*)\slike\smac|;\sopera)/i
          // iOS
        ],
        [
          [I, "iOS"],
          [m, /_/g, "."]
        ],
        [
          /(haiku)\s(\w+)/i
          // Haiku
        ],
        [I, m],
        [
          /cfnetwork\/.+darwin/i,
          /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i
          // iOS
        ],
        [
          [m, /_/g, "."],
          [I, "iOS"]
        ],
        [
          /(mac\sos\sx)\s?([\w\s\.]*)/i,
          /(macintosh|mac(?=_powerpc)\s)/i
          // Mac OS
        ],
        [
          [I, "Mac"],
          [m, /_/g, "."]
        ],
        [
          // Other
          /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,
          /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,
          /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
          // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
          /(unix)\s?([\w\.]*)/i
          // UNIX
        ],
        [I, m]
      ]
    }, t;
  }()
), yx = (
  /** @class */
  function() {
    function t() {
    }
    return t.generate = function(e) {
      var r, n, i, o, a, s, u;
      typeof e > "u" ? u = {
        navigator: { userAgent: "", vendor: "", languages: [] },
        screen: {
          width: "",
          height: ""
        }
      } : u = e;
      var c = gx.parse(u.navigator.userAgent), l = c.browser, f = c.os, p = c.device, d = u.screen, C = ((r = u.navigator.languages) === null || r === void 0 ? void 0 : r[0]) || "", R = C.split("-")[0], S = ((n = p.type) !== null && n !== void 0 ? n : "pc").replace(/\b(mobile|smarttv)\b/g, function(D, Oe) {
        return Oe === "mobile" ? "phone" : Oe === "smarttv" ? "tv" : D;
      }), T = f.name || "", N = "", U = "";
      try {
        T = (o = (i = T.match(/\b(Mac|Windows|Linux|Android|iOS)\b/)) === null || i === void 0 ? void 0 : i[0]) !== null && o !== void 0 ? o : T, N = (s = (a = d.orientation.type.match(/\b(landscape|portrait)\b/)) === null || a === void 0 ? void 0 : a[0]) !== null && s !== void 0 ? s : "", U = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
      } catch {
      }
      return {
        platform: "Web",
        browserName: l.name || "",
        browserMajorVersion: l.major || "",
        browserVersion: l.version || "",
        osName: T,
        osVersion: f.version || "",
        deviceModel: p.model || "",
        deviceType: S,
        deviceVendor: p.vendor || "",
        deviceBrand: p.vendor || "",
        locale: C,
        language: R,
        orientation: N,
        userAgent: u.navigator.userAgent || "",
        screenWidth: d.width || "",
        screenHeight: d.height || "",
        timeZone: U
      };
    }, t;
  }()
), Ix = (
  /** @class */
  function() {
    function t(e, r) {
      this.previous = e, this.current = r;
    }
    return t.prototype.map = function(e) {
      return new t(e(this.previous), e(this.current));
    }, t;
  }()
), mx = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s, u) {
      this.hackleDeviceId = e, this.storage = r, this.cohortFetcher = n, this.campaignParser = i, this.pageManager = o, this.clock = a, this.userListeners = [], this.defaultUser = { id: this.hackleDeviceId, deviceId: this.hackleDeviceId }, this.context = this.initContext(s, u), this.storage.saveUser(this.context.user);
    }
    return t.prototype.initContext = function(e, r) {
      var n, i = (n = r ?? e) !== null && n !== void 0 ? n : this.defaultUser;
      return Ex.of(Xc(i, this.hackleDeviceId), Na.empty());
    }, t.prototype.addListener = function(e) {
      this.userListeners.push(e);
    }, Object.defineProperty(t.prototype, "currentUser", {
      get: function() {
        return this.context.user;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.resolve = function(e) {
      var r = this.resolveContext(e);
      return this.hackleUser(r);
    }, t.prototype.resolveContext = function(e) {
      return e === void 0 ? this.context : typeof e == "string" ? this.updateUser({ id: e }).current : this.updateUser(e).current;
    }, t.prototype.toHackleUser = function(e) {
      var r = this.context.with(e);
      return this.hackleUser(r);
    }, t.prototype.hackleUser = function(e) {
      var r = new zo().addIdentifiers(e.user.identifiers || {}).add(Ee.ID, e.user.id || this.hackleDeviceId).add(Ee.DEVICE, e.user.deviceId || this.hackleDeviceId).add(Ee.HACKLE_DEVICE, this.hackleDeviceId);
      v.isNotNullOrUndefined(e.user.userId) && r.add(Ee.USER, e.user.userId);
      var n = r.build(), i = this.campaignParser.parse(), o = b(b({}, i), e.user.properties);
      return {
        identifiers: n,
        properties: o,
        hackleProperties: this.hackleProperties(),
        cohorts: e.cohorts.rawCohorts
      };
    }, t.prototype.hackleProperties = function() {
      var e;
      return typeof window < "u" && (e = b(b({}, yx.generate(window)), this.pageManager.currentPage.toProperties())), e || {};
    }, t.prototype.setUser = function(e) {
      return this.updateUser(e).map(function(r) {
        return r.user;
      });
    }, t.prototype.setUserId = function(e) {
      var r = b(b({}, this.context.user), { userId: e });
      return this.setUser(r);
    }, t.prototype.setDeviceId = function(e) {
      var r = b(b({}, this.context.user), { deviceId: e });
      return this.setUser(r);
    }, t.prototype.updateUserProperties = function(e) {
      return this.operateProperties(e).map(function(r) {
        return r.user;
      });
    }, t.prototype.resetUser = function() {
      var e = this;
      return this.updateContext(function() {
        return e.defaultUser;
      }).map(function(r) {
        return r.user;
      });
    }, t.prototype.changeUser = function(e, r, n) {
      this.userListeners.forEach(function(i) {
        i.onUserUpdated(e, r, n);
      });
    }, t.prototype.saveUser = function(e) {
      this.storage.saveUser(e);
    }, t.prototype.updateContext = function(e) {
      var r = this.context, n = r.user, i = e(n), o = this.context.with(i);
      return this.context = o, wa(n, i) || (this.changeUser(n, i, this.clock.currentMillis()), this.saveUser(i)), new Ix(r, o);
    }, t.prototype.updateUser = function(e) {
      var r = this;
      return this.updateContext(function(n) {
        return hx(n, Xc(e, r.hackleDeviceId));
      });
    }, t.prototype.operateProperties = function(e) {
      return this.updateContext(function(r) {
        var n, i = (n = r.properties) !== null && n !== void 0 ? n : {}, o = e.operate(new Map(Object.entries(i)));
        return b(b({}, r), { properties: v.fromMap(o) });
      });
    }, t.prototype.sync = function() {
      return M(this, void 0, void 0, function() {
        var e, r;
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, this.cohortFetcher.fetch(this.currentUser)];
            case 1:
              return e = n.sent(), this.context = this.context.update(e), [3, 3];
            case 2:
              return r = n.sent(), O.log.error("Failed to sync cohorts: ".concat(r)), [3, 3];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.syncIfNeeded = function(e) {
      return M(this, void 0, void 0, function() {
        return _(this, function(r) {
          return this.hasNewIdentifiers(e.previous, e.current) ? [2, this.sync()] : [
            2
            /*return*/
          ];
        });
      });
    }, t.prototype.hasNewIdentifiers = function(e, r) {
      var n = sn(e), i = sn(r);
      return Object.entries(i).some(function(o) {
        var a = o[0], s = o[1];
        return n[a] !== s;
      });
    }, t.prototype.close = function() {
      return M(this, void 0, void 0, function() {
        return _(this, function(e) {
          return [
            2
            /*return*/
          ];
        });
      });
    }, t;
  }()
), Ax = (
  /** @class */
  function() {
    function t(e) {
      this.storage = e;
    }
    return t.prototype.getUser = function() {
      var e = this.deviceId || void 0, r = this.userId || void 0;
      return e !== void 0 || r !== void 0 ? { deviceId: e, userId: r } : null;
    }, t.prototype.saveUser = function(e) {
      this.setDeviceId(e.deviceId || null), this.setUserId(e.userId || null);
    }, Object.defineProperty(t.prototype, "deviceId", {
      get: function() {
        return this.storage.getItem(os);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "userId", {
      get: function() {
        return this.storage.getItem(is);
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.setDeviceId = function(e) {
      this.setId(os, e);
    }, t.prototype.setUserId = function(e) {
      this.setId(is, e);
    }, t.prototype.setId = function(e, r) {
      v.isNotNullOrUndefined(r) ? this.storage.setItem(e, r) : this.storage.removeItem(e);
    }, t;
  }()
), Ex = (
  /** @class */
  function() {
    function t(e, r) {
      this.user = e, this.cohorts = r;
    }
    return t.of = function(e, r) {
      return new t(e, r.filterBy(e));
    }, t.prototype.with = function(e) {
      return t.of(e, this.cohorts.filterBy(e));
    }, t.prototype.update = function(e) {
      var r = e.filterBy(this.user), n = this.cohorts.toBuilder().putAll(r).build();
      return t.of(this.user, n);
    }, t;
  }()
), Xc = function(t, e) {
  return b(b({}, t), { id: t.id || e, deviceId: t.deviceId || e });
}, Cx = function(t) {
  return "".concat(t, ".").concat(Pt().slice(0, 8));
}, bx = (
  /** @class */
  function() {
    function t(e, r) {
      this.sessionTimeoutMillis = e, this.storage = r, this.sessionListeners = [], this._currentSessionId = null, this._lastEventTime = null, this.loadSession(), this.loadLastEventTime();
    }
    return Object.defineProperty(t.prototype, "currentSessionId", {
      get: function() {
        return this._currentSessionId;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "sessionId", {
      get: function() {
        var e;
        return (e = this._currentSessionId) !== null && e !== void 0 ? e : t.EMPTY_SESSION_ID;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastEventTime", {
      get: function() {
        return this._lastEventTime;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.addListener = function(e) {
      this.sessionListeners.push(e);
    }, t.prototype.startNewSession = function(e, r, n) {
      return e && this.endSession(e), this.newSession(r, n);
    }, t.prototype.startNewSessionIfNeeded = function(e, r) {
      var n = this._lastEventTime;
      return n === null ? this.startNewSession(e, e, r) : this._currentSessionId !== null && r - n < this.sessionTimeoutMillis ? (this.updateLastEventTime(r), this._currentSessionId) : this.startNewSession(e, e, r);
    }, t.prototype.updateLastEventTime = function(e) {
      this._lastEventTime = e, this.storage.setItem(ns, "".concat(e));
    }, t.prototype.endSession = function(e) {
      var r = this._currentSessionId, n = this._lastEventTime;
      r !== null && n !== null && this.sessionListeners.forEach(function(i) {
        return i.onSessionEnded(r, e, n);
      });
    }, t.prototype.newSession = function(e, r) {
      var n = Cx(r);
      return this.saveSession(n), this.updateLastEventTime(r), this.sessionListeners.forEach(function(i) {
        i.onSessionStarted(n, e, r);
      }), n;
    }, t.prototype.saveSession = function(e) {
      this._currentSessionId = e, this.storage.setItem(rs, e);
    }, t.prototype.loadSession = function() {
      this._currentSessionId = this.storage.getItem(rs);
    }, t.prototype.loadLastEventTime = function() {
      var e = this.storage.getItem(ns);
      if (e !== null) {
        var r = Number.parseFloat(e);
        r > 0 && (this._lastEventTime = r);
      }
    }, t.prototype.onUserUpdated = function(e, r, n) {
      this.endSession(e), this.newSession(r, n);
    }, t.prototype.onLifecycleChanged = function(e, r) {
      switch (e) {
        case "hidden":
        case "pagehide":
          return this.updateLastEventTime(r);
        case "blur":
        case "focus":
        case "locationChange":
        case "visible":
        case "pageshow":
          return;
      }
    }, t.EMPTY_SESSION_ID = "0.ffffffff", t;
  }()
), Tx = (
  /** @class */
  function() {
    function t() {
      this.storage = window.localStorage;
    }
    return t.prototype.getItem = function(e) {
      var r, n;
      return (n = (r = this.storage) === null || r === void 0 ? void 0 : r.getItem(e)) !== null && n !== void 0 ? n : null;
    }, t.prototype.removeItem = function(e) {
      var r;
      (r = this.storage) === null || r === void 0 || r.removeItem(e);
    }, t.prototype.setItem = function(e, r) {
      var n;
      (n = this.storage) === null || n === void 0 || n.setItem(e, r);
    }, t.prototype.clear = function() {
      var e;
      (e = this.storage) === null || e === void 0 || e.clear();
    }, t;
  }()
), At = (
  /** @class */
  function() {
    function t(e, r) {
      this.delegate = e, this.transform = r;
    }
    return t.postfix = function(e, r) {
      return new t(e, function(n) {
        return "".concat(n).concat(r);
      });
    }, t.prefix = function(e, r) {
      return new t(e, function(n) {
        return "".concat(r).concat(n);
      });
    }, t.prototype.getItem = function(e) {
      return this.delegate.getItem(this.transform(e));
    }, t.prototype.removeItem = function(e) {
      this.delegate.removeItem(this.transform(e));
    }, t.prototype.setItem = function(e, r) {
      this.delegate.setItem(this.transform(e), r);
    }, t;
  }()
), Wc = (
  /** @class */
  function() {
    function t(e, r, n) {
      n === void 0 && (n = 4096);
      var i = this;
      this.delegate = e, this.listKey = r, this.encodedListCharLen = 6, this.resolveMaxLength = function(o) {
        var a = o - i.encodedListCharLen;
        return a < 0 ? 0 : a;
      }, this.maxLength = this.resolveMaxLength(n);
    }
    return t.prototype.isEqualItem = function(e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }, t.prototype.getRemainListSize = function() {
      try {
        return this.maxLength - JSON.stringify(this.getList()).length;
      } catch {
        return 0;
      }
    }, t.prototype.isAddableItem = function(e) {
      try {
        return this.getRemainListSize() > JSON.stringify(e).length;
      } catch {
        return !1;
      }
    }, t.prototype.getVictimIndex = function(e) {
      var r = this.getRemainListSize();
      try {
        var n = JSON.stringify(e), i = this.getList(), o = 0;
        return i.findIndex(function(a) {
          return o += JSON.stringify(a).length, o + r >= n.length;
        });
      } catch {
        return -1;
      }
    }, t.prototype.getList = function() {
      try {
        var e = this.delegate.getItem(this.listKey);
        if (!e)
          return [];
        var r = JSON.parse(e);
        return Array.isArray(r) ? r : [];
      } catch {
        return [];
      }
    }, t.prototype.entries = function() {
      return this.getList().flatMap(Object.entries);
    }, t.prototype.setItem = function(e, r) {
      var n;
      try {
        this.removeItem(e);
        var i = this.getList(), o = (n = {}, n[e] = r, n);
        if (!this.isAddableItem(o)) {
          var a = this.getVictimIndex(o);
          if (a < 0)
            return;
          i = i.slice(a + 1);
        }
        var s = JSON.stringify(i.concat(o));
        this.delegate.setItem(this.listKey, s);
      } catch {
      }
    }, t.prototype.getItem = function(e) {
      var r = this, n = this.getList().find(function(i) {
        return r.isEqualItem(i, e);
      });
      if (!(!n || !n[e]))
        return n[e];
    }, t.prototype.removeItem = function(e) {
      var r = this, n = this.getList();
      try {
        var i = n.filter(function(a) {
          return !r.isEqualItem(a, e);
        }), o = JSON.stringify(i);
        this.delegate.setItem(this.listKey, o);
      } catch {
      }
    }, t.prototype.clear = function() {
      this.delegate.removeItem(this.listKey);
    }, t;
  }()
), wx = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.core = e, this.userManager = r, this.abOverrideStorage = n, this.ffOverrideStorage = i;
    }
    return t.prototype.currentUser = function() {
      return this.userManager.resolve();
    }, t.prototype.getAbTestDecisions = function() {
      return this.core.experiments(this.currentUser()).entries();
    }, t.prototype.getAbTestOverrides = function() {
      return this.abOverrideStorage.getAll();
    }, t.prototype.setAbTestOverride = function(e, r) {
      this.abOverrideStorage.set(e, r), this.increment("AB_TEST", "set");
    }, t.prototype.resetAbTestOverride = function(e) {
      this.abOverrideStorage.remove(e), this.increment("AB_TEST", "reset");
    }, t.prototype.resetAllAbTestOverride = function() {
      this.abOverrideStorage.clear(), this.increment("AB_TEST", "reset.all");
    }, t.prototype.getFeatureFlagDecisions = function() {
      return this.core.featureFlags(this.currentUser()).entries();
    }, t.prototype.getFeatureFlagOverrides = function() {
      return this.ffOverrideStorage.getAll();
    }, t.prototype.setFeatureFlagOverride = function(e, r) {
      this.ffOverrideStorage.set(e, r), this.increment("FEATURE_FLAG", "set");
    }, t.prototype.resetFeatureFlagOverride = function(e) {
      this.ffOverrideStorage.remove(e), this.increment("FEATURE_FLAG", "reset");
    }, t.prototype.resetAllFeatureFlagOverride = function() {
      this.ffOverrideStorage.clear(), this.increment("FEATURE_FLAG", "reset.all");
    }, t.prototype.increment = function(e, r) {
      Ue.counter("experiment.manual.override", {
        "experiment.type": e,
        operation: r
      }).increment();
    }, t;
  }()
), Et = (
  /** @class */
  function() {
    function t() {
    }
    return t.serverFetch = function(e, r) {
      return "".concat(e, "/api/v2/workspaces/").concat(r, "/config");
    }, t.clientFetch = function(e, r) {
      return "".concat(e, "/api/v2/workspaces/").concat(r, "/config");
    }, t.userCohorts = function(e) {
      return "".concat(e, "/api/v1/cohorts");
    }, t.serverDispatch = function(e) {
      return "".concat(e, "/api/v2/events");
    }, t.clientDispatch = function(e) {
      return "".concat(e, "/api/v2/w/events");
    }, t.beaconDispatch = function(e, r) {
      return "".concat(e, "/api/v2/w/").concat(r, "/events");
    }, t.inAppMessageRenderer = function(e, r) {
      return "".concat(e, "/sdk/iam-renderer/").concat(r, "/iam-renderer.js");
    }, t.monitoring = function(e) {
      return "".concat(e, "/metrics");
    }, t;
  }()
), Nx = (
  /** @class */
  function() {
    function t(e) {
      this.storage = e;
    }
    return t.prototype.exist = function(e, r) {
      var n = this.key(e), i = this.storage.getItem(n);
      if (v.isNullOrUndefined(i))
        return !1;
      var o = Number.parseInt(i, 10);
      return Number.isNaN(o) ? (this.storage.removeItem(n), !1) : r <= o ? !0 : (this.storage.removeItem(n), !1);
    }, t.prototype.put = function(e, r) {
      this.storage.setItem(this.key(e), "".concat(r));
    }, t.prototype.key = function(e) {
      return "".concat(e.key);
    }, t;
  }()
), Ox = (
  /** @class */
  function() {
    function t(e) {
      this.handlers = e;
    }
    return t.prototype.get = function(e) {
      return this.handlers.find(function(r) {
        return r.supports(e);
      });
    }, t;
  }()
), Mx = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.handle = function(e, r) {
      e.close();
    }, t.prototype.supports = function(e) {
      return e.type === "CLOSE";
    }, t;
  }()
), _x = (
  /** @class */
  function() {
    function t(e) {
      this.urlHandler = e;
    }
    return t.prototype.handle = function(e, r) {
      try {
        if (!r.value)
          return;
        this.urlHandler.open(new URL(r.value));
      } catch {
        O.log.error("Invalid url: ".concat(r.value));
      }
    }, t.prototype.supports = function(e) {
      return e.type === "WEB_LINK";
    }, t;
  }()
), Sx = (
  /** @class */
  function() {
    function t(e) {
      this.urlHandler = e;
    }
    return t.prototype.handle = function(e, r) {
      e.close();
      try {
        if (!r.value)
          return;
        this.urlHandler.open(new URL(r.value));
      } catch {
        O.log.error("Invalid url: ".concat(r.value));
      }
    }, t.prototype.supports = function(e) {
      return e.type === "LINK_AND_CLOSE";
    }, t;
  }()
), Rx = (
  /** @class */
  function() {
    function t(e, r) {
      this.storage = e, this.clock = r;
    }
    return t.prototype.handle = function(e, r) {
      var n = this.clock.currentMillis() + Rl;
      this.storage.put(e.context.inAppMessage, n), e.close();
    }, t.prototype.supports = function(e) {
      return e.type === "HIDDEN";
    }, t;
  }()
), xx = (
  /** @class */
  function() {
    function t(e) {
      this.urlHandler = e;
    }
    return t.prototype.handle = function(e, r) {
      try {
        if (!r.value)
          return;
        this.urlHandler.open(new URL(r.value));
      } catch {
        O.log.error("Invalid url: ".concat(r.value));
      }
    }, t.prototype.supports = function(e) {
      return e.type === "LINK_NEW_WINDOW";
    }, t;
  }()
), Px = (
  /** @class */
  function() {
    function t(e) {
      this.urlHandler = e;
    }
    return t.prototype.handle = function(e, r) {
      e.close();
      try {
        if (!r.value)
          return;
        this.urlHandler.open(new URL(r.value));
      } catch {
        O.log.error("Invalid url: ".concat(r.value));
      }
    }, t.prototype.supports = function(e) {
      return e.type === "LINK_NEW_WINDOW_AND_CLOSE";
    }, t;
  }()
), Ux = (
  /** @class */
  function() {
    function t(e) {
      this.urlHandler = e;
    }
    return t.prototype.handle = function(e, r) {
      try {
        if (!r.value)
          return;
        this.urlHandler.open(new URL(r.value));
      } catch {
        O.log.error("Invalid url: ".concat(r.value));
      }
    }, t.prototype.supports = function(e) {
      return e.type === "LINK_NEW_TAB";
    }, t;
  }()
), Dx = (
  /** @class */
  function() {
    function t(e) {
      this.urlHandler = e;
    }
    return t.prototype.handle = function(e, r) {
      e.close();
      try {
        if (!r.value)
          return;
        this.urlHandler.open(new URL(r.value));
      } catch {
        O.log.error("Invalid url: ".concat(r.value));
      }
    }, t.prototype.supports = function(e) {
      return e.type === "LINK_NEW_TAB_AND_CLOSE";
    }, t;
  }()
), Lx = (
  /** @class */
  function() {
    function t(e) {
      this.core = e;
    }
    return t.prototype.track = function(e, r, n) {
      var i = this.createTrackEvent(r, e);
      this.core.track(i, e.user, n);
    }, t.prototype.createTrackEvent = function(e, r) {
      var n, i, o, a;
      switch (e.type) {
        case "IMPRESSION":
          return {
            key: "$in_app_impression",
            properties: b(b({}, r.properties), { in_app_message_id: r.inAppMessage.id, in_app_message_key: r.inAppMessage.key, in_app_message_display_type: r.message.layout.displayType, title_text: (i = (n = r.message.text) === null || n === void 0 ? void 0 : n.title) === null || i === void 0 ? void 0 : i.text, body_text: (a = (o = r.message.text) === null || o === void 0 ? void 0 : o.body) === null || a === void 0 ? void 0 : a.text, button_text: r.message.buttons.map(function(u) {
              return u.text;
            }), image_url: r.message.images.map(function(u) {
              return u.imagePath;
            }) })
          };
        case "CLOSE":
          return {
            key: "$in_app_close",
            properties: b(b({}, r.properties), { in_app_message_id: r.inAppMessage.id, in_app_message_key: r.inAppMessage.key, in_app_message_display_type: r.message.layout.displayType })
          };
        case "ACTION":
          var s = e;
          return {
            key: "$in_app_action",
            properties: b(b({}, r.properties), { in_app_message_id: r.inAppMessage.id, in_app_message_key: r.inAppMessage.key, in_app_message_display_type: r.message.layout.displayType, action_type: s.action.type, action_area: s.area, action_value: s.action.value, button_text: s.text })
          };
      }
    }, t;
  }()
), $x = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      i === void 0 && (i = null), this.messageViewFactory = e, this.eventHandler = r, this.interactionHandlerFactory = n, this.inAppMessageListener = i, this.currentMessageView = null, this.opening = !1;
    }
    return t.prototype.setListener = function(e) {
      this.inAppMessageListener = e;
    }, t.prototype.present = function(e) {
      return M(this, void 0, void 0, function() {
        var r;
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              if (this.currentMessageView)
                return [
                  2
                  /*return*/
                ];
              if (this.opening)
                return [
                  2
                  /*return*/
                ];
              this.opening = !0, r = null, n.label = 1;
            case 1:
              return n.trys.push([1, 3, 4, 5]), r = this.messageViewFactory.create(e, this), r === null ? [
                2
                /*return*/
              ] : (this.currentMessageView = r, [4, r.open()]);
            case 2:
              return n.sent(), [3, 5];
            case 3:
              return n.sent(), r == null || r.close(), [3, 5];
            case 4:
              return this.opening = !1, [
                7
                /*endfinally*/
              ];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
), kx = (
  /** @class */
  function() {
    function t(e, r, n) {
      var i = this;
      this.userEventEmitter = e, this.determiner = r, this.presenter = n, this.onEvent = function(o) {
        var a = i.determiner.determineOrNull(o);
        a && i.presenter.present(a);
      }, this.initialize();
    }
    return t.prototype.initialize = function() {
      this.userEventEmitter.on("event", this.onEvent);
    }, t.prototype.destroy = function() {
      this.userEventEmitter.off("event", this.onEvent);
    }, t;
  }()
), Fx = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.inAppMessage = e, this.message = r, this.user = n, this.properties = i;
    }
    return t;
  }()
), Gx = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.workspaceFetcher = e, this.eventMatcher = r, this.core = n;
    }
    return t.prototype.determineOrNull = function(e) {
      var r = this.workspaceFetcher.get();
      if (r)
        for (var n = 0, i = r.getInAppMessages(); n < i.length; n++) {
          var o = i[n];
          if (this.eventMatcher.matches(r, o, e)) {
            var a = this.context(o, e);
            if (!a)
              continue;
            return a;
          }
        }
    }, t.prototype.context = function(e, r) {
      var n = this.core.tryInAppMessage(e.key, r.user);
      if (n.inAppMessage && n.message) {
        var i = b(b({}, n.properties), { decision_reason: n.reason });
        return new Fx(n.inAppMessage, n.message, r.user, de.sanitize(i));
      }
    }, t;
  }()
), Vx = function(t) {
  return typeof t.detail.id == "string" && ["OPEN", "CLOSE"].includes(t.detail.type);
}, Bx = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a) {
      var s = this;
      this.scriptLoader = e, this.context = r, this.ui = n, this.renderTypeResolver = i, this.status = o, this.lifecycleRegistry = a, this.container = null, this.renderer = null, this.resolveLifecycleEnd = function(u) {
        if (!(!(u instanceof CustomEvent) || !Vx(u))) {
          var c = u.detail, l = c.id, f = c.type, p = s.lifecycleRegistry.getAndRemove(f, l);
          p == null || p();
        }
      }, this.handleInAppMessageInteraction = function(u) {
        if (u instanceof CustomEvent && u.type === t.HACKLE_IAM_INTERACTION_EVENT_TYPE) {
          var c = u.detail;
          s.handleInteraction(c);
        }
      };
    }
    return t.prototype.open = function() {
      var e, r;
      return M(this, void 0, void 0, function() {
        var n, i, o, a = this;
        return _(this, function(s) {
          switch (s.label) {
            case 0:
              if (!this.status.canOpen())
                return O.log.debug("InAppMessage is already opened. (key=".concat(this.context.inAppMessage.key, ")")), [
                  2
                  /*return*/
                ];
              s.label = 1;
            case 1:
              return s.trys.push([1, 4, , 5]), (r = (e = this.ui.inAppMessageListener) === null || e === void 0 ? void 0 : e.beforeInAppMessageOpen) === null || r === void 0 || r.call(e, this.context.inAppMessage), this.status.current = "OPENING", window.addEventListener(t.HACKLE_IAM_INTERACTION_EVENT_TYPE, this.handleInAppMessageInteraction), window.addEventListener(t.HACKLE_IAM_LIFECYCLE_END_EVENT_TYPE, this.resolveLifecycleEnd), [
                4,
                this.scriptLoader.load()
                // add view container
              ];
            case 2:
              return s.sent(), n = this.addContainer(), n.style.display = "none", n.classList.add("".concat(t.CONTAINER_CLASS_NAME, "--loading")), i = window.HackleInAppMessageRenderer, this.renderer = new i.HackleInAppMessageRenderer(n), o = this.renderTypeResolver.resolve(this.context), [4, this.renderer.render({
                messageId: this.context.inAppMessage.id,
                message: this.context.message.toJson(),
                renderType: o
              })];
            case 3:
              return s.sent(), n.classList.remove("".concat(t.CONTAINER_CLASS_NAME, "--loading")), n.style.display = "block", this.handleInAppMessageLifecycle("OPEN", function() {
                var u, c;
                a.handleEvent({ type: "IMPRESSION" }), a.status.current = "OPENED", (c = (u = a.ui.inAppMessageListener) === null || u === void 0 ? void 0 : u.afterInAppMessageOpen) === null || c === void 0 || c.call(u, a.context.inAppMessage);
              }, function() {
                O.log.warn("Failed to open inAppMessage with [Timeout expired.]"), a.destroy();
              }), [3, 5];
            case 4:
              return s.sent(), this.destroy(), [3, 5];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.close = function() {
      var e = this, r, n;
      if (!this.status.canClose()) {
        O.log.debug("InAppMessage is already closed. (key=".concat(this.context.inAppMessage.key, ")"));
        return;
      }
      (n = (r = this.ui.inAppMessageListener) === null || r === void 0 ? void 0 : r.beforeInAppMessageClose) === null || n === void 0 || n.call(r, this.context.inAppMessage), this.status.current = "CLOSING", this.handleInAppMessageLifecycle("CLOSE", function() {
        var i, o;
        e.handleEvent({ type: "CLOSE" }), e.destroy(), (o = (i = e.ui.inAppMessageListener) === null || i === void 0 ? void 0 : i.afterInAppMessageClose) === null || o === void 0 || o.call(i, e.context.inAppMessage);
      }, function() {
        var i, o;
        O.log.warn("Failed to close inAppMessage with [Timeout expired.]"), e.destroy(), (o = (i = e.ui.inAppMessageListener) === null || i === void 0 ? void 0 : i.afterInAppMessageClose) === null || o === void 0 || o.call(i, e.context.inAppMessage);
      });
    }, t.prototype.handleInAppMessageLifecycle = function(e, r, n) {
      var i = this, o = this.lifecycleRegistry.register(e, r);
      window.dispatchEvent(new CustomEvent(t.HACKLE_IAM_LIFECYCLE_START_EVENT_TYPE, {
        detail: { type: e, id: o }
      })), setTimeout(function() {
        var a = i.lifecycleRegistry.getAndRemove(e, o), s = a === void 0;
        s || n();
      }, t.LIFE_CYCLE_EVENT_LISTEN_TIMEOUT);
    }, t.prototype.destroy = function() {
      var e;
      window.removeEventListener(t.HACKLE_IAM_INTERACTION_EVENT_TYPE, this.handleInAppMessageInteraction), window.removeEventListener(t.HACKLE_IAM_LIFECYCLE_END_EVENT_TYPE, this.resolveLifecycleEnd), (e = this.renderer) === null || e === void 0 || e.destroy(), this.renderer = null, this.removeContainer(), this.ui.currentMessageView = null, this.status.current = "CLOSED";
    }, t.prototype.addContainer = function() {
      if (!this.container) {
        var e = document.createElement("div");
        e.classList.add(t.CONTAINER_CLASS_NAME), this.container = e;
      }
      return this.container.parentNode || document.body.appendChild(this.container), this.container;
    }, t.prototype.removeContainer = function() {
      var e;
      this.container && ((e = this.container.parentNode) === null || e === void 0 || e.removeChild(this.container), this.container = null);
    }, t.prototype.handleInteraction = function(e) {
      var r = this.ui.interactionHandlerFactory.get(e);
      r && r.handle(this, e);
    }, t.prototype.handleEvent = function(e) {
      this.ui.eventHandler.handle(this, e);
    }, t.HACKLE_IAM_INTERACTION_EVENT_TYPE = "hackle-iam-interaction", t.HACKLE_IAM_LIFECYCLE_START_EVENT_TYPE = "hackle-iam-lifecycle-start", t.HACKLE_IAM_LIFECYCLE_END_EVENT_TYPE = "hackle-iam-lifecycle-end", t.CONTAINER_CLASS_NAME = "hackle-iam", t.LIFE_CYCLE_EVENT_LISTEN_TIMEOUT = 5e3, t;
  }()
), jx = (
  /** @class */
  function() {
    function t() {
      this.mobileOSRegex = /(iOS|Android|iPad|iPhone)/g, this.mobileDeviceRegex = /(mobile|phone|tablet)/g;
    }
    return t.prototype.isMobileOS = function(e) {
      var r = e.user.hackleProperties, n = r.osName;
      return typeof n == "string" && !!n.match(this.mobileOSRegex);
    }, t.prototype.isMobileDeviceType = function(e) {
      var r = e.user.hackleProperties, n = r.deviceType;
      return typeof n == "string" && !!n.match(this.mobileDeviceRegex);
    }, t.prototype.resolve = function(e) {
      return this.isMobileOS(e) || this.isMobileDeviceType(e) ? "mobile" : "pc";
    }, t;
  }()
), Hx = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = "CLOSED"), this.current = e;
    }
    return t.prototype.canOpen = function() {
      return this.current !== "OPENED" && this.current !== "OPENING";
    }, t.prototype.canClose = function() {
      return this.current !== "CLOSED" && this.current !== "CLOSING";
    }, t;
  }()
), Xx = (
  /** @class */
  function() {
    function t() {
      this.record = {};
    }
    return t.prototype.resolveKey = function(e, r) {
      return "".concat(e, "_").concat(r);
    }, t.prototype.register = function(e, r) {
      var n = Pt(), i = this.resolveKey(e, n);
      return this.record[i] = r, n;
    }, t.prototype.getAndRemove = function(e, r) {
      var n = this.resolveKey(e, r), i = this.record, o = n, a = i[o], s = Mv(i, [typeof o == "symbol" ? o : o + ""]);
      return this.record = s, a;
    }, t;
  }()
), Wx = (
  /** @class */
  function() {
    function t(e) {
      this.scriptLoader = e;
    }
    return t.create = function(e) {
      return new t(e);
    }, t.prototype.create = function(e, r) {
      var n = new jx(), i = new Hx(), o = new Xx();
      switch (e.message.layout.displayType) {
        case "MODAL":
        case "BANNER":
        case "BOTTOM_SHEET":
          return new Bx(this.scriptLoader, e, r, n, i, o);
        case "NONE":
          return null;
      }
    }, t;
  }()
), zx = (
  /** @class */
  function() {
    function t(e) {
      this.scriptUrl = e;
    }
    return t.prototype.load = function() {
      return M(this, void 0, void 0, function() {
        var e;
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return window.HackleInAppMessageRenderer ? [
                2
                /*return*/
              ] : (e = this.createScript(), document.head.appendChild(e), [4, this.waitForLoad(e)]);
            case 1:
              return [2, r.sent()];
          }
        });
      });
    }, t.prototype.createScript = function() {
      var e = document.createElement("script");
      return e.type = "text/javascript", e.async = !0, e.src = this.scriptUrl, e;
    }, t.prototype.waitForLoad = function(e) {
      return new Promise(function(r, n) {
        var i = function() {
          a(), r(e);
        }, o = function(s) {
          a(), n(s.message);
        }, a = function() {
          e.removeEventListener("error", o), e.removeEventListener("load", i);
        };
        e.addEventListener("load", i), e.addEventListener("error", o);
      });
    }, t;
  }()
), Jx = (
  /** @class */
  function() {
    function t(e) {
      this.targetMatcher = e;
    }
    return t.prototype.isTriggerTarget = function(e, r, n) {
      var i = this;
      return r.eventTrigger.rules.some(function(o) {
        return i.ruleMatches(e, n, r, o);
      });
    }, t.prototype.ruleMatches = function(e, r, n, i) {
      if (r.event.key !== i.eventKey)
        return !1;
      var o = Zx.of(e, r, n);
      return this.targetMatcher.anyMatches(o, tt.create(), i.targets);
    }, t;
  }()
), Zx = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.key = e, this.workspace = r, this.user = n, this.event = i;
    }
    return t.of = function(e, r, n) {
      return new t(new Cr("IN_APP_MESSAGE", n.id), e, r.user, r);
    }, t;
  }()
), Yx = (
  /** @class */
  function() {
    function t(e) {
      this.storage = e;
    }
    return t.prototype.isTriggerTarget = function(e, r, n) {
      if (!r.eventTrigger.frequencyCap)
        return !0;
      var i = this.createMatchContexts(r.eventTrigger.frequencyCap);
      if (i.length === 0)
        return !0;
      for (var o = this.storage.get(r), a = 0, s = o; a < s.length; a++)
        for (var u = s[a], c = 0, l = i; c < l.length; c++) {
          var f = l[c];
          if (f.matches(n, u))
            return !1;
        }
      return !0;
    }, t.prototype.createMatchContexts = function(e) {
      for (var r = [], n = 0, i = e.identifierCaps; n < i.length; n++) {
        var o = i[n];
        r.push(new zc(new Kx(o)));
      }
      return e.durationCap && r.push(new zc(new Qx(e.durationCap))), r;
    }, t;
  }()
), zc = (
  /** @class */
  function() {
    function t(e) {
      this.matchCount = 0, this.predicate = e;
    }
    return t.prototype.matches = function(e, r) {
      return this.predicate.matches(e, r) && (this.matchCount += 1), this.matchCount >= this.predicate.thresholdCount;
    }, t;
  }()
), Kx = (
  /** @class */
  function() {
    function t(e) {
      this.identifierCap = e;
    }
    return Object.defineProperty(t.prototype, "thresholdCount", {
      get: function() {
        return this.identifierCap.count;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.matches = function(e, r) {
      var n = e.user.identifiers[this.identifierCap.identifierType];
      if (v.isNullOrUndefined(n))
        return !1;
      var i = r.identifiers[this.identifierCap.identifierType];
      return v.isNullOrUndefined(i) ? !1 : n === i;
    }, t;
  }()
), Qx = (
  /** @class */
  function() {
    function t(e) {
      this.durationCap = e;
    }
    return Object.defineProperty(t.prototype, "thresholdCount", {
      get: function() {
        return this.durationCap.count;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.matches = function(e, r) {
      return e.timestamp - r.timestamp <= this.durationCap.durationMillis;
    }, t;
  }()
), qx = (
  /** @class */
  function() {
    function t(e) {
      this.storage = e;
    }
    return t.prototype.get = function(e) {
      var r = this.storage.getItem(e.id.toString());
      return v.isNullOrUndefined(r) ? [] : JSON.parse(r);
    }, t.prototype.set = function(e, r) {
      this.storage.setItem(e.id.toString(), JSON.stringify(r));
    }, t;
  }()
), eP = (
  /** @class */
  function() {
    function t(e) {
      this.processors = e;
    }
    return t.prototype.get = function(e) {
      return this.processors.find(function(r) {
        return r.supports(e);
      });
    }, t;
  }()
), tP = (
  /** @class */
  function() {
    function t(e) {
      this.impressionStorage = e;
    }
    return t.prototype.process = function(e, r, n) {
      this.saveImpression(e.context.inAppMessage, e.context.user, n);
    }, t.prototype.saveImpression = function(e, r, n) {
      var i = this.impressionStorage.get(e), o = { identifiers: r.identifiers, timestamp: n };
      i.push(o), i.length > t.IMPRESSION_MAX_SIZE && i.splice(0, i.length - t.IMPRESSION_MAX_SIZE), this.impressionStorage.set(e, i);
    }, t.prototype.supports = function(e) {
      return e.type === "IMPRESSION";
    }, t.IMPRESSION_MAX_SIZE = 100, t;
  }()
), rP = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.process = function(e, r, n) {
    }, t.prototype.supports = function(e) {
      return e.type === "CLOSE";
    }, t;
  }()
), nP = (
  /** @class */
  function() {
    function t(e) {
      this.actionHandlerFactory = e;
    }
    return t.prototype.process = function(e, r, n) {
      var i, o, a = this.actionHandlerFactory.get(r.action), s = (o = (i = e.ui.inAppMessageListener) === null || i === void 0 ? void 0 : i.onInAppMessageClick) === null || o === void 0 ? void 0 : o.call(i, e.context.inAppMessage, e, jh.fromAction(r.action));
      s || !e.status.canClose() || a == null || a.handle(e, r.action);
    }, t.prototype.supports = function(e) {
      return e.type === "ACTION";
    }, t;
  }()
), iP = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.clock = e, this.eventTracker = r, this.eventProcessorFactory = n;
    }
    return t.prototype.handle = function(e, r) {
      var n = this.clock.currentMillis();
      this.eventTracker.track(e.context, r, n);
      var i = this.eventProcessorFactory.get(r);
      i && i.process(e, r, n);
    }, t;
  }()
), oP = (
  /** @class */
  function() {
    function t(e, r) {
      this.ruleDeterminer = e, this.frequencyCapDeterminer = r;
    }
    return t.prototype.matches = function(e, r, n) {
      return !Z.isTrackEvent(n) || !this.ruleDeterminer.isTriggerTarget(e, r, n) ? !1 : this.frequencyCapDeterminer.isTriggerTarget(e, r, n);
    }, t;
  }()
), aP = (
  /** @class */
  function() {
    function t(e) {
      this.handlers = e;
    }
    return t.prototype.get = function(e) {
      return this.handlers.find(function(r) {
        return r.supports(e);
      });
    }, t;
  }()
), sP = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.handle = function(e, r) {
      e.close();
    }, t.prototype.supports = function(e) {
      return e.type === "CLOSE";
    }, t;
  }()
), uP = (
  /** @class */
  function() {
    function t(e) {
      this.eventHandler = e;
    }
    return t.prototype.handle = function(e, r) {
      var n = cr.fromJson(r.action);
      if (n) {
        var i = {
          type: "ACTION",
          action: n,
          area: r.area,
          text: r.text
        };
        this.eventHandler.handle(e, i);
      }
    }, t.prototype.supports = function(e) {
      return e.type === "ACTION";
    }, t;
  }()
), Jc = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.open = function(e) {
      window.location.href = e.href;
    }, t;
  }()
), Zc = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.open = function(e) {
      window.open(e.href, "Hackle", "resizable:true");
    }, t;
  }()
), Yc = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.open = function(e) {
      window.open(e.href);
    }, t;
  }()
), cP = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.open = function(e) {
      window.location.replace(e);
    }, t;
  }()
), Oa = {
  utm_campaign: void 0,
  utm_content: void 0,
  utm_id: void 0,
  utm_medium: void 0,
  utm_source: void 0,
  utm_term: void 0,
  gclid: void 0,
  fbclid: void 0
}, lP = {
  current: void 0,
  referrer: void 0
}, fP = function(t) {
  return jp(t, Oa);
}, jp = function(t, e) {
  return Object.keys(Oa).every(function(r) {
    return t[r] === e[r];
  });
}, pP = function(t, e, r) {
  return t === null ? !0 : fP(e) && r.current === r.referrer ? !1 : !jp(t, e);
}, dP = function(t, e) {
  for (var r = 0, n = Object.entries(t); r < n.length; r++) {
    var i = n[r], o = i[0], a = i[1];
    Tn.isNotEmptyString(a) && e.searchParams.set(o, a);
  }
  return e;
}, vP = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.storage = e, this.parser = r, this.core = n, this.userManager = i;
    }
    return t.prototype.startNewCampaign = function(e, r, n) {
      for (var i = b(b({}, Oa), r), o = new ir(), a = 0, s = Object.entries(i); a < s.length; a++) {
        var u = s[a], c = u[0], l = u[1];
        l ? o.set(c, l) : o.unset(c);
      }
      var f = o.build(), p = f.toEvent(), d = this.userManager.toHackleUser(e);
      this.core.track(p, d, n), this.userManager.updateUserProperties(f);
    }, t.prototype.startNewCampaignIfNeeded = function(e, r) {
      var n = this.storage.get(), i = this.parser.parse(), o = this.parser.parseDomain();
      pP(n, i, o) && (this.storage.set(i), this.startNewCampaign(e, i, r));
    }, t.prototype.onSessionEnded = function(e, r, n) {
    }, t.prototype.onSessionStarted = function(e, r, n) {
      this.startNewCampaignIfNeeded(r, n);
    }, t;
  }()
), hP = (
  /** @class */
  function() {
    function t(e) {
      this.storage = e;
    }
    return t.prototype.get = function() {
      var e = this.storage.getItem(as);
      return e ? JSON.parse(e) : null;
    }, t.prototype.set = function(e) {
      this.storage.setItem(as, JSON.stringify(e));
    }, t;
  }()
), gP = (
  /** @class */
  function() {
    function t(e) {
      this.search = e;
    }
    return t.prototype.getQueryParam = function(e) {
      var r = this.getQueryParams(function() {
        return !0;
      });
      return r[e] || "";
    }, t.prototype.getQueryParams = function(e) {
      for (var r = {}, n = this.search.substring(1).split("&"), i = 0, o = n; i < o.length; i++) {
        var a = o[i], s = a.split("="), u = s[0], c = s[1];
        if (!e || e(u, c)) {
          var l = Ce.tryDecodeURIComponent(c);
          l && (r[u] = l);
        }
      }
      return r;
    }, t;
  }()
), Kc = (
  /** @class */
  function() {
    function t() {
    }
    return t.extractDomain = function(e) {
      var r = this.DOMAIN_MATCH_REGEX, n = e.split("."), i = n[n.length - 1];
      (i.length > 4 || i === "com" || i === "org") && (r = this.SIMPLE_DOMAIN_MATCH_REGEX);
      var o = e.match(r);
      return o ? o[0] : e;
    }, t.DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i, t.SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i, t;
  }()
), yP = (
  /** @class */
  function() {
    function t(e) {
      this.pageManager = e;
    }
    return t.prototype.parse = function(e) {
      var r = this.params(e);
      return this.resolve(r);
    }, t.prototype.params = function(e) {
      var r = v.isNotNullOrUndefined(e) ? e : this.pageManager.currentPage.queryParameter;
      return new gP(r).getQueryParams(t.CAMPAIGN_QUERY_CONDITION);
    }, t.prototype.resolve = function(e) {
      return {
        utm_campaign: e[IP],
        utm_content: e[mP],
        utm_id: e[AP],
        utm_medium: e[EP],
        utm_source: e[CP],
        utm_term: e[bP],
        gclid: e[TP],
        fbclid: e[wP]
      };
    }, t.prototype.parseDomain = function() {
      var e = this;
      if (typeof window > "u")
        return lP;
      var r = function() {
        var n = e.pageManager.currentPage.referrer;
        if (n) {
          var i = new URL(n).hostname;
          return Kc.extractDomain(i);
        }
      };
      return {
        current: Kc.extractDomain(this.pageManager.currentPage.hostname),
        referrer: r()
      };
    }, t.CAMPAIGN_QUERY_CONDITION = function(e, r) {
      return Tn.isNotEmptyString(r);
    }, t;
  }()
), IP = "utm_campaign", mP = "utm_content", AP = "utm_id", EP = "utm_medium", CP = "utm_source", bP = "utm_term", TP = "gclid", wP = "fbclid", NP = (
  /** @class */
  function() {
    function t(e, r) {
      var n = this;
      this.userEventEmitter = e, this.determiner = r, this.onEvent = function(i) {
        var o = n.determiner.determineTargetExposureOrNull(i);
        o && n.send(o);
      }, this.initialize();
    }
    return t.prototype.initialize = function() {
      this.userEventEmitter.on("event", this.onEvent);
    }, t.prototype.send = function(e) {
      var r = e.experiment.key, n = e.variationKey, i = "HACKLE-EXPERIMENT_".concat(r, "_V").concat(e.experiment.version, "-").concat(n);
      try {
        window.gtag("event", "experience_impression", {
          exp_variant_string: i
        });
      } catch (o) {
        O.log.error("Unexpected exception while sending an event to Google Analytics with gtag: ".concat(o));
      }
    }, t;
  }()
), OP = (
  /** @class */
  function() {
    function t(e) {
      this.workspaceFetcher = e;
    }
    return t.prototype.determineTargetExposureOrNull = function(e) {
      var r = this.workspaceFetcher.get();
      if (!r)
        return null;
      var n = r.getAttributes();
      return !n.integration_ga_experiment || !Z.isExposureEvent(e) || e.experiment.status !== "RUNNING" || e.decisionReason !== w.TRAFFIC_ALLOCATED ? null : e;
    }, t;
  }()
), Qc = {
  user: void 0,
  debug: !1,
  log_disabled: !1,
  automaticPageTracking: !0,
  pollingIntervalMillis: Ot,
  exposureEventDedupIntervalMillis: Zr,
  sessionTimeoutMillis: Fv,
  autoOpenDevTool: !1,
  sdkUrl: Sv,
  eventUrl: Rv,
  monitoringUrl: xv,
  cdnUrl: Pv,
  sameSiteCookie: "LAX",
  secureCookie: !1,
  SDK_NAME_HEADER: "javascript-sdk_browser",
  SDK_VERSION_HEADER: Uv,
  IAM_RENDERER_VERSION_HEADER: Xv
}, qe = (
  /** @class */
  function() {
    function t() {
    }
    return t.config = function(e) {
      return b(b(b({}, Qc), e), { automaticPageTracking: t.resolveAutomaticPageTracking(e) });
    }, t.resolveAutomaticPageTracking = function(e) {
      return typeof (e == null ? void 0 : e.automaticPageTracking) != "boolean" && typeof (e == null ? void 0 : e.auto_track_page_view) != "boolean" ? Qc.automaticPageTracking : !!e.automaticPageTracking || !!e.auto_track_page_view;
    }, t.logging = function(e) {
      O.initCounter(function(r) {
        return Ue.counter("log", { level: r });
      }), O.setLogLevel(Me.INFO), e.log_disabled ? O.setLogLevel(Me.DISABLE) : e.debug && O.setLogLevel(Me.DEBUG);
    }, t.sdk = function(e, r) {
      return O.log.debug("SDK key: ".concat(e)), e || O.log.error("invalid sdk key: '".concat(e, "' (expected: not null, not undefined and not empty string)")), {
        key: e,
        name: r.SDK_NAME_HEADER,
        version: r.SDK_VERSION_HEADER
      };
    }, t.isBeaconSupported = function() {
      var e = !1;
      return typeof window < "u" && (e = window && window.navigator && !!window.navigator.sendBeacon && !0, e && O.log.debug("support sendBeacon API")), e;
    }, t.pollingIntervalMillis = function(e) {
      return e.pollingIntervalMillis === void 0 || typeof e.pollingIntervalMillis != "number" || e.pollingIntervalMillis <= 0 ? Ot : Math.max(e.pollingIntervalMillis, Dv);
    }, t.dedupIntervalMillis = function(e) {
      return e.exposureEventDedupIntervalMillis === void 0 || typeof e.exposureEventDedupIntervalMillis != "number" ? Zr : e.exposureEventDedupIntervalMillis < 1e3 || e.exposureEventDedupIntervalMillis > 1e3 * 60 * 60 ? (O.log.warn("Exposure event dedup interval is outside allowed range[1_000ms..3_600_000ms]. Setting to default value[1m]."), Zr) : e.exposureEventDedupIntervalMillis;
    }, t;
  }()
), MP = (
  /** @class */
  function() {
    function t() {
      this.synchronizers = [];
    }
    return t.prototype.add = function(e) {
      this.synchronizers.push(e);
    }, t.prototype.sync = function() {
      return M(this, void 0, void 0, function() {
        var e = this;
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, Promise.all(this.synchronizers.map(function(n) {
                return e.safe(n.sync());
              }))];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.close = function() {
      return M(this, void 0, void 0, function() {
        var e = this;
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, Promise.all(this.synchronizers.map(function(n) {
                return e.safe(n.close());
              }))];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.safe = function(e) {
      return M(this, void 0, void 0, function() {
        var r;
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, e];
            case 1:
              return n.sent(), [3, 3];
            case 2:
              return r = n.sent(), O.log.error("Failed to sync: ".concat(r)), [3, 3];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
), _P = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.delegate = e, this.scheduler = r, this.intervalMillis = n, this.pollingJob = null;
    }
    return t.prototype.sync = function() {
      return M(this, void 0, void 0, function() {
        var e;
        return _(this, function(r) {
          switch (r.label) {
            case 0:
              return r.trys.push([0, 2, , 3]), [4, this.delegate.sync()];
            case 1:
              return r.sent(), [3, 3];
            case 2:
              return e = r.sent(), O.log.error("Failed to sync: ".concat(e)), [3, 3];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.start = function() {
      var e = this;
      this.intervalMillis !== Ot && this.pollingJob === null && (this.pollingJob = this.scheduler.schedulePeriodically(this.intervalMillis, this.intervalMillis, function() {
        return e.sync();
      }));
    }, t.prototype.stop = function() {
      var e;
      this.intervalMillis !== Ot && ((e = this.pollingJob) === null || e === void 0 || e.cancel(), this.pollingJob = null);
    }, t.prototype.close = function() {
      return M(this, void 0, void 0, function() {
        return _(this, function(e) {
          switch (e.label) {
            case 0:
              return this.stop(), [4, this.delegate.close()];
            case 1:
              return e.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
), Qi = (
  /** @class */
  function() {
    function t(e) {
      this.scheduleType = e;
    }
    return t.prototype.schedule = function(e, r) {
      var n = new SP(e, r);
      return n.start(), n;
    }, t.prototype.schedulePeriodically = function(e, r, n) {
      var i;
      switch (this.scheduleType) {
        case "setTimeout":
          i = new RP(e, r, n);
          break;
        case "setInterval":
          i = new xP(e, r, n);
          break;
      }
      return i.start(), i;
    }, t;
  }()
), SP = (
  /** @class */
  function() {
    function t(e, r) {
      this.delayMillis = e, this.task = r, this.timeout = null;
    }
    return t.prototype.start = function() {
      var e = this;
      this.timeout = setTimeout(function() {
        return e.task();
      }, this.delayMillis);
    }, t.prototype.cancel = function() {
      this.timeout && (clearTimeout(this.timeout), this.timeout = null);
    }, t;
  }()
), RP = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.delayMillis = e, this.intervalMillis = r, this.task = n, this.timeout = null;
    }
    return t.prototype.start = function() {
      var e = this;
      this.timeout = setTimeout(function() {
        return e.run();
      }, this.delayMillis);
    }, t.prototype.run = function() {
      var e = this;
      try {
        this.task();
      } catch (r) {
        O.log.error("Failed to run task: ".concat(r));
      }
      this.timeout = setTimeout(function() {
        return e.run();
      }, this.intervalMillis);
    }, t.prototype.cancel = function() {
      this.timeout && (clearTimeout(this.timeout), this.timeout = null);
    }, t;
  }()
), xP = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.delayMillis = e, this.intervalMillis = r, this.task = n, this.timeout = null, this.interval = null;
    }
    return t.prototype.start = function() {
      var e = this;
      this.timeout = setTimeout(function() {
        e.run(), e.interval = setInterval(function() {
          return e.run();
        }, e.intervalMillis);
      }, this.delayMillis);
    }, t.prototype.run = function() {
      try {
        this.task();
      } catch (e) {
        O.log.error("Failed to run task: ".concat(e));
      }
    }, t.prototype.cancel = function() {
      this.timeout && (clearTimeout(this.timeout), this.timeout = null), this.interval && (clearInterval(this.interval), this.interval = null);
    }, t;
  }()
), PP = (
  /** @class */
  function() {
    function t(e, r) {
      this.url = e, this.transport = r;
    }
    return t.prototype.fetchIfModified = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n;
        return _(this, function(i) {
          switch (i.label) {
            case 0:
              return r = this.createRequest(e), [4, this.execute(r)];
            case 1:
              return n = i.sent(), [2, this.handleResponse(n)];
          }
        });
      });
    }, t.prototype.createRequest = function(e) {
      var r = dr.builder().url(this.url).method("GET");
      return e !== null && r.addHeader(_t.IF_MODIFIED_SINCE, e), r.build();
    }, t.prototype.execute = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n, i;
        return _(this, function(o) {
          switch (o.label) {
            case 0:
              r = at.start(), o.label = 1;
            case 1:
              return o.trys.push([1, 3, , 4]), [4, this.transport.send(e)];
            case 2:
              return n = o.sent(), St.record("get.workspace", r, n), [2, n];
            case 3:
              throw i = o.sent(), St.record("get.workspace", r, null), i;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.handleResponse = function(e) {
      if (e.isNotModified())
        return null;
      if (!e.isSuccessful())
        throw new Error("Http status code: ".concat(e.statusCode));
      if (e.body === null)
        throw new Error("Response body is empty");
      var r = JSON.parse(e.body), n = e.headers.get(_t.LAST_MODIFIED);
      return { config: r, lastModified: n };
    }, t;
  }()
), UP = (
  /** @class */
  function() {
    function t(e, r) {
      this.url = e, this.transport = r;
    }
    return t.prototype.fetch = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n;
        return _(this, function(i) {
          switch (i.label) {
            case 0:
              return r = this.createRequest(e), [4, this.execute(r)];
            case 1:
              return n = i.sent(), [2, this.handleResponse(n)];
          }
        });
      });
    }, t.prototype.createRequest = function(e) {
      var r = { identifiers: sn(e) }, n = Ov.encodeURL(JSON.stringify(r));
      return dr.builder().url(this.url).method("GET").addHeader("X-HACKLE-USER", n).build();
    }, t.prototype.execute = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n, i;
        return _(this, function(o) {
          switch (o.label) {
            case 0:
              r = at.start(), o.label = 1;
            case 1:
              return o.trys.push([1, 3, , 4]), [4, this.transport.send(e)];
            case 2:
              return n = o.sent(), St.record("get.cohorts", r, n), [2, n];
            case 3:
              throw i = o.sent(), St.record("get.cohorts", r, null), i;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.handleResponse = function(e) {
      if (!e.isSuccessful())
        throw new Error("Http status code: ".concat(e.statusCode));
      if (e.body === null)
        throw new Error("Response body is null");
      var r = JSON.parse(e.body);
      return Na.fromDto(r);
    }, t;
  }()
), DP = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a, s, u, c, l, f) {
      this.experiments = x.associateBy(e, function(p) {
        return p.key;
      }), this.splitUrlExperiments = x.associateBy(r, function(p) {
        return p.key;
      }), this.featureFlags = x.associateBy(n, function(p) {
        return p.key;
      }), this.buckets = x.associateBy(i, function(p) {
        return p.id;
      }), this.eventTypes = x.associateBy(o, function(p) {
        return p.key;
      }), this.segments = x.associateBy(a, function(p) {
        return p.key;
      }), this.containers = x.associateBy(s, function(p) {
        return p.id;
      }), this.parameterConfigurations = x.associateBy(u, function(p) {
        return p.id;
      }), this.remoteConfigParameters = x.associateBy(c, function(p) {
        return p.key;
      }), this.inAppMessages = x.associateBy(l, function(p) {
        return p.key;
      }), this.attributes = f;
    }
    return t.prototype.getExperiments = function() {
      return Array.from(this.experiments.values());
    }, t.prototype.getSplitUrlExperiments = function() {
      return Array.from(this.splitUrlExperiments.values());
    }, t.prototype.getFeatureFlags = function() {
      return Array.from(this.featureFlags.values());
    }, t.prototype.getInAppMessages = function() {
      return Array.from(this.inAppMessages.values());
    }, t.prototype.getExperimentOrNull = function(e) {
      return this.experiments.get(e);
    }, t.prototype.getFeatureFlagOrNull = function(e) {
      return this.featureFlags.get(e);
    }, t.prototype.getBucketOrNull = function(e) {
      return this.buckets.get(e);
    }, t.prototype.getEventTypeOrNull = function(e) {
      return this.eventTypes.get(e);
    }, t.prototype.getSegmentOrNull = function(e) {
      return this.segments.get(e);
    }, t.prototype.getContainerOrNull = function(e) {
      return this.containers.get(e);
    }, t.prototype.getParameterConfigurationOrNull = function(e) {
      return this.parameterConfigurations.get(e);
    }, t.prototype.getRemoteConfigParameterOrNull = function(e) {
      return this.remoteConfigParameters.get(e);
    }, t.prototype.getInAppMessageOrNull = function(e) {
      return this.inAppMessages.get(e);
    }, t.prototype.getAttributes = function() {
      return this.attributes;
    }, t.from = function(e) {
      var r = x.mapNotNullOrUndefined(e.experiments, function(d) {
        return ni.fromJson("AB_TEST", d);
      }), n = x.mapNotNullOrUndefined(e.experiments, function(d) {
        return ni.fromJson("AB_TEST", d);
      }).filter(function(d) {
        return d.implementationType === "SPLIT_URL";
      }), i = x.mapNotNullOrUndefined(e.featureFlags, function(d) {
        return ni.fromJson("FEATURE_FLAG", d);
      }), o = e.buckets.map(qv.fromJson), a = e.events.map(xl.fromJson), s = x.mapNotNullOrUndefined(e.segments, oh.fromJson), u = e.containers.map(ah.fromJson), c = e.parameterConfigurations.map(Yv.fromJson), l = x.mapNotNullOrUndefined(e.remoteConfigParameters, uh.fromJson), f = x.mapNotNullOrUndefined(e.inAppMessages, wh.fromJson), p = e.workspace.attributes;
      return new t(r, n, i, o, a, s, u, c, l, f, p);
    }, t;
  }()
), LP = (
  /** @class */
  function() {
    function t(e, r) {
      this.workspaceConfigStorage = e, this.workspaceFetcher = r, this.workspace = null, this.lastModified = null;
      var n = this.workspaceConfigStorage.get();
      n && this.setConfig(n);
    }
    return t.prototype.setConfig = function(e) {
      this.setWorkspace(e), this.lastModified = e.lastModified;
    }, t.prototype.setWorkspace = function(e) {
      try {
        this.workspace = DP.from(e.config);
      } catch (r) {
        O.log.error("Failed to set workspace: ".concat(r));
      }
    }, t.prototype.get = function() {
      return this.workspace;
    }, t.prototype.sync = function() {
      return M(this, void 0, void 0, function() {
        var e, r;
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, this.workspaceFetcher.fetchIfModified(this.lastModified)];
            case 1:
              return e = n.sent(), e && (this.setConfig(e), this.workspaceConfigStorage.set(e)), [3, 3];
            case 2:
              return r = n.sent(), O.log.error("Failed to sync workspace: ".concat(r)), [3, 3];
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.close = function() {
      return M(this, void 0, void 0, function() {
        return _(this, function(e) {
          return [
            2
            /*return*/
          ];
        });
      });
    }, t;
  }()
), $P = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.transport = e, this.synchronousTransport = r, this.retryManager = n;
    }
    return t.prototype.dispatch = function(e, r) {
      var n = e.map(function(i) {
        return i.toDto();
      });
      return r ? this.dispatchEventsSynchronously(n) : this.dispatchEvents(n);
    }, t.prototype.dispatchEventsSynchronously = function(e) {
      return M(this, void 0, void 0, function() {
        var r;
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.retryManager.add(e)];
            case 1:
              return n.sent(), [4, this.synchronousTransport.send(e)];
            case 2:
              return r = n.sent(), r.isSuccessful() || r.isClientError() ? [4, this.retryManager.delete(e)] : [3, 4];
            case 3:
              n.sent(), n.label = 4;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.dispatchEvents = function(e) {
      return M(this, void 0, void 0, function() {
        var r;
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.transport.send(e)];
            case 1:
              return r = n.sent(), r.isSuccessful() || r.isClientError() ? [
                2
                /*return*/
              ] : [4, this.retryManager.add(e)];
            case 2:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
);
function kP(t) {
  var e = new Array(), r = new Array(), n = new Array();
  return t.forEach(function(i) {
    i instanceof Z ? Z.isExposureEvent(i) ? e.push(i.toDto()) : Z.isTrackEvent(i) ? r.push(i.toDto()) : Z.isRemoteConfigEvent(i) && n.push(i.toDto()) : Z.isExposureEventDto(i) ? e.push(i) : Z.isTrackEventDto(i) ? r.push(i) : Z.isRemoteConfigEventDto(i) && n.push(i);
  }), {
    exposureEvents: e,
    trackEvents: r,
    remoteConfigEvents: n
  };
}
var qc = (
  /** @class */
  function() {
    function t(e, r) {
      this.url = e, this.transport = r;
    }
    return t.prototype.send = function(e) {
      var r = this.createRequest(e);
      return this.execute(r);
    }, t.prototype.createRequest = function(e) {
      var r = kP(e);
      return dr.builder().url(this.url).method("POST").addHeader("Content-Type", "application/json").body(JSON.stringify(r)).build();
    }, t.prototype.execute = function(e) {
      return M(this, void 0, void 0, function() {
        var r, n, i;
        return _(this, function(o) {
          switch (o.label) {
            case 0:
              r = at.start(), o.label = 1;
            case 1:
              return o.trys.push([1, 3, , 4]), [4, this.transport.send(e)];
            case 2:
              return n = o.sent(), St.record("post.events", r, n), [2, n];
            case 3:
              throw i = o.sent(), St.record("post.events", r, null), i;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
), FP = (
  /** @class */
  function() {
    function t(e, r) {
      this.repository = e, this.transport = r;
    }
    return t.prototype.add = function(e) {
      return this.repository.add(e);
    }, t.prototype.delete = function(e) {
      return this.repository.delete(e);
    }, t.prototype.flush = function() {
      return M(this, void 0, void 0, function() {
        var e, r;
        return _(this, function(n) {
          switch (n.label) {
            case 0:
              return [4, this.repository.read()];
            case 1:
              return e = n.sent(), e.length === 0 ? [
                2
                /*return*/
              ] : [4, this.transport.send(e)];
            case 2:
              return r = n.sent(), r.isSuccessful() || r.isClientError() ? [4, this.delete(e)] : [3, 4];
            case 3:
              n.sent(), n.label = 4;
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onLifecycleChanged = function(e, r) {
      switch (e) {
        case "visible":
        case "pageshow":
          this.flush().catch(function(n) {
            return O.log.warn("Failed to flush retry events: ".concat(n));
          });
          return;
        case "blur":
        case "focus":
        case "hidden":
        case "locationChange":
        case "pagehide":
          return;
      }
    }, t;
  }()
), GP = (
  /** @class */
  function() {
    function t() {
      this.listeners = {};
    }
    return t.prototype.on = function(e, r) {
      this.listeners[e] = (this.listeners[e] || []).concat(r);
    }, t.prototype.off = function(e, r) {
      this.listeners[e] = (this.listeners[e] || []).filter(function(n) {
        return n !== r;
      });
    }, t.prototype.emit = function(e, r) {
      (this.listeners[e] || []).forEach(function(n) {
        n(r);
      });
    }, t;
  }()
), VP = (
  /** @class */
  function(t) {
    Y(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e;
  }(GP)
), BP = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n, i, o) {
      var a = t.call(this) || this;
      return a.eventDispatcher = r, a.eventDispatchMaxSize = n, a.flushScheduler = i, a.flushIntervalMillis = o, a.queue = [], a.flushingJob = null, a;
    }
    return e.prototype.process = function(r) {
      this.enqueue(r), this.emit("event", r);
    }, e.prototype.enqueue = function(r) {
      this.queue.length === 0 && this.scheduleFlush(), this.queue.push(r), this.queue.length >= this.eventDispatchMaxSize && this.flush();
    }, e.prototype.scheduleFlush = function() {
      var r = this, n;
      (n = this.flushingJob) === null || n === void 0 || n.cancel(), this.flushingJob = this.flushScheduler.schedule(this.flushIntervalMillis, function() {
        return r.flush();
      });
    }, e.prototype.flush = function(r) {
      var n;
      r === void 0 && (r = !1), (n = this.flushingJob) === null || n === void 0 || n.cancel(), this.queue.length !== 0 && (this.eventDispatcher.dispatch(this.queue, r).catch(function(i) {
        return O.log.warn("Failed to dispatch events: ".concat(i));
      }), this.queue = []);
    }, e.prototype.close = function() {
      this.flush(!0);
    }, e;
  }(VP)
), el = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.sdk = e, this.clock = r, this.delegate = n;
    }
    return t.prototype.send = function(e) {
      var r = e.toBuilder().addHeader(wl, this.sdk.key).addHeader(Nl, this.sdk.name).addHeader(Ol, this.sdk.version).addHeader(Ml, this.clock.currentMillis().toString()).build();
      return this.delegate.send(r);
    }, t;
  }()
), tl = (
  /** @class */
  function() {
    function t() {
    }
    return t.intercept = function(e, r) {
      return r instanceof el ? r : new el(e, be.instance, r);
    }, t;
  }()
), jP = (
  /** @class */
  function() {
    function t() {
    }
    return t.create = function() {
      return new t();
    }, t.prototype.send = function(e) {
      return new Promise(function(r, n) {
        var i = new XMLHttpRequest();
        e.options.timeoutMillis && (i.timeout = e.options.timeoutMillis), i.open(e.method, e.url), i.onreadystatechange = function() {
          if (i.readyState === i.DONE) {
            if (i.status === 0) {
              n(new Error("Request Error"));
              return;
            }
            var o = XP(i);
            r(o);
          }
        }, HP(i, e), i.send(e.body);
      });
    }, t;
  }()
);
function HP(t, e) {
  var r = e.headers.raw();
  for (var n in r)
    r.hasOwnProperty(n) && t.setRequestHeader(n, r[n]);
}
function XP(t) {
  return new Fl(t.status, t.responseText, WP(t));
}
function WP(t) {
  var e = _t.builder(), r = t.getAllResponseHeaders();
  if (!r)
    return e.build();
  for (var n = 0, i = r.split(`\r
`); n < i.length; n++) {
    var o = i[n], a = o.indexOf(": ");
    if (a > 0) {
      var s = o.slice(0, a), u = o.slice(a + 2);
      e.add(s, u);
    }
  }
  return e.build();
}
var zP = (
  /** @class */
  function() {
    function t() {
    }
    return t.create = function() {
      return new t();
    }, t.prototype.send = function(e) {
      var r = this;
      return new Promise(function(n, i) {
        var o = !1;
        if (typeof window < "u" && (o = window && window.navigator && !!window.navigator.sendBeacon && !0), !o)
          throw new Error("BeaconTransport not supported.");
        var a = r.createBody(e), s = window.navigator.sendBeacon(e.url, a);
        if (!s)
          throw Error("Failed to sendBeacon");
        n(Fl.ok());
      });
    }, t.prototype.createBody = function(e) {
      var r = new URLSearchParams(), n = e.headers.get(wl);
      n && r.append("sdkKey", n), r.append("sdkName", e.headers.getOrDefault(Nl, "unknown")), r.append("sdkVersion", e.headers.getOrDefault(Ol, "unknown"));
      var i = e.headers.get(Ml);
      return i && r.append("sdkTime", i), e.body && r.append("data", e.body), r;
    }, t;
  }()
), JP = (
  /** @class */
  function() {
    function t(e) {
      this.invocationResponseResolver = e;
    }
    return t.prototype.invoke = function(e) {
      var r = window.prompt(JSON.stringify(e));
      return this.invocationResponseResolver.resolve(r);
    }, t;
  }()
), ZP = (
  /** @class */
  function() {
    function t(e) {
      this.invocationResponseResolver = e;
    }
    return t.prototype.invoke = function(e) {
      var r;
      if (!(!((r = window._hackleApp) === null || r === void 0) && r.invoke))
        throw new Error("window._hackleApp.invoke is not implemented");
      var n = window._hackleApp.invoke(JSON.stringify(e));
      return this.invocationResponseResolver.resolve(n);
    }, t;
  }()
), mn;
(function(t) {
  t.prompt = "prompt", t.function = "function";
})(mn || (mn = {}));
var YP = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.getInvocator = function(e, r) {
      return e === mn.prompt ? new JP(r) : e === mn.function ? new ZP(r) : null;
    }, t;
  }()
), KP = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.determiner = e, this.redirector = r, this.userManager = n, this.core = i;
    }
    return t.prototype.onPageStarted = function(e, r) {
      var n = this.userManager.resolve(), i = this.determiner.determineOrNull(n);
      i && (this.core.flush(!0), this.redirector.redirect(i));
    }, t.prototype.onPageEnded = function(e, r) {
    }, t;
  }()
), QP = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.workspace = e, this.experiment = r, this.decision = n, this.user = i;
    }
    return t;
  }()
), qP = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.workspaceFetcher = e, this.splitUrlMatcher = r, this.splitUrlRedirectedCookieStorage = n, this.core = i;
    }
    return t.prototype.determineOrNull = function(e) {
      if (this.splitUrlRedirectedCookieStorage.alreadyRedirected())
        return this.splitUrlRedirectedCookieStorage.clear(), null;
      var r = this.workspaceFetcher.get();
      if (!r)
        return null;
      for (var n = 0, i = r.getSplitUrlExperiments(); n < i.length; n++) {
        var o = i[n], a = this.splitUrlMatcher.matches(r, o, e);
        if (a) {
          var s = this.core.experiment(o.key, e, "A");
          return new QP(r, o, s, e);
        }
      }
      return null;
    }, t;
  }()
), eU = (
  /** @class */
  function() {
    function t(e) {
      this.targetMatcher = e;
    }
    return t.prototype.matches = function(e, r, n) {
      if (r.implementationType !== "SPLIT_URL" || !r.splitUrlTargets)
        return !1;
      var i = r.splitUrlTargets, o = tU.of(e, n);
      return i.excludeTargets.length > 0 && this.targetMatcher.anyMatches(o, tt.create(), i.excludeTargets) ? !1 : i.includeTargets.length > 0 && this.targetMatcher.anyMatches(o, tt.create(), i.includeTargets);
    }, t;
  }()
), tU = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.key = e, this.user = r, this.workspace = n;
    }
    return t.of = function(e, r) {
      return new t(new Cr("SPLIT_URL", Pt()), r, e);
    }, t;
  }()
), rU = (
  /** @class */
  function() {
    function t(e, r, n, i) {
      this.urlResolver = e, this.urlHandler = r, this.splitUrlRedirectedCookieStorage = n, this.initializeEventDispatcher = i;
    }
    return t.prototype.redirect = function(e) {
      var r = this.urlResolver.resolveOrNull(e);
      r && (this.initializeEventDispatcher.setNeedDispatch(!1), this.splitUrlRedirectedCookieStorage.setRedirected(!0), this.urlHandler.open(r));
    }, t;
  }()
), nU = (
  /** @class */
  function() {
    function t(e) {
      this.campaignParser = e;
    }
    return t.prototype.resolveOrNull = function(e) {
      try {
        var r = JSON.parse(e.decision.get(t.SPLIT_URL_CONFIG_KEY, "")), n = Wh.fromDto(r);
        return n.needRedirect ? this.resolveByRedirectType(n.redirectType, n.redirectUrl, e) : null;
      } catch {
        return null;
      }
    }, t.prototype.resolveByRedirectType = function(e, r, n) {
      if (!r)
        return null;
      switch (e) {
        case un.MANUAL:
          return this.resolveManualRedirectUrl(r, n);
        default:
          return null;
      }
    }, t.prototype.resolveManualRedirectUrl = function(e, r) {
      var n = Ce.tryParse(e);
      return n ? this.decorateCampaign(n, r) : null;
    }, t.prototype.decorateCampaign = function(e, r) {
      var n = r.user.hackleProperties.queryParameter;
      if (Tn.isNotEmptyString(n)) {
        var i = this.campaignParser.parse(n);
        return dP(i, e);
      } else
        return e;
    }, t.SPLIT_URL_CONFIG_KEY = "redirectUrl", t;
  }()
), iU = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.storage = e, this.cookieKey = r, this.cookieStorageOptions = n;
    }
    return t.prototype.alreadyRedirected = function() {
      try {
        var e = this.storage.getItem(this.cookieKey);
        return v.isNullOrUndefined(e) ? !1 : !!JSON.parse(e);
      } catch {
        return !1;
      }
    }, t.prototype.clear = function() {
      this.storage.removeItem(this.cookieKey);
    }, t.prototype.setRedirected = function(e) {
      this.storage.setItem(this.cookieKey, String(e), this.cookieStorageOptions);
    }, t;
  }()
), oU = (
  /** @class */
  function() {
    function t() {
      this.needDispatch = !0;
    }
    return t.prototype.setNeedDispatch = function(e) {
      this.needDispatch = e;
    }, t.prototype.dispatchDoneEventIfNeeded = function() {
      this.needDispatch && window.dispatchEvent(new CustomEvent(t.HACKLE_INITIALIZE_DONE_EVENT_TYPE));
    }, t.HACKLE_INITIALIZE_DONE_EVENT_TYPE = "hackle-initialize-done", t;
  }()
), aU = (
  /** @class */
  function() {
    function t(e, r) {
      this.sdk = e, this.storage = r;
    }
    return t.prototype.get = function() {
      var e = this.storage.getItem(ri);
      if (v.isNullOrUndefined(e))
        return null;
      try {
        var r = JSON.parse(e);
        return this.sdk.version !== r.version ? (this.clear(), null) : r;
      } catch {
        return this.clear(), null;
      }
    }, t.prototype.set = function(e) {
      var r = b(b({}, e), { version: this.sdk.version });
      this.storage.setItem(ri, JSON.stringify(r));
    }, t.prototype.clear = function() {
      this.storage.removeItem(ri);
    }, t;
  }()
), jr = O.log, sU = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = be.instance), this.clock = e, this.listeners = [], this._initialized = !1;
    }
    return t.prototype.install = function(e) {
      e === void 0 && (e = null);
      try {
        var r = this.changeLifecycle.bind(this);
        window.addEventListener("pageshow", function() {
          return r("pageshow");
        }), window.addEventListener("pagehide", function() {
          return r("pagehide");
        }), document.addEventListener("visibilitychange", function() {
          return r(document.visibilityState);
        }), window.addEventListener("blur", function() {
          return r("blur");
        }), window.addEventListener("focus", function() {
          return r("focus");
        }), t.isSafariBrowser(e) && window.addEventListener("beforeunload", function() {
          return r("hidden");
        }), history.pushState = function(n) {
          return function() {
            try {
              var o = n.apply(history, arguments);
              return r("locationChange"), o;
            } catch (a) {
              (a instanceof Error || typeof a == "string") && jr.error(a);
            }
          };
        }(history.pushState), history.replaceState = function(n) {
          return function() {
            try {
              var o = n.apply(history, arguments);
              return r("locationChange"), o;
            } catch (a) {
              (a instanceof Error || typeof a == "string") && jr.error(a);
            }
          };
        }(history.replaceState), window.addEventListener("popstate", function() {
          try {
            r("locationChange");
          } catch (n) {
            (n instanceof Error || typeof n == "string") && jr.error(n);
          }
        });
      } catch (n) {
        (n instanceof Error || typeof n == "string") && jr.error(n);
      }
    }, t.prototype.addListener = function(e) {
      this.listeners.push(e);
    }, t.prototype.initialize = function() {
      this._initialized = !0, this.changeLifecycle("pageshow");
    }, t.prototype.changeLifecycle = function(e) {
      this._initialized && this.publish(e);
    }, t.prototype.publish = function(e) {
      var r = this.clock.currentMillis();
      this.listeners.forEach(function(n) {
        n.onLifecycleChanged(e, r);
      });
    }, t.isSafariBrowser = function(e) {
      return v.isNullOrUndefined(e) ? !1 : e.toLowerCase().includes("safari");
    }, t;
  }()
), uU = (
  /** @class */
  function() {
    function t(e) {
      this.limiter = e;
    }
    return t.create = function(e, r, n) {
      n === void 0 && (n = be.instance);
      var i = new cU(n, e, r);
      return new t(i);
    }, t.prototype.execute = function(e, r) {
      return this.limiter.tryAcquire() ? e() : r();
    }, t;
  }()
), cU = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.clock = e, this.intervalMillis = r, this.limit = n, this.currentScope = null;
    }
    return t.prototype.tryAcquire = function() {
      var e = this.clock.currentMillis(), r = this.refreshScopeIfNeeded(e);
      return r.tryAcquire();
    }, t.prototype.refreshScopeIfNeeded = function(e) {
      return (this.currentScope == null || this.currentScope.isExpired(e)) && (this.currentScope = new lU(e + this.intervalMillis, this.limit)), this.currentScope;
    }, t;
  }()
), lU = (
  /** @class */
  function() {
    function t(e, r) {
      this.expirationTime = e, this.token = r;
    }
    return t.prototype.isExpired = function(e) {
      return this.expirationTime < e;
    }, t.prototype.tryAcquire = function() {
      return this.token > 0 ? (this.token -= 1, !0) : !1;
    }, t;
  }()
), fU = (
  /** @class */
  function() {
    function t(e) {
      this.determiners = e;
    }
    return t.prototype.isDedupTarget = function(e) {
      var r = this.determiners.find(function(n) {
        return n.supports(e);
      });
      return r ? r.isDedupTarget(e) : !1;
    }, t;
  }()
), Hp = (
  /** @class */
  function() {
    function t(e, r) {
      this.dedupIntervalMillis = e, this.clock = r, this.cache = {}, this.currentUser = null;
    }
    return t.prototype.isDedupTarget = function(e) {
      var r;
      if (this.dedupIntervalMillis === Gv)
        return !1;
      fe.isEquals(e.user.identifiers, (r = this.currentUser) === null || r === void 0 ? void 0 : r.identifiers) || (this.currentUser = e.user, this.cache = {});
      var n = this.cacheKey(e), i = this.clock.currentMillis(), o = this.cache[n];
      return o !== void 0 && i - o <= this.dedupIntervalMillis ? !0 : (this.cache[n] = i, !1);
    }, t;
  }()
), pU = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n) {
      return n === void 0 && (n = be.instance), t.call(this, r, n) || this;
    }
    return e.prototype.supports = function(r) {
      return Z.isRemoteConfigEvent(r);
    }, e.prototype.cacheKey = function(r) {
      return [r.parameter.id, r.valueId, r.decisionReason].join("-");
    }, e;
  }(Hp)
), dU = (
  /** @class */
  function(t) {
    Y(e, t);
    function e(r, n) {
      return n === void 0 && (n = be.instance), t.call(this, r, n) || this;
    }
    return e.prototype.supports = function(r) {
      return Z.isExposureEvent(r);
    }, e.prototype.cacheKey = function(r) {
      return [r.experiment.id, r.variationId, r.variationKey, r.decisionReason].join("-");
    }, e;
  }(Hp)
), vU = (
  /** @class */
  function() {
    function t() {
    }
    return t.prototype.isInvocatorResponse = function(e) {
      return typeof e == "object" && e !== null && "success" in e && typeof e.success == "boolean" && "message" in e && typeof e.message == "string";
    }, t.prototype.resolve = function(e) {
      var r = JSON.parse(e ?? "");
      if (!this.isInvocatorResponse(r))
        throw new Error("invalid invocator response data");
      if (!r.success)
        throw new Error("failed response");
      var n = {
        message: r.message,
        success: r.success,
        data: r.data
      };
      return n;
    }, t;
  }()
), hU = (
  /** @class */
  function() {
    function t(e) {
      this.invocator = e;
    }
    return t.prototype.createInvocationRequestDto = function(e) {
      var r = e.command, n = e.parameters;
      return { _hackle: { command: r, parameters: n } };
    }, t.prototype.process = function(e) {
      var r, n = this.createInvocationRequestDto(e);
      return (r = this.invocator.invoke(n).data) !== null && r !== void 0 ? r : null;
    }, t;
  }()
), gU = O.log, Xp = (
  /** @class */
  function() {
    function t(e, r) {
      this.core = e, this.userManager = r;
    }
    return t.prototype.onPageStarted = function(e, r) {
      this.track(e, r);
    }, t.prototype.onPageEnded = function(e, r) {
    }, t.prototype.track = function(e, r) {
      var n;
      gU.debug("tracking page view");
      var i = {
        key: t.PAGE_VIEW_EVENT_KEY,
        properties: (n = {}, n[t.PAGE_NAME_PROPERTY_KEY] = e.pageTitle, n)
      };
      this.core.track(i, this.userManager.resolve(), r);
    }, t.PAGE_VIEW_EVENT_KEY = "$page_view", t.PAGE_NAME_PROPERTY_KEY = "$page_name", t;
  }()
), yU = (
  /** @class */
  function() {
    function t() {
      this.listeners = [], this._currentPage = null;
    }
    return Object.defineProperty(t.prototype, "currentPage", {
      get: function() {
        var e;
        return (e = this._currentPage) !== null && e !== void 0 ? e : uo.createWithCurrentPage();
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.updatePage = function(e, r) {
      var n = this._currentPage;
      n && e.isEquals(n) || (n && this.publishEnd(n, r), this._currentPage = e, this.publishStart(e, r));
    }, t.prototype.publishStart = function(e, r) {
      for (var n = 0, i = this.listeners; n < i.length; n++) {
        var o = i[n];
        o.onPageStarted(e, r);
      }
    }, t.prototype.publishEnd = function(e, r) {
      for (var n = 0, i = this.listeners; n < i.length; n++) {
        var o = i[n];
        o.onPageEnded(e, r);
      }
    }, t.prototype.onLifecycleChanged = function(e, r) {
      switch (e) {
        case "pageshow":
        case "locationChange":
          var n = uo.createWithCurrentPage();
          return this.updatePage(n, r);
        case "visible":
        case "pagehide":
        case "blur":
        case "focus":
        case "hidden":
          return;
      }
    }, t.prototype.addListener = function(e) {
      this.listeners.push(e);
    }, t;
  }()
), rl = O.log, IU = (
  /** @class */
  function() {
    function t(e, r, n) {
      this.userManager = e, this.pageManager = r, this.minimumEngagementDurationMillis = n, this.listeners = [], this._lastEngagementTime = null;
    }
    return Object.defineProperty(t.prototype, "lastEngagementTime", {
      get: function() {
        return this._lastEngagementTime;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.startEngagement = function(e) {
      rl.debug("startEngagement timestamp:".concat(e, ", page:").concat(this.pageManager.currentPage.url)), this._lastEngagementTime = e;
    }, t.prototype.endEngagement = function(e, r) {
      if (!v.isNullOrUndefined(this._lastEngagementTime)) {
        var n = this._lastEngagementTime;
        this._lastEngagementTime = r;
        var i = r - n;
        if (!(i < this.minimumEngagementDurationMillis)) {
          var o = { page: e, durationMillis: i };
          this.publish(o, this.userManager.resolve(), r);
        }
      }
    }, t.prototype.publish = function(e, r, n) {
      rl.debug("onEngagement timestamp:".concat(n, ", page:").concat(this.pageManager.currentPage.url));
      for (var i = 0, o = this.listeners; i < o.length; i++) {
        var a = o[i];
        a.onEngagement(e, r, n);
      }
    }, t.prototype.onPageStarted = function(e, r) {
      this.startEngagement(r);
    }, t.prototype.onPageEnded = function(e, r) {
      this.endEngagement(e, r);
    }, t.prototype.onLifecycleChanged = function(e, r) {
      switch (e) {
        case "visible":
        case "focus":
          return this.startEngagement(r);
        case "pagehide":
        case "hidden":
        case "blur":
          return this.endEngagement(this.pageManager.currentPage, r);
        case "pageshow":
        case "locationChange":
          return;
      }
    }, t.prototype.addListener = function(e) {
      this.listeners.push(e);
    }, t;
  }()
), mU = (
  /** @class */
  function() {
    function t(e) {
      this.core = e;
    }
    return t.prototype.onEngagement = function(e, r, n) {
      var i, o = {
        key: t.ENGAGEMENT_EVENT_KEY,
        properties: (i = {}, i[Xp.PAGE_NAME_PROPERTY_KEY] = e.page.pageTitle, i[t.ENGAGEMENT_TIME_PROPERTY_KEY] = e.durationMillis, i)
      };
      this.core.track(o, r, n);
    }, t.ENGAGEMENT_EVENT_KEY = "$engagement", t.ENGAGEMENT_TIME_PROPERTY_KEY = "$engagement_time_ms", t;
  }()
), ko = O.log, qi = null;
function AU(t, e) {
  var r = qe.config(e);
  qe.logging(r);
  try {
    if (xg(window) && t === window._hackleApp.getAppSdkKey())
      return EU(t, r, window._hackleApp);
  } catch (n) {
    ko.error("Unexpected exception while check WebApp client: ".concat(n));
  }
  return Wp(t, r);
}
function EU(t, e, r) {
  var n = new YP(), i = n.getInvocator(r.getInvocationType(), new vU());
  if (i === null)
    throw new Error("Failed to get invocator with invocationType:".concat(r.getInvocationType()));
  var o = new hU(i), a = new Pg(o);
  if (!r.getAppMode)
    return a;
  var s = r.getAppMode().toLowerCase();
  if (s === ln.native)
    return a;
  if (s === ln.web_view_wrapper) {
    var u = Wp(t, e), c = new Ug(u, a);
    return c.syncUser(), c;
  }
  throw new Error("Unsupported HackleAppMode: ".concat(s));
}
function Wp(t, e) {
  var r, n, i = qe.sdk(t, e);
  if (qi)
    return ko.debug("use already exists hackleClient"), qi;
  var o = new Sg();
  o.initialize();
  var a = new Tx(), s = hr.getInstance({
    days: _l,
    isCrossSubdomain: !0,
    sameSite: e.sameSiteCookie,
    isSecure: e.secureCookie
  }), u = qe.isBeaconSupported(), c = tl.intercept(i, jP.create()), l = tl.intercept(i, zP.create()), f = c;
  u && (f = l);
  var p = new MP(), d = new _P(p, new Qi("setTimeout"), qe.pollingIntervalMillis(e)), C = new aU(i, At.postfix(a, "_".concat(t.slice(0, 8)))), R = new PP(Et.clientFetch(e.sdkUrl, i.key), c), S = new LP(C, R);
  p.add(S);
  var T = new yU(), N = new UP(Et.userCohorts(e.sdkUrl), c), U = new yP(T), D = new Ax(At.postfix(s, "_".concat(t))), Oe = D.getUser(), Kp = e.user || null, ce = new mx(Kr(), D, N, U, T, be.instance, Oe, Kp);
  p.add(ce);
  var Re = new bx(e.sessionTimeoutMillis, At.postfix(s, "_".concat(t.slice(8))));
  ce.addListener(Re);
  var Qp = new vx(a, "".concat(kv, "_").concat(t), ao), Xn = new qc(Et.clientDispatch(e.eventUrl), c), Sa = Xn;
  u && (Sa = new qc(Et.beaconDispatch(e.eventUrl, i.key), l));
  var Ra = new FP(Qp, Xn), qp = new $P(Xn, Sa, Ra), ed = new fU([
    new pU(qe.dedupIntervalMillis(e)),
    new dU(qe.dedupIntervalMillis(e))
  ]), Wn = new BP(qp, ao, new Qi("setTimeout"), $v), xa = new QR(Wn, ed, Re, ce), Pa = new oU(), Ua = new $c(new Wc(s, "".concat(Vv, "_").concat(t.slice(0, 8)))), Da = new $c(new Wc(s, "".concat(Bv, "_").concat(t.slice(0, 8)))), La = new Nx(At.prefix(a, "".concat(jv, "_").concat(t.slice(0, 8), "_"))), $a = new qx(At.prefix(a, "".concat(Hv, "_").concat(t.slice(0, 8), "_"))), me = cx.create(S, xa, [Ua, Da], La), ka = new vP(new hP(At.postfix(s, "_".concat(t.slice(0, 8)))), U, me, ce), td = new Gp(ce, me);
  Re.addListener(ka), Re.addListener(td);
  var rd = new Lx(me), nd = new Ox([
    new Mx(),
    new _x(new Jc()),
    new Sx(new Jc()),
    new Rx(La, be.instance),
    new xx(new Zc()),
    new Px(new Zc()),
    new Ux(new Yc()),
    new Dx(new Yc())
  ]), id = new eP([
    new tP($a),
    new nP(nd),
    new rP()
  ]), Fa = new iP(be.instance, rd, id), od = new aP([
    new sP(),
    new uP(Fa)
  ]), ad = new zx(Et.inAppMessageRenderer(e.cdnUrl, e.IAM_RENDERER_VERSION_HEADER)), Ga = new $x(Wx.create(ad), Fa, od), sd = new oP(new Jx($o.get("targetMatcher")), new Yx($a)), ud = new Gx(S, sd, me);
  new kx(Wn, ud, Ga);
  var cd = new OP(S);
  new NP(Wn, cd);
  var zn = new IU(ce, T, Zv);
  T.addListener(zn);
  var ld = new mU(me);
  zn.addListener(ld);
  var Va = new Xp(me, ce);
  e.automaticPageTracking && T.addListener(Va);
  var fd = new eU($o.get("targetMatcher")), Ba = new iU(s, Wv, { days: zv }), pd = new qP(S, fd, Ba, me), dd = new rU(new nU(U), new cP(), Ba, Pa), vd = new KP(pd, dd, ce, me);
  T.addListener(vd);
  var hd = new wx(me, ce, Ua, Da), gd = ((r = e.devTool) === null || r === void 0 ? void 0 : r.userExplorer) && typeof ((n = e.devTool) === null || n === void 0 ? void 0 : n.userExplorer) == "function", yd = e.devTool && gd ? { manager: e.devTool, userExplorer: hd } : void 0, ja = new lg(Et.monitoring(e.monitoringUrl), c, f, new Qi("setTimeout"), Lv);
  Ue.addRegistry(ja);
  var xe = new sU();
  xe.addListener(T), xe.addListener(zn), xe.addListener(Re), xe.addListener(o), xe.addListener(Ra), xe.addListener(xa), xe.addListener(ja), d.start();
  var Id = uU.create(Jv, 1), br = new Og(me, d, Re, ce, Id, Va, Ga, yd);
  qi = br;
  var md = function() {
    e.autoOpenDevTool && (e.devTool ? br.showUserExplorer() : ko.error("DevTool is not provided"));
  }, Ad = function() {
    var Jn = Date.now(), Tr = ce.currentUser, Ed = Re.currentSessionId, Zn;
    wa(Oe, Tr) ? Zn = Re.startNewSessionIfNeeded(Tr, Jn) : Zn = Re.startNewSession(Oe, Tr, Jn), Zn === Ed && ka.startNewCampaignIfNeeded(Tr, Jn);
  };
  new fx().install(me, ce);
  var Ha = ce.resolve().hackleProperties.browserName;
  return xe.install(typeof Ha == "string" ? Ha : null), Ad(), br.onReady(function() {
    md(), xe.initialize(), Pa.dispatchDoneEventIfNeeded();
  }), br;
}
function zp(t, e, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function s(l) {
      try {
        c(n.next(l));
      } catch (f) {
        a(f);
      }
    }
    function u(l) {
      try {
        c(n.throw(l));
      } catch (f) {
        a(f);
      }
    }
    function c(l) {
      l.done ? o(l.value) : i(l.value).then(s, u);
    }
    c((n = n.apply(t, e || [])).next());
  });
}
function Jp(t, e) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(c) {
    return function(l) {
      return u([c, l]);
    };
  }
  function u(c) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, c[0] && (r = 0)), r; )
      try {
        if (n = 1, i && (o = c[0] & 2 ? i.return : c[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, c[1])).done)
          return o;
        switch (i = 0, o && (c = [c[0] & 2, o.value]), c[0]) {
          case 0:
          case 1:
            o = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, i = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!o || c[1] > o[0] && c[1] < o[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < o[1]) {
              r.label = o[1], o = c;
              break;
            }
            if (o && r.label < o[2]) {
              r.label = o[2], r.ops.push(c);
              break;
            }
            o[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = e.call(t, r);
      } catch (l) {
        c = [6, l], i = 0;
      } finally {
        n = o = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
var Zp = "https://devtools.hackle.io", CU = "/user-explorer", bU = "https://cdn.hackle.io/images/20230330/84a95e8b-339b-412e-9200-f3655b5eb91b.png", Ct = function(t, e) {
  var r = e || document, n = r.querySelector(t);
  if (!n)
    throw Error("HackleDevtools Failed when getting element.");
  return n;
}, nl = "hackle-devtools", ot = "hackle-devtools__toggler", An = "hackle-devtools__shadowWrapper", xt = "hackle-devtools__iframeWrapper", Ma = "hackle-devtools__iframe", Fo = "hackle-devtools__style", TU = `
  <template id="`.concat(xt, `-template">
    <div id="`).concat(xt, `">
      <iframe id="`).concat(Ma, `"></iframe>
    </div>
  </template>
`), wU = `
  <template id="`.concat(An, `-template">
    <div id="`).concat(An, `" style="position:fixed; z-index:10000001; left:24px; bottom: 61px; height: 0;"></div>
  </template>
`), NU = `
  <template id="`.concat(ot, `-template">
    <button id="`).concat(ot, `" type="button">
    </button>
  </template>

`), OU = `
  <template id="`.concat(Fo, `-template">
    <style id="`).concat(Fo, `">
      #`).concat(ot, ` {
        width: 45px;
        height: 45px;
        display: block;
        background-image: url(`).concat(bU, `);
        background-size: contain;
        background-color: white;

        border: 2px solid white;
        border-radius: 50%;
        cursor: pointer;
        box-shadow: 0px 0px 10px 3px #CACACA;
      }
      #`).concat(ot, `.hide {
        display: none;
      }
      #`).concat(ot, ` > img {
        width: 100%;
        height: 100%;
      }
      #`).concat(Ma, ` {
        width: 100%;
        height: 100%;
        border: none;
        border-radius: 8px;
      }
      #`).concat(xt, ` {
        width:420px;
        height:80%;
        min-height:580px;
        max-height:620px;
        border-radius:18px;
        position:fixed;
        left:24px;
        bottom:18px;
        animation: fade 0.5s;
        background-color: #F5F5F5;
        overflow: hidden;
        box-shadow: rgba(255, 255, 255, 0.12) 0px 0px 2px 0px inset, rgba(0, 0, 0, 0.05) 0px 0px 2px 1px, rgba(0, 0, 0, 0.3) 0px 12px 60px;
      }

      @media screen and (max-width: 768px) {
        #`).concat(xt, ` {
          width: 100vw;
          min-height: unset;
          max-height: unset;
          left: 0;
        }
      }
      @keyframes fade {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
      }
    </style>
  </template>
`), MU = {
  iframeWrapper: TU,
  shadowWrapper: wU,
  toggler: NU,
  stylesheet: OU
}, H;
(function(t) {
  t.INIT = "HACKLE-EVENT_INIT", t.CLOSE = "HACKLE-EVENT_CLOSE", t.USER = "HACKLE-EVENT_USER", t.DECISION_AB_GET = "HACKLE-EVENT_GET_AB_DECISION", t.DECISION_FF_GET = "HACKLE-EVENT_GET_FF_DECISION", t.OVERRIDE_AB_GET = "HACKLE-EVENT_GET_AB_OVERRIDE", t.OVERRIDE_AB_SET = "HACKLE-EVENT_SET_AB_OVERRIDE", t.OVERRIDE_AB_RESET = "HACKLE-EVENT_RESET_AB_OVERRIDE", t.OVERRIDE_AB_RESET_ALL = "HACKLE-EVENT_RESET_ALL_AB_OVERRIDE", t.OVERRIDE_FF_GET = "HACKLE-EVENT_GET_FF_OVERRIDE", t.OVERRIDE_FF_SET = "HACKLE-EVENT_SET_FF_OVERRIDE", t.OVERRIDE_FF_RESET = "HACKLE-EVENT_RESET_FF_OVERRIDE", t.OVERRIDE_FF_RESET_ALL = "HACKLE-EVENT_RESET_ALL_FF_OVERRIDE";
})(H || (H = {}));
var ye = function(t) {
  return typeof t.type == "string" && Object.values(H).includes(t.type);
}, _U = function(t) {
  return ye(t) && t.type === H.CLOSE;
}, SU = function(t) {
  return ye(t) && t.type === H.INIT;
}, RU = function(t) {
  return ye(t) && t.type === H.USER;
}, xU = function(t) {
  return ye(t) && t.type === H.DECISION_AB_GET;
}, PU = function(t) {
  return ye(t) && t.type === H.DECISION_FF_GET;
}, UU = function(t) {
  return ye(t) && t.type === H.OVERRIDE_AB_GET;
}, DU = function(t) {
  return ye(t) && t.type === H.OVERRIDE_FF_GET;
}, LU = function(t) {
  return ye(t) && t.type === H.OVERRIDE_AB_SET;
}, $U = function(t) {
  return ye(t) && t.type === H.OVERRIDE_FF_SET;
}, kU = function(t) {
  return ye(t) && t.type === H.OVERRIDE_AB_RESET;
}, FU = function(t) {
  return ye(t) && t.type === H.OVERRIDE_FF_RESET;
}, GU = function(t) {
  return ye(t) && t.type === H.OVERRIDE_AB_RESET_ALL;
}, VU = function(t) {
  return ye(t) && t.type === H.OVERRIDE_FF_RESET_ALL;
}, BU = (
  /** @class */
  function() {
    function t(e, r) {
      this.port = e, this.opposite = r, this.port.start();
    }
    return t.prototype.receive = function(e, r) {
      this.port.addEventListener("message", function(n) {
        e(n.data) && r(n.data.payload);
      });
    }, t.prototype.post = function(e) {
      this.port.postMessage(e);
    }, t.prototype.close = function() {
      this.port.close(), this.opposite.close();
    }, t;
  }()
), jU = O.log, HU = 5e3, XU = (
  /** @class */
  function() {
    function t(e) {
      this.transceiver = e;
    }
    return t.connectTo = function(e, r) {
      return zp(this, void 0, void 0, function() {
        var n, i, o, a, s, u, c;
        return Jp(this, function(l) {
          switch (l.label) {
            case 0:
              return o = new Promise(function(f) {
                i = f, n = setTimeout(function() {
                  f({ port1: void 0, port2: void 0 });
                }, HU);
              }), window.addEventListener("message", function(f) {
                if (SU(f.data) && e.contentWindow) {
                  var p = new MessageChannel(), d = p.port1, C = p.port2;
                  e.contentWindow.postMessage({
                    type: H.INIT
                  }, "".concat(Zp, "/").concat(r), [C]), clearTimeout(n), i == null || i({ port1: d, port2: C });
                }
              }), [4, o];
            case 1:
              return a = l.sent(), s = a.port1, u = a.port2, !s || !u ? (jU.error("Timeout occurred while loading devtools."), [
                2
                /*return*/
              ]) : (c = new BU(s, u), [2, new t(c)]);
          }
        });
      });
    }, t.prototype.addMessageListener = function(e, r) {
      this.transceiver.receive(e, r);
    }, t.prototype.applyChannel = function(e) {
      e(this.transceiver);
    }, t.prototype.close = function() {
      this.transceiver.close();
    }, t;
  }()
), WU = function(t) {
  return function(e) {
    e.receive(RU, function() {
      var r = {
        type: H.USER,
        payload: t.currentUser()
      };
      e.post(r);
    }), e.receive(xU, function() {
      var r = {
        type: H.DECISION_AB_GET,
        payload: t.getAbTestDecisions()
      };
      e.post(r);
    }), e.receive(UU, function() {
      var r = {
        type: H.OVERRIDE_AB_GET,
        payload: t.getAbTestOverrides()
      };
      e.post(r);
    }), e.receive(LU, function(r) {
      r && t.setAbTestOverride(r.experiment, r.variationId);
    }), e.receive(kU, function(r) {
      r && t.resetAbTestOverride(r.experiment);
    }), e.receive(GU, function() {
      t.resetAllAbTestOverride();
    }), e.receive(PU, function() {
      var r = {
        type: H.DECISION_FF_GET,
        payload: t.getFeatureFlagDecisions()
      };
      e.post(r);
    }), e.receive(DU, function() {
      var r = {
        type: H.OVERRIDE_FF_GET,
        payload: t.getFeatureFlagOverrides()
      };
      e.post(r);
    }), e.receive($U, function(r) {
      r && t.setFeatureFlagOverride(r.experiment, r.variationId);
    }), e.receive(FU, function(r) {
      r && t.resetFeatureFlagOverride(r.experiment);
    }), e.receive(VU, function() {
      t.resetAllFeatureFlagOverride();
    });
  };
}, zU = function(t) {
  var e = !1, r = 0, n = 0, i = function(s) {
    if (!e) {
      var u = s instanceof TouchEvent ? s.touches[0] : s;
      r = u.clientX, n = u.clientY, e = !0, window.addEventListener("mousemove", o), window.addEventListener("touchmove", o, { passive: !1 });
    }
  }, o = function(s) {
    if (e) {
      t.classList.add("dragged");
      var u = s instanceof TouchEvent ? s.touches[0] : s, c = r - u.clientX, l = n - u.clientY;
      r = u.clientX, n = u.clientY, t.style.left = t.offsetLeft - c + "px", t.style.top = t.offsetTop - l + "px", s.preventDefault();
    }
  }, a = function() {
    e = !1, window.removeEventListener("mousemove", o), window.removeEventListener("touchmove", o);
  };
  t.addEventListener("mousedown", i), t.addEventListener("mouseup", a), t.addEventListener("touchstart", i, { passive: !1 }), t.addEventListener("touchend", a);
}, En = O.log, JU = (
  /** @class */
  function() {
    function t(e, r) {
      this.devtoolSubPath = e, this.channel = r, this.channelManager = null, this.shadowRoot = void 0, this.initialize();
    }
    return t.prototype.getShadowWrapper = function(e) {
      return Ct("#".concat(An), e);
    }, t.prototype.getIFrameWrapper = function(e) {
      return Ct("#".concat(xt), e);
    }, t.prototype.getToggler = function(e) {
      return Ct("#".concat(ot), e);
    }, t.prototype.getIFrame = function(e) {
      return Ct("#".concat(Ma), e);
    }, t.prototype.getTemplate = function(e) {
      return Ct("#".concat(e, "-template"));
    }, t.prototype.createMessageChannel = function() {
      return zp(this, void 0, void 0, function() {
        var e, r;
        return Jp(this, function(n) {
          switch (n.label) {
            case 0:
              return e = this.getIFrame(this.shadowRoot), e.src = "".concat(Zp, "/").concat(this.devtoolSubPath), [4, XU.connectTo(e, this.devtoolSubPath)];
            case 1:
              return r = n.sent(), r ? (this.channelManager = r, r.addMessageListener(_U, this.hide.bind(this)), r.applyChannel(this.channel), [
                2
                /*return*/
              ]) : (this.hide(), [
                2
                /*return*/
              ]);
          }
        });
      });
    }, t.prototype.initialize = function() {
      if (typeof window > "u") {
        En.error("HackleDevtools called before window loaded.");
        return;
      }
      document.getElementById(nl) || this.createRoot();
    }, t.prototype.show = function() {
      var e, r = this.getTemplate(xt);
      (e = this.shadowRoot) === null || e === void 0 || e.appendChild(r.content.cloneNode(!0)), this.createMessageChannel();
    }, t.prototype.createRoot = function() {
      var e = this, r = document.createElement("div");
      r.id = "hackle-devtools", Object.values(MU).forEach(function(c) {
        return r.insertAdjacentHTML("beforeend", c);
      }), document.body.appendChild(r);
      var n = this.getTemplate(An);
      r.appendChild(n.content);
      var i = this.getShadowWrapper();
      zU(i);
      var o = i.attachShadow({ mode: "open" });
      this.shadowRoot = o;
      var a = this.getTemplate(ot), s = this.getTemplate(Fo);
      o.appendChild(s.content), o.appendChild(a.content);
      var u = this.getToggler(o);
      u.addEventListener("click", function() {
        if (i.classList.contains("dragged")) {
          i.classList.remove("dragged");
          return;
        }
        e.show(), u.classList.add("hide");
      }, !0);
    }, t.prototype.hide = function() {
      var e = this.getToggler(this.shadowRoot);
      e.classList.remove("hide"), this.getIFrameWrapper(this.shadowRoot).remove();
    }, t.prototype.close = function() {
      var e;
      try {
        (e = this.channelManager) === null || e === void 0 || e.close();
        var r = Ct("#".concat(nl));
        r.remove();
      } catch {
        En.error("Failed to close HackleDevtools.");
      }
    }, t;
  }()
), ZU = (
  /** @class */
  function() {
    function t() {
    }
    return t.userExplorer = function(e) {
      try {
        t.devtoolInstance = new JU(CU, WU(e));
      } catch {
        En.error("Failed to initialize HackleDevTools.");
      }
    }, t.close = function() {
      if (!t.devtoolInstance) {
        En.error("There is no active HackleDevtools.");
        return;
      }
      t.devtoolInstance.close();
    }, t.devtoolInstance = null, t;
  }()
), Go = function(t, e) {
  return Go = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var i in n)
      Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
  }, Go(t, e);
};
function YU(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  Go(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var ue = function() {
  return ue = Object.assign || function(e) {
    for (var r, n = 1, i = arguments.length; n < i; n++) {
      r = arguments[n];
      for (var o in r)
        Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
    return e;
  }, ue.apply(this, arguments);
};
function Vo(t, e) {
  var r = typeof Symbol == "function" && t[Symbol.iterator];
  if (!r)
    return t;
  var n = r.call(t), i, o = [], a;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = n.next()).done; )
      o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}
var KU = "react-sdk", QU = "11.37.1", qU = (
  /** @class */
  function() {
    function t() {
      this.listeners = {};
    }
    return t.prototype.on = function(e, r) {
      this.listeners[e] = (this.listeners[e] || []).concat(r);
    }, t.prototype.off = function(e, r) {
      this.listeners[e] = (this.listeners[e] || []).filter(function(n) {
        return n !== r;
      });
    }, t.prototype.emit = function(e, r) {
      (this.listeners[e] || []).forEach(function(n) {
        n(r);
      });
    }, t;
  }()
), il = (
  /** @class */
  function() {
    function t() {
    }
    return t.arePropertiesEqual = function(e, r) {
      var n = t.coerceUnknownToProperties(e), i = t.coerceUnknownToProperties(r), o = Object.keys(n), a = Object.keys(i);
      return o.length !== a.length ? !1 : o.every(function(s) {
        return s in i && n[s] === i[s];
      });
    }, t.coerceUnknownToProperties = function(e) {
      return typeof e == "object" && e !== null ? e : {};
    }, t;
  }()
), eD = (
  /** @class */
  function() {
    function t() {
    }
    return t.isUserEqual = function(e, r) {
      return (e == null ? void 0 : e.id) === (r == null ? void 0 : r.id) && (e == null ? void 0 : e.deviceId) === (r == null ? void 0 : r.deviceId) && (e == null ? void 0 : e.userId) === (r == null ? void 0 : r.userId) && il.arePropertiesEqual(e == null ? void 0 : e.properties, r == null ? void 0 : r.properties) && il.arePropertiesEqual(e == null ? void 0 : e.identifiers, r == null ? void 0 : r.identifiers);
    }, t;
  }()
), tD = (
  /** @class */
  function(t) {
    YU(e, t);
    function e(r, n) {
      var i = t.call(this) || this;
      return i._currentUser = null, i.client = AU(r, ue(ue({}, n), { SDK_NAME_HEADER: KU, SDK_VERSION_HEADER: QU })), i.getUser = i.getUser.bind(i), i.setUser = i.setUser.bind(i), i.setUserId = i.setUserId.bind(i), i.setDeviceId = i.setDeviceId.bind(i), i.setUserProperty = i.setUserProperty.bind(i), i.updateUserProperties = i.updateUserProperties.bind(i), i.resetUser = i.resetUser.bind(i), i.variation = i.variation.bind(i), i.variationDetail = i.variationDetail.bind(i), i.isFeatureOn = i.isFeatureOn.bind(i), i.featureFlagDetail = i.featureFlagDetail.bind(i), i.track = i.track.bind(i), i.trackPageView = i.trackPageView.bind(i), i.remoteConfig = i.remoteConfig.bind(i), i.onReady = i.onReady.bind(i), i.onInitialized = i.onInitialized.bind(i), i.emitUpdatedUser = i.emitUpdatedUser.bind(i), i.showUserExplorer = i.showUserExplorer.bind(i), i.hideUserExplorer = i.hideUserExplorer.bind(i), i.fetch = i.fetch.bind(i), i.setInAppMessageListener = i.setInAppMessageListener.bind(i), n != null && n.devTool && (n != null && n.autoOpenDevTool) && typeof window < "u" && i.showUserExplorer(), i;
    }
    return e.prototype.getUser = function() {
      return this.client.getUser();
    }, e.prototype.setUser = function(r) {
      this.client.setUser(r), this.emitUpdatedUser(this.getUser());
    }, e.prototype.setUserId = function(r) {
      this.client.setUserId(r), this.emitUpdatedUser(this.getUser());
    }, e.prototype.setDeviceId = function(r) {
      this.client.setDeviceId(r), this.emitUpdatedUser(this.getUser());
    }, e.prototype.setUserProperty = function(r, n) {
      this.client.setUserProperty(r, n), this.emitUpdatedUser(this.getUser());
    }, e.prototype.updateUserProperties = function(r) {
      this.client.updateUserProperties(r), this.emitUpdatedUser(this.getUser());
    }, e.prototype.resetUser = function() {
      this.client.resetUser(), this.emitUpdatedUser(this.getUser());
    }, e.prototype.variation = function(r, n, i) {
      return this.client.variation(r, n || void 0, i);
    }, e.prototype.variationDetail = function(r, n, i) {
      return this.client.variationDetail(r, n || void 0, i);
    }, e.prototype.isFeatureOn = function(r, n) {
      return this.client.isFeatureOn(r, n || void 0);
    }, e.prototype.featureFlagDetail = function(r, n) {
      return this.client.featureFlagDetail(r, n || void 0);
    }, e.prototype.track = function(r, n) {
      this.client.track(r, n || void 0);
    }, e.prototype.trackPageView = function(r) {
      this.client.trackPageView(ue(ue({}, r), { user: (r == null ? void 0 : r.user) || void 0 }));
    }, e.prototype.remoteConfig = function(r) {
      return this.client.remoteConfig(r || void 0);
    }, e.prototype.onReady = function(r, n) {
      this.client.onReady(r, n);
    }, e.prototype.onInitialized = function(r) {
      return this.client.onInitialized(r);
    }, e.prototype.emitUpdatedUser = function(r) {
      eD.isUserEqual(this._currentUser, r) || this.emit("user-updated", r), this._currentUser = r;
    }, e.prototype.showUserExplorer = function() {
      this.client.showUserExplorer();
    }, e.prototype.hideUserExplorer = function() {
      this.client.hideUserExplorer();
    }, e.prototype.fetch = function() {
      return this.client.fetch();
    }, e.prototype.setInAppMessageListener = function(r) {
      this.client.setInAppMessageListener(r);
    }, e;
  }(qU)
);
function rD(t, e) {
  return new tD(t, e);
}
var _a = xd({
  hackle: void 0,
  userVersion: 0,
  initialized: !1
});
_a.Consumer;
var ol = _a.Provider;
function nD(t) {
  var e = t.hackleClient, r = t.user, n = t.timeout, i = n === void 0 ? 3e3 : n, o = t.supportSSR, a = o === void 0 ? !1 : o, s = t.children, u = Vo(an({
    hackle: e,
    initialized: !1,
    userVersion: 0
  }), 2), c = u[0], l = u[1];
  return De(function() {
    typeof r < "u" && r !== null && e.setUser(r);
  }, [r]), De(function() {
    var f = function() {
      l(function(p) {
        return ue(ue({}, p), { userVersion: p.userVersion + 1 });
      });
    };
    return e.on("user-updated", f), function() {
      e.off("user-updated", f);
    };
  }, [e]), De(function() {
    e.onInitialized({ timeout: i }).then(function() {
      l(function(f) {
        return ue(ue({}, f), { initialized: !0 });
      });
    }, function() {
      l(function(f) {
        return ue(ue({}, f), { initialized: !0 });
      });
    }).catch(function() {
      l(function(f) {
        return ue(ue({}, f), { initialized: !0 });
      });
    });
  }, [e]), a ? za.createElement(ol, { value: c }, s) : c.initialized ? za.createElement(ol, { value: c }, s) : null;
}
var iD = O.log;
function PD(t) {
  var e = Pd(_a), r = e.hackle, n = e.userVersion, i = e.initialized, o = Wr(function() {
    return (r == null ? void 0 : r.isFeatureOn(t)) || !1;
  }, [t, r, i]), a = Vo(an(function() {
    return oD(r) ? (typeof window < "u" && iD.error("HackleClient is not existed"), !1) : o();
  }), 2), s = a[0], u = a[1], c = {
    key: t,
    userVersion: n,
    initialized: i
  }, l = Vo(an(c), 2), f = l[0], p = l[1];
  return aD(f, c) || (p(c), u(o())), s;
}
function oD(t) {
  return !t;
}
function aD(t, e) {
  return t.initialized === e.initialized && t.key === e.key && t.userVersion === e.userVersion;
}
function sD({
  children: t
}) {
  const e = rD(Vd, {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    devTool: ZU,
    pollingIntervalMillis: 3e4,
    exposureEventDedupIntervalMillis: 1e3,
    autoOpenDevTool: Gd !== "production"
  }), r = Fd.get("deviceId"), n = r ? String(r) : void 0;
  return De(() => {
    !e || !n || e.setDeviceId(n);
  }, [n, e]), /* @__PURE__ */ A(nD, { hackleClient: e, supportSSR: !0, children: t });
}
function uD({
  size: t,
  fill: e
}) {
  return /* @__PURE__ */ Ie("svg", { xmlns: "http://www.w3.org/2000/svg", width: t || 18, height: t || 18, fill: e, viewBox: "0 0 18 18", children: [
    /* @__PURE__ */ A("path", { fill: "#4285F4", d: "M17.785 9.169c0-.738-.06-1.276-.189-1.834h-8.42v3.328h4.942c-.1.828-.638 2.073-1.834 2.91l-.016.112 2.662 2.063.185.018c1.694-1.565 2.67-3.867 2.67-6.597z" }),
    /* @__PURE__ */ A("path", { fill: "#34A853", d: "M9.175 17.938c2.422 0 4.455-.797 5.94-2.172l-2.83-2.193c-.758.528-1.774.897-3.11.897-2.372 0-4.385-1.564-5.102-3.727l-.105.01-2.769 2.142-.036.1c1.475 2.93 4.504 4.943 8.012 4.943z" }),
    /* @__PURE__ */ A("path", { fill: "#FBBC05", d: "M4.073 10.743c-.19-.558-.3-1.156-.3-1.774 0-.618.11-1.216.29-1.774l-.005-.119L1.254 4.9l-.091.044C.555 6.159.206 7.524.206 8.969c0 1.445.349 2.81.957 4.026l2.91-2.252z" }),
    /* @__PURE__ */ A("path", { fill: "#EB4335", d: "M9.175 3.468c1.684 0 2.82.728 3.468 1.335l2.531-2.471C13.62.887 11.598 0 9.175 0 5.667 0 2.638 2.013 1.163 4.943l2.9 2.252c.727-2.162 2.74-3.727 5.112-3.727z" })
  ] });
}
function cD({
  size: t,
  fill: e
}) {
  return /* @__PURE__ */ A("svg", { width: t || 30, height: t || 30, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ A("path", { fill: e || "#495057", fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 6C1.22386 6 1 6.22386 1 6.5C1 6.77614 1.22386 7 1.5 7H10C10.2761 7 10.5 6.77614 10.5 6.5C10.5 6.22386 10.2761 6 10 6H1.5ZM1.5 16C1.22386 16 1 16.2239 1 16.5C1 16.7761 1.22386 17 1.5 17H10C10.2761 17 10.5 16.7761 10.5 16.5C10.5 16.2239 10.2761 16 10 16H1.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H8.5C8.77614 11 9 11.2239 9 11.5C9 11.7761 8.77614 12 8.5 12H1.5C1.22386 12 1 11.7761 1 11.5ZM15.5 15.5C17.7091 15.5 19.5 13.7091 19.5 11.5C19.5 9.29086 17.7091 7.5 15.5 7.5C13.2909 7.5 11.5 9.29086 11.5 11.5C11.5 13.7091 13.2909 15.5 15.5 15.5ZM15.5 16.5C16.7006 16.5 17.8024 16.0768 18.6644 15.3715L22.1464 18.8536C22.3417 19.0488 22.6583 19.0488 22.8536 18.8536C23.0488 18.6583 23.0488 18.3417 22.8536 18.1464L19.3715 14.6644C20.0768 13.8024 20.5 12.7006 20.5 11.5C20.5 8.73858 18.2614 6.5 15.5 6.5C12.7386 6.5 10.5 8.73858 10.5 11.5C10.5 14.2614 12.7386 16.5 15.5 16.5Z" }) });
}
const lD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GoogleLogo: uD,
  SearchHamburger: cD
}, Symbol.toStringTag, { value: "Module" }));
function fD({
  size: t,
  fill: e,
  icon: r,
  ...n
}) {
  const i = lD[r];
  return /* @__PURE__ */ A(i, { size: t, fill: e, ...n });
}
var Yp = /* @__PURE__ */ ((t) => (t.Kakao = "Kakao", t.Google = "Google", t.Github = "Github", t.Apple = "Apple", t))(Yp || {});
const Hr = {
  Kakao: "/api/v1/auth/kakao",
  Google: "/api/v1/auth/google",
  Github: "/api/v1/auth/github",
  Apple: "/api/v1/auth/apple"
}, pD = {
  Kakao: {
    responseType: "code",
    clientId: Bd,
    authorizationUrl: "https://kauth.kakao.com/oauth/authorize",
    redirectUri: `${Nr}${Hr.Kakao}`,
    scope: ["profile", "account_email", "birthday", "birthyear", "phone_number", "age_range", "gender"].join(",")
  },
  Github: {
    responseType: "code",
    clientId: jd,
    authorizationUrl: "https://github.com/login/oauth/authorize",
    redirectUri: `${Nr}${Hr.Github}`,
    scope: ["user:email"].join(",")
  },
  Google: {
    responseType: "code",
    clientId: Hd,
    authorizationUrl: "https://accounts.google.com/o/oauth2/v2/auth",
    redirectUri: `${Nr}${Hr.Google}`,
    scope: ["https://www.googleapis.com/auth/userinfo.email", "https://www.googleapis.com/auth/userinfo.profile"].join(" ")
  },
  Apple: {
    responseType: "code id_token",
    clientId: Xd,
    authorizationUrl: "https://appleid.apple.com/auth/authorize",
    redirectUri: `${Nr}${Hr.Apple}`,
    scope: ["email", "name"].join(" "),
    responseMode: "form_post"
  }
};
function dD() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const vD = {
  Kakao: "카카오",
  Google: "구글",
  Github: "깃허브",
  Apple: "애플"
};
function hD(t) {
  return /* @__PURE__ */ A(sD, { children: /* @__PURE__ */ A(yD, { ...t }) });
}
var gD = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "bjn8wh",
  styles: "position:relative",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: dD
};
function yD({
  provider: t,
  showTooltip: e,
  isAuthPage: r = !1,
  checkBrowserRestrictions: n = !0
}) {
  const {
    t: i
  } = Cn(), o = ul(() => ({
    Kakao: {
      color: "yellow.4",
      icon: /* @__PURE__ */ A(Yn, { color: "dark.5", icon: fl.faComment })
    },
    Google: {
      color: "gray.1",
      icon: /* @__PURE__ */ A(fD, { icon: "GoogleLogo" })
    },
    Github: {
      color: "dark.4",
      icon: /* @__PURE__ */ A(Yn, { icon: fv })
    },
    Apple: {
      color: "white",
      icon: /* @__PURE__ */ A(Yn, { color: "dark", icon: lv })
    }
  })[t], [t]), a = Wr((l) => {
    if (nt()) {
      const {
        searchParams: f
      } = new URL(window.location.href), d = `${f.get("referUrl") || (r ? `${Wd}${tr.MAIN}` : window == null ? void 0 : window.location.href)}`;
      return Qn.stringifyUrl({
        url: l,
        query: {
          state: JSON.stringify({
            prev_url: d,
            enableLocalization: !0,
            previousUrl: d
          })
        }
      });
    }
    return Qn.stringifyUrl({
      url: l
    });
  }, [r]), s = Wr(() => {
    const {
      authorizationUrl: l,
      redirectUri: f,
      scope: p,
      clientId: d,
      responseMode: C,
      responseType: R
    } = pD[t], S = Qn.stringifyUrl({
      url: l,
      query: {
        scope: p,
        client_id: d,
        redirect_uri: f,
        response_type: R,
        response_mode: C
      }
    }, {
      skipNull: !0
    });
    return a(S);
  }, [t, a]), u = Wr(() => {
    var l;
    if (t === "Google" && nt() && n) {
      const {
        userAgent: f
      } = window.navigator;
      if (f.match(/kakaotalk/i) && f.match(/(inapp)/i))
        return Wa({
          size: "md",
          zIndex: 202,
          title: i("카카오톡에서 구글 로그인을 지원하지 않습니다."),
          children: /* @__PURE__ */ A(eo, { children: i("다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.") }),
          labels: {
            confirm: i("확인")
          },
          footerType: "full",
          confirmProps: {
            color: "infgreen"
          }
        });
      if (f.match(/NAVER/i))
        return Wa({
          size: "md",
          zIndex: 202,
          title: i("네이버에서 구글 로그인을 지원하지 않습니다."),
          children: /* @__PURE__ */ A(eo, { children: i("다른 모바일 브라우져(Chrome, Safari)를 이용해 주세요.") }),
          labels: {
            confirm: i("확인")
          },
          footerType: "full",
          confirmProps: {
            color: "infgreen"
          }
        });
    }
    nt() && ((l = Bo) == null || l.set("referrer", window.location.href), window.location.href = s());
  }, [s]), c = i("{{provider}}-로그인-버튼", {
    provider: t
  });
  return /* @__PURE__ */ A("div", { css: gD, children: /* @__PURE__ */ A(Od, { label: i("최근 로그인"), arrowPosition: "center", withArrow: !0, opened: e, "aria-describedby": c, fw: "bold", children: /* @__PURE__ */ A(Md, { id: c, size: "xl", variant: "filled", color: o.color, onClick: u, sx: (l) => ({
    boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.2)",
    ...o.color === "white" && {
      backgroundColor: o.color,
      "&:hover": {
        backgroundColor: l.colors.gray[1]
      }
    }
  }), "aria-label": i("{{socialProviderNameMap[provider]}}로 로그인", {
    "socialProviderNameMap[provider]": vD[t]
  }), children: o.icon }) }) });
}
function ID() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var mD = process.env.NODE_ENV === "production" ? {
  name: "1h8nup8",
  styles: "overflow:visible"
} : {
  name: "11ggwp1-LoginModal",
  styles: "overflow:visible;label:LoginModal;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: ID
};
function UD({
  onClose: t,
  opened: e
}) {
  const {
    t: r
  } = Cn(), [n, i] = an(null), {
    trackEvent: o
  } = cl();
  return De(() => {
    if (nt()) {
      const a = Bo.get("_inflearn_spd");
      i(a ?? null);
    }
  }, []), /* @__PURE__ */ A(cv, { children: /* @__PURE__ */ Ie(le.Root, { radius: "md", size: 360, onClose: t, opened: e, closeOnClickOutside: !1, children: [
    /* @__PURE__ */ A(le.Overlay, {}),
    /* @__PURE__ */ Ie(le.Content, { children: [
      /* @__PURE__ */ A(le.Header, { children: /* @__PURE__ */ A(le.CloseButton, { onClick: t }) }),
      /* @__PURE__ */ A(le.Body, { css: mD, children: /* @__PURE__ */ Ie(_d, { component: "article", children: [
        /* @__PURE__ */ A(wr, { component: "h1", justify: "center", mb: "xl", "aria-label": r("인프런 브랜드 로고"), children: /* @__PURE__ */ A(ov, { type: "inflearn", size: 120 }) }),
        /* @__PURE__ */ A(rv, {}),
        /* @__PURE__ */ Ie(wr, { justify: "center", mt: 12, mb: 24, sx: (a) => ({
          ...AD(a.colors.gray[7], a.colors.gray[6])
        }), children: [
          /* @__PURE__ */ A(Kn, { href: tr.FIND_PW, underline: !1, onClick: () => o(er.CLICK_FIND_PW_AT_SIGNIN, {
            spot: "modal"
          }), children: r("비밀번호 찾기") }),
          /* @__PURE__ */ A(Xr, { orientation: "vertical", color: "gray.5", mx: 8, my: 4 }),
          /* @__PURE__ */ A(Kn, { underline: !1, href: tr.SIGN_UP, onClick: () => o(er.CLICK_SIGNUP_AT_SIGNIN, {
            spot: "modal"
          }), children: r("회원가입") }),
          /* @__PURE__ */ A(Xr, { orientation: "vertical", color: "gray.5", mx: 8, my: 4 }),
          /* @__PURE__ */ A(Kn, { underline: !1, href: tr.FIND_ID, onClick: () => o(er.CLICK_FIND_ID_AT_SIGNIN, {
            spot: "modal"
          }), children: r("아이디(이메일) 찾기") })
        ] }),
        /* @__PURE__ */ Ie(wr, { justify: "center", align: "center", direction: "column", children: [
          /* @__PURE__ */ A(Xr, { mb: "md", variant: "solid", labelPosition: "center", label: r("간편 로그인"), color: "gray.3", styles: (a) => ({
            root: {
              width: "100%"
            },
            label: {
              color: `${a.colors.gray[5]} !important`
            }
          }) }),
          /* @__PURE__ */ A(wr, { gap: "sm", children: Object.values(Yp).map((a) => /* @__PURE__ */ A(hD, { provider: a, showTooltip: n === a }, a)) })
        ] })
      ] }) })
    ] })
  ] }) });
}
const AD = (t, e) => ({
  a: {
    color: t,
    fontSize: "12px",
    borderBottom: `1px solid ${e}`
  }
});
export {
  cv as A,
  ov as B,
  sD as H,
  qd as I,
  UD as L,
  xD as N,
  hD as S,
  Yp as a,
  nD as b,
  rD as c,
  ZU as d,
  PD as u
};
